<template>
  <div>
    <spinner-loader :loadingStuff="loadingStuff" />
    <app-template />
    <div
      class="uk-container uk-container-large container profile-page"
      :class="{
        'with-drawer': selectedUserValue !== '',
        'nav-collapsed': navCollapsed,
      }"
    >
      <template v-if="selectedUserValue !== ''">
        <div
          v-if="userData.userType === 'Admin' || userData.userType === 'Coach'"
          class="select-user"
        >
          <template v-if="allUserDataBeforFilterApplied.length > 1">
            <label class="form__label" for="userSelect">Select player </label>
            <select
              v-model="selectedUserId"
              @change="selectedUseChanged(selectedUserId, 'userChangeSelect')"
              id="userSelect"
            >
              <option
                v-for="(player, index) in playerSelectOptions"
                :value="player.id"
                :key="player.id + index"
              >
                {{ player.name }}
              </option>
            </select>
            <!-- Squad-scoped by default; admins/coaches with several squads can widen it -->
            <a
              v-if="playerSelectHasMore"
              href="javascript:;"
              class="select-user__scope"
              @click="showAllPlayersInSelect = !showAllPlayersInSelect"
            >
              {{
                showAllPlayersInSelect
                  ? "Show squad only"
                  : "Show all players (" + allUserDataBeforFilterApplied.length + ")"
              }}
            </a>
          </template>
        </div>

        <user-header
          :userDataForHeader="userData || {}"
          :selectedUserData="selectedUserDataForHeader || {}"
          @weekSelectedChanged="weekSelectedChanged"
          @calendarDateChanged="calendarDateChanged"
          @mondaySunDatesChanged="mondaySunDatesChanged"
          :coachesUsersData="coachesUsersData || []"
          @selectedUseChanged="selectedUseChanged"
        />
      </template>
      <div v-else>
        <h1>
          <span>Overview</span>
        </h1>
      </div>

      <div>
        <template v-if="selectedUserValue !== ''">
          <div class="section-layout">
            <SectionNav
              title="Player"
              :items="profileNavItems"
              :active="selectedTab"
              v-model:collapsed="navCollapsed"
              @select="(k) => tabChange('selectedTab', k)"
            />
            <div class="tabs-wrapper">
              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'player-documents-tab'"
              >
                <div class="games-info">
                  <h3>Signed documents</h3>

                  <b-button
                    @click="charterModal()"
                    size="lg"
                    class="main-button"
                    variant="outline-warning"
                  >
                    <i class="bi bi-pen" aria-hidden="true"></i> View &amp; sign
                    charter
                  </b-button>

                  <DocumentView
                    :uploadedDocuments="uploadedDocuments"
                    :userData="selectedUserData"
                    @documentDeleted="getDocumentUploadsByUserId"
                  />
                </div>
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'performace-tab'"
              >
                <div class="games-info two-col-flex">
                  <div class="games-stats">
                    <!--<div class="button-wrapper-top">
                    <b-button v-if="
                      userData.userType !== 'Admin' &&
                      userData.userType !== 'Coach'
                    " class="main-button" @click="openGamePerformanceModal('performanceModal')" size="lg"
                      variant="outline-success" v-b-tooltip.hover title="Submit game performance report">
                      <i class="bi bi-file-text" aria-hidden="true"></i>
                    </b-button>

                    <b-button v-if="
                      userData.userType !== 'Admin' &&
                      userData.userType !== 'Coach'
                    " @click="playerAssesmentModal()" size="lg" class="main-button" variant="outline-success"
                      v-b-tooltip.hover title="Add a Player Self Assessment">
                      <i class="bi bi-person" aria-hidden="true"></i>
                    </b-button>
                  </div>-->

                    <div class="stats-wrapper">
                      <div class="game-stats">
                        <h3 class="no-margin">
                          Your game stats for this season
                        </h3>
                        <p
                          class="small-date-player-coach days-red-warning"
                          v-if="gamePerformanceData.created_date === undefined"
                        >
                          <i
                            class="bi bi-exclamation-circle"
                            aria-hidden="true"
                          ></i>
                          You have not submitted a game report. Please submit
                          one now.
                        </p>
                        <p
                          v-else
                          class="small-date-player-coach"
                          :class="`days-${checkDateTimeFromNow(
                            gamePerformanceData.created_date,
                          )}`"
                        >
                          You last submitted a game report on
                          {{ formatDate(gamePerformanceData.created_date) }}
                        </p>
                        <ul class="key-value-list">
                          <li>
                            <span>Appearances:</span
                            >{{ gamePerformanceData.gamesPlayed }}
                          </li>
                          <li v-if="checkUserPosition() !== 'Goalkeeper'">
                            <span>Goals:</span>
                            <template
                              v-if="gamePerformanceData.goals !== null"
                              >{{ gamePerformanceData.goals }}</template
                            >
                            <template v-else>0</template>
                          </li>
                          <li v-else>
                            <span>Clean sheets:</span>
                            <template
                              v-if="gamePerformanceData.clean_sheet !== null"
                              >{{ gamePerformanceData.clean_sheet }}</template
                            >
                            <template v-else>0</template>
                          </li>
                          <li>
                            <span>Assists:</span>
                            {{ gamePerformanceData.assists }}
                          </li>
                          <!--<li
                          v-if="gamePerformanceData.player_self_rating !== null"
                        >
                          <span>Player performace rating:</span>
                          {{ gamePerformanceData.player_self_rating }}
                        </li>-->
                          <li v-if="gamePerformanceData.timeOnPitch !== null">
                            <span>Game time:</span>
                            {{ gamePerformanceData.timeOnPitch }} mins
                          </li>
                          <li>
                            <span>Yellow cards:</span>
                            {{ gamePerformanceData.yellowCardTotal }}
                          </li>
                          <li>
                            <span>Red cards:</span>
                            {{ gamePerformanceData.redCardTotal }}
                          </li>
                          <li v-if="selectedUserData.nationality">
                            <span>Nationality:</span
                            >{{ selectedUserData.nationality }}
                          </li>
                          <li v-if="selectedUserData.second_nationality">
                            <span>Second nationality:</span
                            >{{ selectedUserData.second_nationality }}
                          </li>
                          <li v-if="selectedUserData.country_of_birth">
                            <span>Country of birth:</span
                            >{{ selectedUserData.country_of_birth }}
                          </li>
                        </ul>

                        <!-- Medical information — visible to the player (self), admins and coaches only.
                           Structured (Yes/No + per-condition detail); admins and coaches can edit. -->
                        <MedicalInfoCard
                          v-if="canViewMedical && selectedUserData.id"
                          :player-id="selectedUserData.id"
                          :club-id="selectedUserData.clubId || userData.clubId"
                          :can-edit="canEditMedical"
                          :viewer-id="userData.id"
                          @saved="onMedicalSaved"
                        />

                        <academy-report-comp
                          :playerCvData="playerCvData || {}"
                          :userData="userData || {}"
                          :selectedUserValue="selectedUserValue"
                          :gamePerformanceData="gamePerformanceData || {}"
                          :selectedUserData="selectedUserData || {}"
                          :selectedTeamId="selectedTeamId"
                          v-if="selectedUserValue !== ''"
                        />
                      </div>

                      <div class="playing-positions">
                        <h3>Playing positions</h3>
                        <div class="pitch-wrapper">
                          <img
                            class="goalkeeper small-shirt"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />

                          <img
                            class="small-shirt right-full-back"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />
                          <img
                            class="small-shirt center-back-left"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />
                          <img
                            class="small-shirt center-back-right"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />
                          <img
                            class="small-shirt left-full-back"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />

                          <img
                            class="small-shirt left-midfielder"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />
                          <img
                            class="small-shirt defensive-midfielder"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />
                          <img
                            class="small-shirt attacking-midfielder"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />
                          <img
                            class="small-shirt right-midfielder"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />

                          <img
                            class="small-shirt striker-left"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />
                          <img
                            class="small-shirt striker-right"
                            src="../img/player-shirt-gray.svg"
                            alt="player-shirt"
                          />

                          <div
                            class="position-played-wrapper"
                            v-for="(
                              position, index
                            ) in gamePerformanceData.postion_played"
                            :key="index"
                          >
                            <img
                              v-if="position === 'Goalkeeper'"
                              class="goalkeeper small-shirt"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />

                            <img
                              v-if="position === 'Right Full-back (Wingback)'"
                              class="small-shirt right-full-back"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />
                            <img
                              v-if="position === 'Center-back left'"
                              class="small-shirt center-back-left"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />
                            <img
                              v-if="position === 'Center-back right'"
                              class="small-shirt center-back-right"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />
                            <img
                              v-if="position === 'Left Full-back (Wingback)'"
                              class="small-shirt left-full-back"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />

                            <img
                              v-if="position === 'Left Midfielder (Winger)'"
                              class="small-shirt left-midfielder"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />
                            <img
                              v-if="
                                position === 'Defensive Midfielder' ||
                                position === 'Centre Defensive Midfield'
                              "
                              class="small-shirt defensive-midfielder"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />
                            <img
                              v-if="
                                position === 'Attacking Midfielder' ||
                                position === 'Centre midfield'
                              "
                              class="small-shirt attacking-midfielder"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />
                            <img
                              v-if="position === 'Right Midfielder (Winger)'"
                              class="small-shirt right-midfielder"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />

                            <img
                              v-if="
                                position === 'Center Forward (Striker) left'
                              "
                              class="small-shirt striker-left"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />
                            <img
                              v-if="
                                position === 'Center Forward (Striker) right'
                              "
                              class="small-shirt striker-right"
                              src="../img/player-shirt-blue.svg"
                              alt="player-shirt"
                            />
                          </div>

                          <img
                            src="../img/pitch.svg"
                            alt="pitch"
                            class="pitch-svg"
                            id="pitch_svg"
                          />
                        </div>

                        <div
                          class="positions-frequency-wrap"
                          v-if="positionsByFrequency.length"
                        >
                          <h4>Positions played</h4>
                          <ul class="positions-frequency">
                            <li
                              v-for="(p, i) in positionsByFrequency"
                              :key="p.position"
                              :class="{ 'is-top': i === 0 }"
                            >
                              <span class="pos-rank">{{ i + 1 }}</span>
                              <div class="pos-body">
                                <div class="pos-line">
                                  <span class="pos-name">{{ p.position }}</span>
                                  <span class="pos-count"
                                    >{{ p.count }}
                                    {{ p.count === 1 ? "game" : "games" }}</span
                                  >
                                </div>
                                <div class="pos-bar">
                                  <div
                                    class="pos-bar-fill"
                                    :style="{
                                      width:
                                        Math.round(
                                          (p.count / positionsMaxCount) * 100,
                                        ) + '%',
                                    }"
                                  ></div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <RecentActivity
                        :selectedUserData="selectedUserData"
                        :physicalPerformance="allPlayerPhysicalPerformanceData"
                        :games="playerDailyMins"
                      />
                    </div>
                  </div>

                  <!-- Training sits full width under the three columns: on wide
                     screens it renders the whole week (7 day columns) instead
                     of the single-day stepper, which left the right of the
                     page empty when it lived in the narrow game-stats column. -->
                  <section
                    class="training-snapshot-section"
                    v-if="selectedUserValue !== ''"
                  >
                    <ProfileTrainingSnapshot
                      :selectedUserData="selectedUserData"
                      :userData="userData"
                      @openFullWeek="showTrainingWeekModal = true"
                    />
                  </section>

                  <!-- GPS benchmarks sit full width under Recent activity: the
                     card is a six-tile grid, so it would be cramped as a
                     fourth column in the flex row above. Renders nothing at
                     all when the club has no GPS data. -->
                  <section
                    class="gps-benchmark-section"
                    v-if="hasFeature('gpsReports') && selectedUserValue"
                  >
                    <GpsPlayerBenchmark :playerId="selectedUserValue" />
                  </section>

                  <section class="gps-stats-full-width">
                    <!-- Full Training Week Section Card -->
                    <div class="player-performance-review-stats">
                      <h3>Training Week</h3>
                      <a
                        href="javascript:;"
                        class="view-all-reports"
                        @click="showTrainingWeekModal = true"
                      >
                        <img
                          class="large-icon-shape"
                          src="../img/training-ass.svg"
                          alt=""
                        />
                        <span
                          >View the full<br />
                          training and<br />
                          games week.</span
                        >
                      </a>
                    </div>

                    <!-- Players Minutes & Stats Section Card -->
                    <div class="player-performance-review-stats">
                      <h3>Minutes &amp; Stats</h3>
                      <a
                        href="javascript:;"
                        class="view-all-reports"
                        @click="showPlayerMinsStatsModal = true"
                      >
                        <img
                          class="large-icon-shape"
                          src="@/components/PlayerPhysicalPerformanceStats/img/performance-stats-icon.svg"
                          alt=""
                        />
                        <span
                          >View player<br />
                          minutes and<br />
                          season stats.</span
                        >
                      </a>
                    </div>

                    <div class="all-training-reports">
                      <game-reports-modal
                        ref="gameReportsModalComponent"
                        v-if="
                          seasonsgamePerformanceReportsForUser !== undefined
                        "
                        :seasonsGamePerformanceReports="
                          JSON.parse(
                            JSON.stringify(
                              seasonsgamePerformanceReportsForUser,
                            ),
                          )
                        "
                        :selectedUserData="
                          JSON.parse(JSON.stringify(selectedUserData))
                        "
                        :userData="JSON.parse(JSON.stringify(userData))"
                        :playerGameTargetsData="
                          JSON.parse(JSON.stringify(playerGameTargetsData))
                        "
                        :playerPlayMakerGpsData="
                          JSON.parse(JSON.stringify(playerPlayMakerGpsData))
                        "
                        :coachGamePerformanceData="
                          JSON.parse(JSON.stringify(coachGamePerformanceData))
                        "
                        @getCoachesGamePerformanceReport="
                          getCoachesGamePerformanceReport
                        "
                        @getThisSeasionsCoachesGamePerformanceReports="
                          getThisSeasionsCoachesGamePerformanceReports
                        "
                        @sendFBNotificationMessage="sendFBNotificationMessage"
                        @getAllGamesEventsForPlayer="refreshGamesList"
                        @refreshSeasonsGamePerformanceReports="
                          getThisSeasonsgamePerformanceReportsForUser
                        "
                      />

                      <div class="buttons-row">
                        <b-button
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          @click="
                            openGamePerformanceModal(
                              'coachGamePerformanceModal',
                            )
                          "
                          class="main-button"
                          size="lg"
                          variant="outline-success"
                          v-b-tooltip.hover
                          title="Coaches player game assesment"
                        >
                          <i class="bi bi-file-text" aria-hidden="true"></i>
                          Rate player
                        </b-button>
                        <!--<b-button size="lg" class="main-button" variant="outline-success" v-b-tooltip.hover @click="
                        download_csv(
                          seasonsgamePerformanceReportsForUser,
                          'player-season-Game-stats-Reports',
                        )
                        " title="Export player season Game stats to csv">
                        <i class="bi bi-download" aria-hidden="true"></i>
                      </b-button>-->
                      </div>
                    </div>

                    <!--<div class="all-training-reports">
                    <h3>Player self assessments</h3>
                    <a href="javascript:;" @click="openAllPlayerSelfAssessmentModal()">
                      <img class="large-icon-shape" src="../img/player-ass.svg" alt="" />
                      View all this season Player self assessments</a>
                  </div>-->

                    <player-performance-overView
                      :playerPersonalBestAndAverages="
                        playerPersonalBestAndAverages
                      "
                      :playerMakerPersonalBestAndAverages="
                        playerMakerPersonalBestAndAverages
                      "
                      :lastGameSessionData="lastGameSessionData"
                      :lastTrainingSessionData="lastTrainingSessionData"
                      :lastGamePlayMakerSessionData="
                        lastPlayMakerGameSessionData
                      "
                      :lastTrainingPlayMakerSessionData="
                        lastPlayMakerTrainingSessionData
                      "
                      :playerDailyMins="playerDailyMins"
                      :playerPlayMakerGpsData="playerPlayMakerGpsData"
                      :selectedUserData="selectedUserData"
                      v-if="
                        hasFeature('gpsReports') &&
                        Object.keys(this.playerPersonalBestAndAverages).length >
                          0
                      "
                    />

                    <PlayerPhysicalPerformanceStats
                      v-if="hasFeature('gpsReports')"
                      :selectedUserValue="selectedUserValue"
                      :selectedUserData="selectedUserData"
                      :userData="userData"
                      :currentSeason="getCurrentSeason()"
                      :getLastSeason="getLastSeason()"
                      ref="playerPhysicalPerformanceStatsComponent"
                    />

                    <!-- <div class="all-training-reports">
                    <h3>Training stats</h3>
                    <a href="javascript:;" @click="
                      openAllTrainingReportsModal('allTrainingReportsModal')
                      "><img class="large-icon-shape" src="../img/training-ass.svg" alt="" />
                      <span>View all<br /> training stats</span></a>
                  </div>-->

                    <trial-performance-review
                      v-if="hasFeature('trialists')"
                      :selectedUserValue="selectedUserValue"
                    />

                    <!-- Bio-Banding & Growth Section Card -->
                    <div class="player-performance-review-stats">
                      <h3>Bio-Banding & Growth</h3>
                      <a
                        href="javascript:;"
                        class="view-all-reports"
                        @click="showBioBandingModal = true"
                      >
                        <img
                          class="large-icon-shape"
                          src="../img/bio-band-icon.svg"
                          alt=""
                        />
                        <span
                          >Calculate predicted<br />
                          adult height,<br />
                          bio-age, and track growth over time.</span
                        >
                      </a>
                    </div>
                  </section>

                  <!-- Games and training lists removed - now handled by TrainingWeek component -->
                </div>
              </div>

              <div
                class="home-work-tab tab-content"
                v-if="selectedTab === 'home-work-tab'"
              >
                <div class="homework-container">
                  <!-- Player Homework Section -->
                  <div class="homework-section-card">
                    <div class="homework-section-header">
                      <div class="section-title">
                        <i class="bi bi-person-video3"></i>
                        <h3>Player Homework</h3>
                        <span
                          class="badge-count"
                          v-if="allHomeWorkData.length > 0"
                          >{{ allHomeWorkData.length }}</span
                        >
                      </div>
                      <div
                        class="section-actions"
                        v-if="
                          (userData.userType === 'Admin' ||
                            userData.userType === 'Coach') &&
                          !$store.getters.isReadOnlySeason
                        "
                      >
                        <button
                          class="add-homework-btn"
                          @click="addHomeWorkModalCall()"
                        >
                          <i class="bi bi-plus-lg"></i> Add Homework
                        </button>
                      </div>
                    </div>

                    <div class="homework-section-content">
                      <!-- Desktop Table View -->
                      <div
                        v-if="allHomeWorkData.length > 0"
                        class="homework-table-wrapper"
                      >
                        <table class="homework-table-modern desktop-only">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Game</th>
                              <th>Title</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="homework in allHomeWorkData"
                              :key="homework.id"
                            >
                              <td>
                                <span class="date-cell">
                                  <i class="bi bi-calendar3"></i>
                                  {{
                                    formatDateForHuman(homework.created_date)
                                  }}
                                </span>
                              </td>
                              <td>
                                <span class="game-cell">
                                  {{ homework.opposition }} -
                                  {{ formatDate(homework.matchDate) }}
                                </span>
                              </td>
                              <td>
                                <span class="title-cell">{{
                                  homework.title
                                }}</span>
                              </td>
                              <td>
                                <div class="action-buttons">
                                  <button
                                    class="action-btn view"
                                    @click="
                                      viewHomework(homework, 'playerCvData')
                                    "
                                    title="View"
                                  >
                                    <i class="bi bi-eye"></i>
                                  </button>
                                  <button
                                    v-if="
                                      (userData.userType === 'Admin' ||
                                        userData.userType === 'Coach') &&
                                      !$store.getters.isReadOnlySeason
                                    "
                                    class="action-btn edit"
                                    @click="
                                      editHomeworkMdalCall(
                                        homework,
                                        'playerCvData',
                                      )
                                    "
                                    title="Edit"
                                  >
                                    <i class="bi bi-pencil"></i>
                                  </button>
                                  <button
                                    v-if="
                                      (userData.userType === 'Admin' ||
                                        userData.userType === 'Coach') &&
                                      !$store.getters.isReadOnlySeason
                                    "
                                    class="action-btn delete"
                                    @click="deleteHomework(homework.id)"
                                    title="Delete"
                                  >
                                    <i class="bi bi-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Mobile Card View -->
                        <div class="homework-cards mobile-only">
                          <div
                            class="homework-card"
                            v-for="homework in allHomeWorkData"
                            :key="'player-mobile-' + homework.id"
                          >
                            <div class="homework-card-header">
                              <div class="homework-date">
                                <i class="bi bi-calendar3"></i>
                                {{ formatDateForHuman(homework.created_date) }}
                              </div>
                            </div>
                            <div class="homework-card-body">
                              <div class="homework-title">
                                {{ homework.title }}
                              </div>
                              <div class="homework-game">
                                <i class="bi bi-trophy"></i>
                                {{ homework.opposition }} -
                                {{ formatDate(homework.matchDate) }}
                              </div>
                            </div>
                            <div class="homework-card-actions">
                              <button
                                class="action-btn view"
                                @click="viewHomework(homework, 'playerCvData')"
                              >
                                <i class="bi bi-eye"></i> View
                              </button>
                              <div
                                class="action-btns-right"
                                v-if="
                                  (userData.userType === 'Admin' ||
                                    userData.userType === 'Coach') &&
                                  !$store.getters.isReadOnlySeason
                                "
                              >
                                <button
                                  class="action-btn edit"
                                  @click="
                                    editHomeworkMdalCall(
                                      homework,
                                      'playerCvData',
                                    )
                                  "
                                >
                                  <i class="bi bi-pencil"></i>
                                </button>
                                <button
                                  class="action-btn delete"
                                  @click="deleteHomework(homework.id)"
                                >
                                  <i class="bi bi-trash"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-else class="empty-state-modern">
                        <div class="empty-icon">
                          <i class="bi bi-journal-x"></i>
                        </div>
                        <h4>No Player Homework</h4>
                        <p>No homework assignments have been added yet.</p>
                      </div>
                    </div>
                  </div>

                  <!-- Team Homework Section -->
                  <div class="homework-section-card">
                    <div class="homework-section-header team">
                      <div class="section-title">
                        <i class="bi bi-people"></i>
                        <h3>Team Homework</h3>
                        <span
                          class="badge-count team"
                          v-if="allTeamWorkData.length > 0"
                          >{{ allTeamWorkData.length }}</span
                        >
                      </div>
                    </div>

                    <div class="homework-section-content">
                      <!-- Desktop Table View -->
                      <div
                        v-if="allTeamWorkData.length > 0"
                        class="homework-table-wrapper"
                      >
                        <table class="homework-table-modern desktop-only">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Game</th>
                              <th>Title</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="homework in allTeamWorkData"
                              :key="homework.id"
                            >
                              <td>
                                <span class="date-cell">
                                  <i class="bi bi-calendar3"></i>
                                  {{
                                    formatDateForHuman(homework.created_date)
                                  }}
                                </span>
                              </td>
                              <td>
                                <span class="game-cell">
                                  {{ homework.opposition }} -
                                  {{ formatDate(homework.matchDate) }}
                                </span>
                              </td>
                              <td>
                                <span class="title-cell">{{
                                  homework.title
                                }}</span>
                              </td>
                              <td>
                                <div class="action-buttons">
                                  <button
                                    class="action-btn view"
                                    @click="
                                      viewHomework(homework, 'teamVideos')
                                    "
                                    title="View"
                                  >
                                    <i class="bi bi-eye"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Mobile Card View -->
                        <div class="homework-cards mobile-only">
                          <div
                            class="homework-card"
                            v-for="homework in allTeamWorkData"
                            :key="'team-mobile-' + homework.id"
                          >
                            <div class="homework-card-header">
                              <div class="homework-date">
                                <i class="bi bi-calendar3"></i>
                                {{ formatDateForHuman(homework.created_date) }}
                              </div>
                            </div>
                            <div class="homework-card-body">
                              <div class="homework-title">
                                {{ homework.title }}
                              </div>
                              <div class="homework-game">
                                <i class="bi bi-trophy"></i>
                                {{ homework.opposition }} -
                                {{ formatDate(homework.matchDate) }}
                              </div>
                            </div>
                            <div class="homework-card-actions">
                              <button
                                class="action-btn view"
                                @click="viewHomework(homework, 'teamVideos')"
                              >
                                <i class="bi bi-eye"></i> View
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-else class="empty-state-modern">
                        <div class="empty-icon team">
                          <i class="bi bi-journal-x"></i>
                        </div>
                        <h4>No Team Homework</h4>
                        <p>No team homework has been shared yet.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'wellness-tab'"
              >
                <div class="games-info">
                  <div class="button-wrapper-top">
                    <b-button
                      v-if="
                        userData.userType !== 'Admin' &&
                        userData.userType !== 'Coach'
                      "
                      class="main-button"
                      @click="showModal('viewDailyWellnessReport')"
                      size="lg"
                      v-b-tooltip.hover
                      title="Submit daily mood
                    report"
                      variant="outline-success"
                    >
                      <i class="bi bi-emoji-smile"></i>
                    </b-button>

                    <b-button
                      v-if="
                        userData.userType === 'Admin' ||
                        userData.userType === 'Coach' ||
                        userData.id === '964'
                      "
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      @click="
                        download_csv(
                          thisSeasionsPlayerMoodData,
                          'player-Mood-Reports',
                        )
                      "
                      title="Export player wellness information to csv"
                    >
                      <i class="bi bi-download" aria-hidden="true"></i>
                    </b-button>

                    <!--<b-button
                    v-if="
                      userData.userType === 'Admin' ||
                      userData.userType !== 'Coach' ||
                      userData.id === '964'
                    "
                    size="lg"
                    class="main-button"
                    variant="outline-success"
                    v-b-tooltip.hover
                    title="Import player wellness information"
                    ><i class="bi bi-upload" aria-hidden="true"></i
                  ></b-button>-->

                    <b-button
                      v-if="
                        userData.userType === 'Admin' ||
                        userData.userType !== 'Coach' ||
                        userData.id === '964'
                      "
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Email player wellness information"
                    >
                      <i class="bi bi-envelope" aria-hidden="true"></i>
                    </b-button>

                    <p v-if="playerMoodData.date !== undefined">
                      Your last submitted a Mood and wellness score on
                      {{ formatDate(playerMoodData.date) }}
                    </p>
                    <p v-else class="days-red-warning">
                      <i
                        class="bi bi-exclamation-circle"
                        aria-hidden="true"
                      ></i>
                      Please submit your first Mood and wellness score
                    </p>
                  </div>

                  <div class="player-performance-review-info">
                    <div class="mood-data">
                      <div
                        class="season-view-controls"
                        style="margin-bottom: 1rem"
                      >
                        <b-button-group size="sm">
                          <b-button
                            :variant="
                              !showLastSeasonWellness
                                ? 'success'
                                : 'outline-secondary'
                            "
                            @click="showLastSeasonWellness = false"
                          >
                            <i
                              class="bi bi-calendar-check"
                              aria-hidden="true"
                            ></i>
                            This Season
                          </b-button>
                          <b-button
                            :variant="
                              showLastSeasonWellness
                                ? 'success'
                                : 'outline-secondary'
                            "
                            @click="
                              showLastSeasonWellness = true;
                              getLastSeasonsPlayerMoodData();
                            "
                          >
                            <i
                              class="bi bi-calendar-date"
                              aria-hidden="true"
                            ></i>
                            Last Season
                          </b-button>
                        </b-button-group>
                      </div>
                      <wellness-mood-summary
                        :playerMoodData="playerMoodData"
                        :thisSeasionsPlayerMoodData="
                          showLastSeasonWellness
                            ? lastSeasonsPlayerMoodData
                            : thisSeasionsPlayerMoodData
                        "
                        v-if="
                          (showLastSeasonWellness
                            ? lastSeasonsPlayerMoodData.length
                            : thisSeasionsPlayerMoodData.length) > 0
                        "
                      />

                      <wellness-calendar
                        :moodData="
                          showLastSeasonWellness
                            ? lastSeasonsPlayerMoodData
                            : thisSeasionsPlayerMoodData
                        "
                        :canAdd="
                          userData.userType !== 'Admin' &&
                          userData.userType !== 'Coach'
                        "
                        @add-day="showWellnessByDay($event)"
                      />
                    </div>

                    <!-- <div class="player-weight-height-stats">

                    <h3>Player health stats</h3>

                    <div
                    class="charts">
                    <h3>Height</h3>
                    <p>{{ selectedUserData.height }} cm</p>

                    <b-button
                      class="main-button"
                      @click="showModal('addHeight')"
                      size="lg"
                      variant="outline-success"
                      ><i class="bi bi-person-lines-fill"></i> Record
                      height</b-button
                    >
                  </div>

                  <div
                    class="charts">
                    <h3>Weight</h3>
                    <p>{{ selectedUserData.weight }} kg</p>

                    <b-button
                      class="main-button"
                      @click="showModal('addWeight')"
                      size="lg"
                      variant="outline-success"
                      ><i class="bi bi-person-check-fill"></i> Record
                      Weight</b-button
                    >
                  </div>



                  </div>-->
                  </div>
                </div>
              </div>
              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'injury-tab'"
              >
                <PlayerInjuryReport
                  :userData="userData"
                  :selectedUserData="selectedUserData"
                  :currentPlayingSeason="currentPlayingSeason"
                  :selectedUserValue="selectedUserValue"
                  v-if="
                    currentPlayingSeason !== null &&
                    selectedUserValue !== undefined
                  "
                />
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'review-tab'"
              >
                <!-- Performance Reviews Section -->
                <div class="review-tab-container">
                  <!-- Coach Performance Reviews Card -->
                  <div class="review-section-card">
                    <div class="section-header">
                      <div class="section-title">
                        <i class="bi bi-clipboard-check"></i>
                        <h3>Coach Performance Reviews</h3>
                      </div>
                      <div
                        class="section-actions"
                        v-if="
                          userData.userType === 'Admin' ||
                          userData.userType === 'Coach'
                        "
                      >
                        <b-button
                          class="action-btn primary"
                          @click="openNewCoachPerformanceReviewModal('Coach')"
                          size="md"
                          variant="success"
                        >
                          <i class="bi bi-plus-lg"></i> New Review
                        </b-button>
                      </div>
                    </div>

                    <div class="section-content">
                      <div class="table-scroll performance-reviews-data">
                        <!-- Desktop Table View -->
                        <table
                          v-if="
                            allPlayerCoachSignedPerformanceReportData.length > 0
                          "
                          class="reviews-table desktop-only"
                        >
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Report</th>
                              <th>Status</th>
                              <th>Coach</th>
                              <th v-if="userData.userType !== 'User'">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="review in allPlayerCoachSignedPerformanceReportData"
                              :key="review.id"
                            >
                              <td>
                                {{ formatDateForHuman(review.created_date) }}
                              </td>
                              <td>
                                <a
                                  class="report-link"
                                  @click="
                                    openNewCoachPerformanceReviewModal(
                                      'Player',
                                      review.id,
                                    )
                                  "
                                  href="javascript:;"
                                >
                                  <i class="bi bi-file-text"></i> View Details
                                </a>
                              </td>
                              <td>
                                <span
                                  v-if="review.published === 1"
                                  class="status-badge published"
                                >
                                  <i class="bi bi-check-circle-fill"></i>
                                  Published
                                </span>
                                <span v-else class="status-badge draft">
                                  {{ review.status }}
                                  <span
                                    v-b-tooltip.hover
                                    title="No player signature"
                                    v-if="review.player_signature_id === null"
                                  >
                                    <i class="bi bi-pencil-square"></i>
                                  </span>
                                  <span
                                    v-b-tooltip.hover
                                    title="No coach signature"
                                    v-if="review.coach_signature_id === null"
                                  >
                                    <i class="bi bi-pencil-square"></i>
                                  </span>
                                </span>
                              </td>
                              <td>{{ review.name }}</td>
                              <td
                                class="action-buttons"
                                v-if="userData.userType !== 'User'"
                              >
                                <b-button
                                  @click="
                                    deletePlayerCoachAssessment(review.id)
                                  "
                                  variant="outline-danger"
                                  size="sm"
                                  v-b-tooltip.hover
                                  title="Delete"
                                >
                                  <i class="bi bi-trash"></i>
                                </b-button>
                                <b-button
                                  v-if="
                                    review.published === 1 &&
                                    userData.userType !== 'User'
                                  "
                                  @click="
                                    produceThePlayerCoachReportPDF(review)
                                  "
                                  variant="outline-success"
                                  size="sm"
                                  v-b-tooltip.hover
                                  title="Print"
                                >
                                  <i class="bi bi-printer"></i>
                                </b-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Mobile Card View -->
                        <div
                          v-if="
                            allPlayerCoachSignedPerformanceReportData.length > 0
                          "
                          class="reviews-cards mobile-only"
                        >
                          <div
                            class="review-card"
                            v-for="review in allPlayerCoachSignedPerformanceReportData"
                            :key="'mobile-' + review.id"
                          >
                            <div class="review-card-header">
                              <div class="review-date">
                                <i class="bi bi-calendar3"></i>
                                {{ formatDateForHuman(review.created_date) }}
                              </div>
                              <span
                                v-if="review.published === 1"
                                class="status-badge published"
                              >
                                <i class="bi bi-check-circle-fill"></i>
                                Published
                              </span>
                              <span v-else class="status-badge draft">
                                {{ review.status }}
                              </span>
                            </div>
                            <div class="review-card-body">
                              <div class="review-info-row">
                                <span class="info-label">Coach:</span>
                                <span class="info-value">{{
                                  review.name
                                }}</span>
                              </div>
                            </div>
                            <div class="review-card-actions">
                              <a
                                class="action-btn view"
                                @click="
                                  openNewCoachPerformanceReviewModal(
                                    'Player',
                                    review.id,
                                  )
                                "
                                href="javascript:;"
                              >
                                <i class="bi bi-file-text"></i> View Details
                              </a>
                              <div
                                class="action-btns-right"
                                v-if="userData.userType !== 'User'"
                              >
                                <button
                                  class="action-btn print"
                                  v-if="review.published === 1"
                                  @click="
                                    produceThePlayerCoachReportPDF(review)
                                  "
                                  title="Print"
                                >
                                  <i class="bi bi-printer"></i>
                                </button>
                                <button
                                  class="action-btn delete"
                                  @click="
                                    deletePlayerCoachAssessment(review.id)
                                  "
                                  title="Delete"
                                >
                                  <i class="bi bi-trash"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="
                            allPlayerCoachSignedPerformanceReportData.length ===
                            0
                          "
                          class="empty-state-card"
                        >
                          <i class="bi bi-clipboard-x"></i>
                          <p>No performance reviews yet</p>
                          <span
                            class="empty-hint"
                            v-if="
                              userData.userType === 'Admin' ||
                              userData.userType === 'Coach'
                            "
                          >
                            Click "New Review" to create the first one
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- OLD BIOBAND INLINE CODE - HIDDEN -->
                  <div
                    v-if="false"
                    class="review-section-card bioband-section-old"
                    style="display: none"
                  >
                    <div class="section-content">
                      <div class="physical-performance-wrapper">
                        <div
                          class="physical-performance-stats"
                          :class="{ 'last-season-theme': showLastSeasonView }"
                        >
                          <div
                            id="bioband-widget"
                            class="bioband-calculator-container"
                          >
                            <!-- IMPERIAL OR METRIC SELECTOR (hidden, kept for compatibility) -->
                            <div
                              class="row p-3 border-bottom border-white border-1"
                              style="display: none"
                            >
                              <div class="col-8">
                                <span style="font-size: small"
                                  >How would you prefer to enter the height and
                                  weight measurements?</span
                                >
                              </div>
                              <div
                                class="col-4 d-flex justify-content-center align-items-center"
                              >
                                <div>
                                  <div
                                    style="height: 5px"
                                    class="form-check form-check-inline"
                                  >
                                    <input
                                      id="imperial"
                                      class="form-check-input"
                                      type="radio"
                                      checked=""
                                      @click="setMeasurement()"
                                      name="imperial"
                                    />
                                    <label
                                      style="font-size: small"
                                      class="form-check-label"
                                      for="imperial"
                                      >Imperial
                                    </label>
                                  </div>
                                  <div class="form-check form-check-inline">
                                    <div>
                                      <input
                                        id="metric"
                                        class="form-check-input"
                                        type="radio"
                                        @click="setMeasurement()"
                                        name="imperial"
                                      />
                                      <label
                                        style="font-size: small"
                                        class="form-check-label"
                                        for="metric"
                                        >Metric
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- INPUT ROW (IMPERIAL)-->
                            <div
                              id="imperial-row"
                              style="display: flex"
                              class="row p-3 justify-content-center align-items-center text-center bioband-form"
                            >
                              <div class="row needs-validation" novalidate="">
                                <!-- fathers height -->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="fathers-height-ft"
                                    class="form-label"
                                    >Father's Height</label
                                  >
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="fathers-height-ft"
                                      type="number"
                                      class="form-control"
                                      min="1"
                                      max="7"
                                      placeholder="ft"
                                      required=""
                                    />
                                    <input
                                      id="fathers-height-in"
                                      type="number"
                                      step="any"
                                      class="form-control"
                                      min="0"
                                      max="12"
                                      placeholder="in"
                                      required=""
                                    />
                                  </div>
                                </div>
                                <!-- mothers height -->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="mothers-height-ft"
                                    class="form-label"
                                    >Mother's Height</label
                                  >
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="mothers-height-ft"
                                      type="number"
                                      class="form-control"
                                      min="1"
                                      max="7"
                                      placeholder="ft"
                                      required=""
                                    />
                                    <input
                                      id="mothers-height-in"
                                      type="number"
                                      step="any"
                                      class="form-control"
                                      min="0"
                                      max="12"
                                      placeholder="in"
                                      required=""
                                    />
                                  </div>
                                </div>
                                <!-- Childs DOB-->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="childs-dob-imperial"
                                    class="form-label"
                                    >Child's DOB</label
                                  >
                                  <input
                                    id="childs-dob-imperial"
                                    type="date"
                                    class="form-control form-control-sm"
                                    required=""
                                  />
                                </div>
                                <!-- Childs Height-->
                                <div class="col-12 col-md-6 pb-3">
                                  <label
                                    for="childs-height-ft"
                                    class="form-label"
                                    >Child's Height</label
                                  >
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="childs-height-ft"
                                      type="number"
                                      class="form-control"
                                      min="1"
                                      max="7"
                                      placeholder="ft"
                                      required=""
                                    />
                                    <input
                                      id="childs-height-in"
                                      type="number"
                                      step="any"
                                      class="form-control"
                                      min="0"
                                      max="12"
                                      placeholder="in"
                                      required=""
                                    />
                                  </div>
                                </div>
                                <!-- Sitting Height (optional - for PHV calculation) -->
                                <div class="col-12 col-md-6 pb-3">
                                  <label
                                    for="sitting-height-ft"
                                    class="form-label"
                                  >
                                    Sitting Height
                                    <span class="optional-label"
                                      >(optional)</span
                                    >
                                  </label>
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="sitting-height-ft"
                                      type="number"
                                      class="form-control"
                                      min="1"
                                      max="4"
                                      placeholder="ft"
                                    />
                                    <input
                                      id="sitting-height-in"
                                      type="number"
                                      step="any"
                                      class="form-control"
                                      min="0"
                                      max="12"
                                      placeholder="in"
                                    />
                                  </div>
                                  <small class="form-hint"
                                    >For maturity timing (PHV)
                                    calculation</small
                                  >
                                </div>
                                <!-- Childs Weight -->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="childs-weight-st"
                                    class="form-label"
                                    >Child's Weight</label
                                  >
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="childs-weight-st"
                                      type="number"
                                      class="form-control"
                                      min="1"
                                      max="68"
                                      placeholder="st"
                                      required=""
                                    />
                                    <input
                                      id="childs-weight-lb"
                                      type="number"
                                      step="any"
                                      class="form-control"
                                      min="0"
                                      max="14"
                                      placeholder="lb"
                                      required=""
                                    />
                                  </div>
                                </div>
                                <!-- Gender Radio -->
                                <div class="col-12 col-md-4 pb-3">
                                  <label class="form-label">Gender</label>
                                  <div class="gender-toggle">
                                    <label class="gender-option">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="gender-imperial"
                                        id="male-imperial"
                                      />
                                      <span
                                        ><i class="bi bi-gender-male"></i>
                                        Male</span
                                      >
                                    </label>
                                    <label class="gender-option">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="gender-imperial"
                                        id="female-imperial"
                                        required=""
                                      />
                                      <span
                                        ><i class="bi bi-gender-female"></i>
                                        Female</span
                                      >
                                    </label>
                                  </div>
                                </div>
                                <!-- Generate results button -->
                                <div
                                  class="col-12 col-md-4 pb-3 d-flex align-items-end"
                                >
                                  <button
                                    id="show-results-button-imperial"
                                    @click="showResultsImperial('save')"
                                    class="btn btn-success calculate-btn"
                                  >
                                    <i class="bi bi-calculator"></i> Calculate
                                    Bio Age
                                  </button>
                                  <div
                                    id="spinner-imperial"
                                    style="display: none"
                                    class="spinner-wrapper"
                                  >
                                    <div
                                      class="spinner-border text-success"
                                      role="status"
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- INPUT ROW (METRIC)-->
                            <div
                              id="metric-row"
                              style="display: none"
                              class="row p-3 justify-content-center align-items-center text-center bioband-form"
                            >
                              <form
                                class="row needs-validation"
                                novalidate=""
                                @click="showResultsMetric('save')"
                              >
                                <!-- fathers height -->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="fathers-height-cm"
                                    class="form-label"
                                    >Father's Height</label
                                  >
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="fathers-height-cm"
                                      type="number"
                                      step="any"
                                      class="form-control"
                                      min="30"
                                      max="251"
                                      placeholder="cm"
                                      required=""
                                    />
                                  </div>
                                </div>
                                <!-- mothers height -->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="mothers-height-cm"
                                    class="form-label"
                                    >Mother's Height</label
                                  >
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="mothers-height-cm"
                                      type="number"
                                      step="any"
                                      class="form-control form-control-sm"
                                      min="30"
                                      max="251"
                                      placeholder="cm"
                                      required=""
                                    />
                                  </div>
                                </div>
                                <!-- Childs DOB-->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="childs-dob-metric"
                                    class="form-label"
                                    >Child's DOB</label
                                  >
                                  <input
                                    id="childs-dob-metric"
                                    type="date"
                                    class="form-control form-control-sm"
                                    required=""
                                  />
                                </div>
                                <!-- Childs Height-->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="childs-height-cm"
                                    class="form-label"
                                    >Child's Height</label
                                  >
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="childs-height-cm"
                                      type="number"
                                      step="any"
                                      class="form-control form-control-sm"
                                      min="30"
                                      max="251"
                                      placeholder="cm"
                                      required=""
                                    />
                                  </div>
                                </div>
                                <!-- Sitting Height (optional - for PHV calculation) -->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="sitting-height-cm"
                                    class="form-label"
                                  >
                                    Sitting Height
                                    <span class="optional-label"
                                      >(optional)</span
                                    >
                                  </label>
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="sitting-height-cm"
                                      type="number"
                                      step="any"
                                      class="form-control form-control-sm"
                                      min="30"
                                      max="130"
                                      placeholder="cm"
                                    />
                                  </div>
                                  <small class="form-hint"
                                    >For maturity timing (PHV)
                                    calculation</small
                                  >
                                </div>
                                <!-- Childs Weight -->
                                <div class="col-12 col-md-4 pb-3">
                                  <label
                                    for="childs-weight-kg"
                                    class="form-label"
                                    >Child's Weight</label
                                  >
                                  <div class="input-group input-group-sm">
                                    <input
                                      id="childs-weight-kg"
                                      type="number"
                                      step="any"
                                      class="form-control form-control-sm"
                                      min="1"
                                      max="442"
                                      placeholder="kg"
                                      required=""
                                    />
                                  </div>
                                </div>
                                <!-- Gender Radio -->
                                <div class="col-12 col-md-6 pb-3">
                                  <label class="form-label">Gender</label>
                                  <div class="gender-toggle">
                                    <label class="gender-option">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="male-metric"
                                      />
                                      <span
                                        ><i class="bi bi-gender-male"></i>
                                        Male</span
                                      >
                                    </label>
                                    <label class="gender-option">
                                      <input
                                        class="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="female-metric"
                                        required=""
                                      />
                                      <span
                                        ><i class="bi bi-gender-female"></i>
                                        Female</span
                                      >
                                    </label>
                                  </div>
                                </div>
                                <!-- Generate results button -->
                                <div
                                  class="col-12 col-md-6 pb-3 d-flex align-items-end"
                                >
                                  <button
                                    id="show-results-button-metric"
                                    type="submit"
                                    class="btn btn-success calculate-btn"
                                  >
                                    <i class="bi bi-calculator"></i> Calculate
                                    Bio Age
                                  </button>
                                  <div
                                    id="spinner-metric"
                                    style="display: none"
                                    class="spinner-wrapper"
                                  >
                                    <div
                                      class="spinner-border text-success"
                                      role="status"
                                    ></div>
                                  </div>
                                </div>
                              </form>
                            </div>
                            <!-- ERROR ROW -->
                            <div
                              id="error-pane"
                              style="display: none"
                              class="error-pane"
                            >
                              <div
                                id="error-message"
                                class="alert alert-danger"
                                role="alert"
                              >
                                <i class="bi bi-exclamation-circle"></i>
                                <span
                                  >Sorry, we are unable to bioband
                                  {{ selectedUserData.name }} at the moment.
                                  Please try again later.</span
                                >
                              </div>
                            </div>
                            <!-- RESULTS ROW -->
                            <div
                              id="results-pane"
                              style="display: none"
                              class="row bioband-results"
                            >
                              <div class="col">
                                <!-- RESULTS ROW -->
                                <div class="row">
                                  <!-- B1 HEIGHTS GRID-->
                                  <div
                                    style="background-color: white"
                                    class="text-black col-12 border-end border-right border-bottom border-white border-2 rounded-8 bioband-heights-grid"
                                  >
                                    <div
                                      class="row align-items-center justify-content-center pt-3 bioband-section-title"
                                    >
                                      {{ selectedUserData.name }} Estimated
                                      Adult Height
                                    </div>
                                    <div
                                      class="gallery heights-gallery"
                                      style="
                                        display: grid;
                                        grid-template-columns: repeat(21, 5%);
                                        grid-template-rows: repeat(17, 17px);
                                      "
                                    >
                                      <!-- FATHER -->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 2;
                                          grid-column-end: 10;
                                          grid-row-start: 15;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="father-height-human"
                                          id="father-height-human"
                                          height="200px"
                                          viewBox="250 50 600 1500"
                                        >
                                          <g
                                            id="g158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g id="g160" transform="scale(0.1)">
                                              <path
                                                d="m 5892.55,6114.67 c 13.77,456.2 3.09,912.57 -27.09,1367.98 -12.68,191.43 -12.21,335.47 -54.9,499.54 -33.52,128.85 -97.3,268.31 -89.09,404 15.19,250.76 -11.93,535.86 -99.01,778.58 -66.27,184.72 -224.21,335.97 -394.53,424.86 -119.24,62.23 -246.92,107.6 -364.23,173.39 -67.6,33.8 -157.04,89.55 -228.36,155.16 -80.83,74.36 -141.23,151.42 -172.13,233.52 -3.16,8.4 -4.82,16.5 -5.32,24.3 0.9,28.1 16.3,52.9 32.4,77.5 20.01,30.5 42.23,65.7 57.29,101 13.48,31.7 21.67,73.3 47.7,99.4 9.21,9.3 18.13,-11.2 41.44,8.9 18.38,15.8 29.04,43.2 34.92,64.9 5.8,21.4 7.1,43.8 12.92,66 9.9,37.9 23.97,76.1 30.87,113 4.53,24.3 8.95,61.2 -11.61,80.8 -9.01,8.5 -37.51,24.5 -43.91,3.3 43.75,145.1 65.75,320.4 48.23,471.8 -6.36,54.9 -22.95,120.3 -57.03,165 -23.25,30.5 -103.76,46.3 -48.53,72.4 -35.37,14.8 -64.47,1.4 -98.34,6.8 -38.75,6.2 -17.57,-3.6 -45.67,35.1 -18.77,25.8 -34.37,26.6 -60.74,39.2 -26.19,12.6 -22.66,11.8 -43.68,33.6 -23.57,-24.6 -27.45,-11.8 -50.23,-9.3 -30.22,3.2 -62.61,-2.3 -92.32,1.9 -33.85,4.9 -60.8,24.7 -96.41,24.9 -35.63,0.2 -61.37,-12 -91.51,-28.8 -44.15,-24.5 -93.22,-21.8 -135.04,-50.6 -46.37,-32 -97.37,-55 -134.6,-100.2 -34.68,-42.1 -70.09,-78.9 -84.14,-132.1 -10.45,-39.5 -20.17,-79.9 -28.25,-120 -25.79,-128.1 -13.33,-284.1 28.78,-407.6 -99.58,17.9 -30.62,-167.7 -24.21,-207.1 10.42,-64 35.97,-133 75.9,-131.9 11.08,0.4 15.68,9.8 20.58,7.8 21.73,-8.9 29.11,-48.4 36.32,-67.7 19.97,-53.4 24.37,-66.4 52.3,-116.1 18.47,-32.8 45.81,-63.5 47.46,-103.2 -4.29,-101.9 -83.76,-179.98 -155.71,-244.46 -76.1,-68.19 -162.01,-117.58 -250.52,-167.22 -117.31,-65.79 -244.99,-111.16 -364.23,-173.39 -170.32,-88.89 -328.26,-240.14 -394.53,-424.86 -87.08,-242.72 -114.2,-527.82 -99.01,-778.58 8.21,-135.69 -55.57,-275.15 -89.09,-404 -42.69,-164.07 -42.22,-308.11 -54.9,-499.54 -30.18,-455.41 -40.86,-911.78 -27.09,-1367.98 -35.37,-150.74 -67.29,-300.88 -63.37,-457.66 4.48,-179.49 91.37,-432.7 245.89,-556.87 37.72,-30.31 95.19,3.75 83.06,50.59 -1.36,5.26 -3.56,10.17 -6.79,14.53 -47.84,64.38 -68.86,110.31 -96.15,185.74 -22.24,61.47 -42.1,145.51 -23.58,210.54 12.73,44.7 56.77,74.59 89.76,32.58 34.21,-43.56 16.11,-168.21 18.61,-222.48 1.03,-22.47 2.76,-46.76 17.39,-63.85 54.47,-63.63 84.03,61.99 89.26,98.1 14.2,98.24 -5.23,203.03 -13.14,301.22 -6.91,85.64 -12.68,272.48 -15.03,276.56 2.95,28.8 6.87,57.89 11.97,87.34 0.01,0 1.87,0 1.87,0 0,0 10.39,63.38 114.89,533.17 65.87,296.15 32.46,290.84 129.46,580.3 68.86,205.44 149.98,410.67 174.81,627.46 10.6,92.54 1.45,182.46 -0.44,274.97 -0.48,23.23 -11.45,163.09 30.96,163.09 20.38,0 33.89,-205.01 42.11,-439.97 8.66,-247.74 67.61,-485.95 66.48,-723.79 -1.12,-237.84 -62.32,-475.31 -93.11,-721.6 -38.64,-309.08 -85,-625.88 -15.45,-1228.58 40.05,-347.12 125.03,-700.39 148.29,-1054.16 24.41,-371.42 -66.8,-738.84 -37.96,-1109.34 25.95,-333.54 100.63,-663.26 221.21,-975.36 60.05,-155.4 110.66,-310.2 122.71,-476.3 3.16,-43.6 7.5,-87.3 12.51,-131 h -0.03 c 0.61,-5.4 1.29,-10.7 1.93,-16.1 1.28,-10.8 2.53,-21.6 3.9,-32.4 2.25,-18 4.58,-35.9 7.04,-53.7 11.54,-140.8 6.21,-287.798 -46.37,-422.001 -55.79,-142.398 -98.01,-238.297 -103.05,-305.297 -8.48,-112.8 78.86,-139.3 242.17,-167.601 226.67,-39.301 257.51,254.5 251.07,417.5 -3.27,82.801 30.44,208.499 26.04,291.399 0.3,0.2 0.5,0.4 0.48,0.8 0,0 -2.76,57.5 -6.92,147.5 h 0.02 c -0.03,0.7 -0.06,1.3 -0.09,2 -0.39,12.4 -0.79,24.8 -1.05,37.1 h -0.67 c -13.43,292.3 -17.64,841.5 -17.64,1003.45 0,283.15 56.68,424.12 19.24,847.82 -17.71,200.47 -91,412.48 -62.42,612.57 15.46,108.18 92.73,370.9 123.63,811.33 9.85,140.29 20.27,536.01 30.93,726.75 10.65,-190.74 21.07,-586.46 30.92,-726.75 30.9,-440.43 108.17,-703.15 123.63,-811.33 28.58,-200.09 -38.04,-412.81 -62.42,-612.57 -46.83,-383.7 19.24,-564.67 19.24,-847.82 0,-161.95 -4.21,-711.15 -17.64,-1003.45 h -0.67 c -0.26,-12.3 -0.66,-24.7 -1.05,-37.1 -0.03,-0.7 -0.06,-1.3 -0.09,-2 h 0.9 c -4.16,-90 -6.92,-147.5 -6.92,-147.5 -0.02,-0.4 0.18,-0.6 0.48,-0.8 -4.41,-82.9 29.31,-208.598 26.04,-291.399 -6.44,-163 24.4,-456.801 251.07,-417.5 163.31,28.301 250.65,54.801 242.17,167.601 -5.05,67 -47.26,162.899 -103.05,305.297 -52.58,134.203 -57.92,281.201 -46.37,422.001 4.67,33.9 8.96,68 12.87,102.2 h -0.91 c 5.01,43.7 9.35,87.4 12.51,131 12.05,166.1 62.66,320.9 122.71,476.3 120.58,312.1 195.26,641.82 221.21,975.36 28.84,370.5 -62.37,737.92 -37.95,1109.34 23.25,353.77 108.23,707.04 148.28,1054.16 69.55,602.7 23.19,919.5 -15.45,1228.58 -30.79,246.29 -91.99,483.76 -93.12,721.6 -1.12,237.84 57.83,476.05 66.49,723.79 8.22,234.96 21.73,439.97 42.11,439.97 42.41,0 31.44,-139.86 30.96,-163.09 -1.89,-92.51 -11.04,-182.43 -0.44,-274.97 24.83,-216.79 105.95,-422.02 174.81,-627.46 97.01,-289.46 63.59,-284.15 129.47,-580.3 104.49,-469.79 114.87,-533.17 114.87,-533.17 0,0 1.86,0 1.88,0 5.1,-29.45 9.02,-58.54 11.97,-87.34 -2.35,-4.08 -8.12,-190.92 -15.03,-276.56 -7.91,-98.19 -27.34,-202.98 -13.14,-301.22 5.23,-36.11 34.79,-161.73 89.26,-98.1 14.63,17.09 16.36,41.38 17.39,63.85 2.5,54.27 -15.6,178.92 18.61,222.48 32.99,42.01 77.03,12.12 89.76,-32.58 18.52,-65.03 -1.34,-149.07 -23.58,-210.54 -27.29,-75.43 -48.31,-121.36 -96.15,-185.74 -3.23,-4.36 -5.43,-9.27 -6.79,-14.53 -12.13,-46.84 45.34,-80.9 83.06,-50.59 154.52,124.17 241.4,377.38 245.89,556.87 3.92,156.78 -28,306.92 -63.37,457.66"
                                                style="
                                                  fill: #fd85a0;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="path164"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 2;
                                          grid-column-end: 10;
                                          grid-row-start: 16;
                                          grid-row-end: 17;
                                        "
                                      >
                                        <div style="font-size: small">
                                          Father
                                        </div>
                                      </div>
                                      <div
                                        id="father-height"
                                        class="d-flex align-items-start justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 2;
                                          grid-column-end: 10;
                                          grid-row-start: 2;
                                          grid-row-end: 15;
                                        "
                                      >
                                        <div
                                          id="father-height-text"
                                          style="
                                            display: block;
                                            font-size: xx-small;
                                            height: 50px;
                                          "
                                        >
                                          200cm
                                        </div>
                                      </div>
                                      <!-- MOTHER -->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 6;
                                          grid-column-end: 14;
                                          grid-row-start: 15;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="mother-height-human"
                                          id="mother-height-human"
                                          height="200px"
                                          viewBox="800 125 600 1420"
                                        >
                                          <g
                                            id="motg158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g
                                              id="motg160"
                                              transform="scale(0.1)"
                                            >
                                              <path
                                                d="m 9688.49,6279.45 c -13.98,118.85 0,573.25 -34.96,762.01 -34.95,188.75 -69.91,286.62 -97.87,363.52 -27.96,76.9 -27.96,293.61 -48.93,475.38 -34.44,298.47 -9.3,633.87 -102.65,924.69 -112.88,351.63 -379.24,303.09 -602.97,394.17 -103.24,42.03 -196.68,97.51 -259.66,192.19 -6.71,10.1 -21.47,47.71 -37.05,93.15 h 33.6 c -1.91,2.17 -3.82,4.36 -5.67,6.6 2.73,0.47 5.45,1.02 8.17,1.5 1.96,0.3 3.91,0.66 5.82,1.07 8.55,1.55 17.09,3.05 25.63,4.71 h -11.17 c 7.53,3.51 14.04,8.63 18.61,16.18 -31.05,4.05 -59.73,24.92 -74.43,54.18 79.32,-29.77 174,-6.68 233.04,56.84 2.51,2.7 5.16,6.37 3.88,9.92 -0.78,2.17 -2.81,3.49 -4.72,4.65 -8.6,5.23 -103.87,75.93 -46.93,71.3 34.31,-2.8 112.8,-3.57 134.61,26.27 -17.46,16.47 -39.29,28.55 -54.26,48.21 -1.86,2.44 -25.82,33.14 -11.42,22.97 22.97,-16.22 69.15,-27.66 94.98,-22.28 -29.08,24.19 -55.83,48 -68.15,87.26 -7.64,24.36 49.83,73.09 65.16,198.96 15.33,125.9 -15.33,280.2 -65.15,430.4 -49.83,150.2 -95.82,320.8 -275.96,418.2 -180.13,97.5 -287.45,28.4 -287.45,28.4 0,0 -107.31,69.1 -287.45,-28.4 -180.13,-97.4 -226.12,-268 -275.95,-418.2 -49.82,-150.2 -80.48,-304.5 -65.15,-430.4 15.33,-125.87 72.8,-174.6 65.16,-198.96 -12.32,-39.26 -39.07,-63.07 -68.14,-87.26 25.82,-5.38 71.99,6.06 94.97,22.28 14.4,10.17 -9.56,-20.53 -11.42,-22.97 -14.97,-19.66 -36.8,-31.74 -54.26,-48.21 21.81,-29.84 100.3,-29.07 134.61,-26.27 56.94,4.63 -38.33,-66.07 -46.93,-71.3 -1.9,-1.16 -3.94,-2.48 -4.72,-4.65 -1.28,-3.55 1.37,-7.22 3.88,-9.92 59.04,-63.52 153.72,-86.61 233.04,-56.84 -14.7,-29.26 -43.38,-50.13 -74.43,-54.18 10.81,-17.85 32.41,-22.25 53.05,-23.38 v -6.68 h 21.94 c -15.58,-45.44 -30.34,-83.05 -37.05,-93.15 -62.98,-94.68 -156.42,-150.16 -259.66,-192.19 -223.74,-91.08 -490.1,-42.54 -602.97,-394.17 -93.35,-290.82 -68.21,-626.22 -102.65,-924.69 -20.97,-181.77 -20.97,-398.48 -48.93,-475.38 -27.96,-76.9 -62.92,-174.77 -97.87,-363.52 -34.96,-188.76 -20.98,-643.16 -34.96,-762.01 -13.98,-118.84 -13.98,-286.61 0,-510.32 6.46,-103.33 12.28,-211.18 28.3,-315.25 13.71,-89.06 44.79,-176.28 87.05,-255.71 17.69,-33.25 39.18,-65.08 61.43,-95.41 22.11,-30.15 71.65,-112.23 117.66,-100.33 11.66,3.02 20.18,13.81 23.17,25.48 8.9,34.71 -29.84,79.21 -44.3,108.9 -24.43,50.17 -38.96,102.54 -50.35,156.91 -6.89,32.9 -7.86,59.67 2.71,71.7 34.38,39.17 72.98,-193.35 120.01,-186.44 31.48,4.62 22.64,81.53 13.58,178.27 -9.14,97.64 -9.2,212.34 -50.02,303.34 -38.47,85.77 -95.36,170.99 -85.53,269.32 13.98,139.82 181.76,713.07 202.74,901.82 20.97,188.75 65.92,629.18 100.88,741.03 34.8,111.37 82.34,402.95 82.83,405.45 -2.63,-13.35 112.1,-151.76 123.82,-176.97 50.42,-108.43 65.33,-246.17 75.55,-363.98 36.86,-425.05 -133.11,-793.43 -243.27,-1192.76 -55.93,-202.74 -111.85,-713.07 -83.89,-908.81 27.96,-195.74 90.88,-608.2 160.79,-796.96 69.91,-188.75 153.8,-517.32 160.79,-629.17 4.74,-75.79 4.39,-280.99 -1.58,-469.97 h -0.04 c -2.84,-89.93 -6.95,-176.22 -12.4,-243.1 -12.7,-155.8 -13.99,-433.43 69.91,-824.94 87.49,-408.25 239.24,-1014.75 239.03,-1357.85 h 0.04 c 0.02,-0.3 -0.01,-0.6 0,-0.9 5.72,-94.198 0.45,-190.3 -34.38,-279.499 -40.2,-103 -60.62,-172.301 -64.25,-220.801 -6.12,-81.602 45.91,-106.898 164.5,-121.199 207.36,-25 195.56,184 190.92,301.898 -2.36,59.903 11.93,150.801 8.76,210.703 0.22,0.2 0.36,0.399 0.35,0.598 0,0 -1.99,41.602 -4.99,106.7 h 0.01 c -0.02,0.5 -0.04,1 -0.06,1.4 -0.01,0.4 -0.02,0.7 -0.03,1.1 h 0.27 c -0.17,2.3 -0.3,4.7 -0.47,7 -0.04,1.7 -0.09,3.3 -0.14,5 h -0.2 c -41.22,572.6 56.34,1151.46 53.73,1724.7 -1.37,300.3 -26.04,468.31 -33.82,673.92 -0.19,5.06 -0.29,10.16 -0.41,15.27 h 0.05 c -2.31,106.63 12.01,224.25 4.87,375.97 -10.41,220.95 -17.37,351.41 -4.59,652.17 6.97,164.16 60.97,419.12 57.63,578.73 -1.88,89.99 14.54,208.46 29.23,294.81 14.7,-86.35 31.12,-204.82 29.24,-294.81 -3.34,-159.61 48.56,-414.67 57.63,-578.73 13.67,-247.34 5.82,-431.22 -4.59,-652.17 -7.14,-151.72 7.18,-269.34 4.87,-375.97 h -0.21 c -0.11,-5.11 -0.22,-10.21 -0.41,-15.27 -7.77,-205.61 -32.44,-373.62 -33.81,-673.92 -2.62,-573.24 94.95,-1152.1 53.72,-1724.7 h -0.2 c -0.04,-1.7 -0.09,-3.3 -0.14,-5 -0.17,-2.3 -0.29,-4.7 -0.47,-7 h 0.28 c -0.01,-0.4 -0.02,-0.7 -0.03,-1.1 -0.02,-0.4 -0.05,-0.9 -0.07,-1.4 h 0.02 c -3,-65.098 -4.99,-106.7 -4.99,-106.7 -0.01,-0.199 0.13,-0.398 0.34,-0.598 -3.17,-59.902 11.13,-150.8 8.77,-210.703 -4.64,-117.898 -16.45,-326.898 190.92,-301.898 118.58,14.301 170.62,39.597 164.5,121.199 -3.63,48.5 -24.05,117.801 -64.26,220.801 -34.82,89.199 -40.09,185.301 -34.38,279.499 0.02,0.3 -0.01,0.6 0,0.9 h 0.05 c -0.21,343.1 151.54,949.6 239.03,1357.85 83.89,391.51 82.61,669.14 69.91,824.94 -5.45,66.88 -9.56,153.17 -12.4,243.1 h 0.21 c -5.97,188.98 -6.32,394.18 -1.58,469.97 6.99,111.85 90.88,440.42 160.79,629.17 69.91,188.76 132.83,601.22 160.79,796.96 27.96,195.74 -27.96,706.07 -83.89,908.81 -110.16,399.33 -280.13,767.71 -243.27,1192.76 10.22,117.81 25.13,255.55 75.55,363.98 11.72,25.21 126.45,163.62 123.82,176.97 0.49,-2.5 58.03,-294.08 92.83,-405.45 34.96,-111.85 69.91,-552.28 90.89,-741.03 20.97,-188.75 188.75,-762 202.73,-901.82 9.83,-98.33 -47.07,-183.55 -85.53,-269.32 -40.82,-91 -40.88,-205.7 -50.02,-303.34 -9.06,-96.74 -17.9,-173.65 13.58,-178.27 47.03,-6.91 85.63,225.61 120.01,186.44 10.57,-12.03 9.6,-38.8 2.71,-71.7 -11.39,-54.37 -25.92,-106.74 -50.35,-156.91 -14.46,-29.69 -53.2,-74.19 -44.3,-108.9 2.99,-11.67 11.51,-22.46 23.17,-25.48 46.01,-11.9 95.55,70.18 117.66,100.33 22.25,30.33 43.74,62.16 61.43,95.41 42.26,79.43 73.34,166.65 87.05,255.71 16.02,104.07 21.84,211.92 28.3,315.25 13.98,223.71 13.98,391.48 0,510.32"
                                                style="
                                                  fill: #b39fdb;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="motpath166"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 6;
                                          grid-column-end: 14;
                                          grid-row-start: 16;
                                          grid-row-end: 17;
                                        "
                                      >
                                        <div style="font-size: small">
                                          Mother
                                        </div>
                                      </div>
                                      <div
                                        id="mother-height"
                                        class="d-flex align-items-start justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 6;
                                          grid-column-end: 14;
                                          grid-row-start: 2;
                                          grid-row-end: 15;
                                        "
                                      >
                                        <div
                                          id="mother-height-text"
                                          style="
                                            display: block;
                                            font-size: xx-small;
                                            height: 50px;
                                          "
                                        >
                                          200cm
                                        </div>
                                      </div>
                                      <!--CHILD MALE-->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 10;
                                          grid-column-end: 18;
                                          grid-row-start: 15;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="child-height-human"
                                          id="child-height-male-human"
                                          style="display: none"
                                          height="200px"
                                          viewBox="250 50 600 1500"
                                        >
                                          <g
                                            id="chig158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g
                                              id="chig160"
                                              transform="scale(0.1)"
                                            >
                                              <path
                                                d="m 5892.55,6114.67 c 13.77,456.2 3.09,912.57 -27.09,1367.98 -12.68,191.43 -12.21,335.47 -54.9,499.54 -33.52,128.85 -97.3,268.31 -89.09,404 15.19,250.76 -11.93,535.86 -99.01,778.58 -66.27,184.72 -224.21,335.97 -394.53,424.86 -119.24,62.23 -246.92,107.6 -364.23,173.39 -67.6,33.8 -157.04,89.55 -228.36,155.16 -80.83,74.36 -141.23,151.42 -172.13,233.52 -3.16,8.4 -4.82,16.5 -5.32,24.3 0.9,28.1 16.3,52.9 32.4,77.5 20.01,30.5 42.23,65.7 57.29,101 13.48,31.7 21.67,73.3 47.7,99.4 9.21,9.3 18.13,-11.2 41.44,8.9 18.38,15.8 29.04,43.2 34.92,64.9 5.8,21.4 7.1,43.8 12.92,66 9.9,37.9 23.97,76.1 30.87,113 4.53,24.3 8.95,61.2 -11.61,80.8 -9.01,8.5 -37.51,24.5 -43.91,3.3 43.75,145.1 65.75,320.4 48.23,471.8 -6.36,54.9 -22.95,120.3 -57.03,165 -23.25,30.5 -103.76,46.3 -48.53,72.4 -35.37,14.8 -64.47,1.4 -98.34,6.8 -38.75,6.2 -17.57,-3.6 -45.67,35.1 -18.77,25.8 -34.37,26.6 -60.74,39.2 -26.19,12.6 -22.66,11.8 -43.68,33.6 -23.57,-24.6 -27.45,-11.8 -50.23,-9.3 -30.22,3.2 -62.61,-2.3 -92.32,1.9 -33.85,4.9 -60.8,24.7 -96.41,24.9 -35.63,0.2 -61.37,-12 -91.51,-28.8 -44.15,-24.5 -93.22,-21.8 -135.04,-50.6 -46.37,-32 -97.37,-55 -134.6,-100.2 -34.68,-42.1 -70.09,-78.9 -84.14,-132.1 -10.45,-39.5 -20.17,-79.9 -28.25,-120 -25.79,-128.1 -13.33,-284.1 28.78,-407.6 -99.58,17.9 -30.62,-167.7 -24.21,-207.1 10.42,-64 35.97,-133 75.9,-131.9 11.08,0.4 15.68,9.8 20.58,7.8 21.73,-8.9 29.11,-48.4 36.32,-67.7 19.97,-53.4 24.37,-66.4 52.3,-116.1 18.47,-32.8 45.81,-63.5 47.46,-103.2 -4.29,-101.9 -83.76,-179.98 -155.71,-244.46 -76.1,-68.19 -162.01,-117.58 -250.52,-167.22 -117.31,-65.79 -244.99,-111.16 -364.23,-173.39 -170.32,-88.89 -328.26,-240.14 -394.53,-424.86 -87.08,-242.72 -114.2,-527.82 -99.01,-778.58 8.21,-135.69 -55.57,-275.15 -89.09,-404 -42.69,-164.07 -42.22,-308.11 -54.9,-499.54 -30.18,-455.41 -40.86,-911.78 -27.09,-1367.98 -35.37,-150.74 -67.29,-300.88 -63.37,-457.66 4.48,-179.49 91.37,-432.7 245.89,-556.87 37.72,-30.31 95.19,3.75 83.06,50.59 -1.36,5.26 -3.56,10.17 -6.79,14.53 -47.84,64.38 -68.86,110.31 -96.15,185.74 -22.24,61.47 -42.1,145.51 -23.58,210.54 12.73,44.7 56.77,74.59 89.76,32.58 34.21,-43.56 16.11,-168.21 18.61,-222.48 1.03,-22.47 2.76,-46.76 17.39,-63.85 54.47,-63.63 84.03,61.99 89.26,98.1 14.2,98.24 -5.23,203.03 -13.14,301.22 -6.91,85.64 -12.68,272.48 -15.03,276.56 2.95,28.8 6.87,57.89 11.97,87.34 0.01,0 1.87,0 1.87,0 0,0 10.39,63.38 114.89,533.17 65.87,296.15 32.46,290.84 129.46,580.3 68.86,205.44 149.98,410.67 174.81,627.46 10.6,92.54 1.45,182.46 -0.44,274.97 -0.48,23.23 -11.45,163.09 30.96,163.09 20.38,0 33.89,-205.01 42.11,-439.97 8.66,-247.74 67.61,-485.95 66.48,-723.79 -1.12,-237.84 -62.32,-475.31 -93.11,-721.6 -38.64,-309.08 -85,-625.88 -15.45,-1228.58 40.05,-347.12 125.03,-700.39 148.29,-1054.16 24.41,-371.42 -66.8,-738.84 -37.96,-1109.34 25.95,-333.54 100.63,-663.26 221.21,-975.36 60.05,-155.4 110.66,-310.2 122.71,-476.3 3.16,-43.6 7.5,-87.3 12.51,-131 h -0.03 c 0.61,-5.4 1.29,-10.7 1.93,-16.1 1.28,-10.8 2.53,-21.6 3.9,-32.4 2.25,-18 4.58,-35.9 7.04,-53.7 11.54,-140.8 6.21,-287.798 -46.37,-422.001 -55.79,-142.398 -98.01,-238.297 -103.05,-305.297 -8.48,-112.8 78.86,-139.3 242.17,-167.601 226.67,-39.301 257.51,254.5 251.07,417.5 -3.27,82.801 30.44,208.499 26.04,291.399 0.3,0.2 0.5,0.4 0.48,0.8 0,0 -2.76,57.5 -6.92,147.5 h 0.02 c -0.03,0.7 -0.06,1.3 -0.09,2 -0.39,12.4 -0.79,24.8 -1.05,37.1 h -0.67 c -13.43,292.3 -17.64,841.5 -17.64,1003.45 0,283.15 56.68,424.12 19.24,847.82 -17.71,200.47 -91,412.48 -62.42,612.57 15.46,108.18 92.73,370.9 123.63,811.33 9.85,140.29 20.27,536.01 30.93,726.75 10.65,-190.74 21.07,-586.46 30.92,-726.75 30.9,-440.43 108.17,-703.15 123.63,-811.33 28.58,-200.09 -38.04,-412.81 -62.42,-612.57 -46.83,-383.7 19.24,-564.67 19.24,-847.82 0,-161.95 -4.21,-711.15 -17.64,-1003.45 h -0.67 c -0.26,-12.3 -0.66,-24.7 -1.05,-37.1 -0.03,-0.7 -0.06,-1.3 -0.09,-2 h 0.9 c -4.16,-90 -6.92,-147.5 -6.92,-147.5 -0.02,-0.4 0.18,-0.6 0.48,-0.8 -4.41,-82.9 29.31,-208.598 26.04,-291.399 -6.44,-163 24.4,-456.801 251.07,-417.5 163.31,28.301 250.65,54.801 242.17,167.601 -5.05,67 -47.26,162.899 -103.05,305.297 -52.58,134.203 -57.92,281.201 -46.37,422.001 4.67,33.9 8.96,68 12.87,102.2 h -0.91 c 5.01,43.7 9.35,87.4 12.51,131 12.05,166.1 62.66,320.9 122.71,476.3 120.58,312.1 195.26,641.82 221.21,975.36 28.84,370.5 -62.37,737.92 -37.95,1109.34 23.25,353.77 108.23,707.04 148.28,1054.16 69.55,602.7 23.19,919.5 -15.45,1228.58 -30.79,246.29 -91.99,483.76 -93.12,721.6 -1.12,237.84 57.83,476.05 66.49,723.79 8.22,234.96 21.73,439.97 42.11,439.97 42.41,0 31.44,-139.86 30.96,-163.09 -1.89,-92.51 -11.04,-182.43 -0.44,-274.97 24.83,-216.79 105.95,-422.02 174.81,-627.46 97.01,-289.46 63.59,-284.15 129.47,-580.3 104.49,-469.79 114.87,-533.17 114.87,-533.17 0,0 1.86,0 1.88,0 5.1,-29.45 9.02,-58.54 11.97,-87.34 -2.35,-4.08 -8.12,-190.92 -15.03,-276.56 -7.91,-98.19 -27.34,-202.98 -13.14,-301.22 5.23,-36.11 34.79,-161.73 89.26,-98.1 14.63,17.09 16.36,41.38 17.39,63.85 2.5,54.27 -15.6,178.92 18.61,222.48 32.99,42.01 77.03,12.12 89.76,-32.58 18.52,-65.03 -1.34,-149.07 -23.58,-210.54 -27.29,-75.43 -48.31,-121.36 -96.15,-185.74 -3.23,-4.36 -5.43,-9.27 -6.79,-14.53 -12.13,-46.84 45.34,-80.9 83.06,-50.59 154.52,124.17 241.4,377.38 245.89,556.87 3.92,156.78 -28,306.92 -63.37,457.66"
                                                style="
                                                  fill: #ffeb3b;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="chipath164"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 10;
                                          grid-column-end: 18;
                                          grid-row-start: 16;
                                          grid-row-end: 17;
                                        "
                                      >
                                        <div style="font-size: small">
                                          Child
                                        </div>
                                      </div>
                                      <div
                                        id="child-height"
                                        class="d-flex align-items-start justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 10;
                                          grid-column-end: 18;
                                          grid-row-start: 2;
                                          grid-row-end: 15;
                                        "
                                      >
                                        <div
                                          id="child-height-text"
                                          style="
                                            display: block;
                                            font-size: xx-small;
                                            height: 50px;
                                          "
                                        >
                                          200cm
                                        </div>
                                      </div>
                                      <!--CHILD FEMALE-->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 10;
                                          grid-column-end: 18;
                                          grid-row-start: 15;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="child-height-human"
                                          id="child-height-female-human"
                                          style="display: none"
                                          height="200px"
                                          viewBox="800 125 600 1420"
                                        >
                                          <g
                                            id="motgf158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g
                                              id="motgf160"
                                              transform="scale(0.1)"
                                            >
                                              <path
                                                d="m 9688.49,6279.45 c -13.98,118.85 0,573.25 -34.96,762.01 -34.95,188.75 -69.91,286.62 -97.87,363.52 -27.96,76.9 -27.96,293.61 -48.93,475.38 -34.44,298.47 -9.3,633.87 -102.65,924.69 -112.88,351.63 -379.24,303.09 -602.97,394.17 -103.24,42.03 -196.68,97.51 -259.66,192.19 -6.71,10.1 -21.47,47.71 -37.05,93.15 h 33.6 c -1.91,2.17 -3.82,4.36 -5.67,6.6 2.73,0.47 5.45,1.02 8.17,1.5 1.96,0.3 3.91,0.66 5.82,1.07 8.55,1.55 17.09,3.05 25.63,4.71 h -11.17 c 7.53,3.51 14.04,8.63 18.61,16.18 -31.05,4.05 -59.73,24.92 -74.43,54.18 79.32,-29.77 174,-6.68 233.04,56.84 2.51,2.7 5.16,6.37 3.88,9.92 -0.78,2.17 -2.81,3.49 -4.72,4.65 -8.6,5.23 -103.87,75.93 -46.93,71.3 34.31,-2.8 112.8,-3.57 134.61,26.27 -17.46,16.47 -39.29,28.55 -54.26,48.21 -1.86,2.44 -25.82,33.14 -11.42,22.97 22.97,-16.22 69.15,-27.66 94.98,-22.28 -29.08,24.19 -55.83,48 -68.15,87.26 -7.64,24.36 49.83,73.09 65.16,198.96 15.33,125.9 -15.33,280.2 -65.15,430.4 -49.83,150.2 -95.82,320.8 -275.96,418.2 -180.13,97.5 -287.45,28.4 -287.45,28.4 0,0 -107.31,69.1 -287.45,-28.4 -180.13,-97.4 -226.12,-268 -275.95,-418.2 -49.82,-150.2 -80.48,-304.5 -65.15,-430.4 15.33,-125.87 72.8,-174.6 65.16,-198.96 -12.32,-39.26 -39.07,-63.07 -68.14,-87.26 25.82,-5.38 71.99,6.06 94.97,22.28 14.4,10.17 -9.56,-20.53 -11.42,-22.97 -14.97,-19.66 -36.8,-31.74 -54.26,-48.21 21.81,-29.84 100.3,-29.07 134.61,-26.27 56.94,4.63 -38.33,-66.07 -46.93,-71.3 -1.9,-1.16 -3.94,-2.48 -4.72,-4.65 -1.28,-3.55 1.37,-7.22 3.88,-9.92 59.04,-63.52 153.72,-86.61 233.04,-56.84 -14.7,-29.26 -43.38,-50.13 -74.43,-54.18 10.81,-17.85 32.41,-22.25 53.05,-23.38 v -6.68 h 21.94 c -15.58,-45.44 -30.34,-83.05 -37.05,-93.15 -62.98,-94.68 -156.42,-150.16 -259.66,-192.19 -223.74,-91.08 -490.1,-42.54 -602.97,-394.17 -93.35,-290.82 -68.21,-626.22 -102.65,-924.69 -20.97,-181.77 -20.97,-398.48 -48.93,-475.38 -27.96,-76.9 -62.92,-174.77 -97.87,-363.52 -34.96,-188.76 -20.98,-643.16 -34.96,-762.01 -13.98,-118.84 -13.98,-286.61 0,-510.32 6.46,-103.33 12.28,-211.18 28.3,-315.25 13.71,-89.06 44.79,-176.28 87.05,-255.71 17.69,-33.25 39.18,-65.08 61.43,-95.41 22.11,-30.15 71.65,-112.23 117.66,-100.33 11.66,3.02 20.18,13.81 23.17,25.48 8.9,34.71 -29.84,79.21 -44.3,108.9 -24.43,50.17 -38.96,102.54 -50.35,156.91 -6.89,32.9 -7.86,59.67 2.71,71.7 34.38,39.17 72.98,-193.35 120.01,-186.44 31.48,4.62 22.64,81.53 13.58,178.27 -9.14,97.64 -9.2,212.34 -50.02,303.34 -38.47,85.77 -95.36,170.99 -85.53,269.32 13.98,139.82 181.76,713.07 202.74,901.82 20.97,188.75 65.92,629.18 100.88,741.03 34.8,111.37 82.34,402.95 82.83,405.45 -2.63,-13.35 112.1,-151.76 123.82,-176.97 50.42,-108.43 65.33,-246.17 75.55,-363.98 36.86,-425.05 -133.11,-793.43 -243.27,-1192.76 -55.93,-202.74 -111.85,-713.07 -83.89,-908.81 27.96,-195.74 90.88,-608.2 160.79,-796.96 69.91,-188.75 153.8,-517.32 160.79,-629.17 4.74,-75.79 4.39,-280.99 -1.58,-469.97 h -0.04 c -2.84,-89.93 -6.95,-176.22 -12.4,-243.1 -12.7,-155.8 -13.99,-433.43 69.91,-824.94 87.49,-408.25 239.24,-1014.75 239.03,-1357.85 h 0.04 c 0.02,-0.3 -0.01,-0.6 0,-0.9 5.72,-94.198 0.45,-190.3 -34.38,-279.499 -40.2,-103 -60.62,-172.301 -64.25,-220.801 -6.12,-81.602 45.91,-106.898 164.5,-121.199 207.36,-25 195.56,184 190.92,301.898 -2.36,59.903 11.93,150.801 8.76,210.703 0.22,0.2 0.36,0.399 0.35,0.598 0,0 -1.99,41.602 -4.99,106.7 h 0.01 c -0.02,0.5 -0.04,1 -0.06,1.4 -0.01,0.4 -0.02,0.7 -0.03,1.1 h 0.27 c -0.17,2.3 -0.3,4.7 -0.47,7 -0.04,1.7 -0.09,3.3 -0.14,5 h -0.2 c -41.22,572.6 56.34,1151.46 53.73,1724.7 -1.37,300.3 -26.04,468.31 -33.82,673.92 -0.19,5.06 -0.29,10.16 -0.41,15.27 h 0.05 c -2.31,106.63 12.01,224.25 4.87,375.97 -10.41,220.95 -17.37,351.41 -4.59,652.17 6.97,164.16 60.97,419.12 57.63,578.73 -1.88,89.99 14.54,208.46 29.23,294.81 14.7,-86.35 31.12,-204.82 29.24,-294.81 -3.34,-159.61 48.56,-414.67 57.63,-578.73 13.67,-247.34 5.82,-431.22 -4.59,-652.17 -7.14,-151.72 7.18,-269.34 4.87,-375.97 h -0.21 c -0.11,-5.11 -0.22,-10.21 -0.41,-15.27 -7.77,-205.61 -32.44,-373.62 -33.81,-673.92 -2.62,-573.24 94.95,-1152.1 53.72,-1724.7 h -0.2 c -0.04,-1.7 -0.09,-3.3 -0.14,-5 -0.17,-2.3 -0.29,-4.7 -0.47,-7 h 0.28 c -0.01,-0.4 -0.02,-0.7 -0.03,-1.1 -0.02,-0.4 -0.05,-0.9 -0.07,-1.4 h 0.02 c -3,-65.098 -4.99,-106.7 -4.99,-106.7 -0.01,-0.199 0.13,-0.398 0.34,-0.598 -3.17,-59.902 11.13,-150.8 8.77,-210.703 -4.64,-117.898 -16.45,-326.898 190.92,-301.898 118.58,14.301 170.62,39.597 164.5,121.199 -3.63,48.5 -24.05,117.801 -64.26,220.801 -34.82,89.199 -40.09,185.301 -34.38,279.499 0.02,0.3 -0.01,0.6 0,0.9 h 0.05 c -0.21,343.1 151.54,949.6 239.03,1357.85 83.89,391.51 82.61,669.14 69.91,824.94 -5.45,66.88 -9.56,153.17 -12.4,243.1 h 0.21 c -5.97,188.98 -6.32,394.18 -1.58,469.97 6.99,111.85 90.88,440.42 160.79,629.17 69.91,188.76 132.83,601.22 160.79,796.96 27.96,195.74 -27.96,706.07 -83.89,908.81 -110.16,399.33 -280.13,767.71 -243.27,1192.76 10.22,117.81 25.13,255.55 75.55,363.98 11.72,25.21 126.45,163.62 123.82,176.97 0.49,-2.5 58.03,-294.08 92.83,-405.45 34.96,-111.85 69.91,-552.28 90.89,-741.03 20.97,-188.75 188.75,-762 202.73,-901.82 9.83,-98.33 -47.07,-183.55 -85.53,-269.32 -40.82,-91 -40.88,-205.7 -50.02,-303.34 -9.06,-96.74 -17.9,-173.65 13.58,-178.27 47.03,-6.91 85.63,225.61 120.01,186.44 10.57,-12.03 9.6,-38.8 2.71,-71.7 -11.39,-54.37 -25.92,-106.74 -50.35,-156.91 -14.46,-29.69 -53.2,-74.19 -44.3,-108.9 2.99,-11.67 11.51,-22.46 23.17,-25.48 46.01,-11.9 95.55,70.18 117.66,100.33 22.25,30.33 43.74,62.16 61.43,95.41 42.26,79.43 73.34,166.65 87.05,255.71 16.02,104.07 21.84,211.92 28.3,315.25 13.98,223.71 13.98,391.48 0,510.32"
                                                style="
                                                  fill: #ffeb3b;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="motpathf166"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <!--ESTIMATED MALE-->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 14;
                                          grid-column-end: 22;
                                          grid-row-start: 15;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="estimated-height-human"
                                          style="display: none"
                                          id="estimated-height-male-human"
                                          height="200px"
                                          viewBox="250 50 600 1500"
                                        >
                                          <g
                                            id="estg158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g
                                              id="estg160"
                                              transform="scale(0.1)"
                                            >
                                              <path
                                                d="m 5892.55,6114.67 c 13.77,456.2 3.09,912.57 -27.09,1367.98 -12.68,191.43 -12.21,335.47 -54.9,499.54 -33.52,128.85 -97.3,268.31 -89.09,404 15.19,250.76 -11.93,535.86 -99.01,778.58 -66.27,184.72 -224.21,335.97 -394.53,424.86 -119.24,62.23 -246.92,107.6 -364.23,173.39 -67.6,33.8 -157.04,89.55 -228.36,155.16 -80.83,74.36 -141.23,151.42 -172.13,233.52 -3.16,8.4 -4.82,16.5 -5.32,24.3 0.9,28.1 16.3,52.9 32.4,77.5 20.01,30.5 42.23,65.7 57.29,101 13.48,31.7 21.67,73.3 47.7,99.4 9.21,9.3 18.13,-11.2 41.44,8.9 18.38,15.8 29.04,43.2 34.92,64.9 5.8,21.4 7.1,43.8 12.92,66 9.9,37.9 23.97,76.1 30.87,113 4.53,24.3 8.95,61.2 -11.61,80.8 -9.01,8.5 -37.51,24.5 -43.91,3.3 43.75,145.1 65.75,320.4 48.23,471.8 -6.36,54.9 -22.95,120.3 -57.03,165 -23.25,30.5 -103.76,46.3 -48.53,72.4 -35.37,14.8 -64.47,1.4 -98.34,6.8 -38.75,6.2 -17.57,-3.6 -45.67,35.1 -18.77,25.8 -34.37,26.6 -60.74,39.2 -26.19,12.6 -22.66,11.8 -43.68,33.6 -23.57,-24.6 -27.45,-11.8 -50.23,-9.3 -30.22,3.2 -62.61,-2.3 -92.32,1.9 -33.85,4.9 -60.8,24.7 -96.41,24.9 -35.63,0.2 -61.37,-12 -91.51,-28.8 -44.15,-24.5 -93.22,-21.8 -135.04,-50.6 -46.37,-32 -97.37,-55 -134.6,-100.2 -34.68,-42.1 -70.09,-78.9 -84.14,-132.1 -10.45,-39.5 -20.17,-79.9 -28.25,-120 -25.79,-128.1 -13.33,-284.1 28.78,-407.6 -99.58,17.9 -30.62,-167.7 -24.21,-207.1 10.42,-64 35.97,-133 75.9,-131.9 11.08,0.4 15.68,9.8 20.58,7.8 21.73,-8.9 29.11,-48.4 36.32,-67.7 19.97,-53.4 24.37,-66.4 52.3,-116.1 18.47,-32.8 45.81,-63.5 47.46,-103.2 -4.29,-101.9 -83.76,-179.98 -155.71,-244.46 -76.1,-68.19 -162.01,-117.58 -250.52,-167.22 -117.31,-65.79 -244.99,-111.16 -364.23,-173.39 -170.32,-88.89 -328.26,-240.14 -394.53,-424.86 -87.08,-242.72 -114.2,-527.82 -99.01,-778.58 8.21,-135.69 -55.57,-275.15 -89.09,-404 -42.69,-164.07 -42.22,-308.11 -54.9,-499.54 -30.18,-455.41 -40.86,-911.78 -27.09,-1367.98 -35.37,-150.74 -67.29,-300.88 -63.37,-457.66 4.48,-179.49 91.37,-432.7 245.89,-556.87 37.72,-30.31 95.19,3.75 83.06,50.59 -1.36,5.26 -3.56,10.17 -6.79,14.53 -47.84,64.38 -68.86,110.31 -96.15,185.74 -22.24,61.47 -42.1,145.51 -23.58,210.54 12.73,44.7 56.77,74.59 89.76,32.58 34.21,-43.56 16.11,-168.21 18.61,-222.48 1.03,-22.47 2.76,-46.76 17.39,-63.85 54.47,-63.63 84.03,61.99 89.26,98.1 14.2,98.24 -5.23,203.03 -13.14,301.22 -6.91,85.64 -12.68,272.48 -15.03,276.56 2.95,28.8 6.87,57.89 11.97,87.34 0.01,0 1.87,0 1.87,0 0,0 10.39,63.38 114.89,533.17 65.87,296.15 32.46,290.84 129.46,580.3 68.86,205.44 149.98,410.67 174.81,627.46 10.6,92.54 1.45,182.46 -0.44,274.97 -0.48,23.23 -11.45,163.09 30.96,163.09 20.38,0 33.89,-205.01 42.11,-439.97 8.66,-247.74 67.61,-485.95 66.48,-723.79 -1.12,-237.84 -62.32,-475.31 -93.11,-721.6 -38.64,-309.08 -85,-625.88 -15.45,-1228.58 40.05,-347.12 125.03,-700.39 148.29,-1054.16 24.41,-371.42 -66.8,-738.84 -37.96,-1109.34 25.95,-333.54 100.63,-663.26 221.21,-975.36 60.05,-155.4 110.66,-310.2 122.71,-476.3 3.16,-43.6 7.5,-87.3 12.51,-131 h -0.03 c 0.61,-5.4 1.29,-10.7 1.93,-16.1 1.28,-10.8 2.53,-21.6 3.9,-32.4 2.25,-18 4.58,-35.9 7.04,-53.7 11.54,-140.8 6.21,-287.798 -46.37,-422.001 -55.79,-142.398 -98.01,-238.297 -103.05,-305.297 -8.48,-112.8 78.86,-139.3 242.17,-167.601 226.67,-39.301 257.51,254.5 251.07,417.5 -3.27,82.801 30.44,208.499 26.04,291.399 0.3,0.2 0.5,0.4 0.48,0.8 0,0 -2.76,57.5 -6.92,147.5 h 0.02 c -0.03,0.7 -0.06,1.3 -0.09,2 -0.39,12.4 -0.79,24.8 -1.05,37.1 h -0.67 c -13.43,292.3 -17.64,841.5 -17.64,1003.45 0,283.15 56.68,424.12 19.24,847.82 -17.71,200.47 -91,412.48 -62.42,612.57 15.46,108.18 92.73,370.9 123.63,811.33 9.85,140.29 20.27,536.01 30.93,726.75 10.65,-190.74 21.07,-586.46 30.92,-726.75 30.9,-440.43 108.17,-703.15 123.63,-811.33 28.58,-200.09 -38.04,-412.81 -62.42,-612.57 -46.83,-383.7 19.24,-564.67 19.24,-847.82 0,-161.95 -4.21,-711.15 -17.64,-1003.45 h -0.67 c -0.26,-12.3 -0.66,-24.7 -1.05,-37.1 -0.03,-0.7 -0.06,-1.3 -0.09,-2 h 0.9 c -4.16,-90 -6.92,-147.5 -6.92,-147.5 -0.02,-0.4 0.18,-0.6 0.48,-0.8 -4.41,-82.9 29.31,-208.598 26.04,-291.399 -6.44,-163 24.4,-456.801 251.07,-417.5 163.31,28.301 250.65,54.801 242.17,167.601 -5.05,67 -47.26,162.899 -103.05,305.297 -52.58,134.203 -57.92,281.201 -46.37,422.001 4.67,33.9 8.96,68 12.87,102.2 h -0.91 c 5.01,43.7 9.35,87.4 12.51,131 12.05,166.1 62.66,320.9 122.71,476.3 120.58,312.1 195.26,641.82 221.21,975.36 28.84,370.5 -62.37,737.92 -37.95,1109.34 23.25,353.77 108.23,707.04 148.28,1054.16 69.55,602.7 23.19,919.5 -15.45,1228.58 -30.79,246.29 -91.99,483.76 -93.12,721.6 -1.12,237.84 57.83,476.05 66.49,723.79 8.22,234.96 21.73,439.97 42.11,439.97 42.41,0 31.44,-139.86 30.96,-163.09 -1.89,-92.51 -11.04,-182.43 -0.44,-274.97 24.83,-216.79 105.95,-422.02 174.81,-627.46 97.01,-289.46 63.59,-284.15 129.47,-580.3 104.49,-469.79 114.87,-533.17 114.87,-533.17 0,0 1.86,0 1.88,0 5.1,-29.45 9.02,-58.54 11.97,-87.34 -2.35,-4.08 -8.12,-190.92 -15.03,-276.56 -7.91,-98.19 -27.34,-202.98 -13.14,-301.22 5.23,-36.11 34.79,-161.73 89.26,-98.1 14.63,17.09 16.36,41.38 17.39,63.85 2.5,54.27 -15.6,178.92 18.61,222.48 32.99,42.01 77.03,12.12 89.76,-32.58 18.52,-65.03 -1.34,-149.07 -23.58,-210.54 -27.29,-75.43 -48.31,-121.36 -96.15,-185.74 -3.23,-4.36 -5.43,-9.27 -6.79,-14.53 -12.13,-46.84 45.34,-80.9 83.06,-50.59 154.52,124.17 241.4,377.38 245.89,556.87 3.92,156.78 -28,306.92 -63.37,457.66"
                                                style="
                                                  fill: #ffc710;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="estpath164"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 14;
                                          grid-column-end: 22;
                                          grid-row-start: 16;
                                          grid-row-end: 17;
                                        "
                                      >
                                        <div style="font-size: small">
                                          Estimated
                                        </div>
                                      </div>
                                      <div
                                        id="estimated-height"
                                        class="d-flex align-items-start justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 14;
                                          grid-column-end: 22;
                                          grid-row-start: 2;
                                          grid-row-end: 15;
                                        "
                                      >
                                        <div
                                          id="estimated-height-text"
                                          style="
                                            display: block;
                                            font-size: xx-small;
                                            height: 50px;
                                          "
                                        >
                                          200cm
                                        </div>
                                      </div>
                                      <!--ESTIMATED FEMALE-->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 14;
                                          grid-column-end: 22;
                                          grid-row-start: 15;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="estimated-height-human"
                                          style="display: none"
                                          id="estimated-height-female-human"
                                          height="200px"
                                          viewBox="800 125 600 1420"
                                        >
                                          <g
                                            id="motgef158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g
                                              id="motgef160"
                                              transform="scale(0.1)"
                                            >
                                              <path
                                                d="m 9688.49,6279.45 c -13.98,118.85 0,573.25 -34.96,762.01 -34.95,188.75 -69.91,286.62 -97.87,363.52 -27.96,76.9 -27.96,293.61 -48.93,475.38 -34.44,298.47 -9.3,633.87 -102.65,924.69 -112.88,351.63 -379.24,303.09 -602.97,394.17 -103.24,42.03 -196.68,97.51 -259.66,192.19 -6.71,10.1 -21.47,47.71 -37.05,93.15 h 33.6 c -1.91,2.17 -3.82,4.36 -5.67,6.6 2.73,0.47 5.45,1.02 8.17,1.5 1.96,0.3 3.91,0.66 5.82,1.07 8.55,1.55 17.09,3.05 25.63,4.71 h -11.17 c 7.53,3.51 14.04,8.63 18.61,16.18 -31.05,4.05 -59.73,24.92 -74.43,54.18 79.32,-29.77 174,-6.68 233.04,56.84 2.51,2.7 5.16,6.37 3.88,9.92 -0.78,2.17 -2.81,3.49 -4.72,4.65 -8.6,5.23 -103.87,75.93 -46.93,71.3 34.31,-2.8 112.8,-3.57 134.61,26.27 -17.46,16.47 -39.29,28.55 -54.26,48.21 -1.86,2.44 -25.82,33.14 -11.42,22.97 22.97,-16.22 69.15,-27.66 94.98,-22.28 -29.08,24.19 -55.83,48 -68.15,87.26 -7.64,24.36 49.83,73.09 65.16,198.96 15.33,125.9 -15.33,280.2 -65.15,430.4 -49.83,150.2 -95.82,320.8 -275.96,418.2 -180.13,97.5 -287.45,28.4 -287.45,28.4 0,0 -107.31,69.1 -287.45,-28.4 -180.13,-97.4 -226.12,-268 -275.95,-418.2 -49.82,-150.2 -80.48,-304.5 -65.15,-430.4 15.33,-125.87 72.8,-174.6 65.16,-198.96 -12.32,-39.26 -39.07,-63.07 -68.14,-87.26 25.82,-5.38 71.99,6.06 94.97,22.28 14.4,10.17 -9.56,-20.53 -11.42,-22.97 -14.97,-19.66 -36.8,-31.74 -54.26,-48.21 21.81,-29.84 100.3,-29.07 134.61,-26.27 56.94,4.63 -38.33,-66.07 -46.93,-71.3 -1.9,-1.16 -3.94,-2.48 -4.72,-4.65 -1.28,-3.55 1.37,-7.22 3.88,-9.92 59.04,-63.52 153.72,-86.61 233.04,-56.84 -14.7,-29.26 -43.38,-50.13 -74.43,-54.18 10.81,-17.85 32.41,-22.25 53.05,-23.38 v -6.68 h 21.94 c -15.58,-45.44 -30.34,-83.05 -37.05,-93.15 -62.98,-94.68 -156.42,-150.16 -259.66,-192.19 -223.74,-91.08 -490.1,-42.54 -602.97,-394.17 -93.35,-290.82 -68.21,-626.22 -102.65,-924.69 -20.97,-181.77 -20.97,-398.48 -48.93,-475.38 -27.96,-76.9 -62.92,-174.77 -97.87,-363.52 -34.96,-188.76 -20.98,-643.16 -34.96,-762.01 -13.98,-118.84 -13.98,-286.61 0,-510.32 6.46,-103.33 12.28,-211.18 28.3,-315.25 13.71,-89.06 44.79,-176.28 87.05,-255.71 17.69,-33.25 39.18,-65.08 61.43,-95.41 22.11,-30.15 71.65,-112.23 117.66,-100.33 11.66,3.02 20.18,13.81 23.17,25.48 8.9,34.71 -29.84,79.21 -44.3,108.9 -24.43,50.17 -38.96,102.54 -50.35,156.91 -6.89,32.9 -7.86,59.67 2.71,71.7 34.38,39.17 72.98,-193.35 120.01,-186.44 31.48,4.62 22.64,81.53 13.58,178.27 -9.14,97.64 -9.2,212.34 -50.02,303.34 -38.47,85.77 -95.36,170.99 -85.53,269.32 13.98,139.82 181.76,713.07 202.74,901.82 20.97,188.75 65.92,629.18 100.88,741.03 34.8,111.37 82.34,402.95 82.83,405.45 -2.63,-13.35 112.1,-151.76 123.82,-176.97 50.42,-108.43 65.33,-246.17 75.55,-363.98 36.86,-425.05 -133.11,-793.43 -243.27,-1192.76 -55.93,-202.74 -111.85,-713.07 -83.89,-908.81 27.96,-195.74 90.88,-608.2 160.79,-796.96 69.91,-188.75 153.8,-517.32 160.79,-629.17 4.74,-75.79 4.39,-280.99 -1.58,-469.97 h -0.04 c -2.84,-89.93 -6.95,-176.22 -12.4,-243.1 -12.7,-155.8 -13.99,-433.43 69.91,-824.94 87.49,-408.25 239.24,-1014.75 239.03,-1357.85 h 0.04 c 0.02,-0.3 -0.01,-0.6 0,-0.9 5.72,-94.198 0.45,-190.3 -34.38,-279.499 -40.2,-103 -60.62,-172.301 -64.25,-220.801 -6.12,-81.602 45.91,-106.898 164.5,-121.199 207.36,-25 195.56,184 190.92,301.898 -2.36,59.903 11.93,150.801 8.76,210.703 0.22,0.2 0.36,0.399 0.35,0.598 0,0 -1.99,41.602 -4.99,106.7 h 0.01 c -0.02,0.5 -0.04,1 -0.06,1.4 -0.01,0.4 -0.02,0.7 -0.03,1.1 h 0.27 c -0.17,2.3 -0.3,4.7 -0.47,7 -0.04,1.7 -0.09,3.3 -0.14,5 h -0.2 c -41.22,572.6 56.34,1151.46 53.73,1724.7 -1.37,300.3 -26.04,468.31 -33.82,673.92 -0.19,5.06 -0.29,10.16 -0.41,15.27 h 0.05 c -2.31,106.63 12.01,224.25 4.87,375.97 -10.41,220.95 -17.37,351.41 -4.59,652.17 6.97,164.16 60.97,419.12 57.63,578.73 -1.88,89.99 14.54,208.46 29.23,294.81 14.7,-86.35 31.12,-204.82 29.24,-294.81 -3.34,-159.61 48.56,-414.67 57.63,-578.73 13.67,-247.34 5.82,-431.22 -4.59,-652.17 -7.14,-151.72 7.18,-269.34 4.87,-375.97 h -0.21 c -0.11,-5.11 -0.22,-10.21 -0.41,-15.27 -7.77,-205.61 -32.44,-373.62 -33.81,-673.92 -2.62,-573.24 94.95,-1152.1 53.72,-1724.7 h -0.2 c -0.04,-1.7 -0.09,-3.3 -0.14,-5 -0.17,-2.3 -0.29,-4.7 -0.47,-7 h 0.28 c -0.01,-0.4 -0.02,-0.7 -0.03,-1.1 -0.02,-0.4 -0.05,-0.9 -0.07,-1.4 h 0.02 c -3,-65.098 -4.99,-106.7 -4.99,-106.7 -0.01,-0.199 0.13,-0.398 0.34,-0.598 -3.17,-59.902 11.13,-150.8 8.77,-210.703 -4.64,-117.898 -16.45,-326.898 190.92,-301.898 118.58,14.301 170.62,39.597 164.5,121.199 -3.63,48.5 -24.05,117.801 -64.26,220.801 -34.82,89.199 -40.09,185.301 -34.38,279.499 0.02,0.3 -0.01,0.6 0,0.9 h 0.05 c -0.21,343.1 151.54,949.6 239.03,1357.85 83.89,391.51 82.61,669.14 69.91,824.94 -5.45,66.88 -9.56,153.17 -12.4,243.1 h 0.21 c -5.97,188.98 -6.32,394.18 -1.58,469.97 6.99,111.85 90.88,440.42 160.79,629.17 69.91,188.76 132.83,601.22 160.79,796.96 27.96,195.74 -27.96,706.07 -83.89,908.81 -110.16,399.33 -280.13,767.71 -243.27,1192.76 10.22,117.81 25.13,255.55 75.55,363.98 11.72,25.21 126.45,163.62 123.82,176.97 0.49,-2.5 58.03,-294.08 92.83,-405.45 34.96,-111.85 69.91,-552.28 90.89,-741.03 20.97,-188.75 188.75,-762 202.73,-901.82 9.83,-98.33 -47.07,-183.55 -85.53,-269.32 -40.82,-91 -40.88,-205.7 -50.02,-303.34 -9.06,-96.74 -17.9,-173.65 13.58,-178.27 47.03,-6.91 85.63,225.61 120.01,186.44 10.57,-12.03 9.6,-38.8 2.71,-71.7 -11.39,-54.37 -25.92,-106.74 -50.35,-156.91 -14.46,-29.69 -53.2,-74.19 -44.3,-108.9 2.99,-11.67 11.51,-22.46 23.17,-25.48 46.01,-11.9 95.55,70.18 117.66,100.33 22.25,30.33 43.74,62.16 61.43,95.41 42.26,79.43 73.34,166.65 87.05,255.71 16.02,104.07 21.84,211.92 28.3,315.25 13.98,223.71 13.98,391.48 0,510.32"
                                                style="
                                                  fill: #ffc710;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="motpathef166"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <!-- GRID FORMATTING -->
                                      <!-- Y axis -->
                                      <div
                                        style="
                                          border-right: 1px solid #f0f0f1;
                                          grid-column-start: 1;
                                          grid-column-end: 4;
                                          grid-row-start: 2;
                                          grid-row-end: 15;
                                        "
                                      ></div>
                                      <!-- all the grid rows -->
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 2;
                                          grid-row-end: 2;
                                        "
                                      >
                                        <div style="font-size: small">240</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 4;
                                          grid-row-end: 4;
                                        "
                                      >
                                        <div style="font-size: small">200</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 6;
                                          grid-row-end: 6;
                                        "
                                      >
                                        <div style="font-size: small">160</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 8;
                                          grid-row-end: 8;
                                        "
                                      >
                                        <div style="font-size: small">120</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 10;
                                          grid-row-end: 10;
                                        "
                                      >
                                        <div style="font-size: small">80</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 12;
                                          grid-row-end: 12;
                                        "
                                      >
                                        <div style="font-size: small">40</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 14;
                                          grid-row-end: 14;
                                        "
                                      >
                                        <div style="font-size: small">0</div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- B3 SUMMARY -->
                                  <div
                                    style="background-color: white"
                                    class="col-12 col-sm-6 p-3 border-bottom border-end border-white border-2 rounded-8 bioband-summary-card"
                                  >
                                    <div
                                      class="d-flex flex-column align-items-center justify-content-around pt-5"
                                    >
                                      <div
                                        style="background-color: #fff9cd"
                                        class="text-black alert p-2 text-center border-white border-1 rounded border-radius-8"
                                      >
                                        <div
                                          class="py-2"
                                          style="font-size: x-small"
                                        >
                                          Height Achieved
                                        </div>
                                        <div
                                          class="progress"
                                          style="height: 30px"
                                        >
                                          <div
                                            id="percent-obtained-width"
                                            class="progress-bar text-black"
                                            style="
                                              width: 59%;
                                              background-color: #fff06c !important;
                                            "
                                            aria-label="percent obtained"
                                            role="progressbar"
                                          >
                                            <div
                                              id="percent-obtained"
                                              style="font-size: x-small"
                                            >
                                              59 %
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        role="alert"
                                        style="background-color: #c7fef1"
                                        class="p-2 text-black alert text-center border-white rounded border-radius-8"
                                      >
                                        <div
                                          class="py-2"
                                          style="font-size: x-small"
                                        >
                                          Bio Age Difference
                                        </div>
                                        <div
                                          style="
                                            background-color: #89e3f0;
                                            font-size: x-small;
                                            height: 30px;
                                          "
                                          class="d-flex text-black text-center align-items-center justify-content-center border-white rounded radius-8 p-1"
                                        >
                                          <div id="bio-age-diff">+2 yrs</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- B2 BIO AGE GRID-->
                                  <div
                                    style="background-color: white"
                                    class="text-black col-12 col-sm-6 border-bottom border-white border-2 rounded-8 bioband-bioage-grid"
                                  >
                                    <div
                                      class="row align-items-center justify-content-center pt-3 bioband-section-title"
                                    >
                                      {{ selectedUserData.name }} Bio Age
                                    </div>
                                    <div
                                      class="gallery bioage-gallery"
                                      style="
                                        display: grid;
                                        grid-template-columns: repeat(21, 5%);
                                        grid-template-rows: repeat(13, 22px);
                                      "
                                    >
                                      <!-- CURRENT DECIMAL AGE MALE-->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 3;
                                          grid-column-end: 14;
                                          grid-row-start: 12;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="decimal-age-human"
                                          id="decimal-age-male-human"
                                          style="display: none"
                                          height="200px"
                                          viewBox="250 50 600 1500"
                                        >
                                          <g
                                            id="g159"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g id="g161" transform="scale(0.1)">
                                              <path
                                                d="m 5892.55,6114.67 c 13.77,456.2 3.09,912.57 -27.09,1367.98 -12.68,191.43 -12.21,335.47 -54.9,499.54 -33.52,128.85 -97.3,268.31 -89.09,404 15.19,250.76 -11.93,535.86 -99.01,778.58 -66.27,184.72 -224.21,335.97 -394.53,424.86 -119.24,62.23 -246.92,107.6 -364.23,173.39 -67.6,33.8 -157.04,89.55 -228.36,155.16 -80.83,74.36 -141.23,151.42 -172.13,233.52 -3.16,8.4 -4.82,16.5 -5.32,24.3 0.9,28.1 16.3,52.9 32.4,77.5 20.01,30.5 42.23,65.7 57.29,101 13.48,31.7 21.67,73.3 47.7,99.4 9.21,9.3 18.13,-11.2 41.44,8.9 18.38,15.8 29.04,43.2 34.92,64.9 5.8,21.4 7.1,43.8 12.92,66 9.9,37.9 23.97,76.1 30.87,113 4.53,24.3 8.95,61.2 -11.61,80.8 -9.01,8.5 -37.51,24.5 -43.91,3.3 43.75,145.1 65.75,320.4 48.23,471.8 -6.36,54.9 -22.95,120.3 -57.03,165 -23.25,30.5 -103.76,46.3 -48.53,72.4 -35.37,14.8 -64.47,1.4 -98.34,6.8 -38.75,6.2 -17.57,-3.6 -45.67,35.1 -18.77,25.8 -34.37,26.6 -60.74,39.2 -26.19,12.6 -22.66,11.8 -43.68,33.6 -23.57,-24.6 -27.45,-11.8 -50.23,-9.3 -30.22,3.2 -62.61,-2.3 -92.32,1.9 -33.85,4.9 -60.8,24.7 -96.41,24.9 -35.63,0.2 -61.37,-12 -91.51,-28.8 -44.15,-24.5 -93.22,-21.8 -135.04,-50.6 -46.37,-32 -97.37,-55 -134.6,-100.2 -34.68,-42.1 -70.09,-78.9 -84.14,-132.1 -10.45,-39.5 -20.17,-79.9 -28.25,-120 -25.79,-128.1 -13.33,-284.1 28.78,-407.6 -99.58,17.9 -30.62,-167.7 -24.21,-207.1 10.42,-64 35.97,-133 75.9,-131.9 11.08,0.4 15.68,9.8 20.58,7.8 21.73,-8.9 29.11,-48.4 36.32,-67.7 19.97,-53.4 24.37,-66.4 52.3,-116.1 18.47,-32.8 45.81,-63.5 47.46,-103.2 -4.29,-101.9 -83.76,-179.98 -155.71,-244.46 -76.1,-68.19 -162.01,-117.58 -250.52,-167.22 -117.31,-65.79 -244.99,-111.16 -364.23,-173.39 -170.32,-88.89 -328.26,-240.14 -394.53,-424.86 -87.08,-242.72 -114.2,-527.82 -99.01,-778.58 8.21,-135.69 -55.57,-275.15 -89.09,-404 -42.69,-164.07 -42.22,-308.11 -54.9,-499.54 -30.18,-455.41 -40.86,-911.78 -27.09,-1367.98 -35.37,-150.74 -67.29,-300.88 -63.37,-457.66 4.48,-179.49 91.37,-432.7 245.89,-556.87 37.72,-30.31 95.19,3.75 83.06,50.59 -1.36,5.26 -3.56,10.17 -6.79,14.53 -47.84,64.38 -68.86,110.31 -96.15,185.74 -22.24,61.47 -42.1,145.51 -23.58,210.54 12.73,44.7 56.77,74.59 89.76,32.58 34.21,-43.56 16.11,-168.21 18.61,-222.48 1.03,-22.47 2.76,-46.76 17.39,-63.85 54.47,-63.63 84.03,61.99 89.26,98.1 14.2,98.24 -5.23,203.03 -13.14,301.22 -6.91,85.64 -12.68,272.48 -15.03,276.56 2.95,28.8 6.87,57.89 11.97,87.34 0.01,0 1.87,0 1.87,0 0,0 10.39,63.38 114.89,533.17 65.87,296.15 32.46,290.84 129.46,580.3 68.86,205.44 149.98,410.67 174.81,627.46 10.6,92.54 1.45,182.46 -0.44,274.97 -0.48,23.23 -11.45,163.09 30.96,163.09 20.38,0 33.89,-205.01 42.11,-439.97 8.66,-247.74 67.61,-485.95 66.48,-723.79 -1.12,-237.84 -62.32,-475.31 -93.11,-721.6 -38.64,-309.08 -85,-625.88 -15.45,-1228.58 40.05,-347.12 125.03,-700.39 148.29,-1054.16 24.41,-371.42 -66.8,-738.84 -37.96,-1109.34 25.95,-333.54 100.63,-663.26 221.21,-975.36 60.05,-155.4 110.66,-310.2 122.71,-476.3 3.16,-43.6 7.5,-87.3 12.51,-131 h -0.03 c 0.61,-5.4 1.29,-10.7 1.93,-16.1 1.28,-10.8 2.53,-21.6 3.9,-32.4 2.25,-18 4.58,-35.9 7.04,-53.7 11.54,-140.8 6.21,-287.798 -46.37,-422.001 -55.79,-142.398 -98.01,-238.297 -103.05,-305.297 -8.48,-112.8 78.86,-139.3 242.17,-167.601 226.67,-39.301 257.51,254.5 251.07,417.5 -3.27,82.801 30.44,208.499 26.04,291.399 0.3,0.2 0.5,0.4 0.48,0.8 0,0 -2.76,57.5 -6.92,147.5 h 0.02 c -0.03,0.7 -0.06,1.3 -0.09,2 -0.39,12.4 -0.79,24.8 -1.05,37.1 h -0.67 c -13.43,292.3 -17.64,841.5 -17.64,1003.45 0,283.15 56.68,424.12 19.24,847.82 -17.71,200.47 -91,412.48 -62.42,612.57 15.46,108.18 92.73,370.9 123.63,811.33 9.85,140.29 20.27,536.01 30.93,726.75 10.65,-190.74 21.07,-586.46 30.92,-726.75 30.9,-440.43 108.17,-703.15 123.63,-811.33 28.58,-200.09 -38.04,-412.81 -62.42,-612.57 -46.83,-383.7 19.24,-564.67 19.24,-847.82 0,-161.95 -4.21,-711.15 -17.64,-1003.45 h -0.67 c -0.26,-12.3 -0.66,-24.7 -1.05,-37.1 -0.03,-0.7 -0.06,-1.3 -0.09,-2 h 0.9 c -4.16,-90 -6.92,-147.5 -6.92,-147.5 -0.02,-0.4 0.18,-0.6 0.48,-0.8 -4.41,-82.9 29.31,-208.598 26.04,-291.399 -6.44,-163 24.4,-456.801 251.07,-417.5 163.31,28.301 250.65,54.801 242.17,167.601 -5.05,67 -47.26,162.899 -103.05,305.297 -52.58,134.203 -57.92,281.201 -46.37,422.001 4.67,33.9 8.96,68 12.87,102.2 h -0.91 c 5.01,43.7 9.35,87.4 12.51,131 12.05,166.1 62.66,320.9 122.71,476.3 120.58,312.1 195.26,641.82 221.21,975.36 28.84,370.5 -62.37,737.92 -37.95,1109.34 23.25,353.77 108.23,707.04 148.28,1054.16 69.55,602.7 23.19,919.5 -15.45,1228.58 -30.79,246.29 -91.99,483.76 -93.12,721.6 -1.12,237.84 57.83,476.05 66.49,723.79 8.22,234.96 21.73,439.97 42.11,439.97 42.41,0 31.44,-139.86 30.96,-163.09 -1.89,-92.51 -11.04,-182.43 -0.44,-274.97 24.83,-216.79 105.95,-422.02 174.81,-627.46 97.01,-289.46 63.59,-284.15 129.47,-580.3 104.49,-469.79 114.87,-533.17 114.87,-533.17 0,0 1.86,0 1.88,0 5.1,-29.45 9.02,-58.54 11.97,-87.34 -2.35,-4.08 -8.12,-190.92 -15.03,-276.56 -7.91,-98.19 -27.34,-202.98 -13.14,-301.22 5.23,-36.11 34.79,-161.73 89.26,-98.1 14.63,17.09 16.36,41.38 17.39,63.85 2.5,54.27 -15.6,178.92 18.61,222.48 32.99,42.01 77.03,12.12 89.76,-32.58 18.52,-65.03 -1.34,-149.07 -23.58,-210.54 -27.29,-75.43 -48.31,-121.36 -96.15,-185.74 -3.23,-4.36 -5.43,-9.27 -6.79,-14.53 -12.13,-46.84 45.34,-80.9 83.06,-50.59 154.52,124.17 241.4,377.38 245.89,556.87 3.92,156.78 -28,306.92 -63.37,457.66"
                                                style="
                                                  fill: #9afde6;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="path165"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        class="d-flex align-items-center justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 3;
                                          grid-column-end: 14;
                                          grid-row-start: 12;
                                          grid-row-end: 15;
                                        "
                                      >
                                        <div style="font-size: small">Age</div>
                                      </div>
                                      <div
                                        id="decimal-age-height"
                                        class="d-flex align-items-start justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 3;
                                          grid-column-end: 14;
                                          grid-row-start: 3;
                                          grid-row-end: 12;
                                        "
                                      >
                                        <div
                                          id="decimal-age-text"
                                          style="
                                            display: block;
                                            font-size: xx-small;
                                            height: 50px;
                                          "
                                        >
                                          13.1 yrs
                                        </div>
                                      </div>
                                      <!-- CURRENT DECIMAL AGE FEMALE-->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 3;
                                          grid-column-end: 14;
                                          grid-row-start: 12;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="decimal-age-human"
                                          id="decimal-age-female-human"
                                          style="display: none"
                                          height="200px"
                                          viewBox="800 125 600 1420"
                                        >
                                          <g
                                            id="motgdf158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g
                                              id="motgdf160"
                                              transform="scale(0.1)"
                                            >
                                              <path
                                                d="m 9688.49,6279.45 c -13.98,118.85 0,573.25 -34.96,762.01 -34.95,188.75 -69.91,286.62 -97.87,363.52 -27.96,76.9 -27.96,293.61 -48.93,475.38 -34.44,298.47 -9.3,633.87 -102.65,924.69 -112.88,351.63 -379.24,303.09 -602.97,394.17 -103.24,42.03 -196.68,97.51 -259.66,192.19 -6.71,10.1 -21.47,47.71 -37.05,93.15 h 33.6 c -1.91,2.17 -3.82,4.36 -5.67,6.6 2.73,0.47 5.45,1.02 8.17,1.5 1.96,0.3 3.91,0.66 5.82,1.07 8.55,1.55 17.09,3.05 25.63,4.71 h -11.17 c 7.53,3.51 14.04,8.63 18.61,16.18 -31.05,4.05 -59.73,24.92 -74.43,54.18 79.32,-29.77 174,-6.68 233.04,56.84 2.51,2.7 5.16,6.37 3.88,9.92 -0.78,2.17 -2.81,3.49 -4.72,4.65 -8.6,5.23 -103.87,75.93 -46.93,71.3 34.31,-2.8 112.8,-3.57 134.61,26.27 -17.46,16.47 -39.29,28.55 -54.26,48.21 -1.86,2.44 -25.82,33.14 -11.42,22.97 22.97,-16.22 69.15,-27.66 94.98,-22.28 -29.08,24.19 -55.83,48 -68.15,87.26 -7.64,24.36 49.83,73.09 65.16,198.96 15.33,125.9 -15.33,280.2 -65.15,430.4 -49.83,150.2 -95.82,320.8 -275.96,418.2 -180.13,97.5 -287.45,28.4 -287.45,28.4 0,0 -107.31,69.1 -287.45,-28.4 -180.13,-97.4 -226.12,-268 -275.95,-418.2 -49.82,-150.2 -80.48,-304.5 -65.15,-430.4 15.33,-125.87 72.8,-174.6 65.16,-198.96 -12.32,-39.26 -39.07,-63.07 -68.14,-87.26 25.82,-5.38 71.99,6.06 94.97,22.28 14.4,10.17 -9.56,-20.53 -11.42,-22.97 -14.97,-19.66 -36.8,-31.74 -54.26,-48.21 21.81,-29.84 100.3,-29.07 134.61,-26.27 56.94,4.63 -38.33,-66.07 -46.93,-71.3 -1.9,-1.16 -3.94,-2.48 -4.72,-4.65 -1.28,-3.55 1.37,-7.22 3.88,-9.92 59.04,-63.52 153.72,-86.61 233.04,-56.84 -14.7,-29.26 -43.38,-50.13 -74.43,-54.18 10.81,-17.85 32.41,-22.25 53.05,-23.38 v -6.68 h 21.94 c -15.58,-45.44 -30.34,-83.05 -37.05,-93.15 -62.98,-94.68 -156.42,-150.16 -259.66,-192.19 -223.74,-91.08 -490.1,-42.54 -602.97,-394.17 -93.35,-290.82 -68.21,-626.22 -102.65,-924.69 -20.97,-181.77 -20.97,-398.48 -48.93,-475.38 -27.96,-76.9 -62.92,-174.77 -97.87,-363.52 -34.96,-188.76 -20.98,-643.16 -34.96,-762.01 -13.98,-118.84 -13.98,-286.61 0,-510.32 6.46,-103.33 12.28,-211.18 28.3,-315.25 13.71,-89.06 44.79,-176.28 87.05,-255.71 17.69,-33.25 39.18,-65.08 61.43,-95.41 22.11,-30.15 71.65,-112.23 117.66,-100.33 11.66,3.02 20.18,13.81 23.17,25.48 8.9,34.71 -29.84,79.21 -44.3,108.9 -24.43,50.17 -38.96,102.54 -50.35,156.91 -6.89,32.9 -7.86,59.67 2.71,71.7 34.38,39.17 72.98,-193.35 120.01,-186.44 31.48,4.62 22.64,81.53 13.58,178.27 -9.14,97.64 -9.2,212.34 -50.02,303.34 -38.47,85.77 -95.36,170.99 -85.53,269.32 13.98,139.82 181.76,713.07 202.74,901.82 20.97,188.75 65.92,629.18 100.88,741.03 34.8,111.37 82.34,402.95 82.83,405.45 -2.63,-13.35 112.1,-151.76 123.82,-176.97 50.42,-108.43 65.33,-246.17 75.55,-363.98 36.86,-425.05 -133.11,-793.43 -243.27,-1192.76 -55.93,-202.74 -111.85,-713.07 -83.89,-908.81 27.96,-195.74 90.88,-608.2 160.79,-796.96 69.91,-188.75 153.8,-517.32 160.79,-629.17 4.74,-75.79 4.39,-280.99 -1.58,-469.97 h -0.04 c -2.84,-89.93 -6.95,-176.22 -12.4,-243.1 -12.7,-155.8 -13.99,-433.43 69.91,-824.94 87.49,-408.25 239.24,-1014.75 239.03,-1357.85 h 0.04 c 0.02,-0.3 -0.01,-0.6 0,-0.9 5.72,-94.198 0.45,-190.3 -34.38,-279.499 -40.2,-103 -60.62,-172.301 -64.25,-220.801 -6.12,-81.602 45.91,-106.898 164.5,-121.199 207.36,-25 195.56,184 190.92,301.898 -2.36,59.903 11.93,150.801 8.76,210.703 0.22,0.2 0.36,0.399 0.35,0.598 0,0 -1.99,41.602 -4.99,106.7 h 0.01 c -0.02,0.5 -0.04,1 -0.06,1.4 -0.01,0.4 -0.02,0.7 -0.03,1.1 h 0.27 c -0.17,2.3 -0.3,4.7 -0.47,7 -0.04,1.7 -0.09,3.3 -0.14,5 h -0.2 c -41.22,572.6 56.34,1151.46 53.73,1724.7 -1.37,300.3 -26.04,468.31 -33.82,673.92 -0.19,5.06 -0.29,10.16 -0.41,15.27 h 0.05 c -2.31,106.63 12.01,224.25 4.87,375.97 -10.41,220.95 -17.37,351.41 -4.59,652.17 6.97,164.16 60.97,419.12 57.63,578.73 -1.88,89.99 14.54,208.46 29.23,294.81 14.7,-86.35 31.12,-204.82 29.24,-294.81 -3.34,-159.61 48.56,-414.67 57.63,-578.73 13.67,-247.34 5.82,-431.22 -4.59,-652.17 -7.14,-151.72 7.18,-269.34 4.87,-375.97 h -0.21 c -0.11,-5.11 -0.22,-10.21 -0.41,-15.27 -7.77,-205.61 -32.44,-373.62 -33.81,-673.92 -2.62,-573.24 94.95,-1152.1 53.72,-1724.7 h -0.2 c -0.04,-1.7 -0.09,-3.3 -0.14,-5 -0.17,-2.3 -0.29,-4.7 -0.47,-7 h 0.28 c -0.01,-0.4 -0.02,-0.7 -0.03,-1.1 -0.02,-0.4 -0.05,-0.9 -0.07,-1.4 h 0.02 c -3,-65.098 -4.99,-106.7 -4.99,-106.7 -0.01,-0.199 0.13,-0.398 0.34,-0.598 -3.17,-59.902 11.13,-150.8 8.77,-210.703 -4.64,-117.898 -16.45,-326.898 190.92,-301.898 118.58,14.301 170.62,39.597 164.5,121.199 -3.63,48.5 -24.05,117.801 -64.26,220.801 -34.82,89.199 -40.09,185.301 -34.38,279.499 0.02,0.3 -0.01,0.6 0,0.9 h 0.05 c -0.21,343.1 151.54,949.6 239.03,1357.85 83.89,391.51 82.61,669.14 69.91,824.94 -5.45,66.88 -9.56,153.17 -12.4,243.1 h 0.21 c -5.97,188.98 -6.32,394.18 -1.58,469.97 6.99,111.85 90.88,440.42 160.79,629.17 69.91,188.76 132.83,601.22 160.79,796.96 27.96,195.74 -27.96,706.07 -83.89,908.81 -110.16,399.33 -280.13,767.71 -243.27,1192.76 10.22,117.81 25.13,255.55 75.55,363.98 11.72,25.21 126.45,163.62 123.82,176.97 0.49,-2.5 58.03,-294.08 92.83,-405.45 34.96,-111.85 69.91,-552.28 90.89,-741.03 20.97,-188.75 188.75,-762 202.73,-901.82 9.83,-98.33 -47.07,-183.55 -85.53,-269.32 -40.82,-91 -40.88,-205.7 -50.02,-303.34 -9.06,-96.74 -17.9,-173.65 13.58,-178.27 47.03,-6.91 85.63,225.61 120.01,186.44 10.57,-12.03 9.6,-38.8 2.71,-71.7 -11.39,-54.37 -25.92,-106.74 -50.35,-156.91 -14.46,-29.69 -53.2,-74.19 -44.3,-108.9 2.99,-11.67 11.51,-22.46 23.17,-25.48 46.01,-11.9 95.55,70.18 117.66,100.33 22.25,30.33 43.74,62.16 61.43,95.41 42.26,79.43 73.34,166.65 87.05,255.71 16.02,104.07 21.84,211.92 28.3,315.25 13.98,223.71 13.98,391.48 0,510.32"
                                                style="
                                                  fill: #9afde6;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="motpathdf166"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <!-- BIOAGE MALE-->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 12;
                                          grid-column-end: 21;
                                          grid-row-start: 12;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="bio-age-human"
                                          id="bio-age-male-human"
                                          style="display: none"
                                          height="200px"
                                          viewBox="250 50 600 1500"
                                        >
                                          <g
                                            id="biog158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g
                                              id="biog160"
                                              transform="scale(0.1)"
                                            >
                                              <path
                                                d="m 5892.55,6114.67 c 13.77,456.2 3.09,912.57 -27.09,1367.98 -12.68,191.43 -12.21,335.47 -54.9,499.54 -33.52,128.85 -97.3,268.31 -89.09,404 15.19,250.76 -11.93,535.86 -99.01,778.58 -66.27,184.72 -224.21,335.97 -394.53,424.86 -119.24,62.23 -246.92,107.6 -364.23,173.39 -67.6,33.8 -157.04,89.55 -228.36,155.16 -80.83,74.36 -141.23,151.42 -172.13,233.52 -3.16,8.4 -4.82,16.5 -5.32,24.3 0.9,28.1 16.3,52.9 32.4,77.5 20.01,30.5 42.23,65.7 57.29,101 13.48,31.7 21.67,73.3 47.7,99.4 9.21,9.3 18.13,-11.2 41.44,8.9 18.38,15.8 29.04,43.2 34.92,64.9 5.8,21.4 7.1,43.8 12.92,66 9.9,37.9 23.97,76.1 30.87,113 4.53,24.3 8.95,61.2 -11.61,80.8 -9.01,8.5 -37.51,24.5 -43.91,3.3 43.75,145.1 65.75,320.4 48.23,471.8 -6.36,54.9 -22.95,120.3 -57.03,165 -23.25,30.5 -103.76,46.3 -48.53,72.4 -35.37,14.8 -64.47,1.4 -98.34,6.8 -38.75,6.2 -17.57,-3.6 -45.67,35.1 -18.77,25.8 -34.37,26.6 -60.74,39.2 -26.19,12.6 -22.66,11.8 -43.68,33.6 -23.57,-24.6 -27.45,-11.8 -50.23,-9.3 -30.22,3.2 -62.61,-2.3 -92.32,1.9 -33.85,4.9 -60.8,24.7 -96.41,24.9 -35.63,0.2 -61.37,-12 -91.51,-28.8 -44.15,-24.5 -93.22,-21.8 -135.04,-50.6 -46.37,-32 -97.37,-55 -134.6,-100.2 -34.68,-42.1 -70.09,-78.9 -84.14,-132.1 -10.45,-39.5 -20.17,-79.9 -28.25,-120 -25.79,-128.1 -13.33,-284.1 28.78,-407.6 -99.58,17.9 -30.62,-167.7 -24.21,-207.1 10.42,-64 35.97,-133 75.9,-131.9 11.08,0.4 15.68,9.8 20.58,7.8 21.73,-8.9 29.11,-48.4 36.32,-67.7 19.97,-53.4 24.37,-66.4 52.3,-116.1 18.47,-32.8 45.81,-63.5 47.46,-103.2 -4.29,-101.9 -83.76,-179.98 -155.71,-244.46 -76.1,-68.19 -162.01,-117.58 -250.52,-167.22 -117.31,-65.79 -244.99,-111.16 -364.23,-173.39 -170.32,-88.89 -328.26,-240.14 -394.53,-424.86 -87.08,-242.72 -114.2,-527.82 -99.01,-778.58 8.21,-135.69 -55.57,-275.15 -89.09,-404 -42.69,-164.07 -42.22,-308.11 -54.9,-499.54 -30.18,-455.41 -40.86,-911.78 -27.09,-1367.98 -35.37,-150.74 -67.29,-300.88 -63.37,-457.66 4.48,-179.49 91.37,-432.7 245.89,-556.87 37.72,-30.31 95.19,3.75 83.06,50.59 -1.36,5.26 -3.56,10.17 -6.79,14.53 -47.84,64.38 -68.86,110.31 -96.15,185.74 -22.24,61.47 -42.1,145.51 -23.58,210.54 12.73,44.7 56.77,74.59 89.76,32.58 34.21,-43.56 16.11,-168.21 18.61,-222.48 1.03,-22.47 2.76,-46.76 17.39,-63.85 54.47,-63.63 84.03,61.99 89.26,98.1 14.2,98.24 -5.23,203.03 -13.14,301.22 -6.91,85.64 -12.68,272.48 -15.03,276.56 2.95,28.8 6.87,57.89 11.97,87.34 0.01,0 1.87,0 1.87,0 0,0 10.39,63.38 114.89,533.17 65.87,296.15 32.46,290.84 129.46,580.3 68.86,205.44 149.98,410.67 174.81,627.46 10.6,92.54 1.45,182.46 -0.44,274.97 -0.48,23.23 -11.45,163.09 30.96,163.09 20.38,0 33.89,-205.01 42.11,-439.97 8.66,-247.74 67.61,-485.95 66.48,-723.79 -1.12,-237.84 -62.32,-475.31 -93.11,-721.6 -38.64,-309.08 -85,-625.88 -15.45,-1228.58 40.05,-347.12 125.03,-700.39 148.29,-1054.16 24.41,-371.42 -66.8,-738.84 -37.96,-1109.34 25.95,-333.54 100.63,-663.26 221.21,-975.36 60.05,-155.4 110.66,-310.2 122.71,-476.3 3.16,-43.6 7.5,-87.3 12.51,-131 h -0.03 c 0.61,-5.4 1.29,-10.7 1.93,-16.1 1.28,-10.8 2.53,-21.6 3.9,-32.4 2.25,-18 4.58,-35.9 7.04,-53.7 11.54,-140.8 6.21,-287.798 -46.37,-422.001 -55.79,-142.398 -98.01,-238.297 -103.05,-305.297 -8.48,-112.8 78.86,-139.3 242.17,-167.601 226.67,-39.301 257.51,254.5 251.07,417.5 -3.27,82.801 30.44,208.499 26.04,291.399 0.3,0.2 0.5,0.4 0.48,0.8 0,0 -2.76,57.5 -6.92,147.5 h 0.02 c -0.03,0.7 -0.06,1.3 -0.09,2 -0.39,12.4 -0.79,24.8 -1.05,37.1 h -0.67 c -13.43,292.3 -17.64,841.5 -17.64,1003.45 0,283.15 56.68,424.12 19.24,847.82 -17.71,200.47 -91,412.48 -62.42,612.57 15.46,108.18 92.73,370.9 123.63,811.33 9.85,140.29 20.27,536.01 30.93,726.75 10.65,-190.74 21.07,-586.46 30.92,-726.75 30.9,-440.43 108.17,-703.15 123.63,-811.33 28.58,-200.09 -38.04,-412.81 -62.42,-612.57 -46.83,-383.7 19.24,-564.67 19.24,-847.82 0,-161.95 -4.21,-711.15 -17.64,-1003.45 h -0.67 c -0.26,-12.3 -0.66,-24.7 -1.05,-37.1 -0.03,-0.7 -0.06,-1.3 -0.09,-2 h 0.9 c -4.16,-90 -6.92,-147.5 -6.92,-147.5 -0.02,-0.4 0.18,-0.6 0.48,-0.8 -4.41,-82.9 29.31,-208.598 26.04,-291.399 -6.44,-163 24.4,-456.801 251.07,-417.5 163.31,28.301 250.65,54.801 242.17,167.601 -5.05,67 -47.26,162.899 -103.05,305.297 -52.58,134.203 -57.92,281.201 -46.37,422.001 4.67,33.9 8.96,68 12.87,102.2 h -0.91 c 5.01,43.7 9.35,87.4 12.51,131 12.05,166.1 62.66,320.9 122.71,476.3 120.58,312.1 195.26,641.82 221.21,975.36 28.84,370.5 -62.37,737.92 -37.95,1109.34 23.25,353.77 108.23,707.04 148.28,1054.16 69.55,602.7 23.19,919.5 -15.45,1228.58 -30.79,246.29 -91.99,483.76 -93.12,721.6 -1.12,237.84 57.83,476.05 66.49,723.79 8.22,234.96 21.73,439.97 42.11,439.97 42.41,0 31.44,-139.86 30.96,-163.09 -1.89,-92.51 -11.04,-182.43 -0.44,-274.97 24.83,-216.79 105.95,-422.02 174.81,-627.46 97.01,-289.46 63.59,-284.15 129.47,-580.3 104.49,-469.79 114.87,-533.17 114.87,-533.17 0,0 1.86,0 1.88,0 5.1,-29.45 9.02,-58.54 11.97,-87.34 -2.35,-4.08 -8.12,-190.92 -15.03,-276.56 -7.91,-98.19 -27.34,-202.98 -13.14,-301.22 5.23,-36.11 34.79,-161.73 89.26,-98.1 14.63,17.09 16.36,41.38 17.39,63.85 2.5,54.27 -15.6,178.92 18.61,222.48 32.99,42.01 77.03,12.12 89.76,-32.58 18.52,-65.03 -1.34,-149.07 -23.58,-210.54 -27.29,-75.43 -48.31,-121.36 -96.15,-185.74 -3.23,-4.36 -5.43,-9.27 -6.79,-14.53 -12.13,-46.84 45.34,-80.9 83.06,-50.59 154.52,124.17 241.4,377.38 245.89,556.87 3.92,156.78 -28,306.92 -63.37,457.66"
                                                style="
                                                  fill: #89e3f0;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="biopath164"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <div
                                        class="d-flex align-items-center justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 12;
                                          grid-column-end: 21;
                                          grid-row-start: 12;
                                          grid-row-end: 15;
                                        "
                                      >
                                        <div style="font-size: small">
                                          Bio Age
                                        </div>
                                      </div>
                                      <div
                                        id="bio-age-height"
                                        class="d-flex align-items-start justify-content-center"
                                        style="
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 12;
                                          grid-column-end: 21;
                                          grid-row-start: 3;
                                          grid-row-end: 12;
                                        "
                                      >
                                        <div
                                          id="bio-age-text"
                                          style="
                                            display: block;
                                            font-size: xx-small;
                                            height: 50px;
                                          "
                                        >
                                          15.1 yrs
                                        </div>
                                      </div>
                                      <!-- BIOAGE FEMALE-->
                                      <div
                                        class="d-flex align-items-end justify-content-center"
                                        style="
                                          z-index: 1;
                                          height: 100%;
                                          width: 100%;
                                          grid-column-start: 12;
                                          grid-column-end: 21;
                                          grid-row-start: 12;
                                          grid-row-end: 1;
                                        "
                                      >
                                        <!-- <div id="child" class=" d-flex align-items-end justify-content-center"> -->
                                        <svg
                                          class="bio-age-human"
                                          id="bio-age-female-human"
                                          style="display: none"
                                          height="200px"
                                          viewBox="800 125 600 1420"
                                        >
                                          <g
                                            id="motgbf158"
                                            transform="matrix(1.3333333,0,0,-1.3333333,0,1600)"
                                          >
                                            <g
                                              id="motgbf160"
                                              transform="scale(0.1)"
                                            >
                                              <path
                                                d="m 9688.49,6279.45 c -13.98,118.85 0,573.25 -34.96,762.01 -34.95,188.75 -69.91,286.62 -97.87,363.52 -27.96,76.9 -27.96,293.61 -48.93,475.38 -34.44,298.47 -9.3,633.87 -102.65,924.69 -112.88,351.63 -379.24,303.09 -602.97,394.17 -103.24,42.03 -196.68,97.51 -259.66,192.19 -6.71,10.1 -21.47,47.71 -37.05,93.15 h 33.6 c -1.91,2.17 -3.82,4.36 -5.67,6.6 2.73,0.47 5.45,1.02 8.17,1.5 1.96,0.3 3.91,0.66 5.82,1.07 8.55,1.55 17.09,3.05 25.63,4.71 h -11.17 c 7.53,3.51 14.04,8.63 18.61,16.18 -31.05,4.05 -59.73,24.92 -74.43,54.18 79.32,-29.77 174,-6.68 233.04,56.84 2.51,2.7 5.16,6.37 3.88,9.92 -0.78,2.17 -2.81,3.49 -4.72,4.65 -8.6,5.23 -103.87,75.93 -46.93,71.3 34.31,-2.8 112.8,-3.57 134.61,26.27 -17.46,16.47 -39.29,28.55 -54.26,48.21 -1.86,2.44 -25.82,33.14 -11.42,22.97 22.97,-16.22 69.15,-27.66 94.98,-22.28 -29.08,24.19 -55.83,48 -68.15,87.26 -7.64,24.36 49.83,73.09 65.16,198.96 15.33,125.9 -15.33,280.2 -65.15,430.4 -49.83,150.2 -95.82,320.8 -275.96,418.2 -180.13,97.5 -287.45,28.4 -287.45,28.4 0,0 -107.31,69.1 -287.45,-28.4 -180.13,-97.4 -226.12,-268 -275.95,-418.2 -49.82,-150.2 -80.48,-304.5 -65.15,-430.4 15.33,-125.87 72.8,-174.6 65.16,-198.96 -12.32,-39.26 -39.07,-63.07 -68.14,-87.26 25.82,-5.38 71.99,6.06 94.97,22.28 14.4,10.17 -9.56,-20.53 -11.42,-22.97 -14.97,-19.66 -36.8,-31.74 -54.26,-48.21 21.81,-29.84 100.3,-29.07 134.61,-26.27 56.94,4.63 -38.33,-66.07 -46.93,-71.3 -1.9,-1.16 -3.94,-2.48 -4.72,-4.65 -1.28,-3.55 1.37,-7.22 3.88,-9.92 59.04,-63.52 153.72,-86.61 233.04,-56.84 -14.7,-29.26 -43.38,-50.13 -74.43,-54.18 10.81,-17.85 32.41,-22.25 53.05,-23.38 v -6.68 h 21.94 c -15.58,-45.44 -30.34,-83.05 -37.05,-93.15 -62.98,-94.68 -156.42,-150.16 -259.66,-192.19 -223.74,-91.08 -490.1,-42.54 -602.97,-394.17 -93.35,-290.82 -68.21,-626.22 -102.65,-924.69 -20.97,-181.77 -20.97,-398.48 -48.93,-475.38 -27.96,-76.9 -62.92,-174.77 -97.87,-363.52 -34.96,-188.76 -20.98,-643.16 -34.96,-762.01 -13.98,-118.84 -13.98,-286.61 0,-510.32 6.46,-103.33 12.28,-211.18 28.3,-315.25 13.71,-89.06 44.79,-176.28 87.05,-255.71 17.69,-33.25 39.18,-65.08 61.43,-95.41 22.11,-30.15 71.65,-112.23 117.66,-100.33 11.66,3.02 20.18,13.81 23.17,25.48 8.9,34.71 -29.84,79.21 -44.3,108.9 -24.43,50.17 -38.96,102.54 -50.35,156.91 -6.89,32.9 -7.86,59.67 2.71,71.7 34.38,39.17 72.98,-193.35 120.01,-186.44 31.48,4.62 22.64,81.53 13.58,178.27 -9.14,97.64 -9.2,212.34 -50.02,303.34 -38.47,85.77 -95.36,170.99 -85.53,269.32 13.98,139.82 181.76,713.07 202.74,901.82 20.97,188.75 65.92,629.18 100.88,741.03 34.8,111.37 82.34,402.95 82.83,405.45 -2.63,-13.35 112.1,-151.76 123.82,-176.97 50.42,-108.43 65.33,-246.17 75.55,-363.98 36.86,-425.05 -133.11,-793.43 -243.27,-1192.76 -55.93,-202.74 -111.85,-713.07 -83.89,-908.81 27.96,-195.74 90.88,-608.2 160.79,-796.96 69.91,-188.75 153.8,-517.32 160.79,-629.17 4.74,-75.79 4.39,-280.99 -1.58,-469.97 h -0.04 c -2.84,-89.93 -6.95,-176.22 -12.4,-243.1 -12.7,-155.8 -13.99,-433.43 69.91,-824.94 87.49,-408.25 239.24,-1014.75 239.03,-1357.85 h 0.04 c 0.02,-0.3 -0.01,-0.6 0,-0.9 5.72,-94.198 0.45,-190.3 -34.38,-279.499 -40.2,-103 -60.62,-172.301 -64.25,-220.801 -6.12,-81.602 45.91,-106.898 164.5,-121.199 207.36,-25 195.56,184 190.92,301.898 -2.36,59.903 11.93,150.801 8.76,210.703 0.22,0.2 0.36,0.399 0.35,0.598 0,0 -1.99,41.602 -4.99,106.7 h 0.01 c -0.02,0.5 -0.04,1 -0.06,1.4 -0.01,0.4 -0.02,0.7 -0.03,1.1 h 0.27 c -0.17,2.3 -0.3,4.7 -0.47,7 -0.04,1.7 -0.09,3.3 -0.14,5 h -0.2 c -41.22,572.6 56.34,1151.46 53.73,1724.7 -1.37,300.3 -26.04,468.31 -33.82,673.92 -0.19,5.06 -0.29,10.16 -0.41,15.27 h 0.05 c -2.31,106.63 12.01,224.25 4.87,375.97 -10.41,220.95 -17.37,351.41 -4.59,652.17 6.97,164.16 60.97,419.12 57.63,578.73 -1.88,89.99 14.54,208.46 29.23,294.81 14.7,-86.35 31.12,-204.82 29.24,-294.81 -3.34,-159.61 48.56,-414.67 57.63,-578.73 13.67,-247.34 5.82,-431.22 -4.59,-652.17 -7.14,-151.72 7.18,-269.34 4.87,-375.97 h -0.21 c -0.11,-5.11 -0.22,-10.21 -0.41,-15.27 -7.77,-205.61 -32.44,-373.62 -33.81,-673.92 -2.62,-573.24 94.95,-1152.1 53.72,-1724.7 h -0.2 c -0.04,-1.7 -0.09,-3.3 -0.14,-5 -0.17,-2.3 -0.29,-4.7 -0.47,-7 h 0.28 c -0.01,-0.4 -0.02,-0.7 -0.03,-1.1 -0.02,-0.4 -0.05,-0.9 -0.07,-1.4 h 0.02 c -3,-65.098 -4.99,-106.7 -4.99,-106.7 -0.01,-0.199 0.13,-0.398 0.34,-0.598 -3.17,-59.902 11.13,-150.8 8.77,-210.703 -4.64,-117.898 -16.45,-326.898 190.92,-301.898 118.58,14.301 170.62,39.597 164.5,121.199 -3.63,48.5 -24.05,117.801 -64.26,220.801 -34.82,89.199 -40.09,185.301 -34.38,279.499 0.02,0.3 -0.01,0.6 0,0.9 h 0.05 c -0.21,343.1 151.54,949.6 239.03,1357.85 83.89,391.51 82.61,669.14 69.91,824.94 -5.45,66.88 -9.56,153.17 -12.4,243.1 h 0.21 c -5.97,188.98 -6.32,394.18 -1.58,469.97 6.99,111.85 90.88,440.42 160.79,629.17 69.91,188.76 132.83,601.22 160.79,796.96 27.96,195.74 -27.96,706.07 -83.89,908.81 -110.16,399.33 -280.13,767.71 -243.27,1192.76 10.22,117.81 25.13,255.55 75.55,363.98 11.72,25.21 126.45,163.62 123.82,176.97 0.49,-2.5 58.03,-294.08 92.83,-405.45 34.96,-111.85 69.91,-552.28 90.89,-741.03 20.97,-188.75 188.75,-762 202.73,-901.82 9.83,-98.33 -47.07,-183.55 -85.53,-269.32 -40.82,-91 -40.88,-205.7 -50.02,-303.34 -9.06,-96.74 -17.9,-173.65 13.58,-178.27 47.03,-6.91 85.63,225.61 120.01,186.44 10.57,-12.03 9.6,-38.8 2.71,-71.7 -11.39,-54.37 -25.92,-106.74 -50.35,-156.91 -14.46,-29.69 -53.2,-74.19 -44.3,-108.9 2.99,-11.67 11.51,-22.46 23.17,-25.48 46.01,-11.9 95.55,70.18 117.66,100.33 22.25,30.33 43.74,62.16 61.43,95.41 42.26,79.43 73.34,166.65 87.05,255.71 16.02,104.07 21.84,211.92 28.3,315.25 13.98,223.71 13.98,391.48 0,510.32"
                                                style="
                                                  fill: #89e3f0;
                                                  fill-opacity: 1;
                                                  fill-rule: nonzero;
                                                  stroke: none;
                                                "
                                                id="motpathbf166"
                                              ></path>
                                            </g>
                                          </g>
                                        </svg>
                                      </div>
                                      <!-- GRID FORMATTING -->
                                      <!-- Y axis -->
                                      <div
                                        style="
                                          border-right: 1px solid #f0f0f1;
                                          grid-column-start: 1;
                                          grid-column-end: 4;
                                          grid-row-start: 2;
                                          grid-row-end: 12;
                                        "
                                      ></div>
                                      <!-- all the grid rows -->
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 3;
                                          grid-row-end: 2;
                                        "
                                      >
                                        <div style="font-size: small">18</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 4;
                                          grid-row-end: 3;
                                        "
                                      >
                                        <div style="font-size: small">16</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 5;
                                          grid-row-end: 4;
                                        "
                                      >
                                        <div style="font-size: small">14</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 6;
                                          grid-row-end: 5;
                                        "
                                      >
                                        <div style="font-size: small">12</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 7;
                                          grid-row-end: 6;
                                        "
                                      >
                                        <div style="font-size: small">10</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 8;
                                          grid-row-end: 7;
                                        "
                                      >
                                        <div style="font-size: small">8</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 9;
                                          grid-row-end: 8;
                                        "
                                      >
                                        <div style="font-size: small">6</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 10;
                                          grid-row-end: 9;
                                        "
                                      >
                                        <div style="font-size: small">4</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 10;
                                          grid-row-end: 10;
                                        "
                                      >
                                        <div style="font-size: small">2</div>
                                      </div>
                                      <div
                                        style="
                                          border-bottom: 1px solid #f0f0f1;
                                          grid-column-start: 2;
                                          grid-column-end: 20;
                                          grid-row-start: 11;
                                          grid-row-end: 11;
                                        "
                                      >
                                        <div style="font-size: small">0</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Growth Tracking is now part of Bio-Banding & Growth modal -->

                  <!-- Performance Targets Section -->
                  <div
                    class="review-section-card targets-section"
                    v-if="this.playerPerformanceReviewTargetsData.length > 0"
                  >
                    <div class="section-header">
                      <div class="section-title">
                        <i class="bi bi-bullseye"></i>
                        <h3>Current Performance Targets</h3>
                      </div>
                      <div class="section-actions">
                        <b-button
                          size="sm"
                          class="action-btn"
                          variant="outline-secondary"
                          v-b-tooltip.hover
                          title="View history"
                          @click="performanceTargetsHistoryModal()"
                        >
                          <i class="bi bi-clock-history"></i>
                        </b-button>
                        <b-button
                          v-if="
                            userData.userType === 'Admin' ||
                            userData.userType === 'Coach'
                          "
                          size="sm"
                          class="action-btn"
                          variant="outline-success"
                          v-b-tooltip.hover
                          title="Add target"
                          @click="
                            performanceTargetsModal(
                              {},
                              'newPerformanceTargetsModal',
                              'performance target',
                            )
                          "
                        >
                          <i class="bi bi-plus-lg"></i>
                        </b-button>
                        <b-button
                          size="sm"
                          class="action-btn"
                          variant="outline-secondary"
                          v-b-tooltip.hover
                          title="Email targets"
                        >
                          <i class="bi bi-envelope"></i>
                        </b-button>
                      </div>
                    </div>
                    <div class="section-content">
                      <div class="target-categories-wrapper">
                        <div class="target-categories">
                          <h4>Attitude</h4>

                          <div
                            class="target-info"
                            v-for="performanceTarget in getPlayersCurrentPerformanceTargetsForCategory(
                              'Attitude',
                            )"
                            :key="performanceTarget.id"
                          >
                            <h4>
                              <img src="./img/target.svg" alt="" /> Target
                            </h4>
                            <span
                              v-if="performanceTarget.complete == 0"
                              class="small-date-player-coach"
                              >Not complete
                            </span>
                            <span
                              v-else
                              class="small-date-player-coach completed"
                              >Complete
                            </span>

                            <div class="target-content">
                              <div
                                v-if="performanceTarget.target !== ''"
                                v-html="performanceTarget.target"
                              ></div>
                              <div v-else>
                                <span
                                  >Looks you forgot to set a performance target
                                  <br />for the current performance review. Use
                                  the edit button to set one.</span
                                >
                              </div>

                              <b-button
                                v-if="
                                  userData.userType === 'Admin' ||
                                  userData.userType === 'Coach'
                                "
                                size="lg"
                                class="main-button"
                                variant="outline-warning"
                                v-b-tooltip.hover
                                title="Edit"
                                @click="
                                  performanceTargetsModal(
                                    performanceTarget,
                                    'performanceTargetsModal',
                                    'performance target',
                                  )
                                "
                              >
                                <i class="bi bi-pencil" aria-hidden="true"></i>
                              </b-button>
                            </div>
                          </div>
                        </div>

                        <div class="target-categories">
                          <h4>Skill</h4>

                          <div
                            class="target-info"
                            v-for="performanceTarget in getPlayersCurrentPerformanceTargetsForCategory(
                              'Skill',
                            )"
                            :key="performanceTarget.id"
                          >
                            <h4>
                              <img src="./img/target.svg" alt="" /> Target
                            </h4>
                            <span
                              v-if="performanceTarget.complete == 0"
                              class="small-date-player-coach"
                              >Not complete
                            </span>
                            <span
                              v-else
                              class="small-date-player-coach completed"
                              >Complete
                            </span>

                            <div class="target-content">
                              <div
                                v-if="performanceTarget.target !== ''"
                                v-html="performanceTarget.target"
                              ></div>
                              <div v-else>
                                <span
                                  >Looks you forgot to set a performance target
                                  <br />for the current performance review. Use
                                  the edit button to set one.</span
                                >
                              </div>

                              <b-button
                                size="lg"
                                class="main-button"
                                variant="outline-warning"
                                v-b-tooltip.hover
                                title="Edit"
                                @click="
                                  performanceTargetsModal(
                                    performanceTarget,
                                    'performanceTargetsModal',
                                    'performance target',
                                  )
                                "
                              >
                                <i class="bi bi-pencil" aria-hidden="true"></i>
                              </b-button>
                            </div>
                          </div>
                        </div>
                        <div class="target-categories">
                          <h4>Physique</h4>

                          <div
                            class="target-info"
                            v-for="performanceTarget in getPlayersCurrentPerformanceTargetsForCategory(
                              'Physique',
                            )"
                            :key="performanceTarget.id"
                          >
                            <h4>
                              <img src="./img/target.svg" alt="" /> Target
                            </h4>
                            <span
                              v-if="performanceTarget.complete == 0"
                              class="small-date-player-coach"
                              >Not complete
                            </span>
                            <span
                              v-else
                              class="small-date-player-coach completed"
                              >Complete
                            </span>

                            <div class="target-content">
                              <div
                                v-if="performanceTarget.target !== ''"
                                v-html="performanceTarget.target"
                              ></div>
                              <div v-else>
                                <span
                                  >Looks you forgot to set a performance target
                                  <br />for the current performance review. Use
                                  the edit button to set one.</span
                                >
                              </div>

                              <b-button
                                size="lg"
                                class="main-button"
                                variant="outline-warning"
                                v-b-tooltip.hover
                                title="Edit"
                                @click="
                                  performanceTargetsModal(
                                    performanceTarget,
                                    'performanceTargetsModal',
                                    'performance target',
                                  )
                                "
                              >
                                <i class="bi bi-pencil" aria-hidden="true"></i>
                              </b-button>
                            </div>
                          </div>
                        </div>

                        <div class="target-categories">
                          <h4>Mental</h4>

                          <div
                            class="target-info"
                            v-for="performanceTarget in getPlayersCurrentPerformanceTargetsForCategory(
                              'Mentality',
                            )"
                            :key="performanceTarget.id"
                          >
                            <h4>
                              <img src="./img/target.svg" alt="" /> Target
                            </h4>
                            <span
                              v-if="performanceTarget.complete == 0"
                              class="small-date-player-coach"
                              >Not complete
                            </span>
                            <span
                              v-else
                              class="small-date-player-coach completed"
                              >Complete
                            </span>

                            <div class="target-content">
                              <div
                                v-if="performanceTarget.target !== ''"
                                v-html="performanceTarget.target"
                              ></div>
                              <div v-else>
                                <span
                                  >Looks you forgot to set a performance target
                                  <br />for the current performance review. Use
                                  the edit button to set one.</span
                                >
                              </div>

                              <b-button
                                size="lg"
                                class="main-button"
                                variant="outline-warning"
                                v-b-tooltip.hover
                                title="Edit"
                                @click="
                                  performanceTargetsModal(
                                    performanceTarget,
                                    'performanceTargetsModal',
                                    'performance target',
                                  )
                                "
                              >
                                <i class="bi bi-pencil" aria-hidden="true"></i>
                              </b-button>
                            </div>
                          </div>
                        </div>

                        <div class="target-categories">
                          <h4>Leadership</h4>

                          <div
                            class="target-info"
                            v-for="performanceTarget in getPlayersCurrentPerformanceTargetsForCategory(
                              'Leadership',
                            )"
                            :key="performanceTarget.id"
                          >
                            <h4>
                              <img src="./img/target.svg" alt="" /> Target
                            </h4>
                            <span
                              v-if="performanceTarget.complete == 0"
                              class="small-date-player-coach"
                              >Not complete
                            </span>
                            <span
                              v-else
                              class="small-date-player-coach completed"
                              >Complete
                            </span>

                            <div class="target-content">
                              <div
                                v-if="performanceTarget.target !== ''"
                                v-html="performanceTarget.target"
                              ></div>
                              <div v-else>
                                <span
                                  >Looks you forgot to set a performance target
                                  <br />for the current performance review. Use
                                  the edit button to set one.</span
                                >
                              </div>

                              <b-button
                                size="lg"
                                class="main-button"
                                variant="outline-warning"
                                v-b-tooltip.hover
                                title="Edit"
                                @click="
                                  performanceTargetsModal(
                                    performanceTarget,
                                    'performanceTargetsModal',
                                    'performance target',
                                  )
                                "
                              >
                                <i class="bi bi-pencil" aria-hidden="true"></i>
                              </b-button>
                            </div>
                          </div>
                        </div>

                        <div class="target-categories">
                          <h4>Professionalism</h4>

                          <div
                            class="target-info"
                            v-for="performanceTarget in getPlayersCurrentPerformanceTargetsForCategory(
                              'Professionalism',
                            )"
                            :key="performanceTarget.id"
                          >
                            <h4>
                              <img src="./img/target.svg" alt="" /> Target
                            </h4>
                            <span
                              v-if="performanceTarget.complete == 0"
                              class="small-date-player-coach"
                              >Not complete
                            </span>
                            <span
                              v-else
                              class="small-date-player-coach completed"
                              >Complete
                            </span>

                            <div class="target-content">
                              <div
                                v-if="performanceTarget.target !== ''"
                                v-html="performanceTarget.target"
                              ></div>
                              <div v-else>
                                <span
                                  >Looks you forgot to set a performance target
                                  <br />for the current performance review. Use
                                  the edit button to set one.</span
                                >
                              </div>

                              <b-button
                                size="lg"
                                class="main-button"
                                variant="outline-warning"
                                v-b-tooltip.hover
                                title="Edit"
                                @click="
                                  performanceTargetsModal(
                                    performanceTarget,
                                    'performanceTargetsModal',
                                    'performance target',
                                  )
                                "
                              >
                                <i class="bi bi-pencil" aria-hidden="true"></i>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'learning-development-plan-tab'"
              >
                <div class="development-plan-info">
                  <IDPDashboard
                    :reports="allQuatersPlayerIDPdata"
                    :game-targets="playerGameTargetsData || []"
                    :goals="IDPGoalsData"
                    :current-quarter="gameTargetQuarterSelection"
                    :can-edit="
                      userData.userType === 'Admin' ||
                      userData.userType === 'Coach'
                    "
                    @create-report="openNewIDPModal"
                    @edit-report="openIDPModal"
                    @add-target="
                      performanceTargetsModal(
                        {},
                        'newPerformanceTargetsModal',
                        'game target',
                      )
                    "
                    @edit-target="
                      (target) =>
                        performanceTargetsModal(
                          target,
                          'performanceTargetsModal',
                          'game target',
                        )
                    "
                    @add-goal="openMonthGoalModal"
                    @edit-goal="editPlayerIDPGoal"
                    @quarter-change="selectQuaterDataForGameTargets"
                    @date-range-change="getallQuatersPlayerIDPscores($event)"
                    @export-pdf="exportIdpPdf"
                  />
                </div>
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'learning-plan-tab'"
              >
                <div class="games-info">
                  <TrainingPlansLinks :selectedUserData="selectedUserData" />
                </div>
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'parents-meeting-tab'"
              >
                <div class="games-info">
                  <div class="button-wrapper-top">
                    <b-button
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Export Parents evenings to csv"
                    >
                      <i class="bi bi-download" aria-hidden="true"></i>
                    </b-button>

                    <b-button
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Import Parents evenings document"
                    >
                      <i class="bi bi-upload" aria-hidden="true"></i>
                    </b-button>

                    <b-button
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Email Parents evenings data"
                    >
                      <i class="bi bi-envelope" aria-hidden="true"></i>
                    </b-button>
                  </div>
                  <p>Parents evenings cover:</p>

                  <ul>
                    <li>The club objectives for the forthcoming season</li>
                    <li>Club fees and registration processes</li>
                    <li>Club diary of events for the year</li>
                    <li>Team management and support</li>
                    <li>Club communication process</li>
                    <li>To recruit additional volunteers</li>
                    <li>Club welfare policy</li>
                    <li>Club Codes of Conduct and</li>
                    <li>disciplinary policy</li>
                  </ul>

                  <table class="w-a-style">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Discussion points and actions</th>
                        <th>Documents</th>
                        <th>Coach</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>April 2022</td>
                        <td>
                          Overview of progress and outline of player managment
                        </td>
                        <td>
                          <a
                            target="_blank"
                            href="https://south-carolina-surf-performance-centre.com/files/W-academy-IDP-sheet-Ollie-Paxton-2010.pdf"
                            >W-academy-IDP-sheet-Ollie-Paxton-2010.pdf</a
                          >
                        </td>
                        <td>Kyle and Olllie's parents present</td>
                        <td>
                          <div class="player-game-responce">
                            <b-button variant="outline-warning">
                              <i class="bi bi-pencil" aria-hidden="true"></i>
                              Edit
                            </b-button>
                            <b-button variant="outline-danger">
                              <i class="bi bi-trash" aria-hidden="true"></i>
                              Delete
                            </b-button>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>July 2022</td>
                        <td>
                          Overview of progress and outline of player managment
                        </td>
                        <td>
                          <a
                            target="_blank"
                            href="https://south-carolina-surf-performance-centre.com/files/W-academy-IDP-sheet-Ollie-Paxton-2010.pdf"
                            >W-academy-IDP-sheet-Ollie-Paxton-2010.pdf</a
                          >
                        </td>
                        <td>Kyle and Ollie's parents present</td>
                        <td>
                          <div class="player-game-responce">
                            <b-button variant="outline-warning">
                              <i class="bi bi-pencil" aria-hidden="true"></i>
                              Edit
                            </b-button>
                            <b-button variant="outline-danger">
                              <i class="bi bi-trash" aria-hidden="true"></i>
                              Delete
                            </b-button>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td>October 2022</td>
                        <td>
                          Overview of progress and outline of player managment
                        </td>
                        <td>
                          <a
                            target="_blank"
                            href="https://south-carolina-surf-performance-centre.com/files/W-academy-IDP-sheet-Ollie-Paxton-2010.pdf"
                            >W-academy-IDP-sheet-Ollie-Paxton-2010.pdf</a
                          >
                        </td>
                        <td>Kyle and Olllie's parents present</td>
                        <td>
                          <div class="player-game-responce">
                            <b-button variant="outline-warning">
                              <i class="bi bi-pencil" aria-hidden="true"></i>
                              Edit
                            </b-button>
                            <b-button variant="outline-danger">
                              <i class="bi bi-trash" aria-hidden="true"></i>
                              Delete
                            </b-button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'coach-tab'"
              >
                <div class="games-info">
                  <div class="button-wrapper-top">
                    <b-button
                      class="main-button"
                      @click="produceThePlayerCV()"
                      variant="outline-success"
                    >
                      <i
                        class="bi bi-file-earmark-person"
                        aria-hidden="true"
                      ></i>
                      View CV (PDF)
                    </b-button>
                  </div>

                  <div class="player-cv">
                    <section class="cv-section">
                      <div class="cv-section__head">
                        <h3>Personal profile</h3>
                        <b-button
                          size="sm"
                          variant="outline-success"
                          @click="openPlayerCVpersonalProfileModal()"
                        >
                          <i class="bi bi-pencil" aria-hidden="true"></i>
                          Edit
                        </b-button>
                      </div>

                      <p v-if="playerCvData.personal_profile !== ''">
                        {{ playerCvData.personal_profile }}
                      </p>
                      <p v-else class="cv-empty">
                        A few sentences about you as a player — this opens your
                        CV.
                      </p>
                    </section>
                    <section class="cv-section">
                      <div class="cv-section__head">
                        <h3>Playing experience</h3>
                        <b-button
                          size="sm"
                          variant="outline-success"
                          @click="openPlayerCVPlayingExperenceModal()"
                        >
                          <i class="bi bi-plus-lg" aria-hidden="true"></i>
                          Add experience
                        </b-button>
                      </div>

                      <p
                        v-if="playerCvData.playingExperence.length === 0"
                        class="cv-empty"
                      >
                        No clubs added yet — add where you've played.
                      </p>

                      <table
                        v-else
                        style="margin-bottom: 0.5rem"
                        class="w-a-style"
                      >
                        <thead>
                          <tr>
                            <th>Club</th>
                            <th>Time at the club</th>
                            <th>Playing information</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in sortedPlayingExperence"
                            :key="item.id"
                          >
                            <td>{{ item.club }}</td>
                            <td>
                              {{
                                formatCvDateRange(
                                  item.start_date_at_club,
                                  item.end_date_at_club,
                                )
                              }}
                            </td>
                            <td>{{ item.playing_info }}</td>
                            <td>
                              <div class="buttons-row">
                                <b-button
                                  @click="
                                    openPlayerCVPlayingExperenceModal(
                                      playerCvData.playingExperence.indexOf(
                                        item,
                                      ),
                                    )
                                  "
                                  size="sm"
                                  variant="outline-success"
                                >
                                  Edit</b-button
                                >

                                <b-button
                                  @click="
                                    confirmCvDelete(`exp-${item.id}`, () =>
                                      deletePlayingExperence(item.id),
                                    )
                                  "
                                  size="sm"
                                  :variant="
                                    cvDeleteArmedKey === `exp-${item.id}`
                                      ? 'danger'
                                      : 'outline-danger'
                                  "
                                >
                                  {{
                                    cvDeleteArmedKey === `exp-${item.id}`
                                      ? "Confirm delete"
                                      : "Delete"
                                  }}</b-button
                                >
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>

                    <section class="cv-section">
                      <div class="education">
                        <div class="cv-section__head">
                          <h3>Education</h3>
                          <b-button
                            size="sm"
                            variant="outline-success"
                            @click="openPlayerEducationModal()"
                          >
                            <i class="bi bi-plus-lg" aria-hidden="true"></i>
                            Add education
                          </b-button>
                        </div>

                        <p
                          v-if="playerCvData.education.length === 0"
                          class="cv-empty"
                        >
                          No qualifications added yet.
                        </p>

                        <ul style="margin-bottom: 0.5rem">
                          <li
                            v-for="(item, index) in playerCvData.education"
                            :key="index"
                          >
                            <span class="title">{{ item.title }}</span>
                            <span class="info">{{
                              formatCvDateRange(item.start_date, item.end_date)
                            }}</span>
                            <span class="info">{{ item.more_info }}</span>
                            <div class="buttons-row">
                              <b-button
                                @click="openPlayerEducationModal(index)"
                                size="sm"
                                variant="outline-success"
                              >
                                Edit</b-button
                              >

                              <b-button
                                @click="
                                  confirmCvDelete(`edu-${item.id}`, () =>
                                    deletePlayerEducation(item.id),
                                  )
                                "
                                size="sm"
                                :variant="
                                  cvDeleteArmedKey === `edu-${item.id}`
                                    ? 'danger'
                                    : 'outline-danger'
                                "
                              >
                                {{
                                  cvDeleteArmedKey === `edu-${item.id}`
                                    ? "Confirm delete"
                                    : "Delete"
                                }}</b-button
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </section>

                    <section class="cv-section">
                      <div class="hobbies">
                        <div class="cv-section__head">
                          <h3>Interests &amp; hobbies</h3>
                          <b-button
                            size="sm"
                            variant="outline-success"
                            @click="openPlayerInterestsHobbiesModal()"
                          >
                            <i class="bi bi-plus-lg" aria-hidden="true"></i>
                            Add interest
                          </b-button>
                        </div>

                        <p
                          v-if="playerCvData.interests_hobbies.length === 0"
                          class="cv-empty"
                        >
                          No interests added yet.
                        </p>
                        <table
                          v-else
                          style="margin-bottom: 0.5rem"
                          class="w-a-style"
                        >
                          <thead>
                            <tr>
                              <th>Interest or hobby</th>
                              <th>More information</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(
                                item, index
                              ) in playerCvData.interests_hobbies"
                              :key="index"
                            >
                              <td>{{ item.interests }}</td>
                              <td>
                                {{ item.more_info }}
                              </td>

                              <td>
                                <div class="buttons-row">
                                  <b-button
                                    @click="
                                      openPlayerInterestsHobbiesModal(index)
                                    "
                                    size="sm"
                                    variant="outline-success"
                                  >
                                    Edit</b-button
                                  >

                                  <b-button
                                    @click="
                                      confirmCvDelete(`hob-${item.id}`, () =>
                                        deletePlayerInterestsHobbies(item.id),
                                      )
                                    "
                                    size="sm"
                                    :variant="
                                      cvDeleteArmedKey === `hob-${item.id}`
                                        ? 'danger'
                                        : 'outline-danger'
                                    "
                                  >
                                    {{
                                      cvDeleteArmedKey === `hob-${item.id}`
                                        ? "Confirm delete"
                                        : "Delete"
                                    }}</b-button
                                  >
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>

                    <section class="cv-section">
                      <div class="players-videos">
                        <div class="cv-section__head">
                          <h3>Videos</h3>
                          <b-button
                            size="sm"
                            variant="outline-success"
                            @click="openPlayerVideosModal()"
                          >
                            <i class="bi bi-plus-lg" aria-hidden="true"></i>
                            Add video
                          </b-button>
                        </div>
                        <p v-if="cvVideos.length === 0" class="cv-empty">
                          No videos added yet — add links to your football
                          clips.
                        </p>

                        <div
                          class="sessions-info"
                          style="margin-bottom: 0.5rem"
                        >
                          <div
                            class="video-wrapper"
                            v-for="item in cvVideos"
                            :key="item.id"
                          >
                            <a
                              target="_blank"
                              rel="noopener"
                              :href="item.video_url"
                              class="session-card"
                            >
                              <TenantImage image-name="video" extension="jpg" />
                              <p class="small-date">Video</p>
                              <h3>{{ item.video_name }}</h3>
                            </a>

                            <div class="buttons-row">
                              <b-button
                                @click="
                                  openPlayerVideosModal(
                                    playerCvData.videos.indexOf(item),
                                  )
                                "
                                size="sm"
                                variant="outline-success"
                              >
                                Edit</b-button
                              >

                              <b-button
                                @click="
                                  confirmCvDelete(`vid-${item.id}`, () =>
                                    deletePlayerVideoLink(item.id),
                                  )
                                "
                                size="sm"
                                :variant="
                                  cvDeleteArmedKey === `vid-${item.id}`
                                    ? 'danger'
                                    : 'outline-danger'
                                "
                              >
                                {{
                                  cvDeleteArmedKey === `vid-${item.id}`
                                    ? "Confirm delete"
                                    : "Delete"
                                }}</b-button
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'code-of-conduct-tab'"
              >
                <div class="games-info">
                  <div class="button-wrapper-top">
                    <b-button
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Download players and parents code of conduct"
                    >
                      <i class="bi bi-download" aria-hidden="true"></i>
                    </b-button>

                    <b-button
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Email players and parents code of conduct"
                    >
                      <i class="bi bi-envelope" aria-hidden="true"></i>
                    </b-button>
                  </div>
                  <div class="players-code">
                    <h3>Players code of conduct</h3>
                    <p>
                      The rules within the Academy are based upon the principle
                      of ‘consideration and respect for others.’ This ensures
                      that everyone at the Academy can be safe, secure and happy
                      during their time at the club.
                    </p>

                    <ul>
                      <li>
                        Players are reminded that they represent Dundee. and
                        should behave in an appropriate manner;
                      </li>

                      <li>
                        Players are required to wear club colours with pride.
                      </li>

                      <li>
                        Swearing, fighting, bullying and bad behaviour of any
                        kind will not be tolerated at any time All match kit
                        will be provided.
                      </li>

                      <li>
                        Players should attend both training and matches with
                        clean and polished boots;
                      </li>

                      <li>
                        Jewellery must not be worn for matches or training
                        sessions, both for personal safety and that of other
                        players;
                      </li>

                      <li>
                        All Academy players are expected to keep themselves fit
                        at all times through a sensible nourishing diet,
                        appropriate rest and exercise. They may be given
                        instructions on exercises to complete away from the
                        Academy and keep their Player Planner up-to-date for
                        inspection by their age group Coach;
                      </li>

                      <li>
                        When travelling to away fixtures, players should ensure
                        they have all details of venue and time of arrival.
                      </li>

                      <li>
                        Players should arrive 60 minutes prior to kick off(where
                        possible) time for home games. For away matches, players
                        will be instructed by coach;
                      </li>

                      <li>
                        Players, under no circumstances, should argue or dispute
                        decisions given by the referee or his assistants;
                      </li>

                      <li>
                        Players attending the Academy must make a commitment to
                        adhere strictly to their individual programme at school;
                      </li>

                      <li>
                        All players are requested not to wear any jackets or
                        kits affiliated to any other football club on training
                        evenings
                      </li>
                    </ul>
                  </div>

                  <div class="players-code">
                    <h3>Parents’/Guardians’ Code of Conduct</h3>

                    <p>
                      We ask parents/guardians to stand on the appropriate side
                      of the pitch, opposite to the Coaches and substitutes. On
                      grass pitches, please stay behind the cones to permit
                      referees sight of the lines;
                    </p>

                    <p>
                      We ask parents/guardians not to get involved in any form
                      of negative shouting from the touchline. The coaching
                      staff work hard to create the correct environment for all
                      players to express themselves fully, both in training and
                      matches, without fear of making mistakes. The support of
                      parents/guardians is requested to achieve the environment
                      and please leave the coaching to the age group Coaches;
                    </p>

                    <p>
                      If there is an issue that concerns the player or yourself,
                      then please raise it with the appropriate Academy staff;
                    </p>

                    <p>
                      Please ensure that players get plenty of rest. An early
                      night before a game or after training is recommended;
                    </p>

                    <p>
                      Try to get players to eat healthily and at regular
                      intervals.
                    </p>
                    <ul>
                      <li>
                        A good breakfast before a morning game is essential to
                        set up the body for the strenuous work required during a
                        game.
                      </li>
                      <li>
                        Make sure players have an adequate supply of fluids to
                        drink before and after a game;
                      </li>
                    </ul>

                    <p>
                      Try to get players to take responsibility for their
                      football education, i.e. packing their kit bag, cleaning
                      their boots, preparing fluids for the day and making a
                      snack for after the game;
                    </p>

                    <p>
                      Please feel free to talk to the appropriate Coach for
                      feedback on players’ performance. At the start of each
                      season there will be an induction meeting with players and
                      parents/carers of the players to inform them of the games
                      programme and any additional information. Any concerns
                      they may have can be addressed at this meeting.
                    </p>
                  </div>

                  <b-button variant="outline-warning">
                    <i class="bi bi-pencil" aria-hidden="true"></i>
                    Edit
                  </b-button>
                </div>
              </div>

              <div
                class="current-week-tab tab-content"
                v-if="selectedTab === 'game-prep-tab'"
              >
                <div class="games-info">
                  <div class="button-wrapper-top">
                    <b-button
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Import Game preparation data"
                    >
                      <i class="bi bi-upload" aria-hidden="true"></i>
                    </b-button>

                    <b-button
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="Email Game preparation"
                    >
                      <i class="bi bi-envelope" aria-hidden="true"></i>
                    </b-button>
                  </div>
                  <p>
                    Enjoy a good night’s rest by going to bed early after
                    ensuring that your kit bag is packed with your
                  </p>
                  <ul>
                    <li>Boots</li>
                    <li>Shin guards</li>
                    <li>Towel</li>
                    <li>Rain jacket</li>
                    <li>Toiletries</li>
                    <li>Water bottle</li>
                    <li>Isotonic drink</li>
                    <li>Other items at Coach’s request</li>
                  </ul>

                  <ul>
                    <li>
                      Prepare yourself if you have a long journey by bringing
                      reading material, quiz books, personal stereo and possibly
                      school reading material.
                    </li>
                    <li>
                      Have a substantial breakfast as outlined in the section on
                      ‘Food for Football.’
                    </li>
                    <li>
                      Travel to the game in your tracksuit, polo shirt and
                      trainers unless instructed otherwise by your Coach;
                    </li>
                    <li>
                      Allow yourself plenty of time to get to your pick up
                      location. You should arrive 15 minutes before your
                      departure time;
                    </li>
                    <li>
                      It is advisable to bring a snack to eat after the match;
                    </li>
                    <li>
                      If you follow these simple instructions we are confident
                      that you will enjoy the day and always make sure you enjoy
                      the game.
                    </li>
                  </ul>

                  <b-button variant="outline-warning">
                    <i class="bi bi-pencil" aria-hidden="true"></i>
                    Edit
                  </b-button>
                </div>
              </div>

              <b-modal
                v-if="showNewplayerIDPModal"
                v-model="showNewplayerIDPModal"
                size="xl"
                title="Player / Coach ratings"
                hide-footer
              >
                <div class="development-plan-wrapper">
                  <div class="player-coach-scores-idp">
                    <h3>Player IDPs</h3>
                    <p>
                      From the Areas listed in your IDP, Please list a key skill
                      in each of the 4 boxes, with one skill for Green/ 1 for
                      Yellow / 1 for red.<br />
                      Two key areas of improvement (Yellow and Red) and One area
                      of your strongest/best attribute (Green).
                      <br />
                      Add these into your IDP Grade using traffic light system.
                    </p>

                    <ul>
                      <li>Green – Excelling/Striving</li>
                      <li>Yellow- Coping</li>
                      <li>Red – Developing</li>
                    </ul>

                    <div class="scores-wrapper">
                      <div class="score-item">
                        <h3>Technical</h3>
                        <div class="score-by-type green">
                          <h4>Green</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.technical_green"
                            :options="technicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type yellow">
                          <h4>Yellow</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.technical_yellow"
                            :options="technicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type red">
                          <h4>Red</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.technical_red"
                            :options="technicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="score-item">
                        <h3>Tactical</h3>
                        <div class="score-by-type green">
                          <h4>Green</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.tactical_green"
                            :options="tacticalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type yellow">
                          <h4>Yellow</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.tactical_yellow"
                            :options="tacticalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type red">
                          <h4>Red</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.tactical_red"
                            :options="tacticalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="score-item">
                        <h3>Physical</h3>

                        <div class="score-by-type green">
                          <h4>Green</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.physical_green"
                            :options="physicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type yellow">
                          <h4>Yellow</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.physical_yellow"
                            :options="physicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type red">
                          <h4>Red</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.physical_red"
                            :options="physicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="score-item">
                        <h3>Mental</h3>
                        <div class="score-by-type green">
                          <h4>Green</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.physcological_green"
                            :options="physcologicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type yellow">
                          <h4>Yellow</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.physcological_yellow"
                            :options="physcologicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type red">
                          <h4>Red</h4>
                          <b-form-select
                            v-model="newPlayerIDPdata.physcological_red"
                            :options="physcologicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="idp-comments">
                    <div class="comments-item">
                      <h4>Player comments</h4>
                      <b-form-textarea
                        id="textarea-rows"
                        placeholder="add a comment..."
                        v-model="newPlayerIDPdata.player_comments"
                        rows="8"
                      ></b-form-textarea>
                    </div>
                    <div
                      class="comments-item"
                      v-if="
                        userData.userType === 'Admin' ||
                        userData.userType === 'Coach'
                      "
                    >
                      <h4>Coach comments</h4>
                      <b-form-textarea
                        id="textarea-rows"
                        placeholder="add a comment..."
                        v-model="newPlayerIDPdata.coach_comments"
                        rows="8"
                      ></b-form-textarea>
                    </div>
                  </div>

                  <b-button
                    @click="savePlayerIDPScores()"
                    size="lg"
                    variant="outline-success"
                    >Save</b-button
                  >
                </div>
              </b-modal>

              <b-modal
                v-if="showPlayerIDPModal"
                v-model="showPlayerIDPModal"
                size="xl"
                hide-footer
              >
                <div class="development-plan-wrapper">
                  <div class="player-coach-scores-idp">
                    <h3>Player / Coach ratings</h3>

                    <div class="scores-wrapper">
                      <div class="score-item">
                        <h3>Technical</h3>
                        <div class="score-by-type green">
                          <h4>Green</h4>
                          <b-form-select
                            v-model="playerIDPdata.technical_green"
                            :options="technicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type yellow">
                          <h4>Yellow</h4>
                          <b-form-select
                            v-model="playerIDPdata.technical_yellow"
                            :options="technicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type red">
                          <h4>Red</h4>
                          <b-form-select
                            v-model="playerIDPdata.technical_red"
                            :options="technicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="score-item">
                        <h3>Tactical</h3>
                        <div class="score-by-type green">
                          <h4>Green</h4>
                          <b-form-select
                            v-model="playerIDPdata.tactical_green"
                            :options="tacticalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type yellow">
                          <h4>Yellow</h4>
                          <b-form-select
                            v-model="playerIDPdata.tactical_yellow"
                            :options="tacticalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type red">
                          <h4>Red</h4>
                          <b-form-select
                            v-model="playerIDPdata.tactical_red"
                            :options="tacticalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="score-item">
                        <h3>Physical</h3>

                        <div class="score-by-type green">
                          <h4>Green</h4>
                          <b-form-select
                            v-model="playerIDPdata.physical_green"
                            :options="physicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type yellow">
                          <h4>Yellow</h4>
                          <b-form-select
                            v-model="playerIDPdata.physical_yellow"
                            :options="physicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type red">
                          <h4>Red</h4>
                          <b-form-select
                            v-model="playerIDPdata.physical_red"
                            :options="physicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                      </div>

                      <div class="score-item">
                        <h3>Mental</h3>
                        <div class="score-by-type green">
                          <h4>Green</h4>
                          <b-form-select
                            v-model="playerIDPdata.physcological_green"
                            :options="physcologicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type yellow">
                          <h4>Yellow</h4>
                          <b-form-select
                            v-model="playerIDPdata.physcological_yellow"
                            :options="physcologicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>

                        <div class="score-by-type red">
                          <h4>Red</h4>
                          <b-form-select
                            v-model="playerIDPdata.physcological_red"
                            :options="physcologicalSelectOptions"
                            class="mb-3"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled
                                >-- Please select an option
                                --</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="idp-comments">
                    <div class="comments-item">
                      <h4>Player comments</h4>
                      <b-form-textarea
                        id="textarea-rows"
                        placeholder="add a comment..."
                        v-model="playerIDPdata.player_comments"
                        rows="8"
                      ></b-form-textarea>
                    </div>
                    <div
                      class="comments-item"
                      v-if="
                        userData.userType === 'Admin' ||
                        userData.userType === 'Coach'
                      "
                    >
                      <h4>Coach comments</h4>
                      <b-form-textarea
                        id="textarea-rows"
                        placeholder="add a comment..."
                        v-model="playerIDPdata.coach_comments"
                        rows="8"
                      ></b-form-textarea>
                    </div>
                  </div>

                  <b-button
                    @click="updatePlayerIDPScores()"
                    size="lg"
                    variant="outline-success"
                    >Update</b-button
                  >
                </div>
              </b-modal>

              <b-modal
                v-if="showViewHomeworkModal"
                v-model="showViewHomeworkModal"
                size="lg"
                hide-footer
              >
                <h2>homework</h2>

                <div class="form__item">
                  <label class="form__label" for="goals">Title</label>
                  <p>{{ newHomeWorkData.title }}</p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="goals">Game</label>
                  <p>
                    {{ newHomeWorkData.opposition }} -
                    {{ formatDate(newHomeWorkData.matchDate) }}
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="goals">Information</label>
                  <p v-html="newHomeWorkData.information"></p>
                </div>

                <h4>Videos</h4>

                <div
                  v-if="newHomeWorkData.videos.length > 0"
                  class="homework-links player-cv"
                >
                  <div class="sessions-info" style="margin-bottom: 0.5rem">
                    <div
                      class="video-wrapper"
                      v-for="(item, index) in newHomeWorkData.videos"
                      :key="index"
                    >
                      <a
                        target="_blank"
                        :href="item.video_url"
                        class="session-card"
                      >
                        <TenantImage image-name="video" extension="jpg" />
                        <p class="small-date">Video</p>
                        <h3>{{ item.video_name }}</h3>
                      </a>
                    </div>
                  </div>
                </div>
              </b-modal>

              <b-modal
                v-if="showAddHomeworkModal"
                v-model="showAddHomeworkModal"
                size="lg"
                hide-footer
              >
                <h2>
                  <span v-if="newHomeWorkData.id !== undefined">Edit</span
                  ><span v-else>Add</span> homework
                </h2>

                <div class="form__item">
                  <label class="form__label" for="goals">Title</label>
                  <b-form-input
                    id="textarea"
                    v-model="newHomeWorkData.title"
                  ></b-form-input>
                </div>

                <div class="form__item">
                  <label class="form__label" for="goals">Select game</label
                  ><br />

                  <b-form-select v-model="newHomeWorkData.gameId" class="mb-3">
                    <b-form-select-option
                      v-for="(game, index) in allGameData"
                      :key="index"
                      :value="game.id"
                      >{{ formatDates(game.matchDate) }} -
                      {{ game.opposition }}</b-form-select-option
                    >
                  </b-form-select>
                </div>

                <div class="form__item">
                  <label class="form__label" for="goals">Information</label>
                  <QuillEditor
                    v-model:content="newHomeWorkData.information"
                    contentType="html"
                  />
                </div>

                <h4>Videos</h4>

                <b-button
                  v-b-tooltip.hover
                  title="Add video"
                  @click="addVideo('homework')"
                  variant="success"
                >
                  <i class="bi bi-plus" aria-hidden="true"></i>
                </b-button>

                <div
                  class="homework-links"
                  v-for="(video, index) in newHomeWorkData.videos"
                  :key="index"
                  :value="video"
                >
                  <div class="form__item">
                    <label class="form__label" for="video-name"
                      >Video name</label
                    >
                    <b-form-input
                      id="video-name"
                      v-model="video.video_name"
                    ></b-form-input>
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="video-url">Video URL</label>
                    <b-form-input
                      id="video-url"
                      v-model="video.video_url"
                    ></b-form-input>
                  </div>

                  <b-button
                    v-b-tooltip.hover
                    title="remove video"
                    variant="danger"
                  >
                    <i
                      class="bi bi-x"
                      aria-hidden="true"
                      @click="removeVideo(index)"
                    ></i>
                  </b-button>
                </div>

                <b-button
                  v-if="newHomeWorkData.id !== undefined"
                  @click="editHomework()"
                  size="lg"
                  variant="outline-success"
                >
                  <i class="bi bi-file-text" aria-hidden="true"></i> Edit game
                  homework
                </b-button>

                <b-button
                  v-else
                  @click="saveHomework()"
                  size="lg"
                  variant="outline-success"
                  :disabled="$store.getters.isReadOnlySeason"
                >
                  <i class="bi bi-file-text" aria-hidden="true"></i> Submit game
                  homework
                </b-button>
              </b-modal>
              <b-modal
                v-if="showAddHeight"
                v-model="showAddHeight"
                size="lg"
                hide-footer
              >
                <h2>Add your height</h2>

                <div class="form__item">
                  <b-input-group append="cm">
                    <br />
                    <b-form-input
                      type="number"
                      placeholder="Height"
                      v-model="height"
                    ></b-form-input>
                  </b-input-group>
                </div>

                <b-button @click="saveHeight()" variant="outline-success"
                  >Save</b-button
                >
              </b-modal>

              <b-modal
                v-if="showAddWeight && !actorIsFoundationPlayer"
                v-model="showAddWeight"
                hide-footer
              >
                <h2>Add your weight</h2>

                <div class="form__item">
                  <b-input-group append="kg">
                    <br />
                    <b-form-input
                      type="number"
                      v-model="weight"
                      placeholder="Weight"
                    ></b-form-input>
                  </b-input-group>
                </div>

                <b-button @click="saveWeight()" variant="outline-success"
                  >Save</b-button
                >
              </b-modal>

              <b-modal
                v-if="showViewDailyWellnessReport"
                v-model="showViewDailyWellnessReport"
                size="lg"
                @close="onCloseDailyWellnessModal()"
                hide-footer
              >
                <h2>How do you feel today?</h2>
                <b-form-group
                  class="colour-radios"
                  label="Sleep"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio-group
                    v-model="wellnessQuestions.sleep"
                    :aria-describedby="ariaDescribedby"
                    :options="zeroToTen"
                    name="sleep-radios"
                    buttons
                  >
                  </b-form-radio-group>
                  <div class="tyes-of-stuff">
                    <span>Bad</span>
                    <span>Amazing</span>
                  </div>
                </b-form-group>

                <b-form-group
                  class="colour-radios"
                  label="Happiness"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio-group
                    v-model="wellnessQuestions.happyness"
                    :aria-describedby="ariaDescribedby"
                    :options="zeroToTen"
                    name="Happyness-radios"
                    buttons
                  >
                  </b-form-radio-group>
                  <div class="tyes-of-stuff">
                    <span>Very sad</span>
                    <span>Very happy</span>
                  </div>
                </b-form-group>

                <b-form-group
                  class="colour-radios"
                  label="Stress"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio-group
                    v-model="wellnessQuestions.stress"
                    :aria-describedby="ariaDescribedby"
                    :options="zeroToTen"
                    name="Stress-radios"
                    buttons
                  >
                  </b-form-radio-group>
                  <div class="tyes-of-stuff">
                    <span>Really stressed</span>
                    <span>None </span>
                  </div>
                </b-form-group>

                <b-form-group
                  class="colour-radios"
                  label="Fatigue"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio-group
                    v-model="wellnessQuestions.fatigue"
                    :aria-describedby="ariaDescribedby"
                    :options="zeroToTen"
                    name="Fatigue-radios"
                    buttons
                  >
                  </b-form-radio-group>
                  <div class="tyes-of-stuff">
                    <span>Exhausted</span>
                    <span>Ready to go</span>
                  </div>
                </b-form-group>

                <b-form-group
                  class="colour-radios"
                  label="Muscle Soreness"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio-group
                    v-model="wellnessQuestions.muscleSoreness"
                    :aria-describedby="ariaDescribedby"
                    :options="zeroToTen"
                    name="Muscle-radios"
                    buttons
                  >
                  </b-form-radio-group>
                  <div class="tyes-of-stuff">
                    <span>Very sore</span>
                    <span>None</span>
                  </div>
                </b-form-group>

                <div class="player-game-responce">
                  <b-button @click="saveHowYouFeel()" variant="outline-success"
                    >Save</b-button
                  >
                </div>
              </b-modal>

              <b-modal
                v-if="showPerformanceModal"
                v-model="showPerformanceModal"
                size="lg"
                title="Record your game performance"
                hide-footer
              >
                <p>
                  Please fill in the form below to record your game performance.
                  This will help you and your coaches to track your progress and
                  identify areas for improvement. If you don't see your game
                  listed, please check the Game match reports as your coach
                  might have already created one.
                </p>

                <form
                  class="form performance-form"
                  @submit.prevent="saveUserGamePerformanceReport()"
                >
                  <div class="form__item">
                    <label class="form__label required-field" for="gameId"
                      >Select game *</label
                    >
                    <select id="gameId" v-model="newGamePerformanceData.gameId">
                      <option disabled value="">Please select a game</option>
                      <option
                        v-for="game in pastGameDataDataFiltered"
                        :value="game.id"
                        :key="game.id"
                        :disabled="game.disabled"
                      >
                        {{ formatISOStringDateAndTime(game.kickOffTime) }} |
                        {{ game.opposition }}
                      </option>
                    </select>
                  </div>

                  <div class="form__item">
                    <label
                      class="form__label required-field"
                      for="postion_played"
                      >What position did you play? *</label
                    >
                    <select
                      id="postion_played"
                      v-model="newGamePerformanceData.postion_played"
                    >
                      <option disabled value="">
                        Please select a position
                      </option>
                      <option value="Goalkeeper">Goalkeeper</option>
                      <option value="Right Full-back (Wingback)">
                        Right Full-back (Wingback)
                      </option>
                      <option value="Left Full-back (Wingback)">
                        Left Full-back (Wingback)
                      </option>
                      <option value="Center-back left">Center-back left</option>
                      <option value="Center-back right">
                        Center-back right
                      </option>
                      <option value="Centre midfield">Centre midfield</option>
                      <option value="Centre Defensive Midfield">
                        Centre Defensive Midfield
                      </option>
                      <option value="Defensive Midfielder">
                        Defensive Midfielder
                      </option>
                      <option value="Right Midfielder (Winger)">
                        Right Midfielder (Winger)
                      </option>
                      <option value="Left Midfielder (Winger)">
                        Left Midfielder (Winger)
                      </option>
                      <option value="Attacking Midfielder">
                        Attacking Midfielder
                      </option>
                      <option value="Center Forward (Striker) left">
                        Center Forward (Striker) left
                      </option>
                      <option value="Center Forward (Striker) right">
                        Center Forward (Striker) right
                      </option>
                    </select>
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="postion_played_two"
                      >Second position played?</label
                    >
                    <select
                      id="postion_played_two"
                      v-model="newGamePerformanceData.postion_played_two"
                    >
                      <option disabled value="">
                        Please select a position
                      </option>
                      <option value="Goalkeeper">Goalkeeper</option>
                      <option value="Right Full-back (Wingback)">
                        Right Full-back (Wingback)
                      </option>
                      <option value="Left Full-back (Wingback)">
                        Left Full-back (Wingback)
                      </option>
                      <option value="Center-back left">Center-back left</option>
                      <option value="Center-back right">
                        Center-back right
                      </option>
                      <option value="Centre midfield">Centre midfield</option>
                      <option value="Centre Defensive Midfield">
                        Centre Defensive Midfield
                      </option>

                      <option value="Defensive Midfielder">
                        Defensive Midfielder
                      </option>
                      <option value="Right Midfielder (Winger)">
                        Right Midfielder (Winger)
                      </option>
                      <option value="Left Midfielder (Winger)">
                        Left Midfielder (Winger)
                      </option>
                      <option value="Attacking Midfielder">
                        Attacking Midfielder
                      </option>
                      <option value="Center Forward (Striker) left">
                        Center Forward (Striker) left
                      </option>
                      <option value="Center Forward (Striker) right">
                        Center Forward (Striker) right
                      </option>
                    </select>
                  </div>

                  <h3>Technically</h3>

                  <div class="form__item">
                    <label class="form__label required-field" for="goals"
                      >Improvements *</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.technically_improvements"
                      label="Dictate improvements"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.technically_improvements"
                      placeholder="Technical improvements text..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <div class="form__item">
                    <label class="form__label required-field" for="goals"
                      >Positives *</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.technically_positives"
                      label="Dictate positives"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.technically_positives"
                      placeholder="Positives text..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <h3>Tactility</h3>

                  <div class="form__item">
                    <label class="form__label required-field" for="goals"
                      >Improvements *</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.tactility_improvements"
                      label="Dictate improvements"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.tactility_improvements"
                      placeholder="Tactility improvements text..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <div class="form__item">
                    <label class="form__label required-field" for="goals"
                      >Positives *</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.tactility_positives"
                      label="Dictate positives"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.tactility_positives"
                      placeholder="Tactility Positives text..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <h3>Physicality</h3>

                  <div class="form__item">
                    <label class="form__label required-field" for="goals"
                      >Improvements *</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.physicality_improvements"
                      label="Dictate improvements"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.physicality_improvements"
                      placeholder="Physicality improvements text..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <div class="form__item">
                    <label class="form__label required-field" for="goals"
                      >Positives *</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.physicality_positives"
                      label="Dictate positives"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.physicality_positives"
                      placeholder="Physicality Positives text..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <h3>Mental</h3>

                  <div class="form__item">
                    <label class="form__label required-field" for="goals"
                      >Improvements *</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.mentally_improvements"
                      label="Dictate improvements"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.mentally_improvements"
                      placeholder="Physiological improvements text..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <div class="form__item">
                    <label class="form__label required-field" for="goals"
                      >Positives *</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.mentally_positives"
                      label="Dictate positives"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.mentally_positives"
                      placeholder="Physiological Positives text..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                  <div class="form__item head-style">
                    <label class="form__label required-field" for="timeOnPitch"
                      >How long did you play for? (mins) *</label
                    >

                    <input
                      class="form__input"
                      type="number"
                      id="timeOnPitch"
                      max="120"
                      min="0"
                      @keydown="
                        ($event) => {
                          if (
                            newGamePerformanceData.timeOnPitch &&
                            newGamePerformanceData.timeOnPitch.toString()
                              .length >= 3 &&
                            /^[0-9]$/.test($event.key)
                          ) {
                            $event.preventDefault();
                            return false;
                          }
                        }
                      "
                      v-model="newGamePerformanceData.timeOnPitch"
                    />
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="card"
                      >Did you get a card?</label
                    >
                    <select id="card" v-model="newGamePerformanceData.card">
                      <option value="no">No</option>
                      <option value="Yellow">Yellow</option>
                      <option value="two Yellows (red)">
                        Two yellows (red)
                      </option>
                      <option value="red">red</option>
                    </select>
                  </div>

                  <div
                    v-if="
                      newGamePerformanceData.postion_played !== 'Goalkeeper'
                    "
                    class="form__item"
                  >
                    <label class="form__label" for="assists"
                      >How many Assists?</label
                    >
                    <input
                      class="form__input"
                      type="number"
                      id="assists"
                      v-model="newGamePerformanceData.assists"
                    />
                  </div>

                  <div
                    v-if="
                      newGamePerformanceData.postion_played !== 'Goalkeeper'
                    "
                    class="form__item"
                  >
                    <label class="form__label" for="goals"
                      >How many goals did you score?</label
                    >
                    <input
                      class="form__input"
                      type="number"
                      id="goals"
                      v-model="newGamePerformanceData.goals"
                    />
                  </div>
                  <div v-else class="form__item">
                    <label class="form__label" for="goals"
                      >Did you have a clean sheet?</label
                    >
                    <select
                      id="goals"
                      v-model="newGamePerformanceData.clean_sheet"
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="goals"
                      >Overall comments</label
                    >
                    <VoiceDictationButton
                      v-model="newGamePerformanceData.overall_comments"
                      label="Dictate overall comments"
                    />
                    <b-form-textarea
                      id="textarea"
                      v-model="newGamePerformanceData.overall_comments"
                      placeholder="Comments..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>

                  <b-button type="submit" size="lg" variant="outline-success">
                    <i class="bi bi-file-text" aria-hidden="true"></i>
                    Submit game performance report
                  </b-button>
                </form>
              </b-modal>

              <b-modal
                v-if="showTrainingPerformanceModal"
                v-model="showTrainingPerformanceModal"
                size="lg"
                hide-footer
              >
                <h2>Record your training report</h2>
                <form
                  class="form"
                  @submit.prevent="saveTraningPerformanceReport()"
                >
                  <div class="form__item">
                    <label class="form__label" for="traningId"
                      >Select training session</label
                    >
                    <select
                      id="traningId"
                      v-model="newTrainingPerformanceData.traningId"
                    >
                      <option disabled value="">Please select a game</option>
                      <option
                        v-for="training in pastTrainingSessionsDataFiltered"
                        :value="training.id"
                        :key="training.id"
                        :disabled="training.disabled"
                      >
                        {{ formatISOStringDateAndTime(training.kickOffTime) }} |
                        Traning
                      </option>
                    </select>
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="effort"
                      >How hard was the session?</label
                    >
                    <select
                      id="effort"
                      v-model="newTrainingPerformanceData.effort"
                    >
                      <option disabled value="">Please select an option</option>
                      <option value="10">10 Max effort</option>
                      <option value="9">9 VERY HARD</option>
                      <option value="8">8 VIGOROUS ACTIVITY</option>
                      <option value="7">7 MODERATE ACTIVITY</option>
                      <option value="6">6 LIGHT ACTIVITY</option>
                      <option value="5">5 VERY LIGHT ACTIVITY</option>
                    </select>
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="enjoyment"
                      >Did you enjoy the session?</label
                    >
                    <select
                      id="enjoyment"
                      v-model="newTrainingPerformanceData.enjoyment"
                    >
                      <option value="Amazing">Amazing</option>
                      <option value="Good">Good</option>
                      <option value="Ok">Ok</option>
                      <option value="Not so good">Not so good</option>
                      <option value="Did not enjoy it">Did not enjoy it</option>
                    </select>
                  </div>

                  <b-button
                    v-if="pastTrainingSessionsDataFiltered.length > 0"
                    type="submit"
                    size="lg"
                    variant="outline-success"
                  >
                    <i class="bi bi-file-text" aria-hidden="true"></i> Submit
                    training performance report
                  </b-button>
                  <p class="red-warning" v-else>
                    You need to attended at least one training session to
                    complete a training performance report
                  </p>
                </form>
              </b-modal>

              <b-modal
                v-if="showCoachGamePerformanceModal"
                v-model="showCoachGamePerformanceModal"
                size="lg"
                hide-footer
                @hide="hideCoachPerformanceModel()"
              >
                <h2>Record players game report</h2>

                <form
                  class="form"
                  @submit.prevent="coachesGamePerformanceReport()"
                >
                  <div class="form__item">
                    <label class="form__label" for="gameIdSelect"
                      >Select game</label
                    >
                    <select
                      id="gameIdSelect"
                      v-model="coachGamePerformanceReportData.id"
                      @change="onCoachReportGameChange($event)"
                    >
                      <option disabled value="">Please select a game</option>
                      <option
                        v-for="game in pastGameDataFilteredCoach"
                        :value="game.id"
                        :key="game.id"
                        :disabled="game.disabled"
                      >
                        {{ formatDates(game.matchDate) }} |
                        {{ game.opposition }}
                      </option>
                    </select>
                  </div>

                  <div
                    v-if="eyeballPrefillApplied"
                    class="alert alert-info py-2 px-3 mb-3"
                    style="font-size: 0.9em"
                  >
                    <i class="bi bi-info-circle"></i>
                    Pre-filled minutes, goals and positions from Eyeball team
                    lines (won't overwrite existing data).
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="player_rating"
                      >How did you think<br />
                      {{ selectedUserData.name }} played?</label
                    >
                    <select
                      id="player_rating"
                      v-model="coachGamePerformanceReportData.player_rating"
                    >
                      <option value="Excellent">Excellent</option>
                      <option value="Good">Good</option>
                      <option value="Progressing well">Progressing well</option>
                      <option value="⁠⁠Requires improvement">
                        ⁠⁠Requires improvement
                      </option>
                      <option value="Unsatisfactory">Unsatisfactory</option>
                    </select>
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="goals"
                      >Positive comments</label
                    >
                    <CoachReportAIHelper
                      v-model="coachGamePerformanceReportData.game_comments"
                      field-type="positives"
                      :player-name="
                        selectedUserData && selectedUserData.name
                          ? selectedUserData.name
                          : ''
                      "
                      :position="
                        [
                          coachGamePerformanceReportData.postion_played,
                          coachGamePerformanceReportData.postion_played_two,
                        ]
                          .filter(Boolean)
                          .join(', ')
                      "
                    />
                    <textarea
                      class="form__input"
                      id="game_comments"
                      v-model="coachGamePerformanceReportData.game_comments"
                    ></textarea>
                  </div>

                  <div class="form__item">
                    <label class="form__label" for="goals"
                      >Improvments comments</label
                    >
                    <CoachReportAIHelper
                      v-model="coachGamePerformanceReportData.game_improvements"
                      field-type="improvements"
                      :player-name="
                        selectedUserData && selectedUserData.name
                          ? selectedUserData.name
                          : ''
                      "
                      :position="
                        [
                          coachGamePerformanceReportData.postion_played,
                          coachGamePerformanceReportData.postion_played_two,
                        ]
                          .filter(Boolean)
                          .join(', ')
                      "
                    />
                    <textarea
                      class="form__input"
                      id="improvments_comments"
                      v-model="coachGamePerformanceReportData.game_improvements"
                    ></textarea>
                  </div>

                  <div class="form__item" v-if="coachData.length > 0">
                    <label class="form__label" for="coachSelect"
                      >Name of Coach(s) completing the report</label
                    >

                    <b-form-select
                      v-model="coachGamePerformanceReportData.coachId"
                      id="coachSelect"
                      :state="
                        coachSelectTouched
                          ? coachGamePerformanceReportData.coachId
                            ? true
                            : false
                          : null
                      "
                      required
                      @blur="coachSelectTouched = true"
                    >
                      <b-form-select-option disabled value=""
                        >Please select a coach</b-form-select-option
                      >
                      <b-form-select-option
                        v-for="coach in coachData"
                        :value="coach.id"
                        :key="coach.id"
                      >
                        {{ coach.name }}
                      </b-form-select-option>
                    </b-form-select>
                    <b-form-invalid-feedback
                      v-if="
                        coachSelectTouched &&
                        !coachGamePerformanceReportData.coachId
                      "
                    >
                      Please select a coach to complete the report
                    </b-form-invalid-feedback>

                    <p>
                      Selected coach:
                      <span
                        v-if="coachGamePerformanceReportData.coachId !== null"
                        >{{
                          getCoachesNameFromId(
                            coachGamePerformanceReportData.coachId,
                          )
                        }}</span
                      >
                      <span v-else>No coach selected!</span>
                    </p>
                  </div>

                  <b-button
                    v-if="pastGameData.length > 0"
                    type="submit"
                    size="lg"
                    variant="outline-success"
                  >
                    <i class="bi bi-file-text" aria-hidden="true"></i> Submit
                    player game performance report
                  </b-button>
                  <p class="red-warning" v-else>
                    You need to play at least one game to complete a players
                    game report
                  </p>
                </form>
              </b-modal>
            </div>
          </div>
        </template>
        <template v-else>
          <section class="player-profile-wrapper">
            <ul class="tabs headding-space">
              <li class="tab-item" v-if="userData.userType === 'Admin'">
                <a
                  :class="
                    selectedDashboardTab === 'player-over-veiw-tab'
                      ? 'tab-link active'
                      : 'tab-link'
                  "
                  @click="
                    tabChange('selectedDashboardTab', 'player-over-veiw-tab')
                  "
                  href="javascript:;"
                  >Players</a
                >
              </li>
            </ul>

            <div class="tabs-wrapper">
              <div
                class="player-over-veiw-tab tab-content"
                v-if="selectedDashboardTab === 'player-over-veiw-tab'"
              >
                <div class="number-of-results">
                  <p v-if="filterdCoachesUsersData.length > 0">
                    Number of players: {{ filterdCoachesUsersData.length }}
                  </p>
                  <p v-else>Number of players: {{ coachesUsersData.length }}</p>
                </div>
                <div class="button-wrapper-top filters-sort">
                  <b-input-group
                    size="sm"
                    class="mb-2 autocomplete search-small"
                  >
                    <i class="bi bi-search"></i>
                    <b-form-input
                      type="search"
                      placeholder="Search players"
                      @update:modelValue="lookUpSearch($event)"
                    ></b-form-input>
                    <ul
                      class="autocomplete-results"
                      v-if="filterdCoachesUsersData.length > 0"
                    >
                      <li
                        @click="setSelectedUserOfTrainingPlan(userData)"
                        v-for="userData in filterdCoachesUsersData"
                        :key="userData.id"
                        class="autocomplete-result"
                      >
                        {{ userData.name }}
                      </li>
                    </ul>
                  </b-input-group>

                  <b-button
                    @click="toggleFilters = !toggleFilters"
                    variant="outline-success filter-small"
                  >
                    <i class="bi bi-filter" aria-hidden="true"></i>
                    Filters
                  </b-button>

                  <div class="filters" v-if="toggleFilters === true">
                    <div class="select-wrapper">
                      <b-form-select
                        class="mb-3"
                        @change="
                          filterBy('allUserDataBeforFilterApplied', 'teamName')
                        "
                        v-model="selectedFilterData"
                      >
                        <b-form-select-option :value="null" disabled
                          >Select a team</b-form-select-option
                        >
                        <b-form-select-option
                          v-for="team in clubTeams"
                          :key="team.id"
                          :value="team.teamName"
                          >{{ team.teamName }}</b-form-select-option
                        >
                      </b-form-select>
                      <a
                        @click="removeFilter()"
                        v-if="hideRemoveTeamFilterButton === false"
                        href="javascript:;"
                        class="remove-icon-button red-warning"
                        v-b-tooltip.hover
                        title="Remove filter"
                      >
                        <i
                          class="bi bi-x"
                          font-scale="4"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>

                    <div>
                      <input
                        :checked="showOnlyInjuredPlayers"
                        type="checkbox"
                        id="injuredPlayers"
                        name="injuredPlayers"
                        @change="showOnlyInjuredPlayersToggle()"
                      />
                      <label for="injuredPlayers">
                        Show only injured players</label
                      ><br />
                    </div>

                    <div v-if="hasFeature('trialists')">
                      <input
                        :checked="showOnlyTrialistPlayers"
                        type="checkbox"
                        id="trialistPlayers"
                        name="trialistPlayers"
                        @change="showOnlyTrialistPlayersToggle()"
                      />
                      <label for="trialistPlayers">
                        Show only trialist players</label
                      ><br />
                    </div>
                  </div>
                </div>

                <template v-if="coachesUsersData.length > 0">
                  <div
                    v-for="player in coachesUsersData"
                    :value="player.id"
                    :key="player.id"
                    :class="
                      player.injury === true
                        ? 'player-profile-details injury'
                        : 'player-profile-details'
                    "
                    @click="selectedUseChanged(player)"
                  >
                    <div class="user-photo-info">
                      <img
                        class="login-logo"
                        v-if="
                          player.userImage !== '' && player.userImage !== null
                        "
                        :src="getImgUrl(player.userImage)"
                        alt=""
                      />
                      <TenantLogo v-else logo-class="login-logo" />
                    </div>
                    <div class="user-info">
                      <h2>{{ player.name }}</h2>
                      <p>{{ player.teamName }}</p>
                      <p class="red-warning" v-if="player.injury === true">
                        <i class="bi bi-exclamation-circle"></i> Player is
                        injured
                      </p>

                      <p
                        class="amber-warning"
                        v-if="
                          hasFeature('trialists') &&
                          player.trialistId != null &&
                          player.trialistId !== '' &&
                          player.trialistId !== '0'
                        "
                      >
                        <i class="bi bi-exclamation-circle"></i> Trialist
                      </p>

                      <p>Age: {{ player.age_group }}</p>
                      <p>Position: {{ player.position }}</p>
                      <p v-if="checkSignedDate(player.joined_date) === true">
                        Signed: {{ formatDate(player.joined_date) }}
                      </p>
                      <p class="red-warning" v-else>Signed: Missing date</p>
                      <p>
                        Registered:
                        {{ converBoolean(player.sfa_registered) }}
                      </p>
                    </div>
                  </div>
                </template>
                <div class="empty-state" v-else>
                  <img src="../img/emptyStateIllustration.svg" />
                  <p>No player information</p>
                </div>
              </div>
            </div>
          </section>
        </template>

        <b-modal
          v-if="showMissingDataModal"
          v-model="showMissingDataModal"
          size="lg"
          hide-footer
        >
          <h2>Missing data</h2>
          <p>Looks like you need to give us some more data.</p>

          <p v-if="userData.joined_date === null">The date you joined.</p>
          <p v-if="userData.userImage === null">Your photo.</p>

          <p>
            Please update your profile -
            <router-link :to="{ name: 'Settings' }">Settings</router-link>
          </p>
        </b-modal>
        <b-modal
          v-if="showPlayerPerformanceReportModal"
          v-model="showPlayerPerformanceReportModal"
          size="lg"
          hide-footer
          title="Perfomance Report"
        >
          <form class="form" @submit.prevent="savePlayerPerformanceReview()">
            <div class="two-col-pop">
              <div class="user-photo-info">
                <img
                  v-if="
                    selectedUserData.userImage !== '' &&
                    selectedUserData.userImage !== null
                  "
                  :src="getImgUrl(selectedUserData.userImage)"
                  alt=""
                />
                <TenantLogo v-else logo-class="login-logo" />
              </div>
              <div class="user-details-pop">
                <p><span>Name:</span> {{ selectedUserData.name }}</p>
                <p><span>Phone:</span> {{ selectedUserData.phone }}</p>
                <p><span>Email:</span> {{ selectedUserData.email }}</p>
                <p>
                  <span>DOB:</span>
                  {{ formatDateForHuman(selectedUserData.dob) }}
                </p>
                <p><span>Position:</span> {{ selectedUserData.position }}</p>
                <p>
                  <span>Preferred foot:</span>
                  {{ selectedUserData.preferred_foot }}
                </p>
              </div>
            </div>

            <h4>
              Performance review -
              {{ formatDateForHuman(playerPerformanceReportData.review_date) }}
            </h4>

            <div class="form__item">
              <label class="form__label" for="attitude">Attitude</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.attitude"
                  :starSize="25"
                />

                <QuillEditor
                  v-model:content="
                    playerPerformanceReportData.attitude_comments
                  "
                  contentType="html"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="skill">Skill</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.skill"
                  :starSize="25"
                />
                <QuillEditor
                  v-model:content="playerPerformanceReportData.skill_comments"
                  contentType="html"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="physique">Physique</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.physique"
                  :starSize="25"
                />
                <QuillEditor
                  v-model:content="
                    playerPerformanceReportData.physique_comments
                  "
                  contentType="html"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="physique">Mental</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.mentality"
                  :starSize="25"
                />
                <QuillEditor
                  v-model:content="
                    playerPerformanceReportData.mentality_comments
                  "
                  contentType="html"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="physique">Leadership</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.leadership"
                  :starSize="25"
                />
                <QuillEditor
                  v-model:content="
                    playerPerformanceReportData.leadership_comments
                  "
                  contentType="html"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="physique">Professionalism</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.professionalism"
                  :starSize="25"
                />
                <QuillEditor
                  v-model:content="
                    playerPerformanceReportData.professionalism_comments
                  "
                  contentType="html"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="comments">Coachs notes </label>
              <QuillEditor
                v-model:content="playerPerformanceReportData.coachsNotes"
                contentType="html"
              />
            </div>

            <div class="perfomance-targets">
              <label class="form__label" for="perfomance-targets"
                >Add Performance target

                <b-button
                  v-b-tooltip.hover
                  title="Add Performance Target"
                  @click="addItem()"
                  variant="success"
                >
                  <i class="bi bi-plus" aria-hidden="true"></i>
                </b-button>
              </label>

              <div
                class="each-target"
                v-for="(item, index) in playerPerformanceTargets"
                :key="index"
              >
                <label class="form__label" for="perfomance-targets"
                  >Performance target
                </label>
                <br />

                <b-form-select class="mb-3" v-model="item.category">
                  <b-form-select-option :value="null" disabled
                    >Select category</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="(category, index) in performanceCategories"
                    :key="index"
                    :value="category"
                    >{{ category }}</b-form-select-option
                  >
                </b-form-select>

                <QuillEditor v-model:content="item.target" contentType="html" />

                <b-button
                  v-b-tooltip.hover
                  title="remove Performance Target"
                  variant="danger"
                >
                  <i
                    class="bi bi-x"
                    aria-hidden="true"
                    @click="removeItem(index)"
                  ></i>
                </b-button>
              </div>
            </div>

            <div class="player-game-responce">
              <b-button type="submit" variant="success">Save Report</b-button>
            </div>
          </form>
        </b-modal>

        <b-modal
          v-if="showPlayerCoachPerformanceAssessmentModal"
          v-model="showPlayerCoachPerformanceAssessmentModal"
          modal-class="modal-fullscreen"
          size="lg"
          hide-footer
          title="Performance review"
        >
          <h4>
            {{
              formatDateForHuman(
                playerCoachSignedPerformanceReportData.created_date,
              )
            }}
            -
            {{ playerCoachSignedPerformanceReportData.status }}
          </h4>

          <div class="signed-report" v-if="playerCoachsignedReportReady">
            <div class="player-signed-report">
              <h4>Player review</h4>
              <div class="two-col-pop">
                <div class="user-photo-info">
                  <img
                    v-if="
                      selectedUserData.userImage !== '' &&
                      selectedUserData.userImage !== null
                    "
                    :src="getImgUrl(selectedUserData.userImage)"
                    alt=""
                  />
                  <TenantLogo v-else logo-class="login-logo" />
                </div>
                <div class="user-details-pop">
                  <p><span>Name:</span> {{ selectedUserData.name }}</p>
                  <p><span>Phone:</span> {{ selectedUserData.phone }}</p>
                  <p><span>Email:</span> {{ selectedUserData.email }}</p>
                  <p>
                    <span>DOB:</span>
                    {{ formatDateForHuman(selectedUserData.dob) }}
                  </p>
                  <p><span>Position:</span> {{ selectedUserData.position }}</p>
                </div>
              </div>

              <div
                class="review-wrapper"
                v-if="playerCoachSignedPerformanceReportData.id !== undefined"
              >
                <div class="form__item block-item">
                  <label class="form__label" for="attitude">Technical</label>
                  <div
                    class="ratingStars"
                    v-if="
                      playerCoachSignedPerformanceReportData.status !==
                      'published'
                    "
                  >
                    <QuillEditor
                      v-model:content="
                        playerCoachSignedPerformanceReportData.technical_player_comments
                      "
                      contentType="html"
                    />
                  </div>
                  <p
                    v-else
                    v-html="
                      playerCoachSignedPerformanceReportData.technical_player_comments
                    "
                  ></p>
                </div>

                <div class="form__item block-item">
                  <label class="form__label" for="skill">Tactical</label>
                  <div
                    class="ratingStars"
                    v-if="
                      playerCoachSignedPerformanceReportData.status !==
                      'published'
                    "
                  >
                    <QuillEditor
                      v-model:content="
                        playerCoachSignedPerformanceReportData.tactical_player_comments
                      "
                      contentType="html"
                    />
                  </div>
                  <p
                    v-else
                    v-html="
                      playerCoachSignedPerformanceReportData.tactical_player_comments
                    "
                  ></p>
                </div>

                <div class="form__item block-item">
                  <label class="form__label" for="physique">Physical</label>
                  <div
                    class="ratingStars"
                    v-if="
                      playerCoachSignedPerformanceReportData.status !==
                      'published'
                    "
                  >
                    <QuillEditor
                      v-model:content="
                        playerCoachSignedPerformanceReportData.physical_player_comments
                      "
                      contentType="html"
                    />
                  </div>
                  <p
                    v-else
                    v-html="
                      playerCoachSignedPerformanceReportData.physical_player_comments
                    "
                  ></p>
                </div>

                <div class="form__item block-item">
                  <label class="form__label" for="physique">Mental</label>
                  <div
                    class="ratingStars"
                    v-if="
                      playerCoachSignedPerformanceReportData.status !==
                      'published'
                    "
                  >
                    <QuillEditor
                      v-model:content="
                        playerCoachSignedPerformanceReportData.physcological_player_comments
                      "
                      contentType="html"
                    />
                  </div>
                  <p
                    v-else
                    v-html="
                      playerCoachSignedPerformanceReportData.physcological_player_comments
                    "
                  ></p>
                </div>

                <div
                  class="form__item block-item ratingStars"
                  style="margin-bottom: 2rem"
                >
                  <label class="form__label" for="comments"
                    >Overall comments
                  </label>
                  <QuillEditor
                    v-model:content="
                      playerCoachSignedPerformanceReportData.player_comments
                    "
                    v-if="
                      playerCoachSignedPerformanceReportData.status !==
                      'published'
                    "
                    contentType="html"
                  />
                  <p
                    v-else
                    v-html="
                      playerCoachSignedPerformanceReportData.player_comments
                    "
                  ></p>
                </div>
              </div>
              <p v-else>No Player report saved.</p>

              <div
                class="players-charter charter"
                v-if="
                  playerCoachSignedPerformanceReportData.status === 'live' ||
                  playerCoachSignedPerformanceReportData.status === 'published'
                "
              >
                <h4>Player Signature</h4>
                <p
                  v-if="
                    coachSignedPerformanceReportSignature.player_signature_change ===
                    true
                  "
                >
                  Please sign below
                </p>
                <div class="signatureWrapper">
                  <vueSignature
                    v-if="
                      coachSignedPerformanceReportSignature.player_signature_change ===
                      true
                    "
                    ref="playerReportSignature"
                    :sigOption="signatureOptions"
                    :w="'800px'"
                    :h="'400px'"
                    :disabled="false"
                  >
                  </vueSignature>
                  <img
                    id="playerReportSignature"
                    v-else
                    :src="
                      getImgUrl(
                        playerCoachSignedPerformanceReportData.playerReportSignature,
                      )
                    "
                  />

                  <div
                    v-if="
                      coachSignedPerformanceReportSignature.player_signature_change ===
                      true
                    "
                    class="player-game-responce"
                  >
                    <button
                      @click="
                        saveSignatureWithDocumentId(
                          'playerReportSignature',
                          playerCoachSignedPerformanceReportData.id,
                        )
                      "
                    >
                      Save
                    </button>
                    <button @click="clearSignature('playerReportSignature')">
                      Clear
                    </button>
                  </div>
                  <div v-else class="player-game-responce">
                    <button
                      @click="
                        changeSignature(
                          'player_signature_change',
                          playerCoachSignedPerformanceReportData.id,
                        )
                      "
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="players-charter charter"
                v-if="
                  playerCoachSignedPerformanceReportData.status === 'live' ||
                  playerCoachSignedPerformanceReportData.status === 'published'
                "
              >
                <h4>Parent Signature</h4>
                <div class="signatureWrapper">
                  <vueSignature
                    v-if="
                      coachSignedPerformanceReportSignature.parent_signature_change ===
                      true
                    "
                    ref="parentReportSignature"
                    :sigOption="signatureOptions"
                    :w="'800px'"
                    :h="'400px'"
                    :disabled="false"
                  >
                  </vueSignature>
                  <img
                    id="parentReportSignature"
                    v-else
                    :src="
                      getImgUrl(
                        playerCoachSignedPerformanceReportData.parentReportSignature,
                      )
                    "
                  />

                  <div
                    v-if="
                      coachSignedPerformanceReportSignature.parent_signature_change ===
                      true
                    "
                    class="player-game-responce"
                  >
                    <button
                      @click="
                        saveSignatureWithDocumentId(
                          'parentReportSignature',
                          playerCoachSignedPerformanceReportData.id,
                        )
                      "
                    >
                      Save
                    </button>
                    <button @click="clearSignature('parentReportSignature')">
                      Clear
                    </button>
                  </div>
                  <div v-else class="player-game-responce">
                    <button
                      @click="
                        changeSignature(
                          'parent_signature_change',
                          playerCoachSignedPerformanceReportData.id,
                        )
                      "
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="coach-signed-report"
              v-if="
                playerSignedPerformanceReportSelected === 'Coach' ||
                playerCoachSignedPerformanceReportData.status === 'published'
              "
            >
              <h4>Coach review</h4>

              <div class="two-col-pop">
                <div class="user-photo-info">
                  <img
                    v-if="
                      playerCoachSignedPerformanceReportData.userImage !== '' &&
                      playerCoachSignedPerformanceReportData.userImage !== null
                    "
                    :src="
                      getImgUrl(
                        playerCoachSignedPerformanceReportData.userImage,
                      )
                    "
                    alt=""
                  />

                  <TenantLogo v-else logo-class="login-logo" />
                </div>
                <div class="user-details-pop">
                  <p>
                    <span>Coach name:</span>
                    {{ playerCoachSignedPerformanceReportData.name }}
                  </p>
                </div>
              </div>

              <div class="form__item block-item">
                <label class="form__label" for="attitude">Technical</label>
                <div
                  class="ratingStars"
                  v-if="
                    playerCoachSignedPerformanceReportData.status !==
                    'published'
                  "
                >
                  <QuillEditor
                    v-model:content="
                      playerCoachSignedPerformanceReportData.technical_coach_comments
                    "
                    contentType="html"
                  />
                </div>
                <p
                  v-else
                  v-html="
                    playerCoachSignedPerformanceReportData.technical_coach_comments
                  "
                ></p>
              </div>

              <div class="form__item block-item">
                <label class="form__label" for="skill">Tactical</label>
                <div
                  class="ratingStars"
                  v-if="
                    playerCoachSignedPerformanceReportData.status !==
                    'published'
                  "
                >
                  <QuillEditor
                    v-model:content="
                      playerCoachSignedPerformanceReportData.tactical_coach_comments
                    "
                    contentType="html"
                  />
                </div>
                <p
                  v-else
                  v-html="
                    playerCoachSignedPerformanceReportData.tactical_coach_comments
                  "
                ></p>
              </div>

              <div class="form__item block-item">
                <label class="form__label" for="physique">Physical</label>
                <div
                  class="ratingStars"
                  v-if="
                    playerCoachSignedPerformanceReportData.status !==
                    'published'
                  "
                >
                  <QuillEditor
                    v-model:content="
                      playerCoachSignedPerformanceReportData.physical_coach_comments
                    "
                    contentType="html"
                  />
                </div>
                <p
                  v-else
                  v-html="
                    playerCoachSignedPerformanceReportData.physical_coach_comments
                  "
                ></p>
              </div>

              <div class="form__item block-item">
                <label class="form__label" for="physique">Mental</label>
                <div
                  class="ratingStars"
                  v-if="
                    playerCoachSignedPerformanceReportData.status !==
                    'published'
                  "
                >
                  <QuillEditor
                    v-model:content="
                      playerCoachSignedPerformanceReportData.physcological_coach_comments
                    "
                    contentType="html"
                  />
                </div>
                <p
                  v-else
                  v-html="
                    playerCoachSignedPerformanceReportData.physcological_coach_comments
                  "
                ></p>
              </div>

              <div class="form__item block-item ratingStars">
                <label class="form__label" for="comments"
                  >Overall comments
                </label>
                <QuillEditor
                  v-model:content="
                    playerCoachSignedPerformanceReportData.coach_comments
                  "
                  v-if="
                    playerCoachSignedPerformanceReportData.status !==
                    'published'
                  "
                  contentType="html"
                />
                <p
                  v-else
                  v-html="playerCoachSignedPerformanceReportData.coach_comments"
                ></p>
              </div>

              <div
                class="players-charter charter"
                v-if="
                  playerCoachSignedPerformanceReportData.status === 'live' ||
                  playerCoachSignedPerformanceReportData.status === 'published'
                "
              >
                <h4>Coach Signature</h4>
                <p
                  v-if="
                    coachSignedPerformanceReportSignature.coach_signature_change ===
                    true
                  "
                >
                  Please sign below
                </p>
                <div class="signatureWrapper">
                  <vueSignature
                    v-if="
                      coachSignedPerformanceReportSignature.coach_signature_change ===
                      true
                    "
                    ref="coachSignature"
                    :sigOption="signatureOptions"
                    :w="'800px'"
                    :h="'400px'"
                    :disabled="false"
                  >
                  </vueSignature>
                  <img
                    id="coachSignature"
                    v-else
                    :src="
                      getImgUrl(
                        playerCoachSignedPerformanceReportData.coachSignature,
                      )
                    "
                  />

                  <div
                    v-if="
                      coachSignedPerformanceReportSignature.coach_signature_change ===
                      true
                    "
                    class="player-game-responce"
                  >
                    <button
                      @click="
                        saveSignatureWithDocumentId(
                          'coachSignature',
                          playerCoachSignedPerformanceReportData.id,
                        )
                      "
                    >
                      Save
                    </button>
                    <button @click="clearSignature('coachSignature')">
                      Clear
                    </button>
                  </div>
                  <div v-else class="player-game-responce">
                    <button
                      @click="
                        changeSignature(
                          'coach_signature_change',
                          playerCoachSignedPerformanceReportData.id,
                        )
                      "
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="buttons-wrapper">
            <b-form-select
              v-if="
                userData.userType === 'Admin' ||
                (userData.userType === 'Coach' &&
                  playerCoachSignedPerformanceReportData.status !== 'published')
              "
              v-model="playerCoachSignedPerformanceReportData.status"
              @change="changePlayerCoachPerformanceAssessmentStatus"
            >
              <b-form-select-option :value="null"
                >Please select an option</b-form-select-option
              >
              <b-form-select-option value="Draft">Draft</b-form-select-option>
              <b-form-select-option value="live">Live</b-form-select-option>
            </b-form-select>

            <b-button
              v-if="playerCoachSignedPerformanceReportData.id === undefined"
              size="lg"
              variant="outline-success"
              @click="savePlayerCoachSignedPerformanceReport()"
            >
              <i class="bi bi-file-text" aria-hidden="true"></i> Save Report
            </b-button>

            <b-button
              v-if="
                playerCoachSignedPerformanceReportData.id !== undefined &&
                playerCoachSignedPerformanceReportData.status !== 'published'
              "
              size="lg"
              variant="outline-success"
              @click="updatePlayerCoachSignedPerformanceReport()"
            >
              <i class="bi bi-file-text" aria-hidden="true"></i> Update Report
            </b-button>

            <b-button
              v-if="
                playerCoachSignedPerformanceReportData.status !== 'published' &&
                playerCoachSignedPerformanceReportData.player_signature_id !==
                  null &&
                playerCoachSignedPerformanceReportData.coach_signature_id !==
                  null
              "
              @click="publishPlayerCoachReport()"
              variant="outline-success"
              size="lg"
            >
              <i class="bi bi-file-earmark-check" aria-hidden="true"></i>
              Publish Report
            </b-button>

            <b-button
              v-if="
                playerCoachSignedPerformanceReportData.status === 'published' &&
                userData.userType !== 'User'
              "
              @click="unpublishPlayerCoachReport()"
              variant="outline-danger"
              size="lg"
            >
              <i class="bi bi-file-earmark-check" aria-hidden="true"></i>
              Unpublish Report
            </b-button>

            <b-button
              v-if="
                playerCoachSignedPerformanceReportData.status === 'published' &&
                userData.userType !== 'User'
              "
              @click="printPlayerCoachReport()"
              variant="outline-success"
              size="lg"
            >
              <i class="bi bi-printer" aria-hidden="true"></i> Print Report
            </b-button>
          </div>
        </b-modal>

        <!-- Review Type Selection Modal -->
        <ReviewTypeSelectionModal
          v-model="showReviewTypeSelectionModal"
          :player-data="selectedUserData"
          @select="onReviewTypeSelected"
          @cancel="onReviewTypeSelectionCancelled"
        />

        <!-- New Coach Performance Review Modal Component -->
        <CoachPerformanceReviewModal
          v-model="showNewCoachPerformanceReviewModal"
          :player-data="selectedUserData"
          :user-data="userData"
          :initial-report-data="selectedCoachPerformanceReviewData"
          :view-type="coachPerformanceReviewViewType"
          :review-type="coachPerformanceReviewType"
          :season-start-date="getSeasonStartDate()"
          :season-end-date="extendSeasonEndDateToFullYear()"
          @report-saved="onCoachPerformanceReviewSaved"
          @report-updated="onCoachPerformanceReviewUpdated"
          @report-deleted="onCoachPerformanceReviewDeleted"
          @report-published="onCoachPerformanceReviewPublished"
          @report-unpublished="onCoachPerformanceReviewUnpublished"
        />

        <b-modal
          v-if="showPlayerPerformanceReportVewDetailsModal"
          v-model="showPlayerPerformanceReportVewDetailsModal"
          size="lg"
          hide-footer
          title="Perfomance Report"
        >
          <form class="form">
            <template v-if="Object.keys(selectedUserData).length !== 0">
              <UserImageAndInfo
                :selectedUserDataForUserImageAndInfo="selectedUserData"
                :playerPerformanceReportData="playerPerformanceReportData"
              />
            </template>
            <template v-else>
              <UserImageAndInfo
                :selectedUserDataForUserImageAndInfo="userData"
                :playerPerformanceReportData="playerPerformanceReportData"
              />
            </template>

            <h4>
              Performance review -
              {{ formatDateForHuman(selectedUserData.review_date) }}
            </h4>

            <div class="form__item">
              <label class="form__label" for="attitude">Attitude</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.attitude"
                  :starSize="25"
                  :readOnly="true"
                />

                <div
                  class="comments-box"
                  v-html="playerPerformanceReportData.attitude_comments"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="skill">Skill</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.skill"
                  :starSize="25"
                  :readOnly="true"
                />
                <div
                  class="comments-box"
                  v-html="playerPerformanceReportData.skill_comments"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="physique">Physique</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.physique"
                  :starSize="25"
                  :readOnly="true"
                />
                <div
                  class="comments-box"
                  v-html="playerPerformanceReportData.physique_comments"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="physique">Mentality</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.mentality"
                  :starSize="25"
                  :readOnly="true"
                />
                <div
                  class="comments-box"
                  v-html="playerPerformanceReportData.mentality_comments"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="physique">Leadership</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.leadership"
                  :starSize="25"
                  :readOnly="true"
                />
                <div
                  class="comments-box"
                  v-html="playerPerformanceReportData.leadership_comments"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="physique">Professionalism</label>
              <div class="ratingStars">
                <StarRating
                  v-model="playerPerformanceReportData.professionalism"
                  :starSize="25"
                  :readOnly="true"
                />
                <div
                  class="comments-box"
                  v-html="playerPerformanceReportData.professionalism_comments"
                />
              </div>
            </div>

            <div class="form__item">
              <label class="form__label" for="comments">Coachs notes </label>
              <div
                class="comments-box"
                v-html="playerPerformanceReportData.coachsNotes"
              />
            </div>

            <div class="form__item performance-targets-display">
              <h4>Performance targets</h4>

              <div
                class="performance-target-item"
                v-for="target in getSelectedPerformanceReportTargets(
                  playerPerformanceReportData.id,
                )"
                :key="target.id"
              >
                <p>Category: {{ target.category }}</p>
                <div class="target-wrapper">
                  <img src="./img/target.svg" alt="" />
                  <div v-html="target.target"></div>
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <b-modal
          v-if="showAllTrainingReportsModal"
          v-model="showAllTrainingReportsModal"
          size="xl"
          modal-class="modal-fullscreen"
          hide-footer
        >
          <div class="all-training-reports">
            <h3>Seasons training and game stats</h3>
            <h3>{{ selectedUserData.name }}</h3>

            <div class="form__item uk-form">
              <label class="form__label" for="trainingGameDateSelected"
                >Select date:</label
              >

              <VueDatePicker
                :locale="'en-GB'"
                name="trainingGameDateSelected"
                id="trainingGameDateSelected"
                :enable-time-picker="false"
                @selected="setSelectedDatetrainingAndGameData($event)"
                format="dd/MM/yyyy"
              />
            </div>

            <div
              v-if="
                Object.keys(selectedGameAndTrainingChartStats).length !== 0 &&
                under16 === false
              "
            >
              <h3>
                Session name:
                {{ selectedGameAndTrainingChartStats.session_type }}
              </h3>

              <div class="col-wrapper-first">
                <div
                  class="cols"
                  v-if="
                    Object.keys(
                      fullSessionStrainingAndGamesTotalDistanceChartData,
                    ).length !== 0
                  "
                >
                  <h3>Total Distance</h3>
                  <Bar-chart-horizontal
                    :chartData="
                      fullSessionStrainingAndGamesTotalDistanceChartData
                    "
                    height="200px"
                  />
                </div>

                <div
                  class="cols"
                  v-if="
                    Object.keys(
                      fullSessionStrainingAndGamesHighSpeedRunningChartData,
                    ).length !== 0
                  "
                >
                  <h3>High Speed Running</h3>
                  <Bar-chart-horizontal
                    :chartData="
                      fullSessionStrainingAndGamesHighSpeedRunningChartData
                    "
                    height="200px"
                  />
                </div>

                <div
                  class="cols"
                  v-if="
                    sessionStrainingAndGamesSessionHighSpeedRunningChartData.length >
                    0
                  "
                >
                  <h3>Accelerations / Decelerations</h3>
                  <Bar-chart-horizontal
                    :chartData="
                      sessionStrainingAndGamesSessionHighSpeedRunningChartData
                    "
                    height="200px"
                  />
                </div>
              </div>

              <div class="col-wrapper-charts">
                <div class="cols">
                  <div
                    class="pie-charts"
                    v-if="
                      Object.keys(
                        sessionStrainingAndGamesSessionDistancePieData,
                      ).length !== 0
                    "
                  >
                    <h3>Total Distance</h3>
                    <Pie-chart
                      :chartData="
                        sessionStrainingAndGamesSessionDistancePieData
                      "
                    />
                  </div>

                  <div
                    class="pie-charts"
                    v-if="
                      Object.keys(
                        sessionStrainingAndGamesSessionDistancePieData,
                      ).length !== 0
                    "
                  >
                    <h3>Total Distance</h3>
                    <Pie-chart
                      :chartData="
                        sessionStrainingAndGamesSessionDistancePieData
                      "
                    />
                  </div>
                </div>

                <div class="cols">
                  <div
                    class="pie-charts"
                    v-if="
                      Object.keys(
                        sessionStrainingAndGamesSessionHighSpeedRunningPieData,
                      ).length !== 0
                    "
                  >
                    <h3>High Speed Running</h3>
                    <Pie-chart
                      :chartData="
                        sessionStrainingAndGamesSessionHighSpeedRunningPieData
                      "
                    />
                  </div>

                  <div
                    class="pie-charts"
                    v-if="
                      Object.keys(
                        sessionStrainingAndGamesSessionMaximumVelocityPieData,
                      ).length !== 0
                    "
                  >
                    <h3>Maximum Velocity</h3>
                    <Pie-chart
                      :chartData="
                        sessionStrainingAndGamesSessionMaximumVelocityPieData
                      "
                    />
                  </div>
                </div>
              </div>

              <div>
                <div>
                  <h3>Accelerations and Decelerations</h3>
                  <Bar-chart-stacked
                    :chartData="
                      sessionStrainingAndGamesSessionHighSpeedRunningChartData
                    "
                    height="500px"
                  />
                </div>

                <div class="games-info">
                  <table class="w-a-style" style="width: 100%">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Session type</th>
                        <th>Session mins</th>
                        <th>Total Distance</th>
                        <th>High Speed Running</th>
                        <th>Accelerations</th>
                        <th>Decelerations</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="session in playerDailyMins" :key="session.id">
                        <td>{{ formatDateForHuman(session.session_date) }}</td>
                        <td>{{ session.session_type }}</td>
                        <td>{{ session.session_mins }}</td>
                        <td>{{ session.session_distance }}</td>
                        <td>
                          {{ session.total_absolute_high_speed_distance }}
                        </td>
                        <td>{{ session.accelerations_total_efforts }}</td>
                        <td>{{ session.decelerations_total_efforts }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              v-if="
                Object.keys(selectedGameAndTrainingChartStats).length !== 0 &&
                under16 === true
              "
            >
              <h3>
                Session name:
                {{ selectedGameAndTrainingChartStats.session_type }}
              </h3>
              <div class="col-wrapper-first">
                <div
                  class="cols"
                  v-if="
                    Object.keys(
                      fullSessionStrainingAndGamesTotalTouchesChartData,
                    ).length !== 0
                  "
                >
                  <h3>Total Touches</h3>
                  <Bar-chart-horizontal
                    :chartData="
                      fullSessionStrainingAndGamesTotalTouchesChartData
                    "
                  />
                </div>

                <div
                  class="cols"
                  v-if="
                    Object.keys(
                      fullSessionStrainingAndGamesRightFootTouchesChartData,
                    ).length !== 0
                  "
                >
                  <h3>Right foot Touches</h3>
                  <Bar-chart-horizontal
                    :chartData="
                      fullSessionStrainingAndGamesRightFootTouchesChartData
                    "
                  />
                </div>

                <div
                  class="cols"
                  v-if="
                    Object.keys(
                      fullSessionStrainingAndGamesLeftFootTouchesChartData,
                    ).length !== 0
                  "
                >
                  <h3>Left foot Touches</h3>
                  <Bar-chart-horizontal
                    :chartData="
                      fullSessionStrainingAndGamesLeftFootTouchesChartData
                    "
                  />
                </div>
              </div>

              <div class="col-wrapper-charts">
                <div class="cols">
                  <div class="pie-charts">
                    <h3>Right foot touches</h3>
                    <Pie-chart
                      :chartData="
                        sessionStrainingAndGamesSessionLeftRighPieData
                      "
                    />
                  </div>

                  <div class="pie-charts">
                    <h3>Left foot touches</h3>
                    <Pie-chart
                      :chartData="
                        sessionStrainingAndGamesSessionLeftLeftPieData
                      "
                    />
                  </div>
                </div>

                <div class="cols">
                  <div class="cols">
                    <h3>Total Releases</h3>
                    <Bar-chart-horizontal
                      :chartData="
                        fullSessionStrainingAndGamesTotalTouchesChartData
                      "
                    />
                  </div>

                  <div class="cols">
                    <h3>Right foot Releases</h3>
                    <Bar-chart-horizontal
                      :chartData="
                        fullSessionStrainingAndGamesTotalTouchesChartData
                      "
                    />
                  </div>

                  <div class="cols">
                    <h3>Left foot Releases</h3>
                    <Bar-chart-horizontal
                      :chartData="
                        fullSessionStrainingAndGamesTotalTouchesChartData
                      "
                    />
                  </div>
                </div>

                <div class="cols">
                  <div class="cols">
                    <h3>Total Distance</h3>
                    <Bar-chart-horizontal
                      :chartData="
                        fullSessionStrainingAndGamesTotalTouchesChartData
                      "
                    />
                  </div>

                  <div class="cols">
                    <h3>Top speed</h3>
                    <Bar-chart-horizontal
                      :chartData="
                        sessionStrainingAndGamesSessionTopSpeedsChartData
                      "
                    />
                  </div>

                  <div class="cols">
                    <h3>Work rate</h3>
                    <Bar-chart-horizontal
                      :chartData="
                        sessionStrainingAndGamesSessionWorkRateChartData
                      "
                    />
                  </div>
                </div>

                <div class="games-info">
                  <table class="w-a-style" style="width: 100%">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Session Type</th>
                        <th>Tag</th>
                        <th>Session Mins</th>
                        <th>Total Distance</th>
                        <th>work rate</th>
                        <th>Total touches</th>
                        <th>Left Leg Touches</th>
                        <th>Right Leg Touches</th>
                        <th>Releases Left</th>
                        <th>Releases Right</th>
                        <th>Releases total</th>
                        <th>Top speed</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="session in playerPlayMakerGpsData"
                        :key="session.id"
                      >
                        <td>{{ formatDateForHuman(session.session_date) }}</td>
                        <td>{{ session.session_type }}</td>
                        <td>{{ session.tag }}</td>
                        <td>{{ session.phase_duration_min }}</td>
                        <td>{{ session.distance_covered }}</td>
                        <td>{{ session.work_rate }}</td>
                        <td>{{ session.total_touches }}</td>
                        <td>{{ session.left_leg_touches }}</td>
                        <td>{{ session.right_leg_touches }}</td>
                        <td>{{ session.releases_left }}</td>
                        <td>{{ session.releases_right }}</td>
                        <td>{{ session.releases }}</td>
                        <td>{{ session.top_speed }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div
              v-if="Object.keys(selectedGameAndTrainingChartStats).length === 0"
              class="empty-state"
            >
              <img src="../img/emptyStateIllustration.svg" />
              <p>No chart data</p>
            </div>
          </div>
        </b-modal>

        <b-modal
          v-if="showPerformanceTargetsHistoryModal"
          v-model="showPerformanceTargetsHistoryModal"
          size="lg"
          hide-footer
        >
          <table class="w-a-style">
            <thead>
              <tr>
                <th>Date</th>
                <th>Target</th>
                <th>Category</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="target in playerPerformanceReviewTargetsData"
                :key="target.id"
              >
                <td>{{ formatDateForHuman(target.created_date) }}</td>
                <td>
                  <div v-html="target.target"></div>
                </td>
                <td>{{ target.category }}</td>
                <td v-if="target.complete == 1" class="completed">Completed</td>
                <td v-else>Not complete</td>
              </tr>
            </tbody>
          </table>
        </b-modal>

        <b-modal
          v-if="showNewPerformanceTargetsModal"
          v-model="showNewPerformanceTargetsModal"
          size="lg"
          hide-footer
        >
          <div class="performance-target-modal-content">
            <h3
              v-if="
                selectedPerformanceTarget.typeOfTarget === 'Performance target'
              "
            >
              Performance target
            </h3>
            <h3 v-else>Game target</h3>
            <div
              v-if="
                selectedPerformanceTarget.typeOfTarget === 'Performance target'
              "
              class="form__item"
            >
              <label class="form__label" for="select_performace-reports"
                >Select performance review</label
              >
              <select
                id="select_performace-reports"
                v-model="selectedPerformanceTarget.performance_report_id"
              >
                <option
                  v-for="review in allplayerPerformanceReportData"
                  :key="review.id"
                  :value="review.id"
                >
                  {{ formatDateForHuman(review.review_date) }}
                </option>
              </select>
              <p>This will add a performance target to the review selected.</p>
            </div>

            <div v-else class="form__item">
              <label class="form__label" for="select_performace-reports"
                >Select possession</label
              >

              <b-form-select
                class="mb-3"
                v-model="selectedPerformanceTarget.possession"
              >
                <b-form-select-option :value="null" disabled
                  >Select possession</b-form-select-option
                >
                <b-form-select-option value="In possession"
                  >In possession</b-form-select-option
                >
                <b-form-select-option value="Out of possession"
                  >Out of possession</b-form-select-option
                >
              </b-form-select>
            </div>

            <div class="form__item">
              <label class="form__label" for="select_performace-reports"
                >Select category</label
              >

              <b-form-select
                class="mb-3"
                v-model="selectedPerformanceTarget.category"
              >
                <b-form-select-option :value="null" disabled
                  >Select category</b-form-select-option
                >
                <b-form-select-option
                  v-for="(category, index) in performanceCategories"
                  :key="index"
                  :value="category"
                  >{{ category }}</b-form-select-option
                >
              </b-form-select>
            </div>

            <QuillEditor
              v-model:content="selectedPerformanceTarget.target"
              contentType="html"
            />
            <b-form-checkbox
              id="checkbox-1"
              size="lg"
              v-model="selectedPerformanceTarget.complete"
              name="checkbox-1"
              value="1"
              unchecked-value="0"
              >Mark target as complete
            </b-form-checkbox>

            <div class="buttons-row">
              <b-button
                @click="addNewPerformanceReportTarget()"
                size="lg"
                variant="outline-success"
              >
                Save</b-button
              >
            </div>
          </div>
        </b-modal>

        <b-modal
          v-if="showPerformanceTargetsModal"
          v-model="showPerformanceTargetsModal"
          size="lg"
          hide-footer
        >
          <div class="performance-target-modal-content">
            <h3>Performance target</h3>
            <p class="small-date-player-coach">
              {{ formatDateForHuman(selectedPerformanceTarget.created_date) }}
            </p>

            <b-form-select
              class="mb-3"
              v-model="selectedPerformanceTarget.category"
            >
              <b-form-select-option :value="null" disabled
                >Select category</b-form-select-option
              >
              <b-form-select-option
                v-for="(category, index) in performanceCategories"
                :key="index"
                :value="category"
                >{{ category }}</b-form-select-option
              >
            </b-form-select>

            <QuillEditor
              v-model:content="selectedPerformanceTarget.target"
              contentType="html"
            />
            <b-form-checkbox
              id="checkbox-2"
              size="lg"
              v-model="selectedPerformanceTarget.complete"
              name="checkbox-2"
              value="1"
              unchecked-value="0"
              >Mark target as complete
            </b-form-checkbox>

            <div class="buttons-row">
              <b-button
                @click="updatePerformanceReportTarget()"
                size="lg"
                variant="outline-success"
              >
                Update</b-button
              >

              <b-button
                @click="deletePerformanceReportTarget()"
                size="lg"
                variant="outline-danger"
                >Delete</b-button
              >
            </div>
          </div>
        </b-modal>

        <b-modal
          v-if="showPlayerCVpersonalProfileModal"
          v-model="showPlayerCVpersonalProfileModal"
          size="lg"
          hide-footer
          title="Personal profile"
        >
          <div class="player-cv-content">
            <b-form-textarea
              id="personal_profile_text_box"
              v-model="playerCvData.personal_profile"
              placeholder="A few sentences about you as a player — position, strengths, ambitions…"
              rows="8"
            ></b-form-textarea>

            <b-button
              v-b-tooltip.hover
              @click="savePersonalProfile()"
              title="Save"
              variant="success"
              >Save Personal profile</b-button
            >
          </div>
        </b-modal>

        <b-modal
          v-if="showOpenPlayerInterestsHobbiesModal"
          v-model="showOpenPlayerInterestsHobbiesModal"
          size="lg"
          hide-footer
          @close="playerInterestsHobbiesClose()"
          title="Player Interests and Hobbies"
        >
          <div class="player-cv-content">
            <div class="form__item">
              <label class="form__label" for="cv_interests"
                >Interest or hobby</label
              >
              <input
                class="form__input"
                type="text"
                id="cv_interests"
                v-model="selectedPlayerInterestsHobbiesData.interests"
              />
            </div>

            <div class="form__item">
              <label class="form__label" for="cv_interests_info"
                >More information</label
              >

              <b-form-textarea
                id="cv_interests_info"
                v-model="selectedPlayerInterestsHobbiesData.more_info"
                placeholder="Enter more information..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </div>

            <b-button
              variant="success"
              :disabled="!selectedPlayerInterestsHobbiesData.interests"
              v-if="selectedPlayerInterestsHobbiesDataEdit === false"
              @click="saveInterestsHobbies()"
              >Save interest</b-button
            >

            <b-button
              variant="success"
              :disabled="!selectedPlayerInterestsHobbiesData.interests"
              v-else
              @click="editPlayerInterestsHobbies()"
              >Save changes</b-button
            >
          </div>
        </b-modal>

        <b-modal
          v-if="showOpenPlayerEducationModal"
          v-model="showOpenPlayerEducationModal"
          size="lg"
          hide-footer
          @close="playerEducationModalClose()"
          title="Player Education"
        >
          <div class="player-cv-content">
            <div class="playing-experence-wrapper">
              <div class="each-target playing-experence-item">
                <div class="form__item">
                  <label class="form__label" for="cv_qualification_name"
                    >Qualification name</label
                  >
                  <input
                    class="form__input"
                    type="text"
                    id="cv_qualification_name"
                    v-model="selectedPlayerEducationData.title"
                  />
                </div>

                <div class="form__item">
                  <label class="form__label" for="cv_edu_start_date"
                    >Start date</label
                  >
                  <VueDatePicker
                    :locale="'en-GB'"
                    v-model="selectedPlayerEducationData.start_date"
                    :enable-time-picker="false"
                    name="start_date"
                    id="cv_edu_start_date"
                    format="dd/MM/yyyy"
                  />
                </div>

                <div class="form__item">
                  <label class="form__label" for="cv_edu_end_date"
                    >End date (leave blank if ongoing)</label
                  >
                  <VueDatePicker
                    :locale="'en-GB'"
                    v-model="selectedPlayerEducationData.end_date"
                    :enable-time-picker="false"
                    name="end_date"
                    id="cv_edu_end_date"
                    format="dd/MM/yyyy"
                  />
                </div>

                <div class="form__item">
                  <label class="form__label" for="cv_edu_info"
                    >Information</label
                  >

                  <b-form-textarea
                    id="cv_edu_info"
                    v-model="selectedPlayerEducationData.more_info"
                    placeholder="Enter more information..."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </div>

              <b-button
                variant="success"
                :disabled="!selectedPlayerEducationData.title"
                v-if="selectedPlayerEducationDataEdit === false"
                @click="savePlayerEducation()"
                >Save education</b-button
              >

              <b-button
                variant="success"
                :disabled="!selectedPlayerEducationData.title"
                v-else
                @click="editPlayerEducation()"
                >Save changes</b-button
              >
            </div>
          </div>
        </b-modal>

        <b-modal
          v-if="showPlayerVideosModal"
          v-model="showPlayerVideosModal"
          size="lg"
          hide-footer
          title="Video link"
        >
          <div class="player-cv-content">
            <div class="playing-experence-wrapper">
              <div class="each-target playing-experence-item">
                <div class="form__item">
                  <label class="form__label" for="cv_video_name"
                    >Video title</label
                  >
                  <input
                    class="form__input"
                    type="text"
                    id="cv_video_name"
                    v-model="selectedPlayerVideoData.video_name"
                  />
                </div>

                <div class="form__item">
                  <label class="form__label" for="cv_video_url"
                    >Video URL</label
                  >
                  <input
                    class="form__input"
                    type="url"
                    id="cv_video_url"
                    placeholder="https://…"
                    v-model="selectedPlayerVideoData.video_url"
                  />
                </div>

                <b-button
                  variant="success"
                  :disabled="
                    !selectedPlayerVideoData.video_name ||
                    !selectedPlayerVideoData.video_url
                  "
                  v-if="selectedPlayerVideoDataEdit === false"
                  @click="savePlayerVideoLink()"
                  >Save video</b-button
                >

                <b-button
                  variant="success"
                  :disabled="
                    !selectedPlayerVideoData.video_name ||
                    !selectedPlayerVideoData.video_url
                  "
                  v-else
                  @click="editPlayerVideoLink()"
                  >Save changes</b-button
                >
              </div>
            </div>
          </div>
        </b-modal>

        <b-modal
          v-if="showPlayerCVPlayingExperenceModal"
          v-model="showPlayerCVPlayingExperenceModal"
          size="lg"
          hide-footer
          @close="playerCVPlayingExperenceModalClose()"
          title="Playing experience"
        >
          <div class="player-cv-content">
            <div class="playing-experence-wrapper">
              <div class="each-target playing-experence-item">
                <div class="form__item">
                  <label class="form__label" for="cv_club_name"
                    >Club name</label
                  >
                  <input
                    class="form__input"
                    type="text"
                    id="cv_club_name"
                    v-model="selectedPlayingExperenceData.club"
                  />
                </div>

                <div class="form__item">
                  <label class="form__label" for="cv_exp_start_date"
                    >Start date at the club</label
                  >
                  <VueDatePicker
                    :locale="'en-GB'"
                    v-model="selectedPlayingExperenceData.start_date_at_club"
                    :enable-time-picker="false"
                    name="startDateAtClub"
                    id="cv_exp_start_date"
                    format="dd/MM/yyyy"
                  />
                </div>

                <div class="form__item">
                  <label class="form__label" for="cv_exp_end_date"
                    >End date at the club (leave blank if still there)</label
                  >
                  <VueDatePicker
                    :locale="'en-GB'"
                    v-model="selectedPlayingExperenceData.end_date_at_club"
                    :enable-time-picker="false"
                    name="endDateAtClub"
                    id="cv_exp_end_date"
                    format="dd/MM/yyyy"
                  />
                </div>

                <div class="form__item">
                  <label class="form__label" for="cv_playing_info"
                    >Playing information</label
                  >

                  <b-form-textarea
                    id="cv_playing_info"
                    v-model="selectedPlayingExperenceData.playing_info"
                    placeholder="Position, appearances, highlights…"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </div>

              <b-button
                variant="success"
                :disabled="!selectedPlayingExperenceData.club"
                v-if="selectedPlayingExperenceEdit === false"
                @click="savePlayerPlayingExperence()"
                >Save playing experience</b-button
              >

              <b-button
                variant="success"
                :disabled="!selectedPlayingExperenceData.club"
                v-else
                @click="editPlayingExperence()"
                >Save changes</b-button
              >
            </div>
          </div>
        </b-modal>

        <b-modal
          v-if="showViewDayStatsBreakDown"
          v-model="showViewDayStatsBreakDown"
          size="xl"
          hide-footer
        >
          <div class="player-stats-gps-wrapper">
            <div class="player-session-details">
              <p class="player-name">{{ selectedUserData.name }}</p>
              <p class="session-date">
                {{
                  this.formatDateForHuman(selectedDayPlayerData.session_date)
                }}
              </p>

              <div class="session-name">
                <p>
                  <span>Session name:</span
                  >{{ selectedDayPlayerData.session_type }}
                </p>
              </div>
              <gps-pannel
                :selectedDayPlayerData="selectedDayPlayerData"
                :selectedUserData="selectedUserData"
                :playerPlayMakerGpsData="playerPlayMakerGpsData"
              />
            </div>
          </div>
        </b-modal>

        <b-modal
          v-if="showUploadPlayerMinsCSV"
          v-model="showUploadPlayerMinsCSV"
          size="lg"
          hide-footer
        >
          <div>
            <h2>Import CSV file</h2>
            <hr />

            <div class="type-of-csv-import">
              <h3>Select data upload type</h3>

              <b-form-group class="radios-group-gps">
                <b-form-radio
                  v-model="gpsUploadDataTypeSelected"
                  name="catapult-radios"
                  value="catapult"
                  ><img src="../img/cat-gps.jpg"
                /></b-form-radio>
                <b-form-radio
                  v-model="gpsUploadDataTypeSelected"
                  name="playermaker-radios"
                  value="playermaker"
                  ><img src="../img/playMaker.jpg"
                /></b-form-radio>
              </b-form-group>
            </div>

            <div
              class="upload-wrapper"
              v-if="gpsUploadDataTypeSelected !== undefined"
            >
              <label
                >File
                <input type="file" @change="importCSV($event)" />
              </label>

              <div
                v-if="csvDataImported !== null"
                class="show-imported-CSV-data"
              >
                <pre>{{ csvDataImported }}</pre>
              </div>

              <button
                v-if="csvDataImported !== null"
                v-on:click="importUploadedCSVDataFile()"
              >
                Save
              </button>
            </div>
            <p class="days-red-warning" v-if="dataCSVErrorMessage === null">
              <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
              {{ dataCSVErrorMessage }}
            </p>
          </div>
        </b-modal>

        <b-modal
          v-if="showViewDownloadPDF"
          v-model="showViewDownloadPDF"
          size="lg"
          hide-footer
        >
          <div class="player-cv-content">
            <iframe :src="downloadURL" />
          </div>
        </b-modal>

        <b-modal
          v-if="showViewPlayersCV"
          v-model="showViewPlayersCV"
          size="lg"
          hide-footer
          title="Player CV"
        >
          <div class="player-cv-content">
            <div class="cv-preview-actions">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="downloadPlayerCvPdf()"
              >
                <i class="bi bi-download" aria-hidden="true"></i>
                Download PDF
              </b-button>
            </div>
            <iframe id="thePlayerCVPDF_preview" src="" />
          </div>
        </b-modal>

        <b-modal
          v-if="showViewPlayerCoachReviewPDF"
          v-model="showViewPlayerCoachReviewPDF"
          size="lg"
          hide-footer
        >
          <div class="player-cv-content">
            <iframe id="thePlayerCoachReviewPDF_preview" />
          </div>
        </b-modal>

        <b-modal
          v-if="showUpLoadModal"
          v-model="showUpLoadModal"
          size="lg"
          hide-footer
        >
          <div class="player-cv-content">
            <DocumentUploader
              @getDocumentUploadsCall="getDocumentUploadsCall"
              documentCategory="physio"
              :club_id="userData.clubId"
              :user_id="selectedUserData.id"
              :elementData="newInjuryInformation"
            />
          </div>
        </b-modal>

        <b-modal
          v-if="showCharterModal"
          v-model="showCharterModal"
          title="Charter"
          modal-class="modal-fullscreen"
          size="xl"
          hide-footer
        >
          <div class="charter-modal">
            <div class="charter-modal__bar">
              <p class="charter-modal__hint">
                Read each charter below, then sign to confirm agreement. The
                player and parent/guardian sign separately.
              </p>
              <button class="charter-pdf-btn" @click="saveCharterPDF()">
                <i class="bi bi-file-earmark-pdf"></i> Save as PDF
              </button>
            </div>

            <!-- PLAYER -->
            <section class="charter-card">
              <header class="charter-card__head">
                <h3>Players Charter</h3>
                <span
                  class="sign-badge"
                  :class="
                    charterSignature.player_signature &&
                    charterSignature.player_signature_change !== true
                      ? 'is-signed'
                      : 'is-pending'
                  "
                >
                  <i
                    :class="
                      charterSignature.player_signature &&
                      charterSignature.player_signature_change !== true
                        ? 'bi bi-check-circle-fill'
                        : 'bi bi-hourglass-split'
                    "
                  ></i>
                  {{
                    charterSignature.player_signature &&
                    charterSignature.player_signature_change !== true
                      ? "Signed"
                      : "Awaiting signature"
                  }}
                </span>
              </header>

              <div class="charter-card__text" v-if="charterData.player_text">
                <div v-html="charterData.player_text"></div>
              </div>
              <div class="charter-card__empty" v-else>
                <img src="../img/emptyStateIllustration.svg" />
                <p>No Players Charter information.</p>
              </div>

              <div class="charter-card__sign">
                <template
                  v-if="charterSignature.player_signature_change === true"
                >
                  <label class="sign-label"
                    >Player, sign in the box below</label
                  >
                  <div class="sign-pad">
                    <vueSignature
                      ref="playerSignature"
                      :sigOption="signatureOptions"
                      :w="signatureCanvasWidth"
                      :h="'170px'"
                      :disabled="false"
                    ></vueSignature>
                  </div>
                  <label class="charter-consent">
                    <input type="checkbox" v-model="charterConsent.player" />
                    <span
                      >I have read and agree to the Players Charter above.</span
                    >
                  </label>
                  <div class="sign-actions">
                    <button
                      class="btn-sign"
                      @click="saveSignature('playerSignature')"
                      :disabled="!charterConsent.player"
                    >
                      <i class="bi bi-check-lg"></i> Save signature
                    </button>
                    <button
                      class="btn-clear"
                      @click="clearSignature('playerSignature')"
                    >
                      Clear
                    </button>
                  </div>
                </template>

                <template v-else-if="charterSignature.player_signature">
                  <div class="signed-view">
                    <img
                      v-if="
                        isDrawnSignature(
                          charterSignature.player_signature,
                          charterSignature.player_signature_type,
                        )
                      "
                      :src="getImgUrl(charterSignature.player_signature)"
                      class="signed-img"
                    />
                    <div v-else class="typed-signature">
                      {{ charterSignature.player_signature }}
                    </div>
                    <p
                      class="signed-meta"
                      v-if="charterSignature.player_signed_at"
                    >
                      <i class="bi bi-check-circle"></i> Signed
                      {{ charterSignature.player_signed_at }}
                    </p>
                    <button
                      class="btn-resign"
                      @click="
                        changeSignature(
                          'player_signature_change',
                          charterSignature.id,
                        )
                      "
                    >
                      <i class="bi bi-pencil"></i> Re-sign
                    </button>
                  </div>
                </template>

                <template v-else>
                  <div class="sign-prompt">
                    <p>Not signed yet.</p>
                    <button
                      class="btn-sign"
                      @click="
                        changeSignature(
                          'player_signature_change',
                          charterSignature.id,
                        )
                      "
                    >
                      <i class="bi bi-pen"></i> Sign now
                    </button>
                  </div>
                </template>
              </div>
            </section>

            <!-- PARENT -->
            <section class="charter-card">
              <header class="charter-card__head">
                <h3>Parents Charter</h3>
                <span
                  class="sign-badge"
                  :class="
                    charterSignature.parent_signature &&
                    charterSignature.parent_signature_change !== true
                      ? 'is-signed'
                      : 'is-pending'
                  "
                >
                  <i
                    :class="
                      charterSignature.parent_signature &&
                      charterSignature.parent_signature_change !== true
                        ? 'bi bi-check-circle-fill'
                        : 'bi bi-hourglass-split'
                    "
                  ></i>
                  {{
                    charterSignature.parent_signature &&
                    charterSignature.parent_signature_change !== true
                      ? "Signed"
                      : "Awaiting signature"
                  }}
                </span>
              </header>

              <div class="charter-card__text" v-if="charterData.parent_text">
                <div v-html="charterData.parent_text"></div>
              </div>
              <div class="charter-card__empty" v-else>
                <img src="../img/emptyStateIllustration.svg" />
                <p>No Parents Charter information.</p>
              </div>

              <div class="charter-card__sign">
                <template
                  v-if="charterSignature.parent_signature_change === true"
                >
                  <label class="sign-label"
                    >Parent/guardian, sign in the box below</label
                  >
                  <div class="sign-pad">
                    <vueSignature
                      ref="parentSignature"
                      :sigOption="signatureOptions"
                      :w="signatureCanvasWidth"
                      :h="'170px'"
                      :disabled="false"
                    ></vueSignature>
                  </div>
                  <label class="charter-consent">
                    <input type="checkbox" v-model="charterConsent.parent" />
                    <span
                      >I confirm I am the parent/guardian and agree to the
                      Parents Charter above.</span
                    >
                  </label>
                  <div class="sign-actions">
                    <button
                      class="btn-sign"
                      @click="saveSignature('parentSignature')"
                      :disabled="!charterConsent.parent"
                    >
                      <i class="bi bi-check-lg"></i> Save signature
                    </button>
                    <button
                      class="btn-clear"
                      @click="clearSignature('parentSignature')"
                    >
                      Clear
                    </button>
                  </div>
                </template>

                <template v-else-if="charterSignature.parent_signature">
                  <div class="signed-view">
                    <img
                      v-if="
                        isDrawnSignature(
                          charterSignature.parent_signature,
                          charterSignature.parent_signature_type,
                        )
                      "
                      :src="getImgUrl(charterSignature.parent_signature)"
                      class="signed-img"
                    />
                    <div v-else class="typed-signature">
                      {{ charterSignature.parent_signature }}
                    </div>
                    <p
                      class="signed-meta"
                      v-if="charterSignature.parent_signed_at"
                    >
                      <i class="bi bi-check-circle"></i> Signed
                      {{ charterSignature.parent_signed_at }}
                    </p>
                    <button
                      class="btn-resign"
                      @click="
                        changeSignature(
                          'parent_signature_change',
                          charterSignature.id,
                        )
                      "
                    >
                      <i class="bi bi-pencil"></i> Re-sign
                    </button>
                  </div>
                </template>

                <template v-else>
                  <div class="sign-prompt">
                    <p>Not signed yet.</p>
                    <button
                      class="btn-sign"
                      @click="
                        changeSignature(
                          'parent_signature_change',
                          charterSignature.id,
                        )
                      "
                    >
                      <i class="bi bi-pen"></i> Sign now
                    </button>
                  </div>
                </template>
              </div>
            </section>
          </div>
        </b-modal>

        <b-modal
          v-if="showIDPGoalsModal"
          v-model="showIDPGoalsModal"
          title="Your goals"
          size="lg"
          hide-footer
        >
          <div class="player-cv-content">
            <div class="form__item">
              <label class="form__label" for="contact">Goal month:</label>

              <b-form-select
                v-model="IDPselectedGoalData.month_category"
                class="mb-3"
              >
                <b-form-select-option value="12"
                  >12 months</b-form-select-option
                >
                <b-form-select-option value="6">6 months</b-form-select-option>
                <b-form-select-option value="3">3 months</b-form-select-option>
              </b-form-select>
            </div>

            <div class="form__item">
              <label class="form__label" for="contact">Goal:</label>
              <input
                class="form__input"
                type="text"
                id="club"
                v-model="IDPselectedGoalData.goal"
              />
            </div>

            <div class="form__item">
              <label class="form__label" for="how_can"
                >How can I achieve this goal:</label
              >

              <b-form-textarea
                id="how_can"
                placeholder="Add text..."
                rows="8"
                v-model="IDPselectedGoalData.how_can"
              ></b-form-textarea>
            </div>

            <div class="form__item">
              <label class="form__label" for="what_do_i_need"
                >What do i need to achieve this goal:</label
              >

              <b-form-textarea
                id="what_do_i_need"
                placeholder="Add text..."
                rows="8"
                v-model="IDPselectedGoalData.what_do_i_need"
              ></b-form-textarea>
            </div>

            <div class="buttons-row">
              <b-button
                v-if="IDPselectedGoalData.id !== undefined"
                size="lg"
                variant="outline-success"
                @click="editIDPGoal()"
                >Edit
              </b-button>

              <b-button
                v-else
                size="lg"
                variant="outline-success"
                @click="saveIDPGoal()"
                >Save
              </b-button>

              <b-button
                @click="deleteIDPGoal()"
                size="lg"
                variant="outline-danger"
                >Delete</b-button
              >
            </div>
          </div>
        </b-modal>

        <b-modal
          v-if="showPlayerAssesmentModalView"
          v-model="showPlayerAssesmentModalView"
          size="xl"
          modal-class="modal-fullscreen"
          title="Player Self Assessment"
          hide-footer
        >
          <div class="all-game-reports">
            <table
              class="w-a-style game-assesment-reports-table"
              v-if="allPlayerSelfAssessmentData.length > 0"
            >
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="playerSelfAssessment in allPlayerSelfAssessmentData"
                  :key="playerSelfAssessment.id"
                >
                  <td>
                    {{ formatDateForHuman(playerSelfAssessment.created_date) }}
                  </td>
                  <td>
                    <b-button
                      size="lg"
                      class="main-button"
                      variant="outline-success"
                      v-b-tooltip.hover
                      title="View full report"
                      @click="
                        populateSelectedPlayerSelfAssessment(
                          playerSelfAssessment.id,
                        )
                      "
                    >
                      <i class="bi bi-eye" aria-hidden="true"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="empty-state" v-else>
              <img src="../img/emptyStateIllustration.svg" />
              <p>No Player Self Assessments</p>
            </div>

            <section
              class="player-self-assessment-wrapper"
              v-if="Object.keys(playerSelfAssessmentU11to18Data).length > 0"
            >
              <h3>
                Self Assessment
                {{
                  formatDateForHuman(
                    playerSelfAssessmentU11to18Data.created_date,
                  )
                }}
              </h3>

              <div class="multi-radio-wrapper">
                <h4>Technical</h4>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can Control the ball with both feet in multiple
                    directions:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q1 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q1 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q1 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q1 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q1 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can pass with both feet (short):</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q2 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q2 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q2 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q2 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q2 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Has mastered at least one skill move to beat an
                    opponent:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q3 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q3 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q3 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q3 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q3 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can shoot/cross/pass accurately with both feet:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q4 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q4 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q4 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q4 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q4 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can dribble in multiple directions using both feet:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q5 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q5 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q5 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q5 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q5 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can protect the ball from an opponent:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q6 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q6 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q6 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q6 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q6 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>
              </div>

              <div class="multi-radio-wrapper">
                <h4>Tactical</h4>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Makes good decisions on the ball:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q7 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q7 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q7 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q7 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q7 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Takes up good positions to receive the ball:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q8 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q8 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q8 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q8 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q8 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Makes good runs off the ball at the right times:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q9 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q9 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q9 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q9 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q9 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can play in more than one area of the field:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q10 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q10 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q10 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q10 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q10 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can attack in 1v1 situations:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q11 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q11 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q11 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q11 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q11 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can defend in 1v1 situations:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q12 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q12 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q12 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q12 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q12 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Reads situations in the game:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q13 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q13 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q13 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q13 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q13 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>
              </div>

              <div class="multi-radio-wrapper">
                <h4>Physical</h4>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Has good mobility:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q14 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q14 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q14 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q14 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q14 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can Jump and land single leg and double footed:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q15 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q15 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q15 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q15 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q15 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can kick with good technique and generate power (short
                    distances):</label
                  >

                  <p
                    v-if="playerSelfAssessmentU11to18Data.q16 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q16 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q16 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q16 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q16 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Has good balance (single leg, both sides):</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q17 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q17 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q17 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q17 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q17 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Developing basic speed and strength:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q18 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q18 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q18 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q18 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q18 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Is flexible and agile:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q19 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q19 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q19 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q19 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q19 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>
              </div>

              <div class="multi-radio-wrapper">
                <h4>Mental</h4>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Has a growth mindset, willing to learn:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q20 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q20 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q20 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q20 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q20 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Has a competitive mentality:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q21 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q21 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q21 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q21 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q21 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Can build positive relationships and friendships:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q22 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q22 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q22 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q22 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q22 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Calmly and directly expresses their and feelings about
                    situations:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q23 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q23 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q23 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q23 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q23 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Is a problem solver, can find positive solutions to
                    challenges:</label
                  >

                  <p
                    v-if="playerSelfAssessmentU11to18Data.q24 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q24 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q24 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q24 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q24 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Emotional control of winning and losing:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q25 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q25 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q25 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q25 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q25 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>
              </div>

              <div class="multi-radio-wrapper">
                <h4>Social</h4>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Follows Instructions from coaches:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q26 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q26 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q26 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q26 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q26 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Respects club and match rules:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q27 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q27 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q27 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q27 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q27 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Is a good listener and pays attention to coaches and
                    teammates:</label
                  >

                  <p
                    v-if="playerSelfAssessmentU11to18Data.q28 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q28 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q28 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q28 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q28 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Ignores distractions to focus on tasks:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q29 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q29 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q29 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q29 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q29 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Is willing to ask questions to learn:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q30 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q30 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q30 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q30 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q30 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Is positive and enjoys being in a group environment with
                    others:</label
                  >
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q31 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q31 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q31 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q31 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q31 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>

                <div class="form__item">
                  <label class="form__label" for="contact"
                    >Is responsible for their own behaviour:</label
                  >

                  <p
                    v-if="playerSelfAssessmentU11to18Data.q32 === 5"
                    class="green-totals"
                  >
                    Excellent
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q32 === 4"
                    class="green-totals"
                  >
                    Good
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q32 === 3"
                    class="green-totals"
                  >
                    Progressing Well
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q32 === 2"
                    class="amber-totals"
                  >
                    Requires Improvement
                  </p>
                  <p
                    v-if="playerSelfAssessmentU11to18Data.q32 === 1"
                    class="red-totals"
                  >
                    Unsatisfactory
                  </p>
                </div>
              </div>
            </section>
          </div>
        </b-modal>

        <b-modal
          v-if="showPlayerAssesmentModal"
          v-model="showPlayerAssesmentModal"
          size="xl"
          modal-class="modal-fullscreen"
          title="Player Self Assessment"
          hide-footer
        >
          <div class="player-cv-content">
            <div class="multi-radio-wrapper">
              <h4>Technical</h4>
              <p>* Please select all that apply</p>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can Control the ball with both feet in multiple
                  directions:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q1"
                  name="radio-options-1"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can pass with both feet (short):</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q2"
                  name="radio-options-2"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Has mastered at least one skill move to beat an
                  opponent:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q3"
                  name="radio-options-3"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can shoot/cross/pass accurately with both feet:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q4"
                  name="radio-options-4"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can dribble in multiple directions using both feet:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q5"
                  name="radio-options-5"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can protect the ball from an opponent:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q6"
                  name="radio-options-6"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>
            </div>

            <div class="multi-radio-wrapper">
              <h4>Tactical</h4>
              <p>* Please select all that apply</p>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Makes good decisions on the ball:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q7"
                  name="radio-options-7"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Takes up good positions to receive the ball:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q8"
                  name="radio-options-8"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Makes good runs off the ball at the right times:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q9"
                  name="radio-options-9"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can play in more than one area of the field:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q10"
                  name="radio-options-10"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can attack in 1v1 situations:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q11"
                  name="radio-options-11"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can defend in 1v1 situations:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q12"
                  name="radio-options-12"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Reads situations in the game:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q13"
                  name="radio-options-13"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>
            </div>

            <div class="multi-radio-wrapper">
              <h4>Physical</h4>
              <p>* Please select all that apply</p>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Has good mobility:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q14"
                  name="radio-options-14"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can Jump and land single leg and double footed:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q15"
                  name="radio-options-15"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can kick with good technique and generate power (short
                  distances):</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q16"
                  name="radio-options-16"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Has good balance (single leg, both sides):</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q17"
                  name="radio-options-17"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Developing basic speed and strength:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q18"
                  name="radio-options-18"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Is flexible and agile:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q19"
                  name="radio-options-19"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>
            </div>

            <div class="multi-radio-wrapper">
              <h4>Mental</h4>
              <p>* Please select all that apply</p>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Has a growth mindset, willing to learn:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q20"
                  name="radio-options-20"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Has a competitive mentality:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q21"
                  name="radio-options-21"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Can build positive relationships and friendships:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q22"
                  name="radio-options-22"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Calmly and directly expresses their and feelings about
                  situations:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q23"
                  name="radio-options-23"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Is a problem solver, can find positive solutions to
                  challenges:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q24"
                  name="radio-options-24"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Emotional control of winning and losing:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q25"
                  name="radio-options-25"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>
            </div>

            <div class="multi-radio-wrapper">
              <h4>Social</h4>
              <p>* Please select all that apply</p>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Follows Instructions from coaches:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q26"
                  name="radio-options-26"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Respects club and match rules:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q27"
                  name="radio-options-27"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Is a good listener and pays attention to coaches and
                  teammates:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q28"
                  name="radio-options-28"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Ignores distractions to focus on tasks:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q29"
                  name="radio-options-29"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Is willing to ask questions to learn:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q30"
                  name="radio-options-30"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Is positive and enjoys being in a group environment with
                  others:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q31"
                  name="radio-options-31"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>

              <div class="form__item">
                <label class="form__label" for="contact"
                  >Is responsible for their own behaviour:</label
                >

                <b-form-radio-group
                  id="radio-group-technical"
                  class="custom-control-inline-player-assesment"
                  v-model="playerSelfAssessmentU11to18Data.q32"
                  name="radio-options-32"
                >
                  <b-form-radio value="5">Excellent</b-form-radio>
                  <b-form-radio value="4">Good</b-form-radio>
                  <b-form-radio value="3">Progressing Well</b-form-radio>
                  <b-form-radio value="2">Requires Improvement</b-form-radio>
                  <b-form-radio value="1">Unsatisfactory</b-form-radio>
                </b-form-radio-group>
              </div>
            </div>

            <b-button
              @click="saveplayerAssesment('U11-18')"
              v-b-tooltip.hover
              title="Update"
              variant="success"
              >Save</b-button
            >
          </div>
        </b-modal>

        <!-- Bio-Banding & Growth Modal -->
        <div
          v-if="showBioBandingModal"
          class="modal-overlay"
          @click.self="showBioBandingModal = false"
        >
          <div class="modal-dialog modal-xl">
            <div class="modal-content bioband-modal-content">
              <div class="modal-body p-0">
                <BioBandingCalculator
                  :playerName="selectedUserData.name"
                  :playerId="selectedUserData.id"
                  :playerDob="selectedUserData.dob"
                  :playerGender="selectedUserData.gender"
                  :currentUserId="userData.id"
                  @close="showBioBandingModal = false"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Full Training Week Modal -->
        <div
          v-if="showTrainingWeekModal"
          class="modal-overlay"
          @click.self="showTrainingWeekModal = false"
        >
          <div class="modal-dialog report-modal-dialog">
            <div class="modal-content report-modal-content">
              <div class="modal-header report-modal-header">
                <h3>Training Week</h3>
                <button
                  type="button"
                  class="report-modal-close"
                  aria-label="Close"
                  @click="showTrainingWeekModal = false"
                >
                  &times;
                </button>
              </div>
              <div class="modal-body report-modal-body p-0">
                <TrainingWeek
                  :selectedUserData="selectedUserData"
                  :userData="userData"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Players Minutes & Stats Modal -->
        <div
          v-if="showPlayerMinsStatsModal"
          class="modal-overlay"
          @click.self="showPlayerMinsStatsModal = false"
        >
          <div class="modal-dialog report-modal-dialog">
            <div class="modal-content report-modal-content">
              <div class="modal-header report-modal-header">
                <h3>Minutes &amp; Stats</h3>
                <button
                  type="button"
                  class="report-modal-close"
                  aria-label="Close"
                  @click="showPlayerMinsStatsModal = false"
                >
                  &times;
                </button>
              </div>
              <div class="modal-body report-modal-body p-0">
                <PlayersMinsStats
                  :selectedUserValue="selectedUserValue"
                  :selectedUserData="selectedUserData"
                  :under16="under16"
                />
              </div>
            </div>
          </div>
        </div>

        <img
          v-if="
            playerCoachSignedPerformanceReportData.parentReportSignature !==
            undefined
          "
          :src="
            getImgUrl(
              playerCoachSignedPerformanceReportData.parentReportSignature,
            )
          "
          alt=""
          class="visually-hidden"
          id="player_signature_full"
        />
        <img
          src="./img/video-icon.jpg"
          alt=""
          class="visually-hidden"
          id="video-icon"
        />

        <img
          src="./img/pitch-potions.jpg"
          alt=""
          class="visually-hidden"
          id="pitch_potions"
        />
        <img
          src="./img/avrage-scores.jpg"
          alt=""
          class="visually-hidden"
          id="average_scores"
        />
        <img
          src="./img/video-link-image.jpg"
          alt=""
          class="visually-hidden"
          id="video_link_image"
        />
        <img
          src="./img/mood-example.jpg"
          alt=""
          class="visually-hidden"
          id="mood-example_image"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { toRaw } from "vue";
import { mapGetters } from "vuex";
import {
  USER_POPULATE,
  POPULATE_COACHES_USER_DATA,
} from "@/store/actions/user.js";
import { Storage } from "@/services/storage";
import { getNutritionAccess } from "@/composables/useNutritionAccess";
import { Users } from "@/services/user-service.js";
import { Wellness } from "@/services/wellness-service.js";
import { PlayerInjury } from "@/services/player-Injury-service.js";
import { Games } from "@/services/games-service.js";
import { PerformanceReview } from "@/services/performance-review-service.js";
import { Teams } from "@/services/teams-service.js";
import { PlayerPhysicalPerformance } from "@/services/player-physical-performance-service.js";
import { PlayerCv } from "@/services/player-cv-service.js";
import { Documents } from "@/services/documents-service.js";
import { Homework } from "@/services/homework-service.js";
import { EyeBall } from "@/services/eyeball-service.js";
import { Chat } from "@/services/ChatService.js";
import AppTemplate from "../layouts/App";
import SectionNav from "@/components/SectionNav/index.vue";
import JsPDF from "jspdf";
import Axios from "axios";
import TrainingWeek from "../../components/TrainingWeek";
import ProfileTrainingSnapshot from "../../components/TrainingWeek/ProfileTrainingSnapshot.vue";
import SpinnerLoader from "../../components/LoadingSpinning";
import UserImageAndInfo from "../../components/UserImageAndInfo";
import UserHeader from "../../components/UserHeader";
import GpsPannel from "../../components/GpsPanel";
import GpsPlayerBenchmark from "@/components/GpsPlayerBenchmark/index.vue";
import TrialPerformanceReview from "../../components/TrialPerformanceReview";
import WellnessMoodSummary from "../../components/WellnessMoodSummary";
import PlayerPerformanceOverView from "../../components/PlayerPerformanceOverView";
import PlayerPhysicalPerformanceStats from "../../components/PlayerPhysicalPerformanceStats";
import WellnessCalendar from "../../components/WellnessCalendar";
import DocumentView from "../../components/DocumentView";
import GameReportsModal from "@/components/GameReportsModal";
import CoachReportAIHelper from "@/components/CoachReportAIHelper.vue";
import VoiceDictationButton from "@/components/VoiceDictationButton.vue";
import AcademyReportComp from "@/components/AcademyReport";
import MedicalInfoCard from "@/components/MedicalInfo/MedicalInfoCard.vue";
import TrainingPlansLinks from "../training-plans/training-plans-links";
import StarRating from "vue3-star-ratings";
import moment from "moment";
import vueSignature from "vue-signature";
import BarChartStacked from "../../components/BarChart-horizontal-stacked";
import BarChartHorizontal from "../../components/BarChart-horizontal-single";
import PieChart from "../../components/PieChart";
import PlayerInjuryReport from "@/components/PlayerInjuryReport";
import extendSeasonEndDateToFullYearMixin from "@/mixin/extendSeasonEndDateToFullYear.js";
import removeDuplicatesMixin from "@/mixin/removeDuplicates.js";
import checkIfUserHasMoreThanOneAccountMixin from "@/mixin/checkIfUserHasMoreThanOneAccount.js";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import DocumentUploader from "../../components/doucmentUploader";
import PlayersMinsStats from "../../components/PlayersMinsStats";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import dayjs from "dayjs";
import TenantLogo from "@/components/TenantLogo/index.vue";
import TenantImage from "@/components/TenantImage/index.vue";
import { AVATAR_PLACEHOLDER } from "@/utils/avatar";
import CoachPerformanceReviewModal from "@/components/profile/CoachPerformanceReviewModal.vue";
import ReviewTypeSelectionModal from "@/components/profile/ReviewTypeSelectionModal.vue";
import BioBandingCalculator from "@/components/BioBandingCalculator";
import RecentActivity from "@/components/RecentActivity";
import {
  calculateMaturityOffset,
  getMaturityCategory,
} from "@/utils/biobandUtils.js";
import { IDPDashboard } from "@/components/IDP";
import { isFeatureEnabled, getTenantName } from "@/config/tenant";
import { downloadIdpPdf } from "@/utils/idpReportPdf";

// QuillEditor configuration handled per component

export default {
  name: "profile",
  mixins: [
    extendSeasonEndDateToFullYearMixin,
    removeDuplicatesMixin,
    checkIfUserHasMoreThanOneAccountMixin,
  ],
  components: {
    AppTemplate,
    SectionNav,
    SpinnerLoader,
    UserHeader,
    GpsPannel,
    GpsPlayerBenchmark,
    TrainingPlansLinks,
    StarRating,
    UserImageAndInfo,
    BarChartStacked,
    BarChartHorizontal,
    PieChart,
    vueSignature,
    VueDatePicker,
    QuillEditor,
    DocumentUploader,
    TrainingWeek,
    ProfileTrainingSnapshot,
    WellnessMoodSummary,
    PlayerPerformanceOverView,
    GameReportsModal,
    CoachReportAIHelper,
    VoiceDictationButton,
    PlayerInjuryReport,
    AcademyReportComp,
    MedicalInfoCard,
    DocumentView,
    PlayersMinsStats,
    TrialPerformanceReview,
    PlayerPhysicalPerformanceStats,
    WellnessCalendar,
    TenantLogo,
    TenantImage,
    CoachPerformanceReviewModal,
    ReviewTypeSelectionModal,
    BioBandingCalculator,
    RecentActivity,
    IDPDashboard,
  },
  data() {
    return {
      customDateRange: null,
      // Form data
      selectedUserId: "",
      // "Select player" dropdown scope: false = the selected player's squad only
      showAllPlayersInSelect: false,
      isMetricMode: false, // Track imperial/metric toggle state
      showNewplayerIDPModal: false,
      showPlayerIDPModal: false,
      showViewHomeworkModal: false,
      showAddHomeworkModal: false,
      showAddHeight: false,
      showAddWeight: false,
      showViewDailyWellnessReport: false,
      showPerformanceModal: false,
      showTrainingPerformanceModal: false,
      showCoachGamePerformanceModal: false,
      showMissingDataModal: false,
      showPlayerPerformanceReportModal: false,
      showPlayerCoachPerformanceAssessmentModal: false,
      // New Coach Performance Review Modal state
      showNewCoachPerformanceReviewModal: false,
      showReviewTypeSelectionModal: false,
      selectedCoachPerformanceReviewData: {},
      coachPerformanceReviewViewType: "Player",
      coachPerformanceReviewType: "text", // 'text' or 'traffic-light'
      showPlayerPerformanceReportVewDetailsModal: false,
      showAllTrainingReportsModal: false,
      showAllGameReportsModal: false,
      showPerformanceTargetsHistoryModal: false,
      showNewPerformanceTargetsModal: false,
      showPerformanceTargetsModal: false,
      showPlayerCVpersonalProfileModal: false,
      showOpenPlayerInterestsHobbiesModal: false,
      showOpenPlayerEducationModal: false,
      showPlayerVideosModal: false,
      showPlayerCVPlayingExperenceModal: false,
      showViewDayStatsBreakDown: false,
      showUploadPlayerMinsCSV: false,
      showViewDownloadPDF: false,
      showBioBandingModal: false,
      showTrainingWeekModal: false,
      showPlayerMinsStatsModal: false,
      showViewPlayersCV: false,
      showViewPlayerCoachReviewPDF: false,
      showUpLoadModal: false,
      showCharterModal: false,
      showIDPGoalsModal: false,
      showPlayerAssesmentModalView: false,
      showPlayerAssesmentModal: false,
      showLastSeasonWellness: false,
      physicalPerformanceChartSelected: "1",
      physicalPerformanceLineChartData: {},
      physicalPerformanceLineCountermovementJumpChartData: {},
      physicalPerformanceLineReactiveStrengthIndexChartData: {},
      physicalPerformanceLineThirtyFithteenIntermittentFitnessTestChartData: {},
      physicalPerformanceLineHeightChartData: {},
      physicalPerformanceLineWeightChartData: {},
      sessionStrainingAndGamesSessionDistanceChartData: {},
      sessionStrainingAndGamesSessionHighSpeedRunningChartData: {},
      sessionStrainingAndGamesSessionAccelerationsChartData: {},
      sessionStrainingAndGamesSessionDistancePieData: {},
      sessionStrainingAndGamesSessionLeftRighPieData: {},
      sessionStrainingAndGamesSessionLeftLeftPieData: {},
      sessionStrainingAndGamesSessionHighSpeedRunningPieData: {},
      sessionStrainingAndGamesSessionMaximumVelocityPieData: {},
      fullSessionStrainingAndGamesTotalDistanceChartData: {},
      fullSessionStrainingAndGamesHighSpeedRunningChartData: {},
      fullSessionStrainingAndGamesTotalTouchesChartData: {},
      sessionStrainingAndGamesSessionTopSpeedsChartData: {},
      sessionStrainingAndGamesSessionWorkRateChartData: {},
      fullSessionStrainingAndGamesRightFootTouchesChartData: {},
      fullSessionStrainingAndGamesLeftFootTouchesChartData: {},
      sessionStrainingAndGamesChartSelected: "1",
      playerSignature: {
        player_signature: null,
        player_signature_change: true,
        parent_signature: null,
        parent_signature_change: true,
        player_id: null,
        id: null,
      },
      charterSignature: {
        player_signature: null,
        player_signature_change: true,
        parent_signature: null,
        parent_signature_change: true,
        player_id: null,
        id: null,
      },
      // Explicit "I have read and agree" consent, required before a charter
      // signature can be saved (part of the e-signature audit trail).
      charterConsent: {
        player: false,
        parent: false,
      },
      coachSignedPerformanceReportSignature: {
        player_signature_change: true,
        coach_signature_change: true,
        parent_signature_change: true,
      },
      charterData: {
        player_id: "",
        team_id: "",
        player_text: "",
        parent_text: "",
        created_date: "",
      },
      playerDocuments: [],
      technicalSelectOptions: [
        "Passing/Possession",
        "Shooting/Finishing",
        "Heading",
        "1v1 Attacking",
        "1v1 Defending",
        "Crossing",
        "Receiving and ball retaining skills",
        "Dribbling/Running with ball",
        "Close control/First touch",
        "Weak foot",
      ],
      tacticalSelectOptions: [
        "In Possession find/create space",
        "Out of Possession /close space",
        "Winning possession / create space/reaction",
        "Losing Possession /close space/ reaction",
        "Switching Play",
        "Combination/link up play",
        "Positional understanding",
      ],
      physicalSelectOptions: [
        "Agility",
        "Co-ordination",
        "Balance",
        "Speed",
        "Endurance",
        "Strength (U13-U18)",
      ],
      physcologicalSelectOptions: [
        "Intelligence – Game craft/knowledge",
        "Vision",
        "Leadership",
        "Decision making",
        "Composure",
        "Communication",
        "Coachability",
        "Drive/Desire",
        "Discipline",
        "Confidence",
      ],
      playerIDPMonthGoals: {
        tweleveMonth: [],
        sixMonth: [],
        threeMonth: [],
      },
      lastSeasonsPlayerMoodData: [],
      playerSelfAssessmentU11to18Data: {},
      allPlayerSelfAssessmentData: [],
      wellnessDaySelected: null,
      IDPselectedGoalData: {},
      IDPGoalsData: [],
      allQuatersPlayerIDPdata: [],
      newPlayerIDPdata: {},
      playerIDPdata: {
        technical_green: "",
        technical_yellow: "",
        technical_red: "",
        tactical_green: "",
        tactical_yellow: "",
        tactical_red: "",
        physical_green: "",
        physical_yellow: "",
        physical_red: "",
        physcological_green: "",
        physcological_yellow: "",
        physcological_red: "",
        player_comments: "",
        coach_comments: "",
      },
      allGameData: [],
      allHomeWorkDataVideoLinks: [],
      allHomeWorkData: [],
      allTeamWorkData: [],
      newHomeWorkData: {
        created_date: "",
        gameId: null,
        id: null,
        matchDate: null,
        opposition: null,
        title: "",
        information: "",
        player_id: null,
        videos: [],
      },
      physioDocument: {},
      downloadURL: "",
      uploadedDocuments: [],
      file: "",
      selectedDayPlayerData: {},
      csvDataImported: null,
      playerDailyMins: [],
      userHasMoreThanOneAccount: null,
      weight: 0,
      height: 0,
      pastGameDataDataFiltered: [],
      pastGameDataFilteredCoach: [],
      clubTeams: [],
      selectedFilterData: null,
      toggleFilters: false,
      hideRemoveTeamFilterButton: true,
      filterdCoachesUsersData: [],
      allUserDataBeforFilterApplied: [],
      selectedDashboardTab: "player-over-veiw-tab",
      selectedTeamId: 0,
      metricsTrainingTab: "training-distance-tab",
      metricsGameTab: "game-distance-tab",
      signatureOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      allplayerPerformanceReportData: [],
      playerPerformanceReportData: {
        review_date: moment().format("YYYY-MM-DD"),
      },
      selectedPlayerVideoData: {},
      selectedPlayerVideoDataEdit: false,
      selectedPlayerInterestsHobbiesData: {},
      selectedPlayerInterestsHobbiesDataEdit: false,
      selectedPlayerEducationData: {},
      selectedPlayerEducationDataEdit: false,
      selectedPlayingExperenceData: {},
      selectedPlayingExperenceEdit: false,
      cvDeleteArmedKey: null,
      cvDeleteArmedTimer: null,
      cvPdfInstance: null,
      teamVideos: [],
      playerCvData: {
        personal_profile: "",
        playingExperence: [],
        education: [],
        interests_hobbies: [],
        videos: [],
      },
      newInjuryInformation: {
        injury_type: null,
        more_detail: null,
        return_time: null,
        injury_status: null,
        contact: null,
      },
      thisseasongamePerformanceData: [],
      trainingPerformanceData: {},
      newTrainingPerformanceData: {},
      newGamePerformanceData: {
        gameId: null,
        postion_played: null,
        postion_played_two: null,
        goals: 0,
        assists: 0,
        clean_sheet: null,
        player_self_rating: null,
        card: "No",
        timeOnPitch: null,
        gamesPlayed: null,
        technically_improvements: null,
        technically_positives: null,
        tactility_improvements: null,
        tactility_positives: null,
        physicality_improvements: null,
        physicality_positives: null,
        mentally_improvements: null,
        mentally_positives: null,
        pdps_improvements: null,
        pdps_positives: null,
        overall_comments: null,
      },
      gamePerformanceData: {
        gameId: null,
        postion_played: [],
        goals: 0,
        assists: 0,
        clean_sheet: null,
        player_self_rating: null,
        yellowCardTotal: 0,
        redCardTotal: 0,
        timeOnPitch: null,
        gamesPlayed: null,
        gameName: null,
      },
      seasionsCoachGamePerformanceData: [],
      eyeballPrefillApplied: false,
      coachGamePerformanceReportData: {
        gameId: null,
        player_rating: null,
        game_comments: null,
      },
      coachGamePerformanceData: [],
      pastTrainingSessionsData: [],
      pastTrainingSessionsDataFiltered: [],
      pastGameData: [],
      playerMoodData: {},
      thisSeasionsPlayerMoodData: [],
      playerMoodBarChartDataSet: {},
      wellnessQuestions: {
        sleep: 0,
        stress: 0,
        happyness: 0,
        fatigue: 0,
        muscleSoreness: 0,
      },
      // Wellness ratings, 1–5 — the same scale as the phone app so a
      // player's "3" means the same thing wherever it was entered.
      zeroToTen: [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
      ],
      publicPath: process.env.BASE_URL,
      loadingStuff: false,
      selectedUserValue: "",
      weekSelectedNumber: "",
      weeklyDate: "",
      selectedWeekMonSunday: "",
      gamesPlayed: 0,
      selectedUserData: {},
      selectedUserDataForHeader: {},
      userData: {
        name: "",
        userType: "",
      },
      coachesUsersData: [],
      selectedCoachImageURL: null,
      seasonsgamePerformanceReportsForUser: [],
      seasonsTraningPerformanceReportsForUser: [],
      selectedGameFullPerformanceReportsForUser: {},
      selectedTab: "performace-tab",
      navCollapsed: false,
      currentPlayingSeason: null,
      season_start_date: null,
      season_end_date: null,
      allPlayerPhysicalPerformanceData: [],
      playerPhysicalPerformanceData: {},
      showLastSeasonView: false,
      trainingPerformanceBarChartDataSet: {},
      allPlayerInjuryReports: [],
      selectedInjuryReports: [],
      selectedInjury: {},
      playerInjuryHistoryAmounts: {
        headNeckInjury: 0,
        shoulderInjury: 0,
        armInjury: 0,
        wristAndHandInjury: 0,
        hipInjury: 0,
        groinInjury: 0,
        quadInjury: 0,
        hamstringInjury: 0,
        kneeInjury: 0,
        calfInjury: 0,
        ankleInjury: 0,
        footInjury: 0,
      },
      playerCoachSignedPerformanceReportData: {
        created_date: null,
        user_id: "",
        coach_id: null,
        technical_player_comments: "",
        technical_coach_comments: "",
        tactical_player_comments: "",
        tactical_coach_comments: "",
        physical_player_comments: "",
        physical_coach_comments: "",
        physcological_player_comments: "",
        physcological_coach_comments: "",
        player_comments: "",
        coach_comments: "",
        player_signature_id: null,
        parent_signature_id: null,
        coach_signature_id: null,
        published: 0,
      },
      playerSignedPerformanceReportSelected: null,
      performanceCategories: [
        "Technical",
        "Tactical",
        "Physical",
        "Psychological",
        /*"Attitude",
        "Skill",
        "Physique",
        "Mentality",
        "Leadership",
        "Professionalism",*/
      ],
      selectedPerformanceTarget: {},
      playerPerformanceTargets: [
        {
          id: null,
          player_id: this.selectedUserValue,
          performance_report_id: 0,
          idp_id: 0,
          target: "",
          complete: 0,
          created_date: moment().format("YYYY-MM-DD"),
          possession: "",
        },
      ],
      gameTargetQuarterSelection: "all",
      playerGameTargetsData: [],
      playerGameTargetsDataFiltered: [],
      playerPerformanceReviewTargetsData: [],
      showReport: false,
      showCVReport: false,
      showPlayerCoachReportPDFReport: false,
      academyReport: {
        id: null,
        player_id: null,
        seasion: null,
        average_score: 0,
        coaches_comments: "",
      },
      matchReports: [],
      playerMakerPersonalBestAndAverages: {},
      playerPersonalBestAndAverages: {},
      reportDocuments: [],
      slide: 0,
      sliding: true,
      columns: [
        {
          label: "Session name",
          field: "session_name",
        },
        {
          label: "Player name",
          field: "user_name",
        },
        {
          label: "Billing email",
          field: "email",
        },
        {
          label: "Purchase date",
          field: "date",
        },
        {
          label: "Total paid",
          field: "total_price",
        },
        {
          label: "Payment status",
          field: "payment_state",
        },
      ],
      columnsPlayers: [
        {
          label: "Player name",
          field: "name",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "Payment status",
          field: "payment_state",
        },
      ],
      coachData: [],
      showOnlyInjuredPlayers: false,
      showOnlyTrialistPlayers: false,
      lastTrainingSessionData: {},
      lastGameSessionData: {},
      lastPlayMakerGameSessionData: {},
      lastPlayMakerTrainingSessionData: {},
      gpsUploadDataTypeSelected: undefined,
      dataCSVErrorMessage: null,
      playerPlayMakerGpsData: [],
      under16: false,
      over14: false,
      selectedGameAndTrainingChartStats: {},
      allPlayerCoachSignedPerformanceReportData: [],
      playerCoachsignedReportReady: false,
      khamisRoche: [
        {
          roundedDecimalAge: 4,
          gender: "M",
          bo: -26.0521,
          stature: 1.23812,
          weight: -0.48849,
          midParentStature: 0.50286,
          refMean: 57.72,
          refSd: 1.38,
        },
        {
          roundedDecimalAge: 5,
          gender: "M",
          bo: -27.9942,
          stature: 1.10674,
          weight: -0.36274,
          midParentStature: 0.53919,
          refMean: 61.6,
          refSd: 1.49,
        },
        {
          roundedDecimalAge: 5.5,
          gender: "M",
          bo: -28.3354,
          stature: 1.0748,
          weight: -0.32344,
          midParentStature: 0.53691,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 6,
          gender: "M",
          bo: -28.2291,
          stature: 1.05923,
          weight: -0.29649,
          midParentStature: 0.52513,
          refMean: 65.31,
          refSd: 1.58,
        },
        {
          roundedDecimalAge: 6.5,
          gender: "M",
          bo: -27.9963,
          stature: 1.05542,
          weight: -0.27938,
          midParentStature: 0.50692,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 7,
          gender: "M",
          bo: -27.9361,
          stature: 1.05877,
          weight: -0.26959,
          midParentStature: 0.48538,
          refMean: 69.08,
          refSd: 1.6,
        },
        {
          roundedDecimalAge: 7.5,
          gender: "M",
          bo: -27.9943,
          stature: 1.06467,
          weight: -0.26462,
          midParentStature: 0.46361,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 8,
          gender: "M",
          bo: -28.1169,
          stature: 1.06853,
          weight: -0.26194,
          midParentStature: 0.44469,
          refMean: 72.4,
          refSd: 1.68,
        },
        {
          roundedDecimalAge: 8.5,
          gender: "M",
          bo: -28.2499,
          stature: 1.06572,
          weight: -0.25905,
          midParentStature: 0.43171,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 9,
          gender: "M",
          bo: -28.3392,
          stature: 1.05166,
          weight: -0.25341,
          midParentStature: 0.42776,
          refMean: 75.61,
          refSd: 1.68,
        },
        {
          roundedDecimalAge: 9.5,
          gender: "M",
          bo: -28.297,
          stature: 1.02174,
          weight: -0.24253,
          midParentStature: 0.43593,
          refMean: 77.21,
          refSd: 1.66,
        },
        {
          roundedDecimalAge: 10,
          gender: "M",
          bo: -28.0365,
          stature: 0.97135,
          weight: -0.22388,
          midParentStature: 0.45932,
          refMean: 78.4,
          refSd: 1.76,
        },
        {
          roundedDecimalAge: 10.5,
          gender: "M",
          bo: -27.5047,
          stature: 0.89589,
          weight: -0.19495,
          midParentStature: 0.50101,
          refMean: 79.82,
          refSd: 1.77,
        },
        {
          roundedDecimalAge: 11,
          gender: "M",
          bo: -26.649,
          stature: 0.81239,
          weight: -0.16267,
          midParentStature: 0.54781,
          refMean: 81.3,
          refSd: 1.94,
        },
        {
          roundedDecimalAge: 11.5,
          gender: "M",
          bo: -25.4165,
          stature: 0.74134,
          weight: -0.13533,
          midParentStature: 0.58409,
          refMean: 82.54,
          refSd: 2,
        },
        {
          roundedDecimalAge: 12,
          gender: "M",
          bo: -23.7546,
          stature: 0.68325,
          weight: -0.11242,
          midParentStature: 0.60927,
          refMean: 84,
          refSd: 2.23,
        },
        {
          roundedDecimalAge: 12.5,
          gender: "M",
          bo: -21.858,
          stature: 0.63869,
          weight: -0.09341,
          midParentStature: 0.62279,
          refMean: 85.43,
          refSd: 2.49,
        },
        {
          roundedDecimalAge: 13,
          gender: "M",
          bo: -19.9726,
          stature: 0.60818,
          weight: -0.07781,
          midParentStature: 0.62407,
          refMean: 87.32,
          refSd: 3.02,
        },
        {
          roundedDecimalAge: 13.5,
          gender: "M",
          bo: -18.1225,
          stature: 0.59228,
          weight: -0.06509,
          midParentStature: 0.61253,
          refMean: 89.22,
          refSd: 3.57,
        },
        {
          roundedDecimalAge: 14,
          gender: "M",
          bo: -16.3319,
          stature: 0.59151,
          weight: -0.05474,
          midParentStature: 0.58762,
          refMean: 91,
          refSd: 3.96,
        },
        {
          roundedDecimalAge: 14.5,
          gender: "M",
          bo: -14.6249,
          stature: 0.60643,
          weight: -0.04626,
          midParentStature: 0.54875,
          refMean: 92.6,
          refSd: 3.85,
        },
        {
          roundedDecimalAge: 15,
          gender: "M",
          bo: -13.0256,
          stature: 0.63757,
          weight: -0.03913,
          midParentStature: 0.49536,
          refMean: 94.6,
          refSd: 3.74,
        },
        {
          roundedDecimalAge: 15.5,
          gender: "M",
          bo: -11.4535,
          stature: 0.68548,
          weight: -0.03283,
          midParentStature: 0.42687,
          refMean: 96,
          refSd: 3.31,
        },
        {
          roundedDecimalAge: 16,
          gender: "M",
          bo: -9.9801,
          stature: 0.75069,
          weight: -0.02685,
          midParentStature: 0.34271,
          refMean: 97.09,
          refSd: 2.71,
        },
        {
          roundedDecimalAge: 16.5,
          gender: "M",
          bo: -8.8577,
          stature: 0.83375,
          weight: -0.02069,
          midParentStature: 0.24231,
          refMean: 97.95,
          refSd: 2.12,
        },
        {
          roundedDecimalAge: 17,
          gender: "M",
          bo: -8.3388,
          stature: 0.9352,
          weight: -0.01383,
          midParentStature: 0.1251,
          refMean: 98.79,
          refSd: 1.43,
        },
        {
          roundedDecimalAge: 17.5,
          gender: "M",
          bo: -8.6756,
          stature: 1.05558,
          weight: -0.00575,
          midParentStature: -0.0095,
          refMean: 99.28,
          refSd: 1.01,
        },
        {
          roundedDecimalAge: 4,
          gender: "F",
          bo: -20.6566,
          stature: 1.24768,
          weight: -1.0883,
          midParentStature: 0.44774,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 4.5,
          gender: "F",
          bo: -16.4505,
          stature: 1.22177,
          weight: -1.03701,
          midParentStature: 0.41381,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 5,
          gender: "F",
          bo: -13.045,
          stature: 1.19932,
          weight: -0.98161,
          midParentStature: 0.38467,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 5.5,
          gender: "F",
          bo: -10.5103,
          stature: 1.1788,
          weight: -0.92307,
          midParentStature: 0.36039,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 6,
          gender: "F",
          bo: -8.9164,
          stature: 1.15866,
          weight: -0.86236,
          midParentStature: 0.34105,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 6.5,
          gender: "F",
          bo: -7.9838,
          stature: 1.13737,
          weight: -0.80043,
          midParentStature: 0.32672,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 7,
          gender: "F",
          bo: -7.3062,
          stature: 1.11342,
          weight: -0.73826,
          midParentStature: 0.31748,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 7.5,
          gender: "F",
          bo: -6.7638,
          stature: 1.08525,
          weight: -0.6768,
          midParentStature: 0.3134,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 8,
          gender: "F",
          bo: -6.2372,
          stature: 1.05135,
          weight: -0.61704,
          midParentStature: 0.31457,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 8.5,
          gender: "F",
          bo: -5.6065,
          stature: 1.01018,
          weight: -0.55993,
          midParentStature: 0.32105,
          refMean: 0,
          refSd: 0,
        },
        {
          roundedDecimalAge: 9,
          gender: "F",
          bo: -4.7523,
          stature: 0.9602,
          weight: -0.50644,
          midParentStature: 0.33291,
          refMean: 81.19,
          refSd: 2,
        },
        {
          roundedDecimalAge: 9.5,
          gender: "F",
          bo: -2.7008,
          stature: 0.89989,
          weight: -0.45754,
          midParentStature: 0.35025,
          refMean: 83.03,
          refSd: 2.13,
        },
        {
          roundedDecimalAge: 10,
          gender: "F",
          bo: 0.8501,
          stature: 0.82771,
          weight: -0.41419,
          midParentStature: 0.37312,
          refMean: 84.76,
          refSd: 2.42,
        },
        {
          roundedDecimalAge: 10.5,
          gender: "F",
          bo: 5.0131,
          stature: 0.74213,
          weight: -0.37736,
          midParentStature: 0.40161,
          refMean: 86.85,
          refSd: 2.71,
        },
        {
          roundedDecimalAge: 11,
          gender: "F",
          bo: 8.9011,
          stature: 0.67173,
          weight: -0.34357,
          midParentStature: 0.42042,
          refMean: 88.65,
          refSd: 2.88,
        },
        {
          roundedDecimalAge: 11.5,
          gender: "F",
          bo: 11.6268,
          stature: 0.6415,
          weight: -0.30898,
          midParentStature: 0.41686,
          refMean: 90.81,
          refSd: 3.06,
        },
        {
          roundedDecimalAge: 12,
          gender: "F",
          bo: 12.3029,
          stature: 0.64452,
          weight: -0.27405,
          midParentStature: 0.3949,
          refMean: 92.61,
          refSd: 3.27,
        },
        {
          roundedDecimalAge: 12.5,
          gender: "F",
          bo: 10.8679,
          stature: 0.67386,
          weight: -0.23924,
          midParentStature: 0.3585,
          refMean: 94.72,
          refSd: 2.61,
        },
        {
          roundedDecimalAge: 13,
          gender: "F",
          bo: 8.164,
          stature: 0.7226,
          weight: -0.20499,
          midParentStature: 0.31163,
          refMean: 95.96,
          refSd: 2.15,
        },
        {
          roundedDecimalAge: 13.5,
          gender: "F",
          bo: 4.6598,
          stature: 0.78383,
          weight: -0.17175,
          midParentStature: 0.25826,
          refMean: 97.17,
          refSd: 1.7,
        },
        {
          roundedDecimalAge: 14,
          gender: "F",
          bo: 0.8236,
          stature: 0.85062,
          weight: -0.13999,
          midParentStature: 0.20235,
          refMean: 98.27,
          refSd: 1.24,
        },
        {
          roundedDecimalAge: 14.5,
          gender: "F",
          bo: -2.8759,
          stature: 0.91605,
          weight: -0.11015,
          midParentStature: 0.14787,
          refMean: 98.74,
          refSd: 0.93,
        },
        {
          roundedDecimalAge: 15,
          gender: "F",
          bo: -5.9704,
          stature: 0.97319,
          weight: -0.08268,
          midParentStature: 0.0988,
          refMean: 99.31,
          refSd: 0.68,
        },
        {
          roundedDecimalAge: 15.5,
          gender: "F",
          bo: -7.8823,
          stature: 1.01514,
          weight: -0.05805,
          midParentStature: 0.05909,
          refMean: 99.54,
          refSd: 0.48,
        },
        {
          roundedDecimalAge: 16,
          gender: "F",
          bo: -8.0743,
          stature: 1.03496,
          weight: -0.03669,
          midParentStature: 0.03272,
          refMean: 99.62,
          refSd: 0.35,
        },
        {
          roundedDecimalAge: 16.5,
          gender: "F",
          bo: -6.1381,
          stature: 1.02573,
          weight: -0.01906,
          midParentStature: 0.02364,
          refMean: 99.75,
          refSd: 0.34,
        },
        {
          roundedDecimalAge: 17,
          gender: "F",
          bo: -1.6657,
          stature: 0.98054,
          weight: -0.00562,
          midParentStature: 0.03584,
          refMean: 99.95,
          refSd: 0.25,
        },
        {
          roundedDecimalAge: 17.5,
          gender: "F",
          bo: 5.7513,
          stature: 0.89246,
          weight: 0.00318,
          midParentStature: 0.07327,
          refMean: 99.91,
          refSd: 0.25,
        },
      ],
      pah: [
        {
          pah: 28.75,
          gender: "M",
          age: 0,
          ht: 51.04,
        },
        {
          pah: 30.81,
          gender: "M",
          age: 0.083,
          ht: 54.7,
        },
        {
          pah: 32.72,
          gender: "M",
          age: 0.167,
          ht: 58.09,
        },
        {
          pah: 34.4,
          gender: "M",
          age: 0.25,
          ht: 61.07,
        },
        {
          pah: 35.82,
          gender: "M",
          age: 0.333,
          ht: 63.59,
        },
        {
          pah: 37.01,
          gender: "M",
          age: 0.417,
          ht: 65.71,
        },
        {
          pah: 38.01,
          gender: "M",
          age: 0.5,
          ht: 67.49,
        },
        {
          pah: 38.88,
          gender: "M",
          age: 0.583,
          ht: 69.04,
        },
        {
          pah: 39.68,
          gender: "M",
          age: 0.667,
          ht: 70.45,
        },
        {
          pah: 40.43,
          gender: "M",
          age: 0.75,
          ht: 71.78,
        },
        {
          pah: 41.15,
          gender: "M",
          age: 0.833,
          ht: 73.07,
        },
        {
          pah: 41.86,
          gender: "M",
          age: 0.917,
          ht: 74.32,
        },
        {
          pah: 42.53,
          gender: "M",
          age: 1,
          ht: 75.51,
        },
        {
          pah: 43.17,
          gender: "M",
          age: 1.083,
          ht: 76.65,
        },
        {
          pah: 43.78,
          gender: "M",
          age: 1.167,
          ht: 77.74,
        },
        {
          pah: 44.38,
          gender: "M",
          age: 1.25,
          ht: 78.79,
        },
        {
          pah: 44.95,
          gender: "M",
          age: 1.333,
          ht: 79.81,
        },
        {
          pah: 45.5,
          gender: "M",
          age: 1.417,
          ht: 80.79,
        },
        {
          pah: 46.04,
          gender: "M",
          age: 1.5,
          ht: 81.74,
        },
        {
          pah: 46.56,
          gender: "M",
          age: 1.583,
          ht: 82.66,
        },
        {
          pah: 47.05,
          gender: "M",
          age: 1.667,
          ht: 83.54,
        },
        {
          pah: 47.54,
          gender: "M",
          age: 1.75,
          ht: 84.4,
        },
        {
          pah: 48,
          gender: "M",
          age: 1.833,
          ht: 85.22,
        },
        {
          pah: 48.45,
          gender: "M",
          age: 1.917,
          ht: 86.02,
        },
        {
          pah: 48.89,
          gender: "M",
          age: 2,
          ht: 86.8,
        },
        {
          pah: 49.32,
          gender: "M",
          age: 2.083,
          ht: 87.56,
        },
        {
          pah: 49.74,
          gender: "M",
          age: 2.167,
          ht: 88.31,
        },
        {
          pah: 50.15,
          gender: "M",
          age: 2.25,
          ht: 89.04,
        },
        {
          pah: 50.55,
          gender: "M",
          age: 2.333,
          ht: 89.76,
        },
        {
          pah: 50.97,
          gender: "M",
          age: 2.417,
          ht: 90.49,
        },
        {
          pah: 51.37,
          gender: "M",
          age: 2.5,
          ht: 91.21,
        },
        {
          pah: 51.78,
          gender: "M",
          age: 2.583,
          ht: 91.93,
        },
        {
          pah: 52.18,
          gender: "M",
          age: 2.667,
          ht: 92.65,
        },
        {
          pah: 52.58,
          gender: "M",
          age: 2.75,
          ht: 93.36,
        },
        {
          pah: 52.97,
          gender: "M",
          age: 2.833,
          ht: 94.05,
        },
        {
          pah: 53.36,
          gender: "M",
          age: 2.917,
          ht: 94.74,
        },
        {
          pah: 53.74,
          gender: "M",
          age: 3,
          ht: 95.41,
        },
        {
          pah: 54.1,
          gender: "M",
          age: 3.083,
          ht: 96.06,
        },
        {
          pah: 54.46,
          gender: "M",
          age: 3.167,
          ht: 96.7,
        },
        {
          pah: 54.81,
          gender: "M",
          age: 3.25,
          ht: 97.32,
        },
        {
          pah: 55.16,
          gender: "M",
          age: 3.333,
          ht: 97.93,
        },
        {
          pah: 55.49,
          gender: "M",
          age: 3.417,
          ht: 98.53,
        },
        {
          pah: 55.82,
          gender: "M",
          age: 3.5,
          ht: 99.11,
        },
        {
          pah: 56.15,
          gender: "M",
          age: 3.583,
          ht: 99.69,
        },
        {
          pah: 56.46,
          gender: "M",
          age: 3.667,
          ht: 100.25,
        },
        {
          pah: 56.78,
          gender: "M",
          age: 3.75,
          ht: 100.81,
        },
        {
          pah: 57.09,
          gender: "M",
          age: 3.833,
          ht: 101.37,
        },
        {
          pah: 57.41,
          gender: "M",
          age: 3.917,
          ht: 101.93,
        },
        {
          pah: 57.72,
          gender: "M",
          age: 4,
          ht: 102.49,
        },
        {
          pah: 58.05,
          gender: "M",
          age: 4.083,
          ht: 103.06,
        },
        {
          pah: 58.37,
          gender: "M",
          age: 4.167,
          ht: 103.64,
        },
        {
          pah: 58.7,
          gender: "M",
          age: 4.25,
          ht: 104.22,
        },
        {
          pah: 59.03,
          gender: "M",
          age: 4.333,
          ht: 104.8,
        },
        {
          pah: 59.36,
          gender: "M",
          age: 4.417,
          ht: 105.4,
        },
        {
          pah: 59.7,
          gender: "M",
          age: 4.5,
          ht: 106,
        },
        {
          pah: 60.04,
          gender: "M",
          age: 4.583,
          ht: 106.6,
        },
        {
          pah: 60.38,
          gender: "M",
          age: 4.667,
          ht: 107.21,
        },
        {
          pah: 60.72,
          gender: "M",
          age: 4.75,
          ht: 107.81,
        },
        {
          pah: 61.06,
          gender: "M",
          age: 4.833,
          ht: 108.41,
        },
        {
          pah: 61.4,
          gender: "M",
          age: 4.917,
          ht: 109.01,
        },
        {
          pah: 61.72,
          gender: "M",
          age: 5,
          ht: 109.59,
        },
        {
          pah: 62.04,
          gender: "M",
          age: 5.083,
          ht: 110.16,
        },
        {
          pah: 62.37,
          gender: "M",
          age: 5.167,
          ht: 110.73,
        },
        {
          pah: 62.68,
          gender: "M",
          age: 5.25,
          ht: 111.28,
        },
        {
          pah: 62.97,
          gender: "M",
          age: 5.333,
          ht: 111.81,
        },
        {
          pah: 63.28,
          gender: "M",
          age: 5.417,
          ht: 112.35,
        },
        {
          pah: 63.57,
          gender: "M",
          age: 5.5,
          ht: 112.87,
        },
        {
          pah: 63.86,
          gender: "M",
          age: 5.583,
          ht: 113.38,
        },
        {
          pah: 64.15,
          gender: "M",
          age: 5.667,
          ht: 113.9,
        },
        {
          pah: 64.44,
          gender: "M",
          age: 5.75,
          ht: 114.41,
        },
        {
          pah: 64.73,
          gender: "M",
          age: 5.833,
          ht: 114.92,
        },
        {
          pah: 65.01,
          gender: "M",
          age: 5.917,
          ht: 115.43,
        },
        {
          pah: 65.29,
          gender: "M",
          age: 6,
          ht: 115.93,
        },
        {
          pah: 65.58,
          gender: "M",
          age: 6.083,
          ht: 116.44,
        },
        {
          pah: 65.86,
          gender: "M",
          age: 6.167,
          ht: 116.94,
        },
        {
          pah: 66.14,
          gender: "M",
          age: 6.25,
          ht: 117.44,
        },
        {
          pah: 66.43,
          gender: "M",
          age: 6.333,
          ht: 117.94,
        },
        {
          pah: 66.7,
          gender: "M",
          age: 6.417,
          ht: 118.43,
        },
        {
          pah: 66.98,
          gender: "M",
          age: 6.5,
          ht: 118.93,
        },
        {
          pah: 67.26,
          gender: "M",
          age: 6.583,
          ht: 119.42,
        },
        {
          pah: 67.54,
          gender: "M",
          age: 6.667,
          ht: 119.91,
        },
        {
          pah: 67.82,
          gender: "M",
          age: 6.75,
          ht: 120.41,
        },
        {
          pah: 68.09,
          gender: "M",
          age: 6.833,
          ht: 120.9,
        },
        {
          pah: 68.38,
          gender: "M",
          age: 6.917,
          ht: 121.4,
        },
        {
          pah: 68.66,
          gender: "M",
          age: 7,
          ht: 121.9,
        },
        {
          pah: 68.94,
          gender: "M",
          age: 7.083,
          ht: 122.4,
        },
        {
          pah: 69.22,
          gender: "M",
          age: 7.167,
          ht: 122.9,
        },
        {
          pah: 69.5,
          gender: "M",
          age: 7.25,
          ht: 123.4,
        },
        {
          pah: 69.78,
          gender: "M",
          age: 7.333,
          ht: 123.9,
        },
        {
          pah: 70.06,
          gender: "M",
          age: 7.417,
          ht: 124.4,
        },
        {
          pah: 70.35,
          gender: "M",
          age: 7.5,
          ht: 124.9,
        },
        {
          pah: 70.63,
          gender: "M",
          age: 7.583,
          ht: 125.4,
        },
        {
          pah: 70.9,
          gender: "M",
          age: 7.667,
          ht: 125.89,
        },
        {
          pah: 71.19,
          gender: "M",
          age: 7.75,
          ht: 126.39,
        },
        {
          pah: 71.46,
          gender: "M",
          age: 7.833,
          ht: 126.87,
        },
        {
          pah: 71.73,
          gender: "M",
          age: 7.917,
          ht: 127.36,
        },
        {
          pah: 72.01,
          gender: "M",
          age: 8,
          ht: 127.85,
        },
        {
          pah: 72.28,
          gender: "M",
          age: 8.083,
          ht: 128.33,
        },
        {
          pah: 72.54,
          gender: "M",
          age: 8.167,
          ht: 128.8,
        },
        {
          pah: 72.81,
          gender: "M",
          age: 8.25,
          ht: 129.27,
        },
        {
          pah: 73.07,
          gender: "M",
          age: 8.333,
          ht: 129.74,
        },
        {
          pah: 73.33,
          gender: "M",
          age: 8.417,
          ht: 130.19,
        },
        {
          pah: 73.58,
          gender: "M",
          age: 8.5,
          ht: 130.64,
        },
        {
          pah: 73.83,
          gender: "M",
          age: 8.583,
          ht: 131.09,
        },
        {
          pah: 74.09,
          gender: "M",
          age: 8.667,
          ht: 131.54,
        },
        {
          pah: 74.33,
          gender: "M",
          age: 8.75,
          ht: 131.97,
        },
        {
          pah: 74.58,
          gender: "M",
          age: 8.833,
          ht: 132.41,
        },
        {
          pah: 74.82,
          gender: "M",
          age: 8.917,
          ht: 132.84,
        },
        {
          pah: 75.07,
          gender: "M",
          age: 9,
          ht: 133.28,
        },
        {
          pah: 75.31,
          gender: "M",
          age: 9.083,
          ht: 133.71,
        },
        {
          pah: 75.55,
          gender: "M",
          age: 9.167,
          ht: 134.14,
        },
        {
          pah: 75.79,
          gender: "M",
          age: 9.25,
          ht: 134.57,
        },
        {
          pah: 76.03,
          gender: "M",
          age: 9.333,
          ht: 134.99,
        },
        {
          pah: 76.27,
          gender: "M",
          age: 9.417,
          ht: 135.42,
        },
        {
          pah: 76.51,
          gender: "M",
          age: 9.5,
          ht: 135.84,
        },
        {
          pah: 76.74,
          gender: "M",
          age: 9.583,
          ht: 136.26,
        },
        {
          pah: 76.98,
          gender: "M",
          age: 9.667,
          ht: 136.68,
        },
        {
          pah: 77.22,
          gender: "M",
          age: 9.75,
          ht: 137.1,
        },
        {
          pah: 77.46,
          gender: "M",
          age: 9.833,
          ht: 137.53,
        },
        {
          pah: 77.7,
          gender: "M",
          age: 9.917,
          ht: 137.96,
        },
        {
          pah: 77.94,
          gender: "M",
          age: 10,
          ht: 138.39,
        },
        {
          pah: 78.19,
          gender: "M",
          age: 10.083,
          ht: 138.82,
        },
        {
          pah: 78.43,
          gender: "M",
          age: 10.167,
          ht: 139.26,
        },
        {
          pah: 78.68,
          gender: "M",
          age: 10.25,
          ht: 139.69,
        },
        {
          pah: 78.92,
          gender: "M",
          age: 10.333,
          ht: 140.12,
        },
        {
          pah: 79.16,
          gender: "M",
          age: 10.417,
          ht: 140.54,
        },
        {
          pah: 79.39,
          gender: "M",
          age: 10.5,
          ht: 140.96,
        },
        {
          pah: 79.62,
          gender: "M",
          age: 10.583,
          ht: 141.37,
        },
        {
          pah: 79.85,
          gender: "M",
          age: 10.667,
          ht: 141.78,
        },
        {
          pah: 80.08,
          gender: "M",
          age: 10.75,
          ht: 142.18,
        },
        {
          pah: 80.3,
          gender: "M",
          age: 10.833,
          ht: 142.58,
        },
        {
          pah: 80.53,
          gender: "M",
          age: 10.917,
          ht: 142.98,
        },
        {
          pah: 80.75,
          gender: "M",
          age: 11,
          ht: 143.37,
        },
        {
          pah: 80.97,
          gender: "M",
          age: 11.083,
          ht: 143.77,
        },
        {
          pah: 81.19,
          gender: "M",
          age: 11.167,
          ht: 144.16,
        },
        {
          pah: 81.41,
          gender: "M",
          age: 11.25,
          ht: 144.55,
        },
        {
          pah: 81.64,
          gender: "M",
          age: 11.333,
          ht: 144.95,
        },
        {
          pah: 81.86,
          gender: "M",
          age: 11.417,
          ht: 145.34,
        },
        {
          pah: 82.09,
          gender: "M",
          age: 11.5,
          ht: 145.75,
        },
        {
          pah: 82.32,
          gender: "M",
          age: 11.583,
          ht: 146.16,
        },
        {
          pah: 82.56,
          gender: "M",
          age: 11.667,
          ht: 146.58,
        },
        {
          pah: 82.8,
          gender: "M",
          age: 11.75,
          ht: 147.02,
        },
        {
          pah: 83.05,
          gender: "M",
          age: 11.833,
          ht: 147.46,
        },
        {
          pah: 83.31,
          gender: "M",
          age: 11.917,
          ht: 147.91,
        },
        {
          pah: 83.56,
          gender: "M",
          age: 12,
          ht: 148.36,
        },
        {
          pah: 83.82,
          gender: "M",
          age: 12.083,
          ht: 148.83,
        },
        {
          pah: 84.09,
          gender: "M",
          age: 12.167,
          ht: 149.31,
        },
        {
          pah: 84.38,
          gender: "M",
          age: 12.25,
          ht: 149.81,
        },
        {
          pah: 84.66,
          gender: "M",
          age: 12.333,
          ht: 150.31,
        },
        {
          pah: 84.95,
          gender: "M",
          age: 12.417,
          ht: 150.83,
        },
        {
          pah: 85.24,
          gender: "M",
          age: 12.5,
          ht: 151.35,
        },
        {
          pah: 85.55,
          gender: "M",
          age: 12.583,
          ht: 151.89,
        },
        {
          pah: 85.86,
          gender: "M",
          age: 12.667,
          ht: 152.44,
        },
        {
          pah: 86.17,
          gender: "M",
          age: 12.75,
          ht: 153,
        },
        {
          pah: 86.5,
          gender: "M",
          age: 12.833,
          ht: 153.58,
        },
        {
          pah: 86.83,
          gender: "M",
          age: 12.917,
          ht: 154.17,
        },
        {
          pah: 87.17,
          gender: "M",
          age: 13,
          ht: 154.77,
        },
        {
          pah: 87.51,
          gender: "M",
          age: 13.083,
          ht: 155.38,
        },
        {
          pah: 87.86,
          gender: "M",
          age: 13.167,
          ht: 156,
        },
        {
          pah: 88.22,
          gender: "M",
          age: 13.25,
          ht: 156.63,
        },
        {
          pah: 88.58,
          gender: "M",
          age: 13.333,
          ht: 157.27,
        },
        {
          pah: 88.94,
          gender: "M",
          age: 13.417,
          ht: 157.91,
        },
        {
          pah: 89.3,
          gender: "M",
          age: 13.5,
          ht: 158.55,
        },
        {
          pah: 89.66,
          gender: "M",
          age: 13.583,
          ht: 159.2,
        },
        {
          pah: 90.03,
          gender: "M",
          age: 13.667,
          ht: 159.84,
        },
        {
          pah: 90.38,
          gender: "M",
          age: 13.75,
          ht: 160.47,
        },
        {
          pah: 90.74,
          gender: "M",
          age: 13.833,
          ht: 161.11,
        },
        {
          pah: 91.1,
          gender: "M",
          age: 13.917,
          ht: 161.74,
        },
        {
          pah: 91.44,
          gender: "M",
          age: 14,
          ht: 162.36,
        },
        {
          pah: 91.79,
          gender: "M",
          age: 14.083,
          ht: 162.97,
        },
        {
          pah: 92.13,
          gender: "M",
          age: 14.167,
          ht: 163.58,
        },
        {
          pah: 92.46,
          gender: "M",
          age: 14.25,
          ht: 164.17,
        },
        {
          pah: 92.79,
          gender: "M",
          age: 14.333,
          ht: 164.75,
        },
        {
          pah: 93.12,
          gender: "M",
          age: 14.417,
          ht: 165.33,
        },
        {
          pah: 93.43,
          gender: "M",
          age: 14.5,
          ht: 165.88,
        },
        {
          pah: 93.74,
          gender: "M",
          age: 14.583,
          ht: 166.43,
        },
        {
          pah: 94.04,
          gender: "M",
          age: 14.667,
          ht: 166.96,
        },
        {
          pah: 94.33,
          gender: "M",
          age: 14.75,
          ht: 167.48,
        },
        {
          pah: 94.61,
          gender: "M",
          age: 14.833,
          ht: 167.98,
        },
        {
          pah: 94.89,
          gender: "M",
          age: 14.917,
          ht: 168.47,
        },
        {
          pah: 95.15,
          gender: "M",
          age: 15,
          ht: 168.94,
        },
        {
          pah: 95.41,
          gender: "M",
          age: 15.083,
          ht: 169.4,
        },
        {
          pah: 95.66,
          gender: "M",
          age: 15.167,
          ht: 169.84,
        },
        {
          pah: 95.89,
          gender: "M",
          age: 15.25,
          ht: 170.26,
        },
        {
          pah: 96.13,
          gender: "M",
          age: 15.333,
          ht: 170.67,
        },
        {
          pah: 96.34,
          gender: "M",
          age: 15.417,
          ht: 171.06,
        },
        {
          pah: 96.55,
          gender: "M",
          age: 15.5,
          ht: 171.43,
        },
        {
          pah: 96.76,
          gender: "M",
          age: 15.583,
          ht: 171.79,
        },
        {
          pah: 96.95,
          gender: "M",
          age: 15.667,
          ht: 172.14,
        },
        {
          pah: 97.14,
          gender: "M",
          age: 15.75,
          ht: 172.48,
        },
        {
          pah: 97.32,
          gender: "M",
          age: 15.833,
          ht: 172.79,
        },
        {
          pah: 97.49,
          gender: "M",
          age: 15.917,
          ht: 173.1,
        },
        {
          pah: 97.66,
          gender: "M",
          age: 16,
          ht: 173.39,
        },
        {
          pah: 97.81,
          gender: "M",
          age: 16.083,
          ht: 173.66,
        },
        {
          pah: 97.96,
          gender: "M",
          age: 16.167,
          ht: 173.93,
        },
        {
          pah: 98.1,
          gender: "M",
          age: 16.25,
          ht: 174.18,
        },
        {
          pah: 98.24,
          gender: "M",
          age: 16.333,
          ht: 174.42,
        },
        {
          pah: 98.36,
          gender: "M",
          age: 16.417,
          ht: 174.64,
        },
        {
          pah: 98.48,
          gender: "M",
          age: 16.5,
          ht: 174.86,
        },
        {
          pah: 98.6,
          gender: "M",
          age: 16.583,
          ht: 175.06,
        },
        {
          pah: 98.7,
          gender: "M",
          age: 16.667,
          ht: 175.25,
        },
        {
          pah: 98.81,
          gender: "M",
          age: 16.75,
          ht: 175.43,
        },
        {
          pah: 98.91,
          gender: "M",
          age: 16.833,
          ht: 175.61,
        },
        {
          pah: 99,
          gender: "M",
          age: 16.917,
          ht: 175.77,
        },
        {
          pah: 99.08,
          gender: "M",
          age: 17,
          ht: 175.92,
        },
        {
          pah: 99.17,
          gender: "M",
          age: 17.083,
          ht: 176.07,
        },
        {
          pah: 99.25,
          gender: "M",
          age: 17.167,
          ht: 176.21,
        },
        {
          pah: 99.31,
          gender: "M",
          age: 17.25,
          ht: 176.33,
        },
        {
          pah: 99.38,
          gender: "M",
          age: 17.333,
          ht: 176.45,
        },
        {
          pah: 99.45,
          gender: "M",
          age: 17.417,
          ht: 176.57,
        },
        {
          pah: 99.5,
          gender: "M",
          age: 17.5,
          ht: 176.67,
        },
        {
          pah: 99.56,
          gender: "M",
          age: 17.583,
          ht: 176.76,
        },
        {
          pah: 99.61,
          gender: "M",
          age: 17.667,
          ht: 176.85,
        },
        {
          pah: 99.65,
          gender: "M",
          age: 17.75,
          ht: 176.92,
        },
        {
          pah: 99.68,
          gender: "M",
          age: 17.833,
          ht: 176.99,
        },
        {
          pah: 99.71,
          gender: "M",
          age: 17.917,
          ht: 177.04,
        },
        {
          pah: 99.74,
          gender: "M",
          age: 18,
          ht: 177.09,
        },
        {
          pah: 30.73,
          gender: "F",
          age: 0,
          ht: 50.22,
        },
        {
          pah: 32.86,
          gender: "F",
          age: 0.083,
          ht: 53.69,
        },
        {
          pah: 34.83,
          gender: "F",
          age: 0.167,
          ht: 56.91,
        },
        {
          pah: 36.55,
          gender: "F",
          age: 0.25,
          ht: 59.73,
        },
        {
          pah: 38.01,
          gender: "F",
          age: 0.333,
          ht: 62.11,
        },
        {
          pah: 39.24,
          gender: "F",
          age: 0.417,
          ht: 64.11,
        },
        {
          pah: 40.28,
          gender: "F",
          age: 0.5,
          ht: 65.82,
        },
        {
          pah: 41.22,
          gender: "F",
          age: 0.583,
          ht: 67.36,
        },
        {
          pah: 42.09,
          gender: "F",
          age: 0.667,
          ht: 68.77,
        },
        {
          pah: 42.91,
          gender: "F",
          age: 0.75,
          ht: 70.12,
        },
        {
          pah: 43.71,
          gender: "F",
          age: 0.833,
          ht: 71.42,
        },
        {
          pah: 44.49,
          gender: "F",
          age: 0.917,
          ht: 72.69,
        },
        {
          pah: 45.24,
          gender: "F",
          age: 1,
          ht: 73.92,
        },
        {
          pah: 45.97,
          gender: "F",
          age: 1.083,
          ht: 75.11,
        },
        {
          pah: 46.68,
          gender: "F",
          age: 1.167,
          ht: 76.27,
        },
        {
          pah: 47.37,
          gender: "F",
          age: 1.25,
          ht: 77.4,
        },
        {
          pah: 48.03,
          gender: "F",
          age: 1.333,
          ht: 78.48,
        },
        {
          pah: 48.67,
          gender: "F",
          age: 1.417,
          ht: 79.53,
        },
        {
          pah: 49.28,
          gender: "F",
          age: 1.5,
          ht: 80.53,
        },
        {
          pah: 49.87,
          gender: "F",
          age: 1.583,
          ht: 81.49,
        },
        {
          pah: 50.43,
          gender: "F",
          age: 1.667,
          ht: 82.41,
        },
        {
          pah: 50.98,
          gender: "F",
          age: 1.75,
          ht: 83.3,
        },
        {
          pah: 51.51,
          gender: "F",
          age: 1.833,
          ht: 84.16,
        },
        {
          pah: 52.02,
          gender: "F",
          age: 1.917,
          ht: 85,
        },
        {
          pah: 52.52,
          gender: "F",
          age: 2,
          ht: 85.82,
        },
        {
          pah: 53.01,
          gender: "F",
          age: 2.083,
          ht: 86.62,
        },
        {
          pah: 53.49,
          gender: "F",
          age: 2.167,
          ht: 87.41,
        },
        {
          pah: 53.97,
          gender: "F",
          age: 2.25,
          ht: 88.18,
        },
        {
          pah: 54.43,
          gender: "F",
          age: 2.333,
          ht: 88.94,
        },
        {
          pah: 54.88,
          gender: "F",
          age: 2.417,
          ht: 89.68,
        },
        {
          pah: 55.34,
          gender: "F",
          age: 2.5,
          ht: 90.42,
        },
        {
          pah: 55.78,
          gender: "F",
          age: 2.583,
          ht: 91.14,
        },
        {
          pah: 56.21,
          gender: "F",
          age: 2.667,
          ht: 91.84,
        },
        {
          pah: 56.63,
          gender: "F",
          age: 2.75,
          ht: 92.54,
        },
        {
          pah: 57.04,
          gender: "F",
          age: 2.833,
          ht: 93.21,
        },
        {
          pah: 57.45,
          gender: "F",
          age: 2.917,
          ht: 93.87,
        },
        {
          pah: 57.85,
          gender: "F",
          age: 3,
          ht: 94.52,
        },
        {
          pah: 58.23,
          gender: "F",
          age: 3.083,
          ht: 95.15,
        },
        {
          pah: 58.6,
          gender: "F",
          age: 3.167,
          ht: 95.76,
        },
        {
          pah: 58.97,
          gender: "F",
          age: 3.25,
          ht: 96.36,
        },
        {
          pah: 59.33,
          gender: "F",
          age: 3.333,
          ht: 96.95,
        },
        {
          pah: 59.69,
          gender: "F",
          age: 3.417,
          ht: 97.54,
        },
        {
          pah: 60.04,
          gender: "F",
          age: 3.5,
          ht: 98.11,
        },
        {
          pah: 60.4,
          gender: "F",
          age: 3.583,
          ht: 98.69,
        },
        {
          pah: 60.75,
          gender: "F",
          age: 3.667,
          ht: 99.26,
        },
        {
          pah: 61.09,
          gender: "F",
          age: 3.75,
          ht: 99.82,
        },
        {
          pah: 61.44,
          gender: "F",
          age: 3.833,
          ht: 100.39,
        },
        {
          pah: 61.79,
          gender: "F",
          age: 3.917,
          ht: 100.96,
        },
        {
          pah: 62.14,
          gender: "F",
          age: 4,
          ht: 101.54,
        },
        {
          pah: 62.5,
          gender: "F",
          age: 4.083,
          ht: 102.12,
        },
        {
          pah: 62.86,
          gender: "F",
          age: 4.167,
          ht: 102.71,
        },
        {
          pah: 63.23,
          gender: "F",
          age: 4.25,
          ht: 103.31,
        },
        {
          pah: 63.59,
          gender: "F",
          age: 4.333,
          ht: 103.91,
        },
        {
          pah: 63.97,
          gender: "F",
          age: 4.417,
          ht: 104.53,
        },
        {
          pah: 64.35,
          gender: "F",
          age: 4.5,
          ht: 105.15,
        },
        {
          pah: 64.73,
          gender: "F",
          age: 4.583,
          ht: 105.77,
        },
        {
          pah: 65.12,
          gender: "F",
          age: 4.667,
          ht: 106.4,
        },
        {
          pah: 65.5,
          gender: "F",
          age: 4.75,
          ht: 107.02,
        },
        {
          pah: 65.88,
          gender: "F",
          age: 4.833,
          ht: 107.64,
        },
        {
          pah: 66.25,
          gender: "F",
          age: 4.917,
          ht: 108.26,
        },
        {
          pah: 66.62,
          gender: "F",
          age: 5,
          ht: 108.86,
        },
        {
          pah: 66.98,
          gender: "F",
          age: 5.083,
          ht: 109.45,
        },
        {
          pah: 67.34,
          gender: "F",
          age: 5.167,
          ht: 110.03,
        },
        {
          pah: 67.69,
          gender: "F",
          age: 5.25,
          ht: 110.6,
        },
        {
          pah: 68.03,
          gender: "F",
          age: 5.333,
          ht: 111.16,
        },
        {
          pah: 68.37,
          gender: "F",
          age: 5.417,
          ht: 111.71,
        },
        {
          pah: 68.69,
          gender: "F",
          age: 5.5,
          ht: 112.24,
        },
        {
          pah: 69.01,
          gender: "F",
          age: 5.583,
          ht: 112.77,
        },
        {
          pah: 69.33,
          gender: "F",
          age: 5.667,
          ht: 113.29,
        },
        {
          pah: 69.65,
          gender: "F",
          age: 5.75,
          ht: 113.81,
        },
        {
          pah: 69.96,
          gender: "F",
          age: 5.833,
          ht: 114.32,
        },
        {
          pah: 70.27,
          gender: "F",
          age: 5.917,
          ht: 114.82,
        },
        {
          pah: 70.58,
          gender: "F",
          age: 6,
          ht: 115.33,
        },
        {
          pah: 70.89,
          gender: "F",
          age: 6.083,
          ht: 115.83,
        },
        {
          pah: 71.19,
          gender: "F",
          age: 6.167,
          ht: 116.33,
        },
        {
          pah: 71.49,
          gender: "F",
          age: 6.25,
          ht: 116.82,
        },
        {
          pah: 71.79,
          gender: "F",
          age: 6.333,
          ht: 117.31,
        },
        {
          pah: 72.1,
          gender: "F",
          age: 6.417,
          ht: 117.81,
        },
        {
          pah: 72.4,
          gender: "F",
          age: 6.5,
          ht: 118.3,
        },
        {
          pah: 72.7,
          gender: "F",
          age: 6.583,
          ht: 118.79,
        },
        {
          pah: 73,
          gender: "F",
          age: 6.667,
          ht: 119.28,
        },
        {
          pah: 73.3,
          gender: "F",
          age: 6.75,
          ht: 119.77,
        },
        {
          pah: 73.6,
          gender: "F",
          age: 6.833,
          ht: 120.26,
        },
        {
          pah: 73.91,
          gender: "F",
          age: 6.917,
          ht: 120.77,
        },
        {
          pah: 74.22,
          gender: "F",
          age: 7,
          ht: 121.27,
        },
        {
          pah: 74.52,
          gender: "F",
          age: 7.083,
          ht: 121.77,
        },
        {
          pah: 74.83,
          gender: "F",
          age: 7.167,
          ht: 122.28,
        },
        {
          pah: 75.15,
          gender: "F",
          age: 7.25,
          ht: 122.79,
        },
        {
          pah: 75.47,
          gender: "F",
          age: 7.333,
          ht: 123.31,
        },
        {
          pah: 75.78,
          gender: "F",
          age: 7.417,
          ht: 123.82,
        },
        {
          pah: 76.09,
          gender: "F",
          age: 7.5,
          ht: 124.33,
        },
        {
          pah: 76.4,
          gender: "F",
          age: 7.583,
          ht: 124.84,
        },
        {
          pah: 76.71,
          gender: "F",
          age: 7.667,
          ht: 125.34,
        },
        {
          pah: 77.02,
          gender: "F",
          age: 7.75,
          ht: 125.85,
        },
        {
          pah: 77.33,
          gender: "F",
          age: 7.833,
          ht: 126.35,
        },
        {
          pah: 77.63,
          gender: "F",
          age: 7.917,
          ht: 126.85,
        },
        {
          pah: 77.93,
          gender: "F",
          age: 8,
          ht: 127.34,
        },
        {
          pah: 78.23,
          gender: "F",
          age: 8.083,
          ht: 127.82,
        },
        {
          pah: 78.52,
          gender: "F",
          age: 8.167,
          ht: 128.3,
        },
        {
          pah: 78.8,
          gender: "F",
          age: 8.25,
          ht: 128.76,
        },
        {
          pah: 79.09,
          gender: "F",
          age: 8.333,
          ht: 129.23,
        },
        {
          pah: 79.37,
          gender: "F",
          age: 8.417,
          ht: 129.69,
        },
        {
          pah: 79.65,
          gender: "F",
          age: 8.5,
          ht: 130.14,
        },
        {
          pah: 79.92,
          gender: "F",
          age: 8.583,
          ht: 130.59,
        },
        {
          pah: 80.19,
          gender: "F",
          age: 8.667,
          ht: 131.03,
        },
        {
          pah: 80.47,
          gender: "F",
          age: 8.75,
          ht: 131.48,
        },
        {
          pah: 80.73,
          gender: "F",
          age: 8.833,
          ht: 131.92,
        },
        {
          pah: 81.01,
          gender: "F",
          age: 8.917,
          ht: 132.37,
        },
        {
          pah: 81.29,
          gender: "F",
          age: 9,
          ht: 132.82,
        },
        {
          pah: 81.56,
          gender: "F",
          age: 9.083,
          ht: 133.27,
        },
        {
          pah: 81.84,
          gender: "F",
          age: 9.167,
          ht: 133.73,
        },
        {
          pah: 82.12,
          gender: "F",
          age: 9.25,
          ht: 134.19,
        },
        {
          pah: 82.41,
          gender: "F",
          age: 9.333,
          ht: 134.65,
        },
        {
          pah: 82.69,
          gender: "F",
          age: 9.417,
          ht: 135.12,
        },
        {
          pah: 82.98,
          gender: "F",
          age: 9.5,
          ht: 135.59,
        },
        {
          pah: 83.27,
          gender: "F",
          age: 9.583,
          ht: 136.06,
        },
        {
          pah: 83.56,
          gender: "F",
          age: 9.667,
          ht: 136.53,
        },
        {
          pah: 83.84,
          gender: "F",
          age: 9.75,
          ht: 137,
        },
        {
          pah: 84.14,
          gender: "F",
          age: 9.833,
          ht: 137.48,
        },
        {
          pah: 84.42,
          gender: "F",
          age: 9.917,
          ht: 137.95,
        },
        {
          pah: 84.72,
          gender: "F",
          age: 10,
          ht: 138.43,
        },
        {
          pah: 85.01,
          gender: "F",
          age: 10.083,
          ht: 138.9,
        },
        {
          pah: 85.3,
          gender: "F",
          age: 10.167,
          ht: 139.38,
        },
        {
          pah: 85.59,
          gender: "F",
          age: 10.25,
          ht: 139.86,
        },
        {
          pah: 85.88,
          gender: "F",
          age: 10.333,
          ht: 140.33,
        },
        {
          pah: 86.18,
          gender: "F",
          age: 10.417,
          ht: 140.81,
        },
        {
          pah: 86.46,
          gender: "F",
          age: 10.5,
          ht: 141.28,
        },
        {
          pah: 86.76,
          gender: "F",
          age: 10.583,
          ht: 141.76,
        },
        {
          pah: 87.04,
          gender: "F",
          age: 10.667,
          ht: 142.23,
        },
        {
          pah: 87.34,
          gender: "F",
          age: 10.75,
          ht: 142.71,
        },
        {
          pah: 87.63,
          gender: "F",
          age: 10.833,
          ht: 143.18,
        },
        {
          pah: 87.91,
          gender: "F",
          age: 10.917,
          ht: 143.65,
        },
        {
          pah: 88.2,
          gender: "F",
          age: 11,
          ht: 144.12,
        },
        {
          pah: 88.49,
          gender: "F",
          age: 11.083,
          ht: 144.59,
        },
        {
          pah: 88.78,
          gender: "F",
          age: 11.167,
          ht: 145.06,
        },
        {
          pah: 89.06,
          gender: "F",
          age: 11.25,
          ht: 145.53,
        },
        {
          pah: 89.35,
          gender: "F",
          age: 11.333,
          ht: 146,
        },
        {
          pah: 89.64,
          gender: "F",
          age: 11.417,
          ht: 146.47,
        },
        {
          pah: 89.92,
          gender: "F",
          age: 11.5,
          ht: 146.93,
        },
        {
          pah: 90.21,
          gender: "F",
          age: 11.583,
          ht: 147.4,
        },
        {
          pah: 90.5,
          gender: "F",
          age: 11.667,
          ht: 147.87,
        },
        {
          pah: 90.78,
          gender: "F",
          age: 11.75,
          ht: 148.34,
        },
        {
          pah: 91.08,
          gender: "F",
          age: 11.833,
          ht: 148.82,
        },
        {
          pah: 91.36,
          gender: "F",
          age: 11.917,
          ht: 149.28,
        },
        {
          pah: 91.65,
          gender: "F",
          age: 12,
          ht: 149.76,
        },
        {
          pah: 91.95,
          gender: "F",
          age: 12.083,
          ht: 150.24,
        },
        {
          pah: 92.23,
          gender: "F",
          age: 12.167,
          ht: 150.71,
        },
        {
          pah: 92.52,
          gender: "F",
          age: 12.25,
          ht: 151.18,
        },
        {
          pah: 92.82,
          gender: "F",
          age: 12.333,
          ht: 151.66,
        },
        {
          pah: 93.1,
          gender: "F",
          age: 12.417,
          ht: 152.13,
        },
        {
          pah: 93.39,
          gender: "F",
          age: 12.5,
          ht: 152.6,
        },
        {
          pah: 93.67,
          gender: "F",
          age: 12.583,
          ht: 153.06,
        },
        {
          pah: 93.95,
          gender: "F",
          age: 12.667,
          ht: 153.52,
        },
        {
          pah: 94.22,
          gender: "F",
          age: 12.75,
          ht: 153.96,
        },
        {
          pah: 94.5,
          gender: "F",
          age: 12.833,
          ht: 154.41,
        },
        {
          pah: 94.77,
          gender: "F",
          age: 12.917,
          ht: 154.85,
        },
        {
          pah: 95.03,
          gender: "F",
          age: 13,
          ht: 155.28,
        },
        {
          pah: 95.29,
          gender: "F",
          age: 13.083,
          ht: 155.7,
        },
        {
          pah: 95.54,
          gender: "F",
          age: 13.167,
          ht: 156.11,
        },
        {
          pah: 95.79,
          gender: "F",
          age: 13.25,
          ht: 156.52,
        },
        {
          pah: 96.03,
          gender: "F",
          age: 13.333,
          ht: 156.91,
        },
        {
          pah: 96.25,
          gender: "F",
          age: 13.417,
          ht: 157.28,
        },
        {
          pah: 96.48,
          gender: "F",
          age: 13.5,
          ht: 157.65,
        },
        {
          pah: 96.7,
          gender: "F",
          age: 13.583,
          ht: 158,
        },
        {
          pah: 96.91,
          gender: "F",
          age: 13.667,
          ht: 158.35,
        },
        {
          pah: 97.12,
          gender: "F",
          age: 13.75,
          ht: 158.69,
        },
        {
          pah: 97.31,
          gender: "F",
          age: 13.833,
          ht: 159.01,
        },
        {
          pah: 97.5,
          gender: "F",
          age: 13.917,
          ht: 159.31,
        },
        {
          pah: 97.68,
          gender: "F",
          age: 14,
          ht: 159.61,
        },
        {
          pah: 97.85,
          gender: "F",
          age: 14.083,
          ht: 159.89,
        },
        {
          pah: 98.02,
          gender: "F",
          age: 14.167,
          ht: 160.16,
        },
        {
          pah: 98.18,
          gender: "F",
          age: 14.25,
          ht: 160.42,
        },
        {
          pah: 98.33,
          gender: "F",
          age: 14.333,
          ht: 160.67,
        },
        {
          pah: 98.47,
          gender: "F",
          age: 14.417,
          ht: 160.9,
        },
        {
          pah: 98.6,
          gender: "F",
          age: 14.5,
          ht: 161.12,
        },
        {
          pah: 98.73,
          gender: "F",
          age: 14.583,
          ht: 161.32,
        },
        {
          pah: 98.85,
          gender: "F",
          age: 14.667,
          ht: 161.52,
        },
        {
          pah: 98.97,
          gender: "F",
          age: 14.75,
          ht: 161.71,
        },
        {
          pah: 99.07,
          gender: "F",
          age: 14.833,
          ht: 161.88,
        },
        {
          pah: 99.16,
          gender: "F",
          age: 14.917,
          ht: 162.03,
        },
        {
          pah: 99.25,
          gender: "F",
          age: 15,
          ht: 162.18,
        },
        {
          pah: 99.34,
          gender: "F",
          age: 15.083,
          ht: 162.32,
        },
        {
          pah: 99.41,
          gender: "F",
          age: 15.167,
          ht: 162.44,
        },
        {
          pah: 99.49,
          gender: "F",
          age: 15.25,
          ht: 162.56,
        },
        {
          pah: 99.55,
          gender: "F",
          age: 15.333,
          ht: 162.66,
        },
        {
          pah: 99.61,
          gender: "F",
          age: 15.417,
          ht: 162.76,
        },
        {
          pah: 99.66,
          gender: "F",
          age: 15.5,
          ht: 162.85,
        },
        {
          pah: 99.71,
          gender: "F",
          age: 15.583,
          ht: 162.92,
        },
        {
          pah: 99.76,
          gender: "F",
          age: 15.667,
          ht: 163,
        },
        {
          pah: 99.79,
          gender: "F",
          age: 15.75,
          ht: 163.06,
        },
        {
          pah: 99.83,
          gender: "F",
          age: 15.833,
          ht: 163.12,
        },
        {
          pah: 99.87,
          gender: "F",
          age: 15.917,
          ht: 163.18,
        },
        {
          pah: 99.89,
          gender: "F",
          age: 16,
          ht: 163.22,
        },
        {
          pah: 99.92,
          gender: "F",
          age: 16.083,
          ht: 163.27,
        },
        {
          pah: 99.94,
          gender: "F",
          age: 16.167,
          ht: 163.3,
        },
        {
          pah: 99.96,
          gender: "F",
          age: 16.25,
          ht: 163.34,
        },
        {
          pah: 99.98,
          gender: "F",
          age: 16.333,
          ht: 163.37,
        },
        {
          pah: 100,
          gender: "F",
          age: 16.417,
          ht: 163.4,
        },
      ],
      validFathersHeight: true,
      validMothersHeight: true,
      validChildsHeight: true,
      validGender: true,
      validChildsDob: true,
      validChildsWeight: true,
      bioInputs: {},
      bioResults: {},
    };
  },
  computed: {
    ...mapGetters(["getProfile", "getCoachesUsersData"]),
    // "Select player" dropdown: the selected player's squad (users.teamId), not
    // every player the admin/coach can see. Falls back to the full list when
    // the squad can't be worked out or the toggle is on; always keeps the
    // currently-shown player in the list so the select never goes blank.
    playerSelectOptions() {
      const all = this.allUserDataBeforFilterApplied || [];
      const byName = (a, b) => (a.name || "").localeCompare(b.name || "");
      if (this.showAllPlayersInSelect) return [...all].sort(byName);
      const teamId =
        this.selectedUserDataForHeader && this.selectedUserDataForHeader.teamId;
      if (!teamId) return [...all].sort(byName);
      const squad = all.filter(
        (p) => p.teamId == teamId || p.id == this.selectedUserValue,
      );
      return (squad.length > 1 ? squad : [...all]).sort(byName);
    },
    playerSelectHasMore() {
      return (
        this.showAllPlayersInSelect ||
        this.playerSelectOptions.length <
          (this.allUserDataBeforFilterApplied || []).length
      );
    },
    // Playing history: newest club first; entries without a start date last.
    sortedPlayingExperence() {
      return [...(this.playerCvData.playingExperence || [])].sort((a, b) => {
        const aDate = a.start_date_at_club ? new Date(a.start_date_at_club) : 0;
        const bDate = b.start_date_at_club ? new Date(b.start_date_at_club) : 0;
        return bDate - aDate;
      });
    },
    // Only uncategorised videos belong to the CV section.
    cvVideos() {
      return (this.playerCvData.videos || []).filter(
        (video) => video.category === "",
      );
    },
    // Responsive width for the signature pad (evaluated when the modal opens).
    signatureCanvasWidth() {
      const w = typeof window !== "undefined" ? window.innerWidth : 800;
      if (w < 640) return Math.max(260, w - 110) + "px";
      return "640px";
    },
    // Left drawer nav items for the player profile view (see SectionNav).
    // Mirrors the old horizontal tabs; icons are Material Symbols names.
    profileNavItems() {
      // Tier gating: tabs for features the tenant's tier disables
      // (config/tiers.json) are filtered out, e.g. grassroots clubs
      // don't get performance reviews or wellness.
      return [
        { key: "performace-tab", label: "Performance", icon: "insights" },
        {
          key: "review-tab",
          label: "Performance Reviews",
          icon: "reviews",
          feature: "performanceReviews",
        },
        { key: "home-work-tab", label: "Homework", icon: "menu_book" },
        {
          key: "wellness-tab",
          label: "Wellness information",
          icon: "monitor_heart",
          feature: "wellnessMonitoring",
        },
        { key: "injury-tab", label: "Injury information", icon: "healing" },
        {
          key: "learning-development-plan-tab",
          label: "Individual Development plans (IDPs)",
          icon: "flag",
          feature: "idp",
        },
        { key: "coach-tab", label: "Playing history", icon: "history" },
        {
          key: "player-documents-tab",
          label: "Documents",
          icon: "folder_open",
        },
      ].filter((item) => !item.feature || isFeatureEnabled(item.feature));
    },
    // Welfare guardrail: a Foundation-phase player (U11–U15) must not self-enter
    // body weight. Staff entering weight FOR a player are unaffected (they are
    // not Foundation). See useNutritionAccess.js.
    actorIsFoundationPlayer() {
      return getNutritionAccess(this.userData).isFoundation;
    },
    // Medical info is visible to the player viewing their own profile, and to
    // any admin or coach — never to another player.
    canViewMedical() {
      const ud = this.userData || {};
      const sel = this.selectedUserData || {};
      const isStaff = ud.userType === "Admin" || ud.userType === "Coach";
      const isSelf = ud.id != null && String(ud.id) === String(sel.id);
      return isStaff || isSelf;
    },
    // Staff edit the structured record for any player; a player (or the
    // parent logged in as them) may edit their own.
    canEditMedical() {
      return this.canViewMedical;
    },
    // Positions the player has played, ranked by how often (one entry per game
    // in gamePerformanceData.postion_played).
    positionsByFrequency() {
      const arr =
        (this.gamePerformanceData && this.gamePerformanceData.postion_played) ||
        [];
      if (!Array.isArray(arr)) return [];
      const counts = {};
      arr.forEach((p) => {
        if (!p) return;
        counts[p] = (counts[p] || 0) + 1;
      });
      return Object.entries(counts)
        .map(([position, count]) => ({ position, count }))
        .sort((a, b) => b.count - a.count);
    },
    positionsMaxCount() {
      return this.positionsByFrequency.reduce(
        (max, p) => Math.max(max, p.count),
        1,
      );
    },
  },
  async created() {
    this.setPlayingSeasion();
    this.resetPersonalBestAndAveragesData();
    this.loadingStuff = true;
    this.userHasMoreThanOneAccount = this.checkIfUserHasMoreThanOneAccount();
    this.weekSelectedNumber = moment().isoWeek();
    this.setMonToSundayWeekDates();

    const clientId = JSON.parse(localStorage.getItem("the_w_selectedClientId"));

    const response = await this.getUserById(clientId);
    if (response === true) {
      if (
        this.userData.userType !== "Admin" &&
        this.userData.userType !== "Coach" &&
        this.userHasMoreThanOneAccount === null
      ) {
        Promise.all([this.getTeamsDataById(this.userData.teamId)]).then(() => {
          this.under16 = this.showIfUnderU16(this.userData.age_group);
          this.over14 = this.showIfOverU11(this.userData.age_group);
          this.loadPlayersProfilePerformanceData();
          this.getPlayerPerformanceReviews();
          this.getAllgoalsScoredByPlayerId();
          this.getAllgoalAssistsByPlayerId();
          this.selectedTeamId = this.userData.teamId;
          this.populatePlayerCV(this.userData);
          this.loadPlayerMinsPerformanceData();
          this.getAllHomeworkForPlayer();
        });
      }

      if (this.userData.userType === "Admin") {
        this.setPlayingSeasion().then(() => {
          this.getAllUsersForClubId();
        });
      }

      if (this.userData.userType === "Coach") {
        if (
          this.userData.position &&
          (this.userData.position.toLowerCase() === "goalkeeper coach" ||
            this.userData.position.toLowerCase() === "goal keeper coach")
        ) {
          this.setPlayingSeasion().then(() => {
            this.getAllGoalKeepersForCoach();
          });
        } else {
          this.setPlayingSeasion().then(() => {
            this.getAllUsersForCoach();
          });
        }
      }

      if (this.userHasMoreThanOneAccount !== null) {
        this.getAllUsersForHasMoreThanOneAccount();
      }
      this.getGameTargets();
      this.loadingStuff = false;
    }
  },
  methods: {
    // Keep the legacy summary on the loaded profile in sync so nothing else
    // on this page writes a stale `medical` back over the structured record.
    onMedicalSaved(record) {
      if (!record || !this.selectedUserData) return;
      this.selectedUserData = {
        ...this.selectedUserData,
        medical: record.summary,
        has_medical_conditions: record.hasConditions,
      };
    },
    // Tier gating (config/tiers.json): hide Pro-only sections and skip
    // their data loads for tenants whose tier disables the feature
    hasFeature(feature) {
      return isFeatureEnabled(feature);
    },
    getCoachesNameFromId(id) {
      const coach = this.coachData.find((coach) => coach.id === id);
      return coach ? coach.name : "";
    },
    async populateCoachesData() {
      const coachesData = {
        clubId: this.userData.clubId,
        action: "populateOnlyCoachesData",
      };

      const responce = await Users.find(coachesData).catch((error) => {
        console.log(error);
      });

      responce.data.length > 0 ? (this.coachData = responce.data) : [];
    },
    hasGpsData() {
      let playMakerGpsData =
        this.playerMakerPersonalBestAndAverages &&
        Object.keys(this.playerMakerPersonalBestAndAverages).length > 0;
      let playerGpsData =
        this.playerPersonalBestAndAverages &&
        Object.keys(this.playerPersonalBestAndAverages).length > 0;

      console.log(playMakerGpsData);
      console.log(playerGpsData);
    },
    getCurrentSeason() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const isAfterAugust = now.getMonth() >= 7; // August is month 7 (0-indexed)

      return {
        startYear: isAfterAugust ? currentYear : currentYear - 1,
        endYear: isAfterAugust ? currentYear + 1 : currentYear,
        label: isAfterAugust
          ? `${currentYear}/${currentYear + 1}`
          : `${currentYear - 1}/${currentYear}`,
        startDate: `${isAfterAugust ? currentYear : currentYear - 1}-08-01`,
        endDate: `${isAfterAugust ? currentYear + 1 : currentYear}-05-30`,
      };
    },
    getLastSeason() {
      const current = this.getCurrentSeason();
      this.lastSeasonStartDate = `${current.startYear - 1}-08-01`;
      this.lastSeasonEndDate = `${current.endYear - 1}-05-30`;

      console.log({
        startYear: current.startYear - 1,
        endYear: current.endYear - 1,
        label: `${current.startYear - 1}/${current.endYear - 1}`,
        startDate: `${current.startYear - 1}-08-01`,
        endDate: `${current.endYear - 1}-05-30`,
      });
      return {
        startYear: current.startYear - 1,
        endYear: current.endYear - 1,
        label: `${current.startYear - 1}/${current.endYear - 1}`,
        startDate: `${current.startYear - 1}-08-01`,
        endDate: `${current.endYear - 1}-05-30`,
      };
    },
    getLastSeasonsPlayerMoodData() {
      const lastSeason = this.getLastSeason();
      const userData = {
        player_id: this.selectedUserValue,
        action: "getThisSeasionsPlayerMoodData",
        season_start_date: lastSeason.startDate,
        season_end_date: lastSeason.endDate,
      };
      Wellness.find(userData)
        .then((responce) => {
          if (responce.data.length > 0) {
            this.lastSeasonsPlayerMoodData = responce.data;
            this.barChartDataForPlayerMood();
          } else {
            this.lastSeasonsPlayerMoodData = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatMatchDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    setResultsPanel() {
      // Guard: Bio-Banding calculator is now a separate modal component
      // Return early if old DOM elements don't exist
      if (!document.getElementById("child-height-male-human")) {
        return;
      }
      //SET MALE OR FEMALE SVGS
      if (this.bioInputs.gender == "M") {
        document
          .getElementById("child-height-male-human")
          .setAttribute("style", "display:flex");
        document
          .getElementById("child-height-female-human")
          .setAttribute("style", "display:none");
        document
          .getElementById("estimated-height-male-human")
          .setAttribute("style", "display:flex");
        document
          .getElementById("estimated-height-female-human")
          .setAttribute("style", "display:none");
        document
          .getElementById("decimal-age-male-human")
          .setAttribute("style", "display:flex");
        document
          .getElementById("decimal-age-female-human")
          .setAttribute("style", "display:none");
        document
          .getElementById("bio-age-male-human")
          .setAttribute("style", "display:flex");
        document
          .getElementById("bio-age-female-human")
          .setAttribute("style", "display:none");
      }

      if (this.bioInputs.gender == "F") {
        document
          .getElementById("child-height-male-human")
          .setAttribute("style", "display:none");
        document
          .getElementById("child-height-female-human")
          .setAttribute("style", "display:flex");
        document
          .getElementById("estimated-height-male-human")
          .setAttribute("style", "display:none");
        document
          .getElementById("estimated-height-female-human")
          .setAttribute("style", "display:flex");
        document
          .getElementById("decimal-age-male-human")
          .setAttribute("style", "display:none");
        document
          .getElementById("decimal-age-female-human")
          .setAttribute("style", "display:flex");
        document
          .getElementById("bio-age-male-human")
          .setAttribute("style", "display:none");
        document
          .getElementById("bio-age-female-human")
          .setAttribute("style", "display:flex");
      }

      // SET ACTUAL HEIGHTS
      this.setHeights(
        "height",
        Math.round(this.bioInputs.fathersHeight * 10) / 10,
        "father-height-text",
        "father-height-human",
        "father-height",
        "2",
        "10",
      );
      this.setHeights(
        "height",
        Math.round(this.bioInputs.mothersHeight * 10) / 10,
        "mother-height-text",
        "mother-height-human",
        "mother-height",
        "6",
        "14",
      );
      this.setHeights(
        "height",
        Math.round(this.bioInputs.childsHeight * 10) / 10,
        "child-height-text",
        "child-height-human",
        "child-height",
        "10",
        "18",
      );
      this.setHeights(
        "height",
        this.bioResults.childEstimatedHeight,
        "estimated-height-text",
        "estimated-height-human",
        "estimated-height",
        "14",
        "22",
      );

      //SET % ESTIMATED HEIGHT OBTAINED
      var percentageObtained = this.bioResults.childEstimatedHeightAchieved;
      document.getElementById("percent-obtained").innerHTML =
        percentageObtained + " %";
      var percentObtainedStyle =
        "width:" + percentageObtained + "%;background-color:#FFF06C !important";
      document
        .getElementById("percent-obtained-width")
        .setAttribute("style", percentObtainedStyle);

      //SET AGE HEIGHTS
      this.setHeights(
        "age",
        this.bioResults.decimalAge,
        "decimal-age-text",
        "decimal-age-human",
        "decimal-age-height",
        "3",
        "14",
      );
      this.setHeights(
        "age",
        this.bioResults.bioAge,
        "bio-age-text",
        "bio-age-human",
        "bio-age-height",
        "12",
        "21",
      );

      //SET BIOLOGICAL AGE DIFFERENCE
      var bioAgeDiffFixed = this.bioResults.bioAgeDifference;
      var bioAgeDiffText =
        bioAgeDiffFixed > 0
          ? "+" + bioAgeDiffFixed + " yrs"
          : bioAgeDiffFixed + " yrs";
      document.getElementById("bio-age-diff").innerHTML = bioAgeDiffText;
    },
    setHeights(
      type,
      height,
      heightTextId,
      humanHeightId,
      textHeightId,
      start,
      end,
    ) {
      // Validate height input
      if (height === undefined || height === null || height === "") {
        console.warn(`Invalid height value: ${height}`);
        return;
      }

      var parsedHeight = parseFloat(height);
      if (isNaN(parsedHeight)) {
        console.warn(`Height is not a valid number: ${height}`);
        return;
      }

      var unit = "";
      var rowHeightPixel = 0;
      var rowHeightValue = 0;
      var maxHeightRows = 0;
      var maxHeight = 0;
      if (type == "height") {
        rowHeightPixel = 17;
        rowHeightValue = 20;
        maxHeightRows = 14;
        maxHeight = 240;
        unit = "cm";
      }
      if (type == "age") {
        rowHeightPixel = 22;
        rowHeightValue = 2;
        maxHeightRows = 11;
        maxHeight = 18;
        unit = "yrs";
      }
      var heightPixelConversion = rowHeightPixel / rowHeightValue;
      document.getElementById(heightTextId).innerHTML =
        parsedHeight + " " + unit;
      var heightCapped = parsedHeight > maxHeight ? maxHeight : parsedHeight;
      var heightPixel = heightCapped * heightPixelConversion;
      var humans = document.getElementsByClassName(humanHeightId);
      for (let i = 0; i < humans.length; i++) {
        humans[i].setAttribute("height", heightPixel);
      }
      var textRowHeight =
        maxHeightRows - Math.ceil(heightCapped / rowHeightValue);
      var textStyle =
        "height:100%;width:100%; grid-column-start: " +
        start +
        ";grid-column-end: " +
        end +
        ";grid-row-start: " +
        textRowHeight +
        ";grid-row-end: 15";
      document.getElementById(textHeightId).setAttribute("style", textStyle);
    },
    getBioResults(bioInputs) {
      // B. CHILD DECIMAL AGE

      // b1. calculate the decimal age to nearest 0.5
      var cb = new Date(bioInputs.childsDob);
      var today = new Date();

      var ms = today.getTime() - cb.getTime();
      var totalDays = Math.ceil(ms / (1000 * 3600 * 24));
      var decimalAge = totalDays / 365.25;
      var decimalAgeRounded = Math.round(decimalAge * 2) / 2;
      var decimalAgeRoundedOne = Math.round(decimalAge * 10) / 10;

      // b2. if child date is out of range throw error

      if (decimalAgeRounded < 4 || decimalAgeRounded > 17.5) {
        console.log("need to deal with this");
      }

      // b3. if decimal age is 4.5 move to 5 as no value in khamis roche table

      if (decimalAgeRounded == 4.5) {
        decimalAgeRounded = 5;
      }

      console.log("decimal age: " + decimalAgeRounded);

      // C. BIOLOGICAL MID PARENT HEIGHT

      // c1. do the calculation and adjustment is for over estimation of cms input

      //adjust to inches to apply the overestimation value
      var fathersHeightInches = bioInputs.fathersHeight * 0.3937;
      var mothersHeightInches = bioInputs.mothersHeight * 0.3937;

      //apply overestimation and convert back to cms
      var fathersHeightAdjusted = (fathersHeightInches * 0.955 + 2.316) * 2.54;
      var mothersHeightAdjusted = (mothersHeightInches * 0.953 + 2.803) * 2.54;

      //do the mid parent height adjustment
      var bioMidParentHeight =
        (fathersHeightAdjusted + mothersHeightAdjusted) / 2;

      console.log("mid parent height adjustment: " + bioMidParentHeight);

      // D. GET KHAMIS ROCHE COEFFICIENTS

      var kr = this.khamisRoche.find(
        (kr) =>
          kr.roundedDecimalAge == decimalAgeRounded &&
          kr.gender == bioInputs.gender,
      );

      console.log("khamis roche: ", kr);

      // E. KHAMIS ROCHE ESTIMATED HEIGHT

      var childEstimatedHeight =
        kr.bo +
        bioInputs.childsHeight * kr.stature +
        bioInputs.childsWeight * kr.weight +
        bioMidParentHeight * kr.midParentStature;
      // + (bioInputs.childsHeight * kr.stature) + (bioInputs.childsWeight * kr.weight) + (bioMidParentHeight * kr.midParentStature);

      var childEstimatedHeightRounded =
        Math.round(childEstimatedHeight * 10) / 10;

      // F. ESTIMATED HEIGHT ACHIEVED
      var childEstimatedHeightAchieved =
        (bioInputs.childsHeight / childEstimatedHeight) * 100;
      var childEstimatedHeightAchievedRounded =
        Math.round(childEstimatedHeightAchieved * 10) / 10;

      // G. BIO AGE
      // 1. sort and filter the list by gender initially

      var p = [...this.pah.filter((x) => x.gender == bioInputs.gender)].sort(
        (a, b) => a.pah - b.pah,
      );

      var pahList = p.map((p) => p.pah);

      // 2. get closest pah value
      const pahValue = pahList.reduce((prev, curr) =>
        Math.abs(curr - childEstimatedHeightAchieved) <
        Math.abs(prev - childEstimatedHeightAchieved)
          ? curr
          : prev,
      );

      //3. get pah row
      var pahRecord = p.find((x) => x.pah == pahValue);

      console.log("pah", pahRecord);
      var bioAge = pahRecord.age;

      var bioAgeRounded = Math.round(pahRecord.age * 10) / 10;

      // H. BIO AGE DIFFERENCE

      var bioAgeDiff = bioAge - decimalAgeRoundedOne;
      var bioAgeDiffRounded = Math.round(bioAgeDiff * 10) / 10;

      // Z. RETURN RESPONSE MESSAGE
      this.bioResults = {
        decimalAge: decimalAgeRoundedOne,
        childEstimatedHeight: childEstimatedHeightRounded,
        childEstimatedHeightAchieved: childEstimatedHeightAchievedRounded,
        bioAge: bioAgeRounded,
        bioAgeDifference: bioAgeDiffRounded,
      };
      console.log("bio results: ", this.bioResults);
      return this.bioResults;
    },
    isValidInputs(bioInputs) {
      this.validFathersHeight =
        !isNaN(bioInputs.fathersHeight) &&
        bioInputs.fathersHeight > 29 &&
        bioInputs.fathersHeight;
      this.validMothersHeight =
        !isNaN(bioInputs.mothersHeight) &&
        bioInputs.mothersHeight > 29 &&
        bioInputs.mothersHeight <= 251;
      this.validChildsHeight =
        !isNaN(bioInputs.childsHeight) &&
        bioInputs.childsHeight > 29 &&
        bioInputs.childsHeight <= 251;
      this.validGender = bioInputs.gender == "M" || bioInputs.gender == "F";
      this.validChildsDob =
        bioInputs.childsDob != "" &&
        bioInputs.childsDob >= this.setDateForBiobandCalculator().min &&
        bioInputs.childsDob <= this.setDateForBiobandCalculator().max;
      this.validChildsWeight =
        !isNaN(bioInputs.childsWeight) &&
        bioInputs.childsWeight > 0 &&
        bioInputs.childsWeight <= 442;

      var valid =
        !isNaN(bioInputs.fathersHeight) &&
        bioInputs.fathersHeight > 29 &&
        bioInputs.fathersHeight <= 251 &&
        !isNaN(bioInputs.mothersHeight) &&
        bioInputs.mothersHeight > 29 &&
        bioInputs.mothersHeight <= 251 &&
        !isNaN(bioInputs.childsHeight) &&
        bioInputs.childsHeight > 29 &&
        bioInputs.childsHeight <= 251 &&
        (bioInputs.gender == "M" || bioInputs.gender == "F") &&
        bioInputs.childsDob != "" &&
        bioInputs.childsDob >= this.setDateForBiobandCalculator().min &&
        bioInputs.childsDob <= this.setDateForBiobandCalculator().max &&
        !isNaN(bioInputs.childsWeight) &&
        bioInputs.childsWeight > 0 &&
        bioInputs.childsWeight <= 442;
      return valid;
    },
    getAndParseInputsMetric() {
      //set is loading spinner
      this.isLoading(true, "spinner-metric", "show-results-button-metric");

      //get all the inputs
      var fathersHeight = document.getElementById("fathers-height-cm").value;
      var mothersHeight = document.getElementById("mothers-height-cm").value;
      var childsDob = document.getElementById("childs-dob-metric").value;
      var childsHeight = document.getElementById("childs-height-cm").value;
      var childsWeight = document.getElementById("childs-weight-kg").value;
      var sittingHeightRaw = document.getElementById("sitting-height-cm").value;
      var male = document.getElementById("male-metric").checked;
      var female = document.getElementById("female-metric").checked;

      //parse ints
      fathersHeight = Math.round(parseFloat(fathersHeight) * 10) / 10;
      mothersHeight = Math.round(parseFloat(mothersHeight) * 10) / 10;
      childsHeight = Math.round(parseFloat(childsHeight) * 10) / 10;
      childsWeight = Math.round(parseFloat(childsWeight) * 10) / 10;
      var sittingHeight = sittingHeightRaw
        ? Math.round(parseFloat(sittingHeightRaw) * 10) / 10
        : null;
      var gender = male ? "M" : female ? "F" : "";
      this.bioInputs = {
        fathersHeight: fathersHeight,
        mothersHeight: mothersHeight,
        gender: gender,
        childsHeight: childsHeight,
        childsDob: childsDob,
        childsWeight: childsWeight,
        sittingHeight: sittingHeight,
      };
      console.log("bio inputs: ", this.bioInputs);
      return this.bioInputs;
    },
    getAndParseInputsImperial() {
      //get inputs
      var fathersHeightFt = document.getElementById("fathers-height-ft").value;
      var fathersHeightIn = document.getElementById("fathers-height-in").value;
      var mothersHeightFt = document.getElementById("mothers-height-ft").value;
      var mothersHeightIn = document.getElementById("mothers-height-in").value;
      var childsDob = document.getElementById("childs-dob-imperial").value;
      var childsHeightFt = document.getElementById("childs-height-ft").value;
      var childsHeightIn = document.getElementById("childs-height-in").value;
      var sittingHeightFt = document.getElementById("sitting-height-ft").value;
      var sittingHeightIn = document.getElementById("sitting-height-in").value;
      var childsWeightSt = document.getElementById("childs-weight-st").value;
      var childsWeightLb = document.getElementById("childs-weight-lb").value;
      var male = document.getElementById("male-imperial").checked;
      var female = document.getElementById("female-imperial").checked;
      //parse ints/ do conversion calcs
      var fathersHeight = this.convertFtInToCm(
        parseFloat(fathersHeightFt),
        parseFloat(fathersHeightIn),
      );
      var mothersHeight = this.convertFtInToCm(
        parseFloat(mothersHeightFt),
        parseFloat(mothersHeightIn),
      );
      var childsHeight = this.convertFtInToCm(
        parseFloat(childsHeightFt),
        parseFloat(childsHeightIn),
      );
      var sittingHeight =
        sittingHeightFt || sittingHeightIn
          ? this.convertFtInToCm(
              parseFloat(sittingHeightFt || 0),
              parseFloat(sittingHeightIn || 0),
            )
          : null;
      var childsWeight = this.convertStAndLbToKg(
        parseFloat(childsWeightSt),
        parseFloat(childsWeightLb),
      );
      var gender = male ? "M" : female ? "F" : "";
      this.bioInputs = {
        fathersHeight: fathersHeight,
        mothersHeight: mothersHeight,
        gender: gender,
        childsHeight: childsHeight,
        childsDob: childsDob,
        childsWeight: childsWeight,
        sittingHeight: sittingHeight,
      };
      console.log("bio inputs: ", this.bioInputs);
      return this.bioInputs;
    },
    isLoading(state, spinner, showResults) {
      // Guard: Bio-Banding calculator is now a separate modal component
      if (!document.getElementById("results-pane")) return;
      if (state) {
        document
          .getElementById("results-pane")
          .setAttribute("style", "display:none;");
        document.getElementById(spinner).setAttribute("style", "display:flex;");
        document
          .getElementById(showResults)
          .setAttribute("style", "display:none;");
      } else {
        document.getElementById(spinner).setAttribute("style", "display:none;");
        document
          .getElementById(showResults)
          .setAttribute(
            "style",
            "display:flex;font-size:small;font-weight:bold;color:white",
          );
      }
    },
    convertFtInToCm(feet, inches) {
      var cm = feet * 30.48 + inches * 2.54;
      return cm;
    },
    convertStAndLbToKg(stone, lb) {
      var kg = stone * 6.35029 + lb * 0.453592142840941;
      return kg;
    },
    async saveBioAgeResults() {
      // Calculate maturity offset (Mirwald PHV) if sitting height is available
      let maturityOffset = null;
      let maturityCategory = null;

      if (this.bioInputs.sittingHeight && this.bioInputs.childsHeight) {
        const height = parseFloat(this.bioInputs.childsHeight);
        const sittingHeight = parseFloat(this.bioInputs.sittingHeight);
        const weight = parseFloat(this.bioInputs.childsWeight);
        const decimalAge = parseFloat(this.bioResults.decimalAge);
        const gender = this.bioInputs.gender;

        if (height && sittingHeight && weight && decimalAge) {
          maturityOffset = calculateMaturityOffset({
            gender,
            decimalAge,
            height,
            sittingHeight,
            weight,
          });
          maturityCategory = getMaturityCategory(maturityOffset);
        }
      }

      const userData = {
        action: "saveBioAgeResults",
        userId: this.selectedUserData.id,
        ...this.bioResults,
        ...this.bioInputs,
        maturityOffset,
        maturityCategory,
      };

      // Save to measurement history BEFORE the API call overwrites bioInputs/bioResults
      try {
        await PlayerPhysicalPerformance.saveBioAgeMeasurement({
          userId: this.selectedUserData.id,
          childsHeight: this.bioInputs.childsHeight,
          childsWeight: this.bioInputs.childsWeight,
          sittingHeight: this.bioInputs.sittingHeight,
          fathersHeight: this.bioInputs.fathersHeight,
          mothersHeight: this.bioInputs.mothersHeight,
          gender: this.bioInputs.gender,
          decimalAge: this.bioResults.decimalAge,
          percentPAH: this.bioResults.childEstimatedHeightAchieved,
          bioAge: this.bioResults.bioAge,
          bioAgeDifference: this.bioResults.bioAgeDifference,
          childEstimatedHeight: this.bioResults.childEstimatedHeight,
          maturityOffset,
          maturityCategory,
          createdBy: this.userData.id,
        });
      } catch (err) {
        console.error("Error saving bio age measurement to history:", err);
      }

      const response = await PlayerPhysicalPerformance.find(userData).catch(
        (error) => {
          console.log(error);
        },
      );

      if (response.status === 200) {
        // Refresh the growth velocity chart if it exists
        if (this.$refs.growthVelocityChart) {
          this.$refs.growthVelocityChart.loadHistory();
        }
      }
    },
    async getBioAgeResults() {
      const userData = {
        action: "getBioAgeResults",
        userId: this.selectedUserData.id,
      };

      const response = await PlayerPhysicalPerformance.find(userData).catch(
        (error) => {
          console.log(error);
        },
      );

      if (response.status === 200 && response.data !== false) {
        this.bioInputs = {
          fathersHeight: response.data.fathersHeight,
          mothersHeight: response.data.mothersHeight,
          gender: response.data.gender,
          childsHeight: response.data.childsHeight,
          childsDob: response.data.childsDob,
          childsWeight: response.data.childsWeight,
        };

        this.bioResults = {
          decimalAge: response.data.decimalAge,
          childEstimatedHeight: response.data.childEstimatedHeight,
          childEstimatedHeightAchieved:
            response.data.childEstimatedHeightAchieved,
          bioAge: response.data.bioAge,
          bioAgeDifference: response.data.bioAgeDifference,
        };
      }
    },
    async showResultsMetric(type) {
      // Guard: Bio-Banding calculator is now a separate modal component
      // Return early if old DOM elements don't exist
      if (!document.getElementById("error-pane")) {
        return;
      }
      let validationResult = false;
      try {
        //set is loading spinner
        this.isLoading(true, "spinner-metric", "show-results-button-metric");

        //clear error pane
        document
          .getElementById("error-pane")
          .setAttribute("style", "display:none;border-radius:3px");

        //get and parse bio inputs
        if (type === "save") {
          //get and parse bio inputs
          this.getAndParseInputsMetric();
          validationResult = !this.isValidInputs(this.bioInputs);
        } else {
          await this.getBioAgeResults();
        }

        //validate inputs
        if (validationResult) {
          this.isLoading(false, "spinner-metric", "show-results-button-metric");
          console.log("validation input error");
        } else {
          if (type === "save") {
            this.bioResults = this.getBioResults(this.bioInputs);

            this.setResultsPanel(this.bioResults, this.bioInputs);
            document
              .getElementById("results-pane")
              .setAttribute("style", "display:flex;border-radius:3px");
            this.isLoading(
              false,
              "spinner-metric",
              "show-results-button-metric",
            );
            this.saveBioAgeResults();
          } else {
            if (Object.keys(this.bioResults).length !== 0) {
              this.setResultsPanel(this.bioResults, this.bioInputs);
              document
                .getElementById("results-pane")
                .setAttribute("style", "display:flex;border-radius:3px");
            }
            this.isLoading(
              false,
              "spinner-imperial",
              "show-results-button-imperial",
            );
          }
        }
      } catch (error) {
        console.log("error showing metric results");
        console.log(error);
        document
          .getElementById("error-pane")
          .setAttribute("style", "display:flex;border-radius:3px");
        this.isLoading(false, "spinner-metric", "show-results-button-metric");
      }
    },
    async showResultsImperial(type) {
      // Guard: Bio-Banding calculator is now a separate modal component
      // Return early if old DOM elements don't exist
      if (!document.getElementById("error-pane")) {
        return;
      }
      let validationResult = false;
      try {
        this.isLoading(
          true,
          "spinner-imperial",
          "show-results-button-imperial",
        );
        //clear error pane
        document
          .getElementById("error-pane")
          .setAttribute("style", "display:none;border-radius:3px");

        if (type === "save") {
          //get and parse bio inputs
          this.getAndParseInputsImperial();
          validationResult = !this.isValidInputs(this.bioInputs);
        } else {
          await this.getBioAgeResults();
        }

        //validate inputs
        if (validationResult) {
          this.isLoading(
            false,
            "spinner-imperial",
            "show-results-button-imperial",
          );
        } else {
          if (type === "save") {
            this.bioResults = this.getBioResults(this.bioInputs);
            this.setResultsPanel(this.bioResults, this.bioInputs);
            document
              .getElementById("results-pane")
              .setAttribute("style", "display:flex;border-radius:3px");
            this.isLoading(
              false,
              "spinner-imperial",
              "show-results-button-imperial",
            );
            this.saveBioAgeResults();
          } else {
            if (Object.keys(this.bioResults).length !== 0) {
              this.setResultsPanel(this.bioResults, this.bioInputs);
              document
                .getElementById("results-pane")
                .setAttribute("style", "display:flex;border-radius:3px");
            }
            this.isLoading(
              false,
              "spinner-imperial",
              "show-results-button-imperial",
            );
          }
        }
      } catch (error) {
        console.log("error showing imperial results");
        console.log(error);
        document
          .getElementById("error-pane")
          .setAttribute("style", "display:flex;border-radius:3px");

        this.isLoading(
          false,
          "spinner-imperial",
          "show-results-button-imperial",
        );
      }
    },
    switchToImperial() {
      this.isMetricMode = false;
      // Guard: Bio-Banding calculator is now a separate modal component
      if (!document.getElementById("results-pane")) return;
      document
        .getElementById("results-pane")
        .setAttribute("style", "display:none;");
      document
        .getElementById("imperial-row")
        .setAttribute("style", "display:flex;");
      document
        .getElementById("metric-row")
        .setAttribute("style", "display:none;");
    },
    switchToMetric() {
      this.isMetricMode = true;
      // Guard: Bio-Banding calculator is now a separate modal component
      if (!document.getElementById("results-pane")) return;
      document
        .getElementById("results-pane")
        .setAttribute("style", "display:none;");
      document
        .getElementById("metric-row")
        .setAttribute("style", "display:flex;");
      document
        .getElementById("imperial-row")
        .setAttribute("style", "display:none;");
    },
    setMeasurement() {
      // Guard: Bio-Banding calculator is now a separate modal component
      if (!document.getElementById("results-pane")) return;
      document
        .getElementById("results-pane")
        .setAttribute("style", "display:none;");

      // Check which toggle was clicked (new toggle or legacy)
      var imperialMode = document.getElementById("imperial-mode");
      var imperial = document.getElementById("imperial");

      // Sync the toggles
      var isImperial =
        (imperialMode && imperialMode.checked) ||
        (imperial && imperial.checked);

      // Update the data property for reactive styling
      this.isMetricMode = !isImperial;

      if (isImperial) {
        document
          .getElementById("imperial-row")
          .setAttribute("style", "display:flex;");
        document
          .getElementById("metric-row")
          .setAttribute("style", "display:none;");
      } else {
        document
          .getElementById("metric-row")
          .setAttribute("style", "display:flex;");
        document
          .getElementById("imperial-row")
          .setAttribute("style", "display:none;");
      }
    },
    setDateForBiobandCalculator() {
      //min date (needs to be <= 16)
      var minDate = new Date();
      var minDays = 16 * 365.25;

      minDate.setDate(minDate.getDate() - minDays);
      minDate = minDate.toISOString().split("T")[0];

      const childsDobImperial = document.getElementById("childs-dob-imperial");
      const childsDobMetric = document.getElementById("childs-dob-metric");

      if (childsDobImperial) {
        childsDobImperial.setAttribute("min", minDate);
      }
      if (childsDobMetric) {
        childsDobMetric.setAttribute("min", minDate);
      }

      //max date needs (needs to be >= 5)
      var maxDate = new Date();
      var maxDays = 5 * 365.25;
      maxDate.setDate(maxDate.getDate() - maxDays);
      maxDate = maxDate.toISOString().split("T")[0];

      if (childsDobImperial) {
        childsDobImperial.setAttribute("max", maxDate);
      }
      if (childsDobMetric) {
        childsDobMetric.setAttribute("max", maxDate);
      }

      var ageDates = {
        min: minDate,
        max: maxDate,
      };
      return ageDates;
    },
    filterUploadedDocuments(categorySelected) {
      return this.uploadedDocuments.filter(
        (document) => document.category === categorySelected,
      );
    },
    changePlayerCoachPerformanceAssessmentStatus() {
      console.log(
        "Status changed to:",
        this.playerCoachSignedPerformanceReportData.status,
      );
      if (this.playerCoachSignedPerformanceReportData.id === undefined) {
        this.savePlayerCoachSignedPerformanceReport();
      } else {
        this.updatePlayerCoachSignedPerformanceReport();
      }
    },
    async getSeasionDates() {
      const userData = {
        action: "getSeasionDates",
      };

      const response = await Teams.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        return response.data;
      }
    },
    setPlayingSeasion() {
      let result = this.getSeasionDates().then((responce) => {
        let year = moment().year();
        // Don't clobber a past-season override (set by the global season selector).
        if (!localStorage.getItem("selectedSeasonYear")) {
          localStorage.setItem(
            "currentPlayingseasonStartDate",
            responce.season_start_date,
          );
          localStorage.setItem(
            "currentPlayingseasonEndDate",
            responce.season_end_date,
          );
        }

        localStorage.setItem("currentPlayingSeason", `${year}`);

        return true;
      });

      return result;
    },
    checkChartHasData(dataName, playerId, date) {
      const data = this.playerDailyMins.find(
        (data) =>
          data.player_id === playerId &&
          data.session_date === date &&
          data.session_type === "Session" &&
          data[dataName] !== undefined,
      );
      return data !== undefined;
    },
    setSelectedDatetrainingAndGameData(data) {
      const date = this.formatDateForDB(data);

      if (this.under16 === false) {
        // catapult data
        this.selectedGameAndTrainingChartStats = this.playerDailyMins.find(
          (dailyMins) => dailyMins.session_date === date,
        );

        if (this.selectedGameAndTrainingChartStats !== undefined) {
          this.sessionStrainingAndGamesSessionDistancePieData =
            this.populateSeasonStrainingAndGamesstatsChartPieDataSetsData(
              this.selectedUserData.id,
              date,
              "session_distance",
            );
          this.sessionStrainingAndGamesSessionHighSpeedRunningPieData =
            this.populateSeasonStrainingAndGamesstatsChartPieDataSetsData(
              this.selectedUserData.id,
              date,
              "total_absolute_high_speed_distance",
            );
          this.sessionStrainingAndGamesSessionMaximumVelocityPieData =
            this.populateSeasonStrainingAndGamesstatsChartPieDataSetsData(
              this.selectedUserData.id,
              date,
              "maximum_velocity",
            );

          if (
            this.checkChartHasData(
              "total_absolute_high_speed_distance",
              this.selectedUserData.id,
              date,
            ) === true
          ) {
            this.fullSessionStrainingAndGamesTotalDistanceChartData = {
              labels: ["High Speed Running"],
              datasets:
                this.populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                  "total_absolute_high_speed_distance",
                  this.selectedUserData.id,
                  date,
                  "High Speed Running",
                ),
            };
          }

          if (
            this.checkChartHasData(
              "session_distance",
              this.selectedUserData.id,
              date,
            ) === true
          ) {
            this.fullSessionStrainingAndGamesHighSpeedRunningChartData = {
              labels: ["Total Distance"],
              datasets:
                this.populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
                  "session_distance",
                  this.selectedUserData.id,
                  date,
                  "Total Distance",
                ),
            };
          }

          this.sessionStrainingAndGamesSessionHighSpeedRunningChartData = {
            labels: this.populateSeasonStrainingAndGamesstatsChartDataLabels(
              "session_type",
              this.selectedUserData.id,
              date,
            ),
            datasets:
              this.populateSeasonTrainingAndGamesstatsAccelerationsAndDecelerationsChart(
                this.selectedUserData.id,
                date,
              ),
          };
        } else {
          this.selectedGameAndTrainingChartStats = {};
        }
      } else {
        // playMaker data

        this.selectedGameAndTrainingChartStats = this.playerDailyMins.find(
          (dailyMins) => dailyMins.session_date === date,
        );

        if (this.selectedGameAndTrainingChartStats === undefined) {
          this.selectedGameAndTrainingChartStats = {};
        }

        if (
          this.playerPlayMakerGpsData.find(
            (gps) => gps.session_date === date,
          ) !== undefined
        ) {
          this.sessionStrainingAndGamesSessionLeftRighPieData =
            this.populateSeasonStrainingAndGamesstatsChartPieDataPlayMakerSetsData(
              this.selectedUserData.id,
              date,
              "right_leg_touches",
            );
          this.sessionStrainingAndGamesSessionLeftLeftPieData =
            this.populateSeasonStrainingAndGamesstatsChartPieDataPlayMakerSetsData(
              this.selectedUserData.id,
              date,
              "left_leg_touches",
            );

          this.fullSessionStrainingAndGamesTotalTouchesChartData = {
            labels: ["Total Touches"],
            datasets:
              this.populateFullSeasonStrainingAndGamesstatsAllPlaymakerChartDataSetsData(
                "total_touches",
                this.selectedUserData.id,
                date,
                "Total Touches",
              ),
          };

          this.fullSessionStrainingAndGamesRightFootTouchesChartData = {
            labels: ["Right foot Touches"],
            datasets:
              this.populateFullSeasonStrainingAndGamesstatsAllPlaymakerChartDataSetsData(
                "right_leg_touches",
                this.selectedUserData.id,
                date,
                "Right foot Touches",
              ),
          };

          this.fullSessionStrainingAndGamesLeftFootTouchesChartData = {
            labels: ["Left foot Touches"],
            datasets:
              this.populateFullSeasonStrainingAndGamesstatsAllPlaymakerChartDataSetsData(
                "left_leg_touches",
                this.selectedUserData.id,
                date,
                "Left foot Touches",
              ),
          };

          this.fullSessionStrainingAndGamesTotalDistanceChartData = {
            labels: ["Total distance (m)"],
            datasets:
              this.populateFullSeasonStrainingAndGamesstatsAllPlaymakerChartDataSetsData(
                "distance_covered",
                this.selectedUserData.id,
                date,
                "Total distance (m)",
              ),
          };

          this.sessionStrainingAndGamesSessionTopSpeedsChartData = {
            labels: ["Top Speed"],
            datasets:
              this.populateFullSeasonStrainingAndGamesstatsAllPlaymakerChartDataSetsData(
                "top_speed",
                this.selectedUserData.id,
                date,
                "Top Speed",
              ),
          };

          this.sessionStrainingAndGamesSessionWorkRateChartData = {
            labels: ["Work rate"],
            datasets:
              this.populateFullSeasonStrainingAndGamesstatsAllPlaymakerChartDataSetsData(
                "work_rate",
                this.selectedUserData.id,
                date,
                "Work rate",
              ),
          };
        } else {
          this.sessionStrainingAndGamesSessionLeftRighPieData = {};
          this.sessionStrainingAndGamesSessionLeftLeftPieData = {};
          this.fullSessionStrainingAndGamesTotalTouchesChartData = {};
          this.fullSessionStrainingAndGamesRightFootTouchesChartData = {};
          this.fullSessionStrainingAndGamesLeftFootTouchesChartData = {};
          this.fullSessionStrainingAndGamesTotalDistanceChartData = {};
          this.sessionStrainingAndGamesSessionTopSpeedsChartData = {};
          this.sessionStrainingAndGamesSessionWorkRateChartData = {};
        }
      }
    },
    showOnlyInjuredPlayersToggle() {
      this.showOnlyInjuredPlayers = !this.showOnlyInjuredPlayers;
      this.removeFilter();

      if (this.showOnlyInjuredPlayers) {
        // Filter injured players using toRaw to avoid Vue reactivity issues
        const rawUserData = this.allUserDataBeforFilterApplied.map(toRaw);
        this.coachesUsersData = rawUserData.filter(
          (player) => player.injury === true,
        );
      } else {
        // Reset to show all players
        this.coachesUsersData = [...this.allUserDataBeforFilterApplied];
      }
    },
    showOnlyTrialistPlayersToggle() {
      this.showOnlyTrialistPlayers = !this.showOnlyTrialistPlayers;
      this.removeFilter();

      if (this.showOnlyTrialistPlayers) {
        // Filter trialist players using toRaw to avoid Vue reactivity issues
        const rawUserData = this.allUserDataBeforFilterApplied.map(toRaw);
        this.coachesUsersData = rawUserData.filter(
          (player) => player.trialistId !== null,
        );
      } else {
        // Reset to show all players
        this.coachesUsersData = [...this.allUserDataBeforFilterApplied];
      }
    },
    removeNumberFromStart(documentName) {
      if (documentName !== undefined) {
        return documentName.substring(documentName.indexOf("_") + 1);
      }
    },
    populateSelectedPlayerSelfAssessment(id) {
      this.playerSelfAssessmentU11to18Data =
        this.allPlayerSelfAssessmentData.find(
          (assessment) => assessment.id === id,
        );
      console.log(this.playerSelfAssessmentU11to18Data);
    },
    async getPlayerCoachSignedPerformanceReport() {
      const userData = {
        action: "getPlayerCoachSignedPerformanceReport",
        id: this.selectedUserData.id,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };

      const response = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.allPlayerCoachSignedPerformanceReportData = response.data;
      }
    },
    unpublishPlayerCoachReport() {
      this.playerCoachSignedPerformanceReportData.published = 0;
      this.playerCoachSignedPerformanceReportData.status = "live";
      this.updatePlayerCoachSignedPerformanceReport();
    },
    publishPlayerCoachReport() {
      this.playerCoachSignedPerformanceReportData.published = 1;
      this.playerCoachSignedPerformanceReportData.status = "published";
      this.updatePlayerCoachSignedPerformanceReport();
    },
    signPlayerCoachReport() {
      this.playerCoachSignedPerformanceReportData.status = "live";
      this.updatePlayerCoachSignedPerformanceReport();
    },
    async updatePlayerCoachSignedPerformanceReport() {
      const userData = {
        action: "updatePlayerCoachSignedPerformanceReport",
        ...this.playerCoachSignedPerformanceReportData,
      };

      const response = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.playerCoachsignedReportReady = false;
        this.getPlayerCoachSignedPerformanceReport();
        this.showPlayerCoachPerformanceAssessmentModal = false;
        this.$toast.info("Performance Assesment updated", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async savePlayerCoachSignedPerformanceReport() {
      this.playerCoachSignedPerformanceReportData.created_date =
        moment().format("YYYY-MM-DD");
      this.playerCoachSignedPerformanceReportData.user_id =
        this.selectedUserData.id;
      if (this.userData.userType !== "User") {
        this.playerCoachSignedPerformanceReportData.coach_id = this.userData.id;
      }

      const userData = {
        action: "savePlayerCoachSignedPerformanceReport",
        user_id: this.selectedUserData.id,
        ...this.playerCoachSignedPerformanceReportData,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };

      const response = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.playerCoachsignedReportReady = false;
        this.getPlayerCoachSignedPerformanceReport();
        this.showPlayerCoachPerformanceAssessmentModal = false;
        this.$toast.info("Performance Assesment saved", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    // New Coach Performance Review Modal handlers
    openNewCoachPerformanceReviewModal(type = "Player", reviewId = null) {
      this.coachPerformanceReviewViewType = type;
      if (reviewId) {
        // Find the existing review - open directly with its stored review type
        const review = this.allPlayerCoachSignedPerformanceReportData.find(
          (r) => r.id === reviewId,
        );
        this.selectedCoachPerformanceReviewData = review || {};
        this.coachPerformanceReviewType = review?.review_type || "text";
        this.showNewCoachPerformanceReviewModal = true;
      } else {
        // New review - show selection modal first
        this.selectedCoachPerformanceReviewData = {};
        this.showReviewTypeSelectionModal = true;
      }
    },
    onReviewTypeSelected({ reviewType, playerType }) {
      this.coachPerformanceReviewType = reviewType;
      this.showReviewTypeSelectionModal = false;
      this.showNewCoachPerformanceReviewModal = true;
    },
    onReviewTypeSelectionCancelled() {
      this.showReviewTypeSelectionModal = false;
    },
    getSeasonStartDate() {
      return localStorage.getItem("currentPlayingseasonStartDate");
    },
    onCoachPerformanceReviewSaved(data) {
      this.getPlayerCoachSignedPerformanceReport();
      this.showNewCoachPerformanceReviewModal = false;
    },
    onCoachPerformanceReviewUpdated(data) {
      this.getPlayerCoachSignedPerformanceReport();
      this.showNewCoachPerformanceReviewModal = false;
    },
    onCoachPerformanceReviewDeleted(id) {
      this.getPlayerCoachSignedPerformanceReport();
      this.showNewCoachPerformanceReviewModal = false;
    },
    onCoachPerformanceReviewPublished(data) {
      this.getPlayerCoachSignedPerformanceReport();
    },
    onCoachPerformanceReviewUnpublished(data) {
      this.getPlayerCoachSignedPerformanceReport();
    },
    async getAllPlayerAssesments() {
      const userData = {
        action: "getAllPlayerAssesments",
        user_id: this.selectedUserData.id,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };

      const response = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.allPlayerSelfAssessmentData = response.data;
      }
    },
    async saveplayerAssesment() {
      const userData = {
        action: "saveplayerAssesment",
        ...this.playerSelfAssessmentU11to18Data,
        user_id: this.selectedUserData.id,
        age_group: this.selectedUserData.age_group,
        created_date: moment().format("YYYY-MM-DD"),
      };
      const response = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.getAllPlayerAssesments();
        this.showPlayerAssesmentModal = false;
        this.$toast.info("Player Assesment saved", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    playerAssesmentModal() {
      this.playerSelfAssessmentU11to18Data = {};
      this.showPlayerAssesmentModal = true;
    },
    checkPlayerMinsMonthTotals(total) {
      if (total > 1300) {
        //this.sendFBNotificationMessage(`${this.selectedUserData.name} mins load high this month!`, `Please review ${this.selectedUserData.name} mins load! `, [], this.selectedUserData.coach_id);
      }
      return total;
    },
    charterModal() {
      this.showModal("charterModal");
    },
    async getCharterData() {
      const userData = {
        action: "getCharterData",
        player_id: 0,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.charterData = response.data;
        if (this.charterData.parent_signature !== null) {
          this.charterData.parent_signature = false;
        }

        if (this.charterData.player_signature !== null) {
          this.charterData.player_signature = false;
        }
      }
    },
    async getDocumentUploadsByUserId() {
      const userData = {
        action: "getDocumentUploadsByUserId",
        user_id: this.selectedUserValue,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.uploadedDocuments = response.data;
      }
    },
    onCloseDailyWellnessModal() {
      this.wellnessDaySelected = null;
    },
    showWellnessByDay(weekDay) {
      this.wellnessDaySelected = weekDay;
      this.showModal("viewDailyWellnessReport");
    },
    async showIfOver2010() {
      const under2011Groups = ["2016", "2015", "2014", "2013", "2012", "2011"];

      try {
        const clientId = JSON.parse(
          localStorage.getItem("the_w_selectedClientId"),
        );
        const response = await this.getUserByIdReturnData(clientId);
        return response && under2011Groups.includes(response.age_group);
      } catch (error) {
        console.error("Error fetching user data:", error);
        return false;
      }
    },
    showIfOverU11(age_group) {
      if (age_group !== undefined) {
        const currentYear = new Date().getFullYear();
        const birthYear = parseInt(age_group);

        // Check if birth year is valid
        if (isNaN(birthYear)) {
          return false;
        }

        // Calculate age based on current year
        const age = currentYear - birthYear;

        // Return true if player is over 11 years old
        return age > 11;
      }
      return false;
    },
    showIfUnderU16(age_group) {
      if (age_group !== undefined) {
        const currentYear = new Date().getFullYear();
        const birthYear = parseInt(age_group);

        // Check if birth year is valid
        if (isNaN(birthYear)) {
          return false;
        }

        // Calculate age based on current year
        const age = currentYear - birthYear;

        // Return true if player is under 14
        return age < 14;
      }
      return false;
    },
    selectQuaterDataForGameTargets() {
      const quarters = {
        1: {
          start: moment().quarter(1).startOf("quarter").format("YYYY-MM-DD"),
          end: moment().quarter(1).endOf("quarter").format("YYYY-MM-DD"),
        },
        2: {
          start: moment().quarter(2).startOf("quarter").format("YYYY-MM-DD"),
          end: moment().quarter(2).endOf("quarter").format("YYYY-MM-DD"),
        },
        3: {
          start: moment().quarter(3).startOf("quarter").format("YYYY-MM-DD"),
          end: moment().quarter(3).endOf("quarter").format("YYYY-MM-DD"),
        },
        4: {
          start: moment().quarter(4).startOf("quarter").format("YYYY-MM-DD"),
          end: moment().quarter(4).endOf("quarter").format("YYYY-MM-DD"),
        },
      };

      let selectedQuarterStart = null;
      let selectedQuarterEnd = null;

      if (this.gameTargetQuarterSelection in quarters) {
        selectedQuarterStart = quarters[this.gameTargetQuarterSelection].start;
        selectedQuarterEnd = quarters[this.gameTargetQuarterSelection].end;
      }

      if (this.gameTargetQuarterSelection === "all") {
        this.playerGameTargetsDataFiltered = this.playerGameTargetsData;
      } else {
        this.playerGameTargetsDataFiltered = this.playerGameTargetsData.filter(
          (gameTarget) => {
            return (
              gameTarget.created_date >= selectedQuarterStart &&
              gameTarget.created_date <= selectedQuarterEnd
            );
          },
        );
      }
    },
    async updatePlayerIDPScores() {
      const data = {
        action: "updatePlayerIDPScores",
        ...this.playerIDPdata,
      };

      const responce = await PerformanceReview.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getallQuatersPlayerIDPscores();
        this.getGameTargets();
        this.getIDPGoals();
        this.showPlayerIDPModal = false;
        this.$toast.info("Player IDP score updated", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async savePlayerIDPScores() {
      if (
        !Object.prototype.hasOwnProperty.call(
          this.newPlayerIDPdata,
          "player_comments",
        )
      ) {
        this.newPlayerIDPdata.player_comments = "";
      }

      const data = {
        action: "savePlayerIDPScores",
        user_id: this.selectedUserValue,
        ...this.newPlayerIDPdata,
        coach_comments: "",
        created_date: moment().format("YYYY-MM-DD"),
      };

      const responce = await PerformanceReview.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getallQuatersPlayerIDPscores();
        this.getGameTargets();
        this.getIDPGoals();
        this.showNewplayerIDPModal = false;
        this.$toast.info("Player IDP score saved", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async deleteIDPGoal() {
      const data = {
        action: "deleteIDPGoal",
        player_id: this.IDPselectedGoalData.id,
      };

      const responce = await PerformanceReview.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getIDPGoals();
        this.showIDPGoalsModal = false;
        this.$toast.info("Goal deleted", {
          title: "Deleted",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async editIDPGoal() {
      const data = {
        action: "editIDPGoal",
        ...this.IDPselectedGoalData,
      };

      const responce = await PerformanceReview.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getIDPGoals();
        this.showIDPGoalsModal = false;
        this.$toast.info("Player IDP score edited", {
          title: "edited",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async saveIDPGoal() {
      const data = {
        action: "saveIDPGoal",
        player_id: this.selectedUserValue,
        created_date: moment().format("YYYY-MM-DD"),
        ...this.IDPselectedGoalData,
      };

      const responce = await PerformanceReview.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getIDPGoals();
        this.showIDPGoalsModal = false;
        this.$toast.info("Player IDP score saved", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async getIDPGoals() {
      if (!this.hasFeature("idp")) return;
      const data = {
        action: "getIDPGoals",
        user_id: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };

      const responce = await PerformanceReview.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.IDPGoalsData = responce.data;
      }
    },
    async getallQuatersPlayerIDPscores(dateRange = "current") {
      if (!this.hasFeature("idp")) return;
      console.log(
        "getallQuatersPlayerIDPscores called with dateRange:",
        dateRange,
      );
      const data = {
        action: "allQuatersPlayerIDPdata",
        user_id: this.selectedUserValue,
        season_start_date:
          dateRange === "all"
            ? "2015-01-01"
            : localStorage.getItem("currentPlayingseasonStartDate"),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      console.log("IDP API request data:", data);

      const responce = await PerformanceReview.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200 && responce.data !== false) {
        this.allQuatersPlayerIDPdata = responce.data;
      }
    },
    setCurrentQuaterPlayerIDPdata(quaterNumber) {
      const quarters = {
        1: {
          start: moment().quarter(1).startOf("quarter").format("YYYY-MM-DD"),
          end: moment().quarter(1).endOf("quarter").format("YYYY-MM-DD"),
        },
        2: {
          start: moment().quarter(2).startOf("quarter").format("YYYY-MM-DD"),
          end: moment().quarter(2).endOf("quarter").format("YYYY-MM-DD"),
        },
        3: {
          start: moment().quarter(3).startOf("quarter").format("YYYY-MM-DD"),
          end: moment().quarter(3).endOf("quarter").format("YYYY-MM-DD"),
        },
        4: {
          start: moment().quarter(4).startOf("quarter").format("YYYY-MM-DD"),
          end: moment().quarter(4).endOf("quarter").format("YYYY-MM-DD"),
        },
      };

      let selectedQuarterStart = null;
      let selectedQuarterEnd = null;
      selectedQuarterStart = quarters[quaterNumber].start;
      selectedQuarterEnd = quarters[quaterNumber].end;

      return this.allQuatersPlayerIDPdata.filter((iDP) => {
        return (
          iDP.created_date >= selectedQuarterStart &&
          iDP.created_date <= selectedQuarterEnd
        );
      });
    },
    async getPlayersIPDscores() {
      const data = {
        action: "getPlayersIPDscores",
        user_id: this.selectedUserValue,
      };

      const responce = await PerformanceReview.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200 && responce.data !== false) {
        //this.playerIDPdata = responce.data;
        this.getallQuatersPlayerIDPscores();
      }
    },
    populateIdp(idpData) {
      this.playerIDPdata = idpData;
    },
    /**
     * Drop every piece of IDP state tied to the player we are leaving.
     * Without this the dashboard keeps rendering the previous player's
     * reports/goals/targets, and the edit form stays primed with their
     * selections — one save away from writing them to the wrong player.
     */
    resetIDPDataForPlayerSwitch() {
      this.allQuatersPlayerIDPdata = [];
      this.IDPGoalsData = [];
      this.playerGameTargetsData = [];
      this.playerIDPdata = {
        technical_green: "",
        technical_yellow: "",
        technical_red: "",
        tactical_green: "",
        tactical_yellow: "",
        tactical_red: "",
        physical_green: "",
        physical_yellow: "",
        physical_red: "",
        physcological_green: "",
        physcological_yellow: "",
        physcological_red: "",
        player_comments: "",
        coach_comments: "",
      };
    },
    editPlayerIDPGoal(goal) {
      this.IDPselectedGoalData = goal;
      this.showModal("iDPGoalsModal");
    },
    // IDP → PDF (performance schools ask for these; players can keep a copy).
    exportIdpPdf({ report, goals, targets, quarter }) {
      const player = this.selectedUserData || {};
      const team = (this.clubTeams || []).find(
        (t) => Number(t.id) === Number(player.teamId),
      );
      const q = Number(quarter);
      const quarterLabel =
        q >= 1 && q <= 4 ? `Q${q} ${moment(report.created_date).year()}` : "";
      try {
        downloadIdpPdf({
          clubName: getTenantName(),
          player: {
            name: player.name,
            teamName: team ? team.teamName : "",
            position: player.position,
          },
          report,
          goals: goals || [],
          targets: targets || [],
          quarterLabel,
        });
      } catch (error) {
        console.error("IDP PDF export failed:", error);
        this.$toast?.error("Couldn't build the PDF. Please try again.");
      }
    },
    openMonthGoalModal() {
      this.IDPselectedGoalData = {};
      this.showModal("iDPGoalsModal");
    },
    populateGoalKeeperIDPs() {
      this.technicalSelectOptions = [
        "Shot stopping – various distances / angles",
        "Good Footwork to adjust position",
        "Correct start position and body stance",
        "1v1’s – spreads body, delays striker, diverts shots",
        "Cross balls – catching / punching crosses",
        "Movement to provide angles of support",
        "Good decision making in build phase",
        "Distribution by hand accurately over various distances",
        "Distribution over long / short distances by foot",
        "Pass back clearances",
      ];

      this.tacticalSelectOptions = [
        "Adjusts pitch position in relation to the ball / team-mat",
        "Provides depth to recycle / enable switch of play",
        "Recognises when to play around, through or over",
        "Anticipates balls over the top – sweeper keeper",
        "Identifies overloads in build phase",
        "Reacts to opposition counterattack",
        "Good distribution to trigger counterattack opportunities",
      ];

      this.physicalSelectOptions = [
        "Agility/Change of Direction",
        "Co-ordination",
        "Balance",
        "Speed",
        "Endurance",
        "Strength (U13-U18) Upper body / Lower body",
        "Other   - Please specify",
      ];

      this.physcologicalSelectOptions = [
        "Intelligence – Game craft/knowledge",
        "Vision",
        "Leadership",
        "Decision making",
        "Composure",
        "Communication",
        "Coachability",
        "Drive/Desire",
        "Discipline",
        "Confidence",
      ];
    },
    openNewIDPModal() {
      if (this.selectedUserData.position === "Goalkeeper") {
        this.populateGoalKeeperIDPs();
      }
      this.showModal("newplayerIDPModal");
    },
    openIDPModal(report) {
      // Populate playerIDPdata with the report values for editing
      if (report) {
        this.playerIDPdata = {
          id: report.id,
          user_id: report.user_id,
          created_date: report.created_date,
          technical_green: report.technical_green || "",
          technical_yellow: report.technical_yellow || "",
          technical_red: report.technical_red || "",
          tactical_green: report.tactical_green || "",
          tactical_yellow: report.tactical_yellow || "",
          tactical_red: report.tactical_red || "",
          physical_green: report.physical_green || "",
          physical_yellow: report.physical_yellow || "",
          physical_red: report.physical_red || "",
          physcological_green: report.physcological_green || "",
          physcological_yellow: report.physcological_yellow || "",
          physcological_red: report.physcological_red || "",
          player_comments: report.player_comments || "",
          coach_comments: report.coach_comments || "",
        };
      }
      this.showModal("playerIDPModal");
    },
    async sendFBNotificationMessage(title, body, ageGroup, playerId) {
      const data = {
        action: "sendFBNotificationMessage",
        title: title,
        body: body,
        age_group: ageGroup,
        link: `${window.location.origin}/login`,
        player_id: playerId,
        clubId: this.userData.clubId,
      };
      const responce = await Chat.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.$toast.info("Notification sent", {
          title: "Notification sent",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    editHomeworkMdalCall(homework, type) {
      Object.assign(this.newHomeWorkData, {
        created_date: homework.created_date,
        gameId: homework.gameId,
        id: homework.id,
        information: homework.information,
        matchDate: homework.matchDate,
        opposition: homework.opposition,
        player_id: homework.player_id,
        title: homework.title,
        videos: homework.videos,
      });

      if (!Object.prototype.hasOwnProperty.call(homework, "homework")) {
        this.newHomeWorkData.videos = [];
      }
      this.filterHomeworkVideos(homework.id, type);
      this.showModal("addHomeworkModal");
    },
    addHomeWorkModalCall() {
      this.resetNewHomeWorkData();
      this.showModal("addHomeworkModal");
    },
    async getAllHomeworkForPlayer() {
      const data = {
        action: "getAllHomeworkForPlayer",
        player_id: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.allHomeWorkData = response.data;
        this.getAllHomeworkForTeam();
      }
    },
    async getAllHomeworkForTeam() {
      const data = {
        action: "getAllHomeworkForTeam",
        teamId: this.selectedUserData.teamId,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.allTeamWorkData = response.data;
      }
    },
    async editHomework() {
      const data = {
        ...this.newHomeWorkData,
        created_date: moment().format("YYYY-MM-DD"),
        player_id: this.selectedUserValue,
        action: "editHomework",
        document_id: this.newHomeWorkData.id,
      };

      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.getAllHomeworkForPlayer();
        this.populatePlayerVideoLinkData();
        this.populateTeamVideoLinkData();

        this.showAddHomeworkModal = false;
        this.resetNewHomeWorkData();

        this.$toast.info("Homework successfully updated.", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async saveHomework() {
      const data = {
        ...this.newHomeWorkData,
        created_date: moment().format("YYYY-MM-DD"),
        player_id: this.selectedUserValue,
        action: "saveHomework",
      };

      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.getAllHomeworkForPlayer();
        this.populatePlayerVideoLinkData();
        this.populateTeamVideoLinkData();
        this.showAddHomeworkModal = false;
        this.resetNewHomeWorkData();

        this.$toast.info("Homework successfully saved.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.sendFBNotificationMessage(
          "Homework added",
          "You have a new homework item to review.",
          [],
          this.selectedUserValue,
        );
      }
    },
    resetNewHomeWorkData() {
      this.newHomeWorkData = {
        title: "",
        information: "",
        videos: [
          {
            video_name: "",
            video_url: "",
            player_id: "",
            category: "",
          },
        ],
      };
    },
    filterHomeworkVideos(id, type) {
      let result = [];

      if (type === "teamVideos") {
        result = this[type].filter((video) => video.document_id === id);
      } else {
        result = this[type].videos.filter((video) => video.document_id === id);
      }

      this.newHomeWorkData.videos = result;
    },
    viewHomework(homeworkData, type) {
      this.newHomeWorkData = homeworkData;
      this.filterHomeworkVideos(homeworkData.id, type);
      this.showViewHomeworkModal = true;
    },
    async deleteHomework(id) {
      const data = {
        id: id,
        action: "deleteHomework",
      };

      const response = await Homework.find(data).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.getAllHomeworkForPlayer();

        this.$toast.info("Homework successfully deleted.", {
          title: "Deleted",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    getFileURL(fileId) {
      const document = this.uploadedDocuments.find(
        (document) => document.id === fileId,
      );
      return document ? document.url : null;
    },
    showDownloadFile(fileId) {
      this.downloadURL = this.getFileURL(fileId);
      this.showModal("viewDownloadPDF");
    },
    openDocumentUpLoadModal() {
      this.showUpLoadModal = true;
    },
    async getDocumentUploadsCall() {
      const userData = {
        action: "getDocumentUploadsByCategoryandUser",
        user_id: this.selectedUserData.id,
      };
      const response = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (response.status === 200) {
        this.uploadedDocuments = response.data;
        this.showUpLoadModal = false;
      }
    },
    getDayMinsData() {
      return this.pastGameData.find(
        (game) => game.id === this.newGamePerformanceData.gameId,
      );
    },
    async editDayMinsOnlyData() {
      const selectedGameData = this.getDayMinsData();

      // Check if selectedGameData exists
      if (!selectedGameData) {
        console.error("No selected game data found");
        return;
      }

      const date = selectedGameData.kickOffTime.substring(0, 10);

      // Fix the find condition to actually search for matching date
      let minsData = this.playerDailyMins.find(
        (data) => data.session_date === date,
      );

      if (minsData === undefined) {
        // Ensure minsData is defined before proceeding
        minsData.player_id = this.selectedUserValue;
        minsData.session_date = date;
        minsData.game_id = this.newGamePerformanceData.gameId;
        minsData.session_mins = this.newGamePerformanceData.timeOnPitch;
        minsData.session_type = selectedGameData.gameType;
        minsData.kick_off_time = selectedGameData.kickOffTime;
        minsData.opposition = selectedGameData.opposition;
        minsData.match_location = selectedGameData.matchLocation;
        minsData.playing_up_level = 0;
        minsData.playing_down_level = 0;
        minsData.session_distance = 0;

        this.selectedDayPlayerData = minsData;
        this.addDayMinsStatsData();
      } else {
        if (
          this.newGamePerformanceData.timeOnPitch !== undefined &&
          this.newGamePerformanceData.timeOnPitch !== null
        ) {
          minsData.session_mins = Number(
            this.newGamePerformanceData.timeOnPitch,
          );

          this.selectedDayPlayerData = minsData;
          this.editDayMinsStatsData();
        }
      }
    },
    async addDayMinsStatsData() {
      const data = {
        action: "addDayMinsStatsData",
        data: this.selectedDayPlayerData,
      };
      const responce = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );
      if (responce.status === 200) {
        this.loadPlayerMinsPerformanceData();
        this.showAddDayStatsBreakDown = false;
        this.$toast.info("Player day mins stats added.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async editDayMinsStatsData() {
      const data = {
        action: "editDayMinsStatsData",
        ...this.selectedDayPlayerData,
      };
      const responce = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );
      if (responce.status === 200) {
        this.loadPlayerMinsPerformanceData();
        this.$toast.info("Player day mins stats updated.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async importUploadedCSVDataFile() {
      this.gpsUploadDataTypeSelected === "catapult"
        ? this.saveCSVCatapultData()
        : this.saveCSVPlayermakerData();
    },
    csvErrorMessage() {
      this.dataCSVErrorMessage =
        "Please verify that your CSV upload template is correct and that you have selected the appropriate upload option.";
      setTimeout(() => (this.dataCSVErrorMessage = null), 2000);
    },
    checkCSVdata() {
      return this.gpsUploadDataTypeSelected === "catapult"
        ? Object.prototype.hasOwnProperty.call(
            this.csvDataImported[0],
            "Accelerations Total Efforts",
          )
        : Object.prototype.hasOwnProperty.call(this.csvDataImported[0], "Tag");
    },
    fixDateForImport(date) {
      return date.substring(0, 10);
    },
    async saveCSVPlayermakerData() {
      const dataIsGood = this.checkCSVdata();
      if (dataIsGood === true) {
        this.csvDataImported[0].Date = this.fixDateForImport(
          this.csvDataImported[0].Date,
        );
        const data = {
          action: "importUploadedCSVDataForPlayMakerFile",
          data: this.csvDataImported,
        };
        const responce = await PlayerPhysicalPerformance.find(data).catch(
          (error) => {
            console.log(error);
          },
        );
        if (responce.status === 200) {
          this.loadPlayerMinsPerformanceData();
          this.hideModal("uploadPlayerMinsCSV");

          this.$toast.info("CSV PlayMaker data added.", {
            title: "saved",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "success",
          });
        }
      } else {
        this.csvErrorMessage();
      }
    },
    async saveCSVCatapultData() {
      const dataIsGood = this.checkCSVdata();

      if (dataIsGood === true) {
        const data = {
          action: "importUploadedCSVDataFile",
          data: this.csvDataImported,
        };
        const responce = await PlayerPhysicalPerformance.find(data).catch(
          (error) => {
            console.log(error);
          },
        );
        if (responce.status === 200) {
          this.loadPlayerMinsPerformanceData();
          this.hideModal("uploadPlayerMinsCSV");

          this.$toast.info("CSV Catapult data added.", {
            title: "saved",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "success",
          });
        }
      } else {
        this.csvErrorMessage();
      }
    },
    openImportCSVModal() {
      this.showModal("uploadPlayerMinsCSV");
    },
    async importCSV(e) {
      const file = e.target.files.item(0);
      const csv = await file.text();
      var lines = csv.split("\n");

      var result = [];

      var headers = lines[0].split(",");

      for (var i = 1; i < lines.length; i++) {
        var obj = {};
        var currentline = lines[i].split(",");

        for (var j = 0; j < headers.length; j++) {
          let str1 = currentline[j].replace(/\n|\r/g, "");
          let str2 = headers[j].replace(/\n|\r/g, "");
          obj[str2] = str1;
        }

        result.push(obj);
      }
      this.csvDataImported = result;
    },
    async getPlayerMinsPerformanceDataForLastGameSessionPlayMaker() {
      const data = {
        action: "getPlayerMinsPerformanceDataForLastGameSessionPlayMaker",
        player_id: this.selectedUserValue,
      };

      const responce = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );

      if (responce.status === 200) {
        //this.lastGameSessionData = responce.data;
        this.lastPlayMakerGameSessionData = responce.data;
      }
    },
    async getPlayerMinsPerformanceDataForLastTrainingSessionPlayMaker() {
      const data = {
        action: "getPlayerMinsPerformanceDataForLastTrainingSessionPlayMaker",
        player_id: this.selectedUserValue,
      };

      const responce = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );

      if (responce.status === 200) {
        //this.lastTrainingSessionData = responce.data;
        this.lastPlayMakerTrainingSessionData = responce.data;
      }
    },
    async getPlayerMinsPerformanceDataForLastTrainingSession() {
      const data = {
        action: "getPlayerMinsPerformanceDataForLastTrainingSession",
        player_id: this.selectedUserValue,
      };

      const responce = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );

      if (responce.status === 200) {
        this.lastTrainingSessionData = responce.data;
      }
    },
    async getPlayerMinsPerformanceDataForLastGameSession() {
      const data = {
        action: "getPlayerMinsPerformanceDataForLastGameSession",
        player_id: this.selectedUserValue,
      };

      const responce = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );

      if (responce.status === 200) {
        this.lastGameSessionData = responce.data;
      }
    },
    getAverage(array) {
      return array.reduce((sum, item) => sum + item, 0) / array.length;
    },
    getAverageFromNumber(data, metric, types) {
      // Accepts string or array for types
      const typeArr = Array.isArray(types) ? types : [types];
      const allNumbers = data
        .filter(
          (item) =>
            typeArr.includes(item.session_type) ||
            typeArr.includes(item.gameType),
        )
        .map((item) => Number(item[metric]));
      return allNumbers.length ? this.getAverage(allNumbers) : 0;
    },
    getPBNumber(data, metric, types) {
      const typeArr = Array.isArray(types) ? types : [types];
      const allNumbers = data
        .filter(
          (item) =>
            typeArr.includes(item.session_type) ||
            typeArr.includes(item.gameType),
        )
        .map((item) => item[metric]);
      return allNumbers.length ? Math.max(...allNumbers) : 0;
    },
    generateMetrics(type, metrics, data) {
      return metrics.reduce((acc, metric) => {
        acc[metric] = this.getAverageFromNumber(data, metric, type);
        return acc;
      }, {});
    },
    generatePBMetrics(type, metrics, data) {
      return metrics.reduce((acc, metric) => {
        acc[metric] = this.getPBNumber(data, metric, type);
        return acc;
      }, {});
    },
    personalBestAndAverages(data, typeOfData) {
      let metrics = [];

      if (typeOfData === "Playmaker") {
        metrics = [
          "phase_duration_min",
          "distance_covered",
          "work_rate",
          "total_touches",
          "left_leg_touches",
          "right_leg_touches",
          "releases",
          "releases_left",
          "releases_right",
          "top_speed",
        ];
      } else {
        metrics = [
          "accelerations_total_efforts",
          "decelerations_total_efforts",
          "max_vel_max",
          "maximum_velocity",
          "meterage_per_minute",
          "session_distance",
          "total_absolute_high_speed_distance",
        ];
      }
      const sessionTypes = ["Session", "Friendly", "League game", "Cup game"];
      const sessionMetrics = this.generateMetrics(sessionTypes, metrics, data);
      const trainingMetrics = this.generateMetrics("Training", metrics, data);

      if (typeOfData === "Playmaker") {
        this.metricsTrainingTab = "training-phase_duration_min-tab";
        this.metricsGameTab = "game-phase_duration_min-tab";
        this.playerMakerPersonalBestAndAverages = {
          games: {
            ...sessionMetrics,
            pb: this.generatePBMetrics(sessionTypes, metrics, data),
          },
          training: {
            ...trainingMetrics,
            pb: this.generatePBMetrics("Training", metrics, data),
          },
        };
      } else {
        this.playerPersonalBestAndAverages = {
          games: {
            ...sessionMetrics,
            pb: this.generatePBMetrics(sessionTypes, metrics, data),
          },
          training: {
            ...trainingMetrics,
            pb: this.generatePBMetrics("Training", metrics, data),
          },
        };
      }
    },
    async handleLoadPlayerMinsPerformanceData() {
      try {
        await this.loadPlayerMinsPerformanceData();
      } catch (error) {
        console.error(
          "Parent: Error loading player mins performance data:",
          error,
        );
      }
    },
    async loadPlayerMinsPerformanceData() {
      if (!this.hasFeature("gpsReports")) return;
      const playMakerData = {
        action: "getPlayerMinsPerformancePlayeMakerData",
        player_id: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const playMakerResponse = await PlayerPhysicalPerformance.find(
        playMakerData,
      ).catch((error) => {
        console.log(error);
      });

      if (playMakerResponse.status === 200) {
        this.playerPlayMakerGpsData = playMakerResponse.data;
        if (this.playerPlayMakerGpsData.length > 0) {
          this.personalBestAndAverages(
            this.playerPlayMakerGpsData,
            "Playmaker",
          );
        }
      }
      const data = {
        action: "getPlayerMinsPerformanceData",
        player_id: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await PlayerPhysicalPerformance.find(data).catch(
        (error) => {
          console.log(error);
        },
      );

      if (responce.status === 200) {
        this.playerDailyMins = responce.data;
        if (this.playerDailyMins.length > 0) {
          this.personalBestAndAverages(this.playerDailyMins, "Catapult");
        }
      }
    },
    resetPersonalBestAndAveragesData() {
      this.playerMakerPersonalBestAndAverages = {};
      this.playerPersonalBestAndAverages = {};
    },
    showDayStatsBreakDown(day) {
      this.selectedDayPlayerData = day;
      this.showModal("viewDayStatsBreakDown");
    },
    async populateTeamVideoLinkData() {
      const data = {
        action: "populatePlayerVideoLinkData",
        teamId: this.selectedTeamId,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.teamVideos = responce.data;
      }
    },
    async populatePlayerVideoLinkData() {
      const data = {
        action: "populatePlayerVideoLinkData",
        userId: this.selectedUserValue,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.playerCvData = {
          ...this.playerCvData,
          videos: [...responce.data],
        };
      }
    },
    async populatePlayerInterestsHobbiesData() {
      const data = {
        action: "populatePlayerInterestsHobbiesData",
        userId: this.selectedUserValue,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.playerCvData = {
          ...this.playerCvData,
          interests_hobbies: [...responce.data],
        };
      }
    },

    async populatePlayerEducationData() {
      const data = {
        action: "populatePlayerEducationData",
        userId: this.selectedUserValue,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.playerCvData = {
          ...this.playerCvData,
          education: [...responce.data],
        };
      }
    },

    async editPlayerVideoLink() {
      const data = {
        action: "editPlayerVideoLink",
        playerVideo: this.selectedPlayerVideoData,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.populatePlayerVideoLinkData();
        this.populateTeamVideoLinkData();
        this.$toast.info("Player video updated.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showPlayerVideosModal = false;
      }
    },
    async editPlayingExperence() {
      this.updateDatesForDB(
        "selectedPlayingExperenceData",
        "start_date_at_club",
      );
      this.updateDatesForDB("selectedPlayingExperenceData", "end_date_at_club");
      const data = {
        action: "editPlayingExperence",
        playingExperence: this.selectedPlayingExperenceData,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.populatePlayerPlayingExperenceData();
        this.$toast.info("Player Playing Experence updated.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showPlayerCVPlayingExperenceModal = false;
      }
    },
    async editPlayerInterestsHobbies() {
      const data = {
        action: "editPlayerInterestsHobbies",
        playerInterestsHobbies: this.selectedPlayerInterestsHobbiesData,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.populatePlayerPlayingExperenceData();
        this.$toast.info("Player Interests and Hobbies updated.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showOpenPlayerInterestsHobbiesModal = false;
      }
    },
    async editPlayerEducation() {
      this.updateDatesForDB("selectedPlayerEducationData", "start_date");
      this.updateDatesForDB("selectedPlayerEducationData", "end_date");
      const data = {
        action: "editPlayerEducation",
        playerEducation: this.selectedPlayerEducationData,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.populatePlayerPlayingExperenceData();
        this.$toast.info("Player Education updated.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showOpenPlayerEducationModal = false;
      }
    },
    async deletePlayerEducation(id) {
      const data = {
        action: "deletePlayerEducation",
        id: id,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.populatePlayerEducationData();
        this.$toast.info("Player Education deleted.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async deletePlayerVideoLink(id) {
      const data = {
        action: "deletePlayerVideoLink",
        id: id,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.populatePlayerVideoLinkData();
        this.populateTeamVideoLinkData();
        this.$toast.info("Player video  deleted.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async deletePlayerInterestsHobbies(id) {
      const data = {
        action: "deletePlayerInterestsHobbies",
        id: id,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.populatePlayerInterestsHobbiesData();
        this.$toast.info("Player Interests and Hobbies deleted.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    downloadPlayerCvPdf() {
      if (this.cvPdfInstance !== null) {
        const name = this.selectedUserData.name || "Player";
        toRaw(this.cvPdfInstance).save(`${name} - CV.pdf`);
      }
    },
    // Two-step delete for CV entries: first tap arms the button
    // ("Confirm delete"), second tap within 4s runs it.
    confirmCvDelete(key, deleteFn) {
      if (this.cvDeleteArmedKey === key) {
        this.cvDeleteArmedKey = null;
        clearTimeout(this.cvDeleteArmedTimer);
        deleteFn();
        return;
      }
      this.cvDeleteArmedKey = key;
      clearTimeout(this.cvDeleteArmedTimer);
      this.cvDeleteArmedTimer = setTimeout(() => {
        this.cvDeleteArmedKey = null;
      }, 4000);
    },
    // "May 2023 – Present" style range for CV entries.
    formatCvDateRange(start, end) {
      const format = (value) => {
        if (!value) return null;
        const d = dayjs(value);
        return d.isValid() ? d.format("MMM YYYY") : null;
      };
      const startLabel = format(start);
      const endLabel = format(end);
      if (!startLabel && !endLabel) return "";
      return `${startLabel || "?"} – ${endLabel || "Present"}`;
    },
    async deletePlayingExperence(id) {
      const data = {
        action: "deletePlayingExperence",
        id: id,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.populatePlayerPlayingExperenceData();
        this.$toast.info("Player Playing Experence deleted.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async populatePlayerPlayingExperenceData() {
      const data = {
        action: "populatePlayerPlayingExperenceData",
        userId: this.selectedUserValue,
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.playerCvData = {
          ...this.playerCvData,
          playingExperence: [...responce.data],
        };
      }
    },
    updateDatesForDB(objectName, itemName) {
      if (this[objectName][itemName] !== null) {
        this[objectName][itemName] = this.formatDateForDB(
          this[objectName][itemName],
        );
      }
    },
    populatePlayerCV(data) {
      this.playerCvData = {
        ...this.playerCvData,
        personal_profile: data.personal_profile,
      };
      this.populatePlayerPlayingExperenceData();
      this.populatePlayerEducationData();
      this.populatePlayerInterestsHobbiesData();
      this.populatePlayerVideoLinkData();
      this.populateTeamVideoLinkData();
    },
    async savePlayerVideoLink() {
      this.selectedPlayerVideoData.player_id = this.selectedUserData.id;

      const data = {
        playerVideo: this.selectedPlayerVideoData,
        action: "savePlayerVideoLink",
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.populatePlayerVideoLinkData();
        this.populateTeamVideoLinkData();
        this.$toast.info("Player video saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showPlayerVideosModal = false;
      }
    },
    async saveInterestsHobbies() {
      this.selectedPlayerInterestsHobbiesData.player_id =
        this.selectedUserData.id;

      const data = {
        playerInterestsHobbies: this.selectedPlayerInterestsHobbiesData,
        action: "savePlayerInterestsHobbies",
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.populatePlayerInterestsHobbiesData();
        this.$toast.info("Player Interests Hobbies saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showOpenPlayerInterestsHobbiesModal = false;
      }
    },
    async savePlayerEducation() {
      this.selectedPlayerEducationData.player_id = this.selectedUserData.id;
      this.updateDatesForDB("selectedPlayerEducationData", "start_date");
      this.updateDatesForDB("selectedPlayerEducationData", "end_date");

      const data = {
        playerEducation: this.selectedPlayerEducationData,
        action: "savePlayerEducation",
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.populatePlayerEducationData();
        this.$toast.info("Player Education saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showOpenPlayerEducationModal = false;
      }
    },
    async savePlayerPlayingExperence() {
      this.updateDatesForDB(
        "selectedPlayingExperenceData",
        "start_date_at_club",
      );
      this.updateDatesForDB("selectedPlayingExperenceData", "end_date_at_club");
      this.selectedPlayingExperenceData.player_id = this.selectedUserData.id;

      const data = {
        playingExperence: this.selectedPlayingExperenceData,
        action: "savePlayerPlayingExperence",
      };
      const responce = await PlayerCv.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.populatePlayerPlayingExperenceData();
        this.$toast.info("Player Playing Experence saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showPlayerCVPlayingExperenceModal = false;
      }
    },
    async savePersonalProfile() {
      const data = {
        personalProfileData: this.playerCvData.personal_profile,
        userId: this.selectedUserData.id,
        action: "savePersonalProfile",
      };
      const responce = await Users.find(data).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.$toast.info("Player Personal Profile saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.showPlayerCVpersonalProfileModal = false;
      }
    },
    playerPlayerVideosClose() {
      this.selectedPlayerVideoData = {};
      this.selectedPlayerVideoDataEdit = false;
    },
    playerInterestsHobbiesClose() {
      this.selectedPlayerInterestsHobbiesData = {};
      this.selectedPlayerInterestsHobbiesDataEdit = false;
    },
    playerEducationModalClose() {
      this.selectedPlayerEducationData = {};
      this.selectedPlayerEducationDataEdit = false;
    },
    playerCVPlayingExperenceModalClose() {
      this.selectedPlayingExperenceData = {};
      this.selectedPlayingExperenceEdit = false;
    },

    openPlayerVideosModal(index) {
      this.playerPlayerVideosClose();
      if (index !== undefined) {
        this.selectedPlayerVideoData = this.playerCvData.videos[index];
        this.selectedPlayerVideoDataEdit = true;
      }
      this.showPlayerVideosModal = true;
    },
    openPlayerInterestsHobbiesModal(index) {
      this.playerInterestsHobbiesClose();
      if (index !== undefined) {
        this.selectedPlayerInterestsHobbiesData =
          this.playerCvData.interests_hobbies[index];
        this.selectedPlayerInterestsHobbiesDataEdit = true;
      }
      this.showOpenPlayerInterestsHobbiesModal = true;
    },
    openPlayerEducationModal(index) {
      this.playerEducationModalClose();
      if (index !== undefined) {
        this.selectedPlayerEducationData = this.playerCvData.education[index];
        this.selectedPlayerEducationDataEdit = true;
      }
      this.showOpenPlayerEducationModal = true;
    },
    openPlayerCVPlayingExperenceModal(index) {
      this.playerCVPlayingExperenceModalClose();
      if (index !== undefined) {
        this.selectedPlayingExperenceData =
          this.playerCvData.playingExperence[index];
        this.selectedPlayingExperenceEdit = true;
      }
      this.showPlayerCVPlayingExperenceModal = true;
    },
    openPlayerCVpersonalProfileModal() {
      this.showPlayerCVpersonalProfileModal = true;
    },
    addPlayingExperence() {
      const playingExperenceData = {
        club: "",
        start_date_at_club: null,
        end_date_at_club: null,
        playing_info: "",
        player_id: this.selectedUserData.id,
      };

      this.playerCvData = {
        ...this.playerCvData,
        playingExperence: [
          ...this.playerCvData.playingExperence,
          playingExperenceData,
        ],
      };
    },
    poupulateUserData(userData) {
      this.$store.dispatch(USER_POPULATE, { userData });
      Storage.setJSON("selectedClientId", userData.id);
    },
    getTeamIdsFromUsers() {
      return this.userHasMoreThanOneAccount.map((user) => user.id);
    },
    async getAllUsersForHasMoreThanOneAccount() {
      const userData = {
        clubId: this.userData.clubId,
        userIds: this.getTeamIdsFromUsers(),
        action: "getAllUsersForHasMoreThanOneAccount",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.populatePlayerDataFromAllUsersCall(responce.data);
      }
    },
    async saveHeight() {
      const userData = {
        id: this.selectedUserData.id,
        value: this.height,
        action: "saveHeight",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.getPlayerUserDataId(this.selectedUserValue);
        this.hideModal("addHeight");

        this.$toast.info("Player height updated.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async saveWeight() {
      // Welfare guardrail: block self weight-entry by Foundation-phase players.
      // Staff entering weight for a player are not Foundation, so unaffected.
      if (this.actorIsFoundationPlayer) {
        this.hideModal("addWeight");
        return;
      }
      const userData = {
        id: this.selectedUserData.id,
        value: this.weight,
        action: "saveWeight",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.status === 200) {
        this.getPlayerUserDataId(this.selectedUserValue);
        this.hideModal("addWeight");

        this.$toast.info("Player weight updated.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    removeFilter() {
      this.coachesUsersData = this.allUserDataBeforFilterApplied;
      this.hideRemoveTeamFilterButton = true;
    },
    filterBy(arrayToFilter, filterBy) {
      let arrayToFilterByValaue;
      arrayToFilterByValaue = this[arrayToFilter].map(toRaw);

      const filterResult = arrayToFilterByValaue.filter(
        (player) => player[filterBy] === this.selectedFilterData,
      );

      this.coachesUsersData = filterResult;
      this.hideRemoveTeamFilterButton = false;
    },
    setCoachesUsersData(id) {
      this.$store.dispatch(
        POPULATE_COACHES_USER_DATA,
        JSON.parse(localStorage.getItem("coachesUsersData")),
      );
      this.getAllUsersForThisAdmin();
      this.setSelectedTrainingPlanUser(id);
    },
    setSelectedTrainingPlanUser(id) {
      let arrayResult = this.coachesUsersData.filter((selectedTrainingUser) => {
        return selectedTrainingUser.id == id;
      });
      if (arrayResult.length !== 0) {
        this.selectedTrainingUserData = arrayResult[0];
      }
    },
    setSelectedUserOfTrainingPlan(e) {
      let userId = null;
      this.filterdCoachesUsersData = [];
      e.target === undefined ? (userId = e) : (userId = e.target.value);

      this.coachesUsersData.length > 0
        ? this.setSelectedTrainingPlanUser(userId)
        : this.setCoachesUsersData(userId);
      // const selectedUser = e;
      this.selectedUseChanged({ ...e });
    },
    lookUpSearch(value) {
      if (value.length > 3) {
        this.filterdCoachesUsersData = [];

        const results = Array.from(value).reduce(
          (a, v, i) => `${a}[^${value.substr(i)}]*?${v}`,
          "",
        );
        const regEx = RegExp(results);

        this.coachesUsersData.filter((v) => {
          if (v.name.match(regEx)) {
            this.filterdCoachesUsersData.push(v);
          }
        });
      } else {
        this.filterdCoachesUsersData = [];
      }
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    newPageCheck(height, dynamicHeight, pdf) {
      if (height >= "210") {
        pdf.addPage();
        return 10;
      } else {
        height = Math.round(dynamicHeight.h + height + 10);
        return height;
      }
    },
    addPlayerVideos(pdf, height) {
      pdf.setFontSize(10).setFont(undefined, "normal");
      height = Math.round(height);

      this.playerCvData.videos.map((item, index) => {
        let videoIcon = document.getElementById("video-icon");
        pdf.addImage(videoIcon, "PNG", 5, height - 7, 10, 10);

        pdf.textWithLink(item.video_name, 20, height, { url: item.video_url });
        pdf.textWithLink(item.video_name, 20, height, { url: item.video_url });
        height = height + 10;

        if (index !== 0 && height >= "210") {
          pdf.addPage();
          height = 10;
        }
      });

      return height;
    },
    addPlayingPostions(pdf, height) {
      pdf.setFontSize(10).setFont(undefined, "normal");

      this.gamePerformanceData.postion_played.map((item) => {
        if (item === "Goalkeeper") {
          pdf.text(158, 201, "GK");
        }

        if (item === "Right Full-back (Wingback)") {
          pdf.text(188.5, 189, "RB");
        }

        if (item === "Center-back left") {
          pdf.text(147, 189, "CB");
        }

        if (item === "Center-back right") {
          pdf.text(167, 189, "CB");
        }

        if (item === "Defensive Midfielder") {
          pdf.text(147, 152, "CM");
        }

        if (item === "Attacking Midfielder") {
          pdf.text(167, 152, "CM");
        }

        if (item === "Right Midfielder (Winger)") {
          pdf.text(188.5, 152, "RW");
        }

        if (item === "Left Midfielder (Winger)") {
          pdf.text(127.5, 152, "LW");
        }

        if (item === "Center Forward (Striker) left") {
          pdf.text(147, 119, "CF");
        }

        if (item === "Center Forward (Striker) right") {
          pdf.text(169, 119, "CF");
        }

        if (item === "Left Full-back (Wingback)") {
          pdf.text(127.5, 189, "LB");
        }
      });

      return height;
    },
    getTheLastPlayerPerformanceReview() {
      return this.allplayerPerformanceReportData[
        this.allplayerPerformanceReportData.length - 1
      ];
    },
    buildThePlayerCoachReportPDF() {
      let previewContainer = document.getElementById(
        "thePlayerCoachReviewPDF_preview",
      );

      // load player image //
      let img = document.querySelector("#user_photo");
      let pdf = new JsPDF("p", "mm", "a4");

      const review = this.playerCoachSignedPerformanceReportData;
      const isTrafficLight =
        review.review_type === "traffic-light" ||
        review.review_type === "traffic_light";

      // Colors
      const primaryColor = [0, 85, 150]; // Partick Thistle blue
      const secondaryColor = [255, 204, 0]; // Partick Thistle yellow
      const textColor = [51, 51, 51];
      const lightGray = [245, 245, 245];

      // Header background
      pdf.setFillColor(...primaryColor);
      pdf.rect(0, 0, 210, 35, "F");

      // Title
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(18).setFont(undefined, "bold");
      pdf.text("Performance Review", 105, 15, { align: "center" });
      pdf.setFontSize(12).setFont(undefined, "normal");
      pdf.text(
        `Date: ${this.formatDateForHuman(review.created_date)}`,
        105,
        25,
        { align: "center" },
      );

      // Review type badge
      pdf.setFontSize(10);
      const reviewTypeText = isTrafficLight
        ? "Traffic Light Assessment"
        : "Text-Based Review";
      pdf.text(reviewTypeText, 105, 32, { align: "center" });

      // Player info section
      let yPos = 45;

      // Player photo
      if (img) {
        pdf.addImage(img, "PNG", 10, yPos, 30, 30);
      }

      // Player details
      pdf.setTextColor(...textColor);
      pdf.setFontSize(14).setFont(undefined, "bold");
      pdf.text(this.selectedUserData.name, 50, yPos + 8);

      pdf.setFontSize(10).setFont(undefined, "normal");
      pdf.text(
        `Position: ${this.selectedUserData.position || "N/A"}`,
        50,
        yPos + 15,
      );
      pdf.text(
        `DOB: ${this.formatDateForHuman(this.selectedUserData.dob)}`,
        50,
        yPos + 21,
      );
      pdf.text(`Email: ${this.selectedUserData.email || "N/A"}`, 50, yPos + 27);

      yPos = 85;

      if (isTrafficLight) {
        // Traffic Light Review PDF
        yPos = this.buildTrafficLightPDFSection(
          pdf,
          yPos,
          "Player Assessment",
          review.traffic_light_data?.player,
          review.player_comments,
        );
        yPos = this.buildTrafficLightPDFSection(
          pdf,
          yPos,
          "Coach Assessment",
          review.traffic_light_data?.coach,
          review.coach_comments,
        );
      } else {
        // Text-Based Review PDF
        yPos = this.buildTextBasedPDFSection(pdf, yPos, "Player Review", {
          technical: review.technical_player_comments,
          tactical: review.tactical_player_comments,
          physical: review.physical_player_comments,
          mental: review.physcological_player_comments,
          comments: review.player_comments,
        });

        yPos = this.buildTextBasedPDFSection(
          pdf,
          yPos,
          "Coach Review",
          {
            technical: review.technical_coach_comments,
            tactical: review.tactical_coach_comments,
            physical: review.physical_coach_comments,
            mental: review.physcological_coach_comments,
            comments: review.coach_comments,
          },
          review.name,
        );
      }

      // Signatures section
      if (yPos > 220) {
        pdf.addPage();
        yPos = 20;
      }

      pdf.setFillColor(...primaryColor);
      pdf.rect(0, yPos - 5, 210, 10, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(14).setFont(undefined, "bold");
      pdf.text("Signatures", 10, yPos + 2);
      yPos += 15;

      pdf.setTextColor(...textColor);

      const loadedSigs = this._loadedSignatures || {};
      const signatures = [
        { label: "Player Signature", key: "playerReportSignature" },
        { label: "Parent/Guardian Signature", key: "parentReportSignature" },
        { label: "Coach Signature", key: "coachSignature" },
      ];

      for (const sig of signatures) {
        if (yPos > 250) {
          pdf.addPage();
          yPos = 20;
        }

        pdf.setFontSize(10).setFont(undefined, "bold");
        pdf.setTextColor(...textColor);
        pdf.text(sig.label + ":", 10, yPos);
        yPos += 3;

        if (loadedSigs[sig.key]) {
          try {
            const loaded = loadedSigs[sig.key];
            const maxW = 60;
            const maxH = 25;
            const ratio =
              loaded.width && loaded.height
                ? loaded.width / loaded.height
                : maxW / maxH;
            let drawW = maxW;
            let drawH = maxW / ratio;
            if (drawH > maxH) {
              drawH = maxH;
              drawW = maxH * ratio;
            }
            pdf.addImage(loaded.dataUrl, "PNG", 10, yPos, drawW, drawH);
            yPos += drawH + 5;
          } catch (e) {
            console.warn("[PerformanceReviewPDF] addImage failed:", e);
            pdf.setFontSize(9).setFont(undefined, "italic");
            pdf.text("Signed", 10, yPos + 5);
            pdf.setFont(undefined, "normal");
            yPos += 10;
          }
        } else if (review[sig.key]) {
          pdf.setFontSize(9).setFont(undefined, "italic");
          pdf.text("Signed (image could not be loaded)", 10, yPos + 5);
          pdf.setFont(undefined, "normal");
          yPos += 10;
        } else {
          pdf.setFontSize(9).setFont(undefined, "italic");
          pdf.setTextColor(150, 150, 150);
          pdf.text("Not signed", 10, yPos + 5);
          pdf.setTextColor(...textColor);
          pdf.setFont(undefined, "normal");
          yPos += 10;
        }

        yPos += 5;
      }

      return { pdfData: pdf, previewLink: previewContainer };
    },

    buildTextBasedPDFSection(
      pdf,
      startY,
      sectionTitle,
      data,
      coachName = null,
    ) {
      const primaryColor = [0, 85, 150];
      const textColor = [51, 51, 51];
      const categoryColors = {
        technical: [0, 85, 150],
        tactical: [23, 162, 184],
        physical: [253, 126, 20],
        mental: [111, 66, 193],
      };

      let yPos = startY;

      // Check for new page
      if (yPos > 250) {
        pdf.addPage();
        yPos = 20;
      }

      // Section header
      pdf.setFillColor(...primaryColor);
      pdf.rect(0, yPos - 5, 210, 10, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(14).setFont(undefined, "bold");
      pdf.text(sectionTitle, 10, yPos + 2);
      if (coachName) {
        pdf.setFontSize(10).setFont(undefined, "normal");
        pdf.text(`Coach: ${coachName}`, 200, yPos + 2, { align: "right" });
      }

      yPos += 15;
      pdf.setTextColor(...textColor);

      const categories = [
        { key: "technical", label: "Technical", icon: "⚙️" },
        { key: "tactical", label: "Tactical", icon: "📊" },
        { key: "physical", label: "Physical", icon: "⚡" },
        { key: "mental", label: "Mental", icon: "🧠" },
      ];

      for (const cat of categories) {
        const content = data[cat.key] || "";
        if (!content && content !== "") continue;

        // Check for new page
        if (yPos > 260) {
          pdf.addPage();
          yPos = 20;
        }

        // Category header with colored accent
        pdf.setFillColor(...categoryColors[cat.key]);
        pdf.rect(10, yPos - 4, 3, 8, "F");

        pdf.setFontSize(11).setFont(undefined, "bold");
        pdf.setTextColor(...categoryColors[cat.key]);
        pdf.text(cat.label, 16, yPos);

        yPos += 6;

        // Content - strip HTML tags
        pdf.setFontSize(10).setFont(undefined, "normal");
        pdf.setTextColor(...textColor);

        const contentText = (content || "No comments provided")
          .replace(/<[^>]*>/g, "")
          .trim();
        const lines = pdf.splitTextToSize(contentText, 180);

        for (const line of lines) {
          if (yPos > 280) {
            pdf.addPage();
            yPos = 20;
          }
          pdf.text(line, 16, yPos);
          yPos += 5;
        }

        yPos += 5;
      }

      // Overall comments
      if (data.comments) {
        if (yPos > 250) {
          pdf.addPage();
          yPos = 20;
        }

        pdf.setFillColor(200, 200, 200);
        pdf.rect(10, yPos - 4, 3, 8, "F");

        pdf.setFontSize(11).setFont(undefined, "bold");
        pdf.setTextColor(100, 100, 100);
        pdf.text("Overall Comments", 16, yPos);

        yPos += 6;
        pdf.setFontSize(10).setFont(undefined, "normal");
        pdf.setTextColor(...textColor);

        const commentLines = pdf.splitTextToSize(
          data.comments.replace(/<[^>]*>/g, "").trim(),
          180,
        );
        for (const line of commentLines) {
          if (yPos > 280) {
            pdf.addPage();
            yPos = 20;
          }
          pdf.text(line, 16, yPos);
          yPos += 5;
        }
      }

      return yPos + 10;
    },

    buildTrafficLightPDFSection(
      pdf,
      startY,
      sectionTitle,
      trafficLightData,
      overallComments,
    ) {
      const primaryColor = [0, 85, 150];
      const textColor = [51, 51, 51];
      const ragColors = {
        green: [40, 167, 69],
        amber: [255, 193, 7],
        red: [220, 53, 69],
      };
      const categoryColors = {
        technical: [0, 85, 150],
        tactical: [23, 162, 184],
        physical: [253, 126, 20],
        mental: [111, 66, 193],
      };

      let yPos = startY;

      // Check for new page
      if (yPos > 250) {
        pdf.addPage();
        yPos = 20;
      }

      // Section header
      pdf.setFillColor(...primaryColor);
      pdf.rect(0, yPos - 5, 210, 10, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(14).setFont(undefined, "bold");
      pdf.text(sectionTitle, 10, yPos + 2);

      yPos += 15;

      if (!trafficLightData) {
        pdf.setTextColor(...textColor);
        pdf.setFontSize(10).setFont(undefined, "italic");
        pdf.text("No assessment data available", 10, yPos);
        return yPos + 20;
      }

      // Parse if string
      let tlData = trafficLightData;
      if (typeof tlData === "string") {
        try {
          tlData = JSON.parse(tlData);
        } catch (e) {
          tlData = {};
        }
      }

      const categories = ["technical", "tactical", "physical", "mental"];
      const categoryLabels = {
        technical: "Technical",
        tactical: "Tactical",
        physical: "Physical",
        mental: "Mental",
      };

      // Get skills config based on player position
      const isGoalkeeper =
        this.selectedUserData?.position
          ?.toLowerCase()
          ?.includes("goalkeeper") ||
        this.selectedUserData?.position?.toLowerCase()?.includes("gk");

      for (const cat of categories) {
        const catData = tlData[cat];
        if (!catData || typeof catData !== "object") continue;

        // Check for new page
        if (yPos > 240) {
          pdf.addPage();
          yPos = 20;
        }

        // Category header
        pdf.setFillColor(...categoryColors[cat]);
        pdf.rect(10, yPos - 3, 190, 8, "F");
        pdf.setTextColor(255, 255, 255);
        pdf.setFontSize(11).setFont(undefined, "bold");
        pdf.text(categoryLabels[cat], 15, yPos + 2);

        yPos += 12;

        // Skills table header
        pdf.setFontSize(9).setFont(undefined, "bold");
        pdf.setTextColor(...textColor);
        pdf.text("Skill", 15, yPos);
        pdf.text("R", 165, yPos, { align: "center" });
        pdf.text("A", 180, yPos, { align: "center" });
        pdf.text("G", 195, yPos, { align: "center" });

        yPos += 2;
        pdf.setDrawColor(200, 200, 200);
        pdf.line(10, yPos, 200, yPos);
        yPos += 5;

        // Skills rows
        pdf.setFontSize(9).setFont(undefined, "normal");

        const skillKeys = Object.keys(catData);
        for (const skillKey of skillKeys) {
          if (yPos > 275) {
            pdf.addPage();
            yPos = 20;

            // Re-draw header on new page
            pdf.setFontSize(9).setFont(undefined, "bold");
            pdf.text("Skill", 15, yPos);
            pdf.text("R", 165, yPos, { align: "center" });
            pdf.text("A", 180, yPos, { align: "center" });
            pdf.text("G", 195, yPos, { align: "center" });
            yPos += 2;
            pdf.line(10, yPos, 200, yPos);
            yPos += 5;
            pdf.setFont(undefined, "normal");
          }

          const value = catData[skillKey];
          const skillLabel = skillKey
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());

          // Truncate long skill names
          const displayLabel =
            skillLabel.length > 45
              ? skillLabel.substring(0, 42) + "..."
              : skillLabel;

          pdf.setTextColor(...textColor);
          pdf.text(displayLabel, 15, yPos);

          // Draw RAG circles
          const circleY = yPos - 2;
          const circleRadius = 3;

          // Red circle
          if (value === "red") {
            pdf.setFillColor(...ragColors.red);
            pdf.circle(165, circleY, circleRadius, "F");
          } else {
            pdf.setDrawColor(...ragColors.red);
            pdf.circle(165, circleY, circleRadius, "S");
          }

          // Amber circle
          if (value === "amber") {
            pdf.setFillColor(...ragColors.amber);
            pdf.circle(180, circleY, circleRadius, "F");
          } else {
            pdf.setDrawColor(...ragColors.amber);
            pdf.circle(180, circleY, circleRadius, "S");
          }

          // Green circle
          if (value === "green") {
            pdf.setFillColor(...ragColors.green);
            pdf.circle(195, circleY, circleRadius, "F");
          } else {
            pdf.setDrawColor(...ragColors.green);
            pdf.circle(195, circleY, circleRadius, "S");
          }

          yPos += 7;
        }

        yPos += 5;
      }

      // Overall comments
      if (overallComments) {
        if (yPos > 250) {
          pdf.addPage();
          yPos = 20;
        }

        pdf.setFillColor(100, 100, 100);
        pdf.rect(10, yPos - 3, 190, 8, "F");
        pdf.setTextColor(255, 255, 255);
        pdf.setFontSize(11).setFont(undefined, "bold");
        pdf.text("Overall Comments", 15, yPos + 2);

        yPos += 12;
        pdf.setFontSize(10).setFont(undefined, "normal");
        pdf.setTextColor(...textColor);

        const commentLines = pdf.splitTextToSize(
          overallComments.replace(/<[^>]*>/g, "").trim(),
          180,
        );
        for (const line of commentLines) {
          if (yPos > 280) {
            pdf.addPage();
            yPos = 20;
          }
          pdf.text(line, 15, yPos);
          yPos += 5;
        }
      }

      return yPos + 10;
    },
    buildThePlayerCVPDF() {
      const previewContainer = document.getElementById(
        "thePlayerCVPDF_preview",
      );
      const pdf = new JsPDF("p", "mm", "a4");

      const MARGIN = 14;
      const PAGE_WIDTH = 210;
      const CONTENT_WIDTH = PAGE_WIDTH - MARGIN * 2;
      const BOTTOM = 280;
      const INK = [28, 40, 48];
      const MUTED = [91, 103, 112];
      const ACCENT = [3, 86, 158];
      let y = 0;

      const ensureSpace = (needed) => {
        if (y + needed > BOTTOM) {
          pdf.addPage();
          y = 18;
        }
      };

      const sectionTitle = (title) => {
        ensureSpace(18);
        y += 6;
        pdf.setTextColor(...ACCENT);
        pdf.setFontSize(14).setFont(undefined, "bold");
        pdf.text(MARGIN, y, title.toUpperCase());
        y += 2;
        pdf.setDrawColor(...ACCENT);
        pdf.setLineWidth(0.4);
        pdf.line(MARGIN, y, MARGIN + CONTENT_WIDTH, y);
        y += 7;
      };

      const bodyText = (text, options = {}) => {
        const value = (text || "").toString().trim();
        if (value === "") return;
        pdf
          .setFontSize(options.size || 10.5)
          .setFont(undefined, options.style || "normal");
        pdf.setTextColor(...(options.color || INK));
        const lines = pdf.splitTextToSize(value, CONTENT_WIDTH);
        const blockHeight = pdf.getTextDimensions(lines).h;
        ensureSpace(blockHeight + 2);
        pdf.text(MARGIN, y, lines);
        y += blockHeight + (options.gap !== undefined ? options.gap : 3);
      };

      const entryHeading = (left, right) => {
        ensureSpace(9);
        pdf.setFontSize(11).setFont(undefined, "bold");
        pdf.setTextColor(...INK);
        pdf.text(MARGIN, y, left || "");
        if (right) {
          pdf.setFont(undefined, "normal");
          pdf.setTextColor(...MUTED);
          pdf.text(PAGE_WIDTH - MARGIN, y, right, { align: "right" });
        }
        y += 5.5;
      };

      // Header band
      pdf.setFillColor(241, 246, 249);
      pdf.rect(0, 0, PAGE_WIDTH, 44, "F");

      try {
        const img = document.querySelector("#user_photo");
        if (img) {
          pdf.addImage(img, "PNG", MARGIN, 7, 30, 30);
        }
      } catch (e) {
        // No usable photo — header renders without one.
      }

      pdf.setTextColor(...ACCENT);
      pdf.setFontSize(22).setFont(undefined, "bold");
      pdf.text(MARGIN + 38, 20, this.selectedUserData.name || "", {
        maxWidth: 115,
      });

      pdf.setFontSize(11).setFont(undefined, "normal");
      pdf.setTextColor(...MUTED);
      const headerMeta = [
        this.selectedUserData.dob
          ? `Born ${this.formatDateForHuman(this.selectedUserData.dob)}`
          : null,
        this.selectedUserData.position || null,
      ]
        .filter(Boolean)
        .join("   |   ");
      if (headerMeta !== "") {
        pdf.text(MARGIN + 38, 29, headerMeta);
      }

      y = 54;

      const profileText =
        this.playerCvData.personal_profile ||
        this.selectedUserData.personal_profile ||
        "";
      if (profileText.trim() !== "") {
        sectionTitle("Personal profile");
        bodyText(profileText);
      }

      if (this.sortedPlayingExperence.length > 0) {
        sectionTitle("Playing experience");
        this.sortedPlayingExperence.forEach((item) => {
          entryHeading(
            item.club,
            this.formatCvDateRange(
              item.start_date_at_club,
              item.end_date_at_club,
            ),
          );
          bodyText(item.playing_info, { color: MUTED, gap: 5 });
        });
      }

      if (this.playerCvData.education.length > 0) {
        sectionTitle("Education");
        this.playerCvData.education.forEach((item) => {
          entryHeading(
            item.title,
            this.formatCvDateRange(item.start_date, item.end_date),
          );
          bodyText(item.more_info, { color: MUTED, gap: 5 });
        });
      }

      if (this.playerCvData.interests_hobbies.length > 0) {
        sectionTitle("Interests & hobbies");
        this.playerCvData.interests_hobbies.forEach((item) => {
          entryHeading(item.interests);
          bodyText(item.more_info, { color: MUTED, gap: 5 });
        });
      }

      if (this.cvVideos.length > 0) {
        sectionTitle("Videos");
        this.cvVideos.forEach((item) => {
          ensureSpace(8);
          pdf.setFontSize(11).setFont(undefined, "normal");
          pdf.setTextColor(...ACCENT);
          pdf.textWithLink(item.video_name, MARGIN, y, {
            url: item.video_url,
          });
          y += 7;
        });
      }

      // Footer on every page
      const pageCount = pdf.getNumberOfPages();
      for (let page = 1; page <= pageCount; page++) {
        pdf.setPage(page);
        pdf.setFontSize(8.5).setFont(undefined, "normal");
        pdf.setTextColor(...MUTED);
        pdf.text(
          MARGIN,
          291,
          `${this.selectedUserData.name || "Player"} — Player CV`,
        );
        pdf.text(PAGE_WIDTH - MARGIN, 291, `Page ${page} of ${pageCount}`, {
          align: "right",
        });
      }

      this.cvPdfInstance = pdf;
      return { pdfData: pdf, previewLink: previewContainer };
    },
    buildTheAcademyReportPDF() {
      let previewContainer = document.getElementById(
        "theAcademyReportPdf_preview",
      );
      //let shirtImage = document.getElementById("small_shirt");
      // load player image //
      let img = document.querySelector("#user_photo");
      let pdf = new JsPDF("p", "mm", "a4");

      pdf.setFillColor(241, 246, 249);
      pdf.rect(0, 0, 300, 120, "F");

      pdf.setTextColor(3, 86, 158);
      pdf.addImage(img, "PNG", 1, 0, "40", "40");

      pdf.setFontSize(23).setFont(undefined, "bold");
      pdf.text(45, 18, this.selectedUserData.name, { maxWidth: 70 });

      pdf.setFontSize(16);
      pdf.text(5, 55, "Season: Aug 2022 - May 2023");

      pdf.setFontSize(14).setFont(undefined, "normal");
      pdf.text(5, 65, "Appearances:");
      pdf.text(75, 65, `${this.gamePerformanceData.gamesPlayed}`);

      pdf.text(5, 75, "Goals:");
      pdf.text(75, 75, `${this.gamePerformanceData.goals}`);

      pdf.text(5, 85, "Assists:");
      pdf.text(75, 85, `${this.gamePerformanceData.assists}`);

      pdf.text(5, 95, "Player performace rating:");
      let playerSelfRating;
      this.gamePerformanceData.player_self_rating === null
        ? (playerSelfRating = "Not Rated")
        : (playerSelfRating = this.gamePerformanceData.player_self_rating);
      pdf.text(75, 95, `${playerSelfRating}`);

      pdf.text(5, 105, "Game time:");
      let timeOnPitch;
      this.gamePerformanceData.timeOnPitch === null
        ? (timeOnPitch = 0)
        : (timeOnPitch = this.gamePerformanceData.timeOnPitch);
      pdf.text(75, 105, `${timeOnPitch} mins`);

      pdf
        .text(
          125,
          10,
          `Dob: ${this.formatDateForHuman(this.selectedUserData.dob)}`,
        )
        .setFont(undefined, "normal");
      pdf
        .text(125, 20, `Position: ${this.selectedUserData.position}`)
        .setFont(undefined, "normal");
      pdf
        .text(
          125,
          30,
          `Height: ${this.playerPhysicalPerformanceData.height} cm`,
        )
        .setFont(undefined, "normal");
      pdf
        .text(
          125,
          40,
          `Weight:  ${this.playerPhysicalPerformanceData.weight} kg`,
        )
        .setFont(undefined, "normal");
      pdf
        .text(125, 50, `Age: ${this.selectedUserData.age_group}`)
        .setFont(undefined, "normal");
      pdf
        .text(
          125,
          60,
          `Signed: ${this.formatDateForHuman(
            this.selectedUserData.joined_date,
          )}`,
        )
        .setFont(undefined, "normal");

      let pitchBackground = document.getElementById("pitch_potions");
      pdf.addImage(pitchBackground, "PNG", 120, 90, 80, 120);

      let height = this.addPlayingPostions(pdf, 85);

      pdf.setFontSize(14).setFont(undefined, "bold");
      pdf.text(125, height, "PLAYING POSITIONS");

      pdf.text(125, height + 135, "PHYSICAL PERFORMANCE");

      pdf.setFontSize(12).setFont(undefined, "normal");
      pdf.text(125, height + 143, "10m SPRINT");
      const tenMsprintTime =
        this.playerPhysicalPerformanceData.tenM_sprint_time;
      if (tenMsprintTime !== undefined) {
        pdf.text(183, height + 143, tenMsprintTime);
      }

      pdf.text(125, height + 153, "30m SPRINT");
      const fortyMSprintTime =
        this.playerPhysicalPerformanceData.fortyM_sprint_time;
      if (fortyMSprintTime !== undefined) {
        pdf.text(183, height + 153, `${fortyMSprintTime}s`);
      }

      pdf.text(125, height + 163, "Countermovement jump");
      const cuntermovementJump =
        this.playerPhysicalPerformanceData.cuntermovement_jump;
      if (cuntermovementJump !== undefined) {
        pdf.text(183, height + 163, `${cuntermovementJump}cm`);
      }

      pdf.text(125, height + 173, "Reactive strength index");
      const reactiveStrengthindex =
        this.playerPhysicalPerformanceData.reactive_strength_index;
      if (reactiveStrengthindex !== undefined) {
        pdf.text(183, height + 173, `${reactiveStrengthindex}`);
      }

      pdf.text(125, height + 183, "Fitness Test Time");
      const thirty15IntermittentFitnessTest =
        this.playerPhysicalPerformanceData.reactive_strength_index;
      if (thirty15IntermittentFitnessTest !== undefined) {
        pdf.text(183, height + 183, `${thirty15IntermittentFitnessTest}`);
      }
      pdf.setFontSize(16).setFont(undefined, "bold");
      pdf.text(5, 130, "COACHES COMMENTS");

      pdf.setFontSize(12).setFont(undefined, "normal");

      //let playerPerformanceReview = this.getTheLastPlayerPerformanceReview();
      let paraOneLines = "Please add comments";

      var paraOne = this.academyReport.coaches_comments;
      paraOneLines = pdf.splitTextToSize(paraOne, 112);

      pdf.text(5, 139, paraOneLines);
      let dynamicHeight = pdf.getTextDimensions(paraOneLines);

      pdf.setFontSize(16).setFont(undefined, "bold");
      pdf.text(5, dynamicHeight.h + 150, "Playing videos");
      dynamicHeight.h = this.addPlayerVideos(pdf, dynamicHeight.h + 160);

      return { pdfData: pdf, previewLink: previewContainer };
    },
    async produceThePlayerCoachReportPDF(review) {
      this.playerCoachSignedPerformanceReportData = review;
      await this.getPlayerCoachSignedPerformanceSignatures(review.id);

      // Preload signature images for PDF by painting them through a canvas.
      // Using HTMLImageElement (not fetch) avoids service-worker/SPA-shell
      // fallbacks that return HTML, and canvas normalises the output to PNG
      // regardless of the source format so jsPDF can always render it.
      const sigFields = [
        "playerReportSignature",
        "parentReportSignature",
        "coachSignature",
      ];
      const loadedSignatures = {};
      const loadSignature = (field) => {
        const url = this.playerCoachSignedPerformanceReportData[field];
        if (!url) return Promise.resolve();
        return new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          let settled = false;
          const finish = (err) => {
            if (settled) return;
            settled = true;
            if (err) {
              console.warn(
                `[PerformanceReviewPDF] failed to load ${field}:`,
                err,
              );
            }
            resolve();
          };
          const timer = setTimeout(() => finish(new Error("timeout")), 8000);
          img.onload = () => {
            clearTimeout(timer);
            try {
              if (!img.naturalWidth || !img.naturalHeight) {
                return finish(new Error("empty image"));
              }
              const canvas = document.createElement("canvas");
              canvas.width = img.naturalWidth;
              canvas.height = img.naturalHeight;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);
              loadedSignatures[field] = {
                dataUrl: canvas.toDataURL("image/png"),
                width: img.naturalWidth,
                height: img.naturalHeight,
              };
              finish();
            } catch (e) {
              finish(e);
            }
          };
          img.onerror = () => {
            clearTimeout(timer);
            finish(new Error("image load error"));
          };
          // Cache-buster so a bad SW cache entry can't keep serving HTML.
          img.src = `/images/${url}?t=${Date.now()}`;
        });
      };
      await Promise.all(sigFields.map(loadSignature));
      this._loadedSignatures = loadedSignatures;

      this.showModal("viewPlayerCoachReviewPDF");
      this.$nextTick(() => {
        let pdf = this.buildThePlayerCoachReportPDF();
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.showPlayerCoachReportPDFReport = true;
      });
    },
    produceThePlayerCV() {
      this.showModal("viewPlayersCV");
      setTimeout(() => {
        let pdf = this.buildThePlayerCVPDF();
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.showCVReport = true;
      }, 500);
    },
    async printPlayerCoachAssementPDF() {
      // Ensure physical performance data is loaded before generating PDF
      await this.loadPlayerPhysicalPerformanceData();

      setTimeout(() => {
        let pdf = this.buildTheAcademyReportPDF();
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.showReport = true;
      }, 500);
    },
    async produceTheAcademyReport() {
      this.showReport = true;
      this.academyReport.player_id = this.selectedUserValue;
      this.academyReport.seasion = "2023";

      console.log(
        "produceTheAcademyReport - selectedUserValue:",
        this.selectedUserValue,
      );

      // Wait for physical performance data to load before generating PDF
      await this.loadPlayerPhysicalPerformanceData();

      console.log(
        "produceTheAcademyReport - after load, playerPhysicalPerformanceData:",
        this.playerPhysicalPerformanceData,
      );

      setTimeout(() => {
        let pdf = this.buildTheAcademyReportPDF();
        pdf.previewLink.src = pdf.pdfData.output("datauristring");
        this.showReport = true;
      }, 500);
    },
    performanceTargetsModal(data, modelName, typeOfTarget) {
      this.selectedPerformanceTarget = data;
      this.selectedPerformanceTarget.typeOfTarget = typeOfTarget;
      this.showModal(modelName);
    },
    addVideo(category) {
      if (!category || typeof category !== "string") {
        console.error("Invalid category provided.");
        return;
      }

      const videoData = {
        id: null,
        player_id: this.selectedUserValue || null,
        video_name: "New Video",
        category: category.trim(),
        document_id: this.newHomeWorkData.id,
        video_url: "",
      };

      this.newHomeWorkData.videos = [...this.newHomeWorkData.videos, videoData];
    },
    removeVideo(index) {
      this.newHomeWorkData.videos = this.newHomeWorkData.videos.filter(
        (_, i) => i !== index,
      );
    },
    addItem(targetText) {
      const playerPerformanceTarget = {
        player_id: this.selectedUserValue,
        performance_report_id: 0,
        idp_id: 0,
        target: targetText,
        complete: 0,
        category: "Attitude",
        created_date: moment().format("YYYY-MM-DD"),
      };
      this.playerPerformanceTargets = [
        ...this.playerPerformanceTargets,
        playerPerformanceTarget,
      ];
    },
    removeItem(index) {
      this.playerPerformanceTargets = this.playerPerformanceTargets.filter(
        (_, i) => i !== index,
      );
    },
    openPhysicalPerformanceHistoryModal() {
      this.showModal("physicalPerformanceHistoryModal");
    },
    checkIfNewValueisBetterOrWorse() {
      if (this.allPlayerPhysicalPerformanceData.length < 2) {
        return false;
      }
      const lastIndex = this.allPlayerPhysicalPerformanceData.length - 1;
      const lastItem = this.allPlayerPhysicalPerformanceData[lastIndex];
      const secondLastItem =
        this.allPlayerPhysicalPerformanceData[lastIndex - 1];

      const updatedLastItem = { ...lastItem };

      if (lastItem.tenM_sprint_time > secondLastItem.tenM_sprint_time) {
        updatedLastItem.tenM_sprint_time_icon = "worse";
      }
      if (lastItem.tenM_sprint_time < secondLastItem.tenM_sprint_time) {
        updatedLastItem.tenM_sprint_time_icon = "better";
      }
      if (lastItem.tenM_sprint_time === secondLastItem.tenM_sprint_time) {
        updatedLastItem.tenM_sprint_time_icon = "same";
      }

      if (lastItem.tenM_sprint_time_1 > secondLastItem.tenM_sprint_time_1) {
        updatedLastItem.tenM_sprint_time_icon_1 = "worse";
      }
      if (lastItem.tenM_sprint_time_1 < secondLastItem.tenM_sprint_time_1) {
        updatedLastItem.tenM_sprint_time_icon_1 = "better";
      }
      if (lastItem.tenM_sprint_time_1 === secondLastItem.tenM_sprint_time_1) {
        updatedLastItem.tenM_sprint_time_icon_1 = "same";
      }

      if (lastItem.fortyM_sprint_time > secondLastItem.fortyM_sprint_time) {
        updatedLastItem.fortyM_sprint_time_icon = "worse";
      }
      if (lastItem.fortyM_sprint_time < secondLastItem.fortyM_sprint_time) {
        updatedLastItem.fortyM_sprint_time_icon = "better";
      }
      if (lastItem.fortyM_sprint_time === secondLastItem.fortyM_sprint_time) {
        updatedLastItem.fortyM_sprint_time_icon = "same";
      }

      if (lastItem.fortyM_sprint_time_1 > secondLastItem.fortyM_sprint_time_1) {
        updatedLastItem.fortyM_sprint_time_icon_1 = "worse";
      }
      if (lastItem.fortyM_sprint_time_1 < secondLastItem.fortyM_sprint_time_1) {
        updatedLastItem.fortyM_sprint_time_icon_1 = "better";
      }
      if (
        lastItem.fortyM_sprint_time_1 === secondLastItem.fortyM_sprint_time_1
      ) {
        updatedLastItem.fortyM_sprint_time_icon_1 = "same";
      }

      if (lastItem.cuntermovement_jump > secondLastItem.cuntermovement_jump) {
        updatedLastItem.cuntermovement_jump_icon = "better";
      }
      if (lastItem.cuntermovement_jump < secondLastItem.cuntermovement_jump) {
        updatedLastItem.cuntermovement_jump_icon = "worse";
      }
      if (lastItem.cuntermovement_jump === secondLastItem.cuntermovement_jump) {
        updatedLastItem.cuntermovement_jump_icon = "same";
      }

      if (
        lastItem.cuntermovement_jump_2 > secondLastItem.cuntermovement_jump_2
      ) {
        updatedLastItem.cuntermovement_jump_icon_2 = "better";
      }
      if (
        lastItem.cuntermovement_jump_2 < secondLastItem.cuntermovement_jump_2
      ) {
        updatedLastItem.cuntermovement_jump_icon_2 = "worse";
      }
      if (
        lastItem.cuntermovement_jump_2 === secondLastItem.cuntermovement_jump_2
      ) {
        updatedLastItem.cuntermovement_jump_icon_2 = "same";
      }

      if (
        lastItem.reactive_strength_index >
        secondLastItem.reactive_strength_index
      ) {
        updatedLastItem.reactive_strength_index_icon = "better";
      }
      if (
        lastItem.reactive_strength_index <
        secondLastItem.reactive_strength_index
      ) {
        updatedLastItem.reactive_strength_index_icon = "worse";
      }
      if (
        lastItem.reactive_strength_index ===
        secondLastItem.reactive_strength_index
      ) {
        updatedLastItem.reactive_strength_index_icon = "same";
      }

      if (
        lastItem.reactive_strength_index_2 >
        secondLastItem.reactive_strength_index_2
      ) {
        updatedLastItem.reactive_strength_index_icon = "better";
      }
      if (
        lastItem.reactive_strength_index_2 <
        secondLastItem.reactive_strength_index_2
      ) {
        updatedLastItem.reactive_strength_index_icon_2 = "worse";
      }
      if (
        lastItem.reactive_strength_index_2 ===
        secondLastItem.reactive_strength_index_2
      ) {
        updatedLastItem.reactive_strength_index_icon_2 = "same";
      }

      if (
        lastItem.reactive_strength_index_3 >
        secondLastItem.reactive_strength_index_3
      ) {
        updatedLastItem.reactive_strength_index_icon_3 = "better";
      }
      if (
        lastItem.reactive_strength_index_3 <
        secondLastItem.reactive_strength_index_3
      ) {
        updatedLastItem.reactive_strength_index_icon_3 = "worse";
      }
      if (
        lastItem.reactive_strength_index_3 ===
        secondLastItem.reactive_strength_index_3
      ) {
        updatedLastItem.reactive_strength_index_icon_3 = "same";
      }

      if (
        lastItem.reactive_strength_index_4 >
        secondLastItem.reactive_strength_index_4
      ) {
        updatedLastItem.reactive_strength_index_icon_4 = "better";
      }
      if (
        lastItem.reactive_strength_index_4 <
        secondLastItem.reactive_strength_index_4
      ) {
        updatedLastItem.reactive_strength_index_icon_4 = "worse";
      }
      if (
        lastItem.reactive_strength_index_4 ===
        secondLastItem.reactive_strength_index_4
      ) {
        updatedLastItem.reactive_strength_index_icon_4 = "same";
      }

      if (
        lastItem.reactive_strength_index_5 >
        secondLastItem.reactive_strength_index_5
      ) {
        updatedLastItem.reactive_strength_index_icon_5 = "better";
      }
      if (
        lastItem.reactive_strength_index_5 <
        secondLastItem.reactive_strength_index_5
      ) {
        updatedLastItem.reactive_strength_index_icon_5 = "worse";
      }
      if (
        lastItem.reactive_strength_index_5 ===
        secondLastItem.reactive_strength_index_5
      ) {
        updatedLastItem.reactive_strength_index_icon_5 = "same";
      }

      if (
        lastItem.reactive_strength_index_average >
        secondLastItem.reactive_strength_index_average
      ) {
        updatedLastItem.reactive_strength_index_average_icon = "better";
      }
      if (
        lastItem.reactive_strength_index_average <
        secondLastItem.reactive_strength_index_average
      ) {
        updatedLastItem.reactive_strength_index_average_icon = "worse";
      }
      if (
        lastItem.reactive_strength_index_average ===
        secondLastItem.reactive_strength_index_average
      ) {
        updatedLastItem.reactive_strength_index_average_icon = "same";
      }

      if (
        lastItem.thirty_15_intermittent_fitness_test >
        secondLastItem.thirty_15_intermittent_fitness_test
      ) {
        updatedLastItem.thirty_15_intermittent_fitness_test_icon = "worse";
      }
      if (
        lastItem.thirty_15_intermittent_fitness_test <
        secondLastItem.thirty_15_intermittent_fitness_test
      ) {
        updatedLastItem.thirty_15_intermittent_fitness_test_icon = "better";
      }
      if (
        lastItem.thirty_15_intermittent_fitness_test ===
        secondLastItem.thirty_15_intermittent_fitness_test
      ) {
        updatedLastItem.thirty_15_intermittent_fitness_test_icon = "same";
      }

      if (lastItem.weight > secondLastItem.weight) {
        updatedLastItem.weight_icon = "better";
      }
      if (lastItem.weight < secondLastItem.weight) {
        updatedLastItem.weight_icon = "worse";
      }
      if (lastItem.weight === secondLastItem.weight) {
        updatedLastItem.weight_icon = "same";
      }

      if (lastItem.height > secondLastItem.height) {
        updatedLastItem.height_icon = "better";
      }
      if (lastItem.height < secondLastItem.height) {
        updatedLastItem.height_icon = "worse";
      }
      if (lastItem.height === secondLastItem.height) {
        updatedLastItem.height_icon = "same";
      }

      if (lastItem.sitting_height > secondLastItem.sitting_height) {
        updatedLastItem.height_icon_sitting = "better";
      }
      if (lastItem.sitting_height < secondLastItem.sitting_height) {
        updatedLastItem.height_icon_sitting = "worse";
      }
      if (lastItem.sitting_height === secondLastItem.sitting_height) {
        updatedLastItem.height_icon_sitting = "same";
      }

      if (lastItem.bronco_time_mins > secondLastItem.bronco_time_mins) {
        updatedLastItem.bronco_time_mins_icon = "better";
      }
      if (lastItem.bronco_time_mins < secondLastItem.bronco_time_mins) {
        updatedLastItem.bronco_time_mins_icon = "worse";
      }
      if (lastItem.bronco_time_mins === secondLastItem.bronco_time_mins) {
        updatedLastItem.bronco_time_mins_icon = "same";
      }

      if (lastItem.bronco_time_sec > secondLastItem.bronco_time_sec) {
        updatedLastItem.bronco_time_sec_icon = "better";
      }
      if (lastItem.bronco_time_sec < secondLastItem.bronco_time_sec) {
        updatedLastItem.bronco_time_sec_icon = "worse";
      }
      if (lastItem.bronco_time_sec === secondLastItem.bronco_time_sec) {
        updatedLastItem.bronco_time_sec_icon = "same";
      }

      this.allPlayerPhysicalPerformanceData = [
        ...this.allPlayerPhysicalPerformanceData.slice(0, lastIndex),
        updatedLastItem,
      ];
    },
    async addPhysicalPerformanceValue() {
      this.playerPhysicalPerformanceData.date = moment().format("YYYY-MM-DD");
      const userData = {
        date: this.playerPhysicalPerformanceData.date,
        player_id: this.selectedUserValue,
        tenM_sprint_time:
          this.playerPhysicalPerformanceData.tenM_sprint_time || 0,
        tenM_sprint_time_1:
          this.playerPhysicalPerformanceData.tenM_sprint_time_1 || 0,
        fortyM_sprint_time:
          this.playerPhysicalPerformanceData.fortyM_sprint_time || 0,
        fortyM_sprint_time_1:
          this.playerPhysicalPerformanceData.fortyM_sprint_time_1 || 0,
        cuntermovement_jump:
          this.playerPhysicalPerformanceData.cuntermovement_jump || 0,
        cuntermovement_jump_2:
          this.playerPhysicalPerformanceData.cuntermovement_jump_2 || 0,
        cuntermovement_jump_3:
          this.playerPhysicalPerformanceData.cuntermovement_jump_3 || 0,
        reactive_strength_index:
          this.playerPhysicalPerformanceData.reactive_strength_index || 0,
        reactive_strength_index_2:
          this.playerPhysicalPerformanceData.reactive_strength_index_2 || 0,
        reactive_strength_index_3:
          this.playerPhysicalPerformanceData.reactive_strength_index_3 || 0,
        reactive_strength_index_4:
          this.playerPhysicalPerformanceData.reactive_strength_index_4 || 0,
        reactive_strength_index_5:
          this.playerPhysicalPerformanceData.reactive_strength_index_5 || 0,
        reactive_strength_index_average:
          this.playerPhysicalPerformanceData.reactive_strength_index_average ||
          0,
        thirty_15_intermittent_fitness_test:
          this.playerPhysicalPerformanceData
            .thirty_15_intermittent_fitness_test || 0,
        weight: this.playerPhysicalPerformanceData.weight || 0,
        height: this.playerPhysicalPerformanceData.height || 0,
        sitting_height: this.playerPhysicalPerformanceData.sitting_height || 0,
        bronco_time_mins:
          this.playerPhysicalPerformanceData.bronco_time_mins || 0,
        bronco_time_sec:
          this.playerPhysicalPerformanceData.bronco_time_sec || 0,
        action: "addPlayerPhysicalPerformanceData",
      };

      const responce = await PlayerPhysicalPerformance.find(userData).catch(
        (error) => {
          console.log(error);
        },
      );

      if (responce.data === "New player physical performance results added.") {
        await this.checkIfNewValueisBetterOrWorse();
        this.loadPlayerPhysicalPerformanceData();
        this.hideModal("addNewPhysicalPerformanceTimeModal");

        this.$toast.info("Player Physical Performance saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    addNewPhysicalPerformanceTimeModal() {
      this.showModal("addNewPhysicalPerformanceTimeModal");
    },
    async saveSignatureWithDocumentId(signatureName, id) {
      signatureName =
        this.playerCoachSignedPerformanceReportData[signatureName] ||
        signatureName;

      if (!this.$refs[signatureName]) {
        console.error(`Signature ref "${signatureName}" not found`);
        return;
      }

      const jpeg = this.$refs[signatureName].save("image/jpeg");

      const userData = {
        fileName: signatureName,
        imageFile: jpeg,
        document_id: id,
        action: "saveSignatureWithDocumentId",
        created_date: moment().format("YYYY-MM-DD"),
        type: signatureName,
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.getPlayerCoachSignedPerformanceSignatures(id);
        this.getPlayerCoachSignedPerformanceReport();
        this.$toast.info("Signature saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    // Detect whether a stored signature value is a drawn image (filename) or a
    // typed name, so each renders correctly. Prefers the explicit *_type
    // column, falls back to sniffing the value for legacy rows.
    isDrawnSignature(value, type) {
      if (!value) return false;
      if (type) return type === "drawn";
      return /\.(jpe?g|png|gif|webp|svg)$/i.test(value);
    },
    // Load a signature image URL into a data URL for jsPDF. Fetches the raw
    // bytes directly (same-origin) rather than drawing to a canvas — this
    // avoids the crossOrigin/tainted-canvas trap where an image already cached
    // by the on-screen <img> (no CORS headers) can't be re-read via canvas.
    // Resolves null if the image can't be loaded, so the PDF falls back to a
    // text placeholder instead of silently omitting the signature.
    async loadImageAsDataUrl(url) {
      if (!url) return null;
      try {
        const res = await fetch(url);
        if (!res.ok) return null;
        const blob = await res.blob();
        const dataUrl = await new Promise((resolve) => {
          const fr = new FileReader();
          fr.onload = () => resolve(fr.result);
          fr.onerror = () => resolve(null);
          fr.readAsDataURL(blob);
        });
        if (!dataUrl) return null;
        // Measure via an Image built from the (same-origin, un-taintable)
        // data URL so we can preserve the signature's aspect ratio.
        const dims = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () =>
            resolve({ w: img.naturalWidth, h: img.naturalHeight });
          img.onerror = () => resolve(null);
          img.src = dataUrl;
        });
        if (!dims || !dims.h) return null;
        return { dataUrl, w: dims.w, h: dims.h };
      } catch (e) {
        return null;
      }
    },
    async saveSignatureCall(image, signatureName) {
      const isParent = signatureName === "parentSignature";

      // The backend now upserts the single per-player charter_signatures row
      // and records the audit trail (who/when/where/consent/charter version),
      // so we just send the drawn image, the signer, and their consent.
      const userData = {
        fileName: signatureName, // 'playerSignature' | 'parentSignature'
        imageFile: image,
        player_id: this.selectedUserData.id,
        action: "saveSignatureCall",
        signature_type: "drawn",
        signed_by: this.getProfile?.id ?? null,
        consent: isParent
          ? this.charterConsent.parent
          : this.charterConsent.player,
        created_date: moment().format("YYYY-MM-DD"),
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce && responce.status === 200) {
        await this.getSignatures();
        this.$toast.info("Signature saved.", {
          title: "saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async getSignatures() {
      const userData = {
        player_id: this.selectedUserData.id,
        action: "getSignatures",
      };

      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200 && typeof responce.data !== "boolean") {
        this.charterSignature = responce.data;
      }
    },
    async saveCharterPDF() {
      const pdf = new JsPDF("p", "mm", "a4");
      const pageWidth = 210;
      const margin = 15;
      const contentWidth = pageWidth - margin * 2;
      const primaryColor = [0, 85, 150];
      const textColor = [51, 51, 51];
      const playerName = this.selectedUserData.name || "Player";

      // Header
      pdf.setFillColor(...primaryColor);
      pdf.rect(0, 0, pageWidth, 30, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(18).setFont(undefined, "bold");
      pdf.text("Charter Agreement", pageWidth / 2, 13, { align: "center" });
      pdf.setFontSize(11).setFont(undefined, "normal");
      pdf.text(playerName, pageWidth / 2, 22, { align: "center" });

      let y = 40;

      // Helper to render HTML text content as plain text lines
      const renderHtmlText = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return (div.textContent || div.innerText || "").trim();
      };

      const addWrappedText = (text, x, startY, maxWidth, lineHeight) => {
        pdf.setFontSize(10).setFont(undefined, "normal");
        const lines = pdf.splitTextToSize(text, maxWidth);
        let currentY = startY;
        for (const line of lines) {
          if (currentY > 270) {
            pdf.addPage();
            currentY = 20;
          }
          pdf.text(line, x, currentY);
          currentY += lineHeight;
        }
        return currentY;
      };

      // Render one signature (player or parent) into the PDF, handling drawn
      // images (loaded by URL, not the DOM), typed names (rendered as text),
      // and the unsigned state — plus the audit date underneath.
      const renderSignatureBlock = async (
        value,
        type,
        changeFlag,
        signedAt,
        startY,
      ) => {
        let currentY = startY;
        const notSigned = !value || changeFlag === true;

        if (notSigned) {
          pdf.setFontSize(9).setFont(undefined, "italic");
          pdf.setTextColor(150, 150, 150);
          pdf.text("Not yet signed", margin, currentY);
          return currentY + 8;
        }

        if (this.isDrawnSignature(value, type)) {
          const loaded = await this.loadImageAsDataUrl(this.getImgUrl(value));
          if (loaded && loaded.h > 0) {
            const sigW = Math.min(80, contentWidth);
            const sigH = sigW * (loaded.h / loaded.w);
            if (currentY + sigH > 270) {
              pdf.addPage();
              currentY = 20;
            }
            const fmt = /^data:image\/png/i.test(loaded.dataUrl)
              ? "PNG"
              : "JPEG";
            pdf.addImage(loaded.dataUrl, fmt, margin, currentY, sigW, sigH);
            currentY += sigH + 4;
          } else {
            pdf.setFontSize(9).setFont(undefined, "italic");
            pdf.setTextColor(150, 150, 150);
            pdf.text("Signature on file", margin, currentY);
            currentY += 6;
          }
        } else {
          // Typed signature — render the name in a signature-like face.
          pdf.setFontSize(18).setFont("times", "italic");
          pdf.setTextColor(...textColor);
          pdf.text(String(value), margin, currentY + 6);
          pdf.setFont(undefined, "normal");
          currentY += 12;
        }

        if (signedAt) {
          pdf.setFontSize(8).setFont(undefined, "normal");
          pdf.setTextColor(150, 150, 150);
          pdf.text("Signed: " + signedAt, margin, currentY);
          currentY += 6;
        }
        return currentY;
      };

      // Players Charter section
      pdf.setTextColor(...primaryColor);
      pdf.setFontSize(14).setFont(undefined, "bold");
      pdf.text("Players Charter", margin, y);
      y += 8;

      pdf.setTextColor(...textColor);
      if (this.charterData.player_text) {
        const playerText = renderHtmlText(this.charterData.player_text);
        y = addWrappedText(playerText, margin, y, contentWidth, 5);
      } else {
        pdf.setFontSize(10).setFont(undefined, "italic");
        pdf.text("No Players Charter information.", margin, y);
        y += 8;
      }

      // Player signature
      y += 5;
      if (y > 250) {
        pdf.addPage();
        y = 20;
      }
      pdf.setTextColor(...primaryColor);
      pdf.setFontSize(12).setFont(undefined, "bold");
      pdf.text("Player Signature", margin, y);
      y += 5;

      y = await renderSignatureBlock(
        this.charterSignature.player_signature,
        this.charterSignature.player_signature_type,
        this.charterSignature.player_signature_change,
        this.charterSignature.player_signed_at,
        y,
      );

      // Parents Charter section
      y += 10;
      if (y > 230) {
        pdf.addPage();
        y = 20;
      }
      pdf.setTextColor(...primaryColor);
      pdf.setFontSize(14).setFont(undefined, "bold");
      pdf.text("Parents Charter", margin, y);
      y += 8;

      pdf.setTextColor(...textColor);
      if (this.charterData.parent_text) {
        const parentText = renderHtmlText(this.charterData.parent_text);
        y = addWrappedText(parentText, margin, y, contentWidth, 5);
      } else {
        pdf.setFontSize(10).setFont(undefined, "italic");
        pdf.text("No Parents Charter information.", margin, y);
        y += 8;
      }

      // Parent signature
      y += 5;
      if (y > 250) {
        pdf.addPage();
        y = 20;
      }
      pdf.setTextColor(...primaryColor);
      pdf.setFontSize(12).setFont(undefined, "bold");
      pdf.text("Parent Signature", margin, y);
      y += 5;

      y = await renderSignatureBlock(
        this.charterSignature.parent_signature,
        this.charterSignature.parent_signature_type,
        this.charterSignature.parent_signature_change,
        this.charterSignature.parent_signed_at,
        y,
      );

      // Footer with date
      y += 10;
      if (y > 270) {
        pdf.addPage();
        y = 20;
      }
      pdf.setDrawColor(200, 200, 200);
      pdf.line(margin, y, pageWidth - margin, y);
      y += 6;
      pdf.setFontSize(8).setFont(undefined, "normal");
      pdf.setTextColor(150, 150, 150);
      pdf.text(`Generated: ${moment().format("DD/MM/YYYY")}`, margin, y);

      // Upload to server as a player document
      const fileName = `Charter_${playerName.replace(/\s+/g, "_")}.pdf`;
      const pdfBlob = pdf.output("blob");
      const pdfFile = new File([pdfBlob], fileName, {
        type: "application/pdf",
      });

      const API_SERVER =
        window.location.href.indexOf("8080") > -1
          ? "http://www.localhost:8888/upload-document.php"
          : "/personal-training-BE/upload-document.php";

      const formData = new FormData();
      formData.append("pdf", pdfFile);
      formData.append("documentCategory", "charter");
      formData.append("user_id", this.selectedUserData.id);
      formData.append("club_id", this.userData.clubId);
      formData.append(
        "selectedDocumentData",
        JSON.stringify({
          category: "charter",
          teams: [],
          users: [{ id: this.selectedUserData.id }],
        }),
      );

      try {
        const response = await Axios.post(API_SERVER, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data && response.data.success === false) {
          throw new Error(response.data.error || "Upload rejected.");
        }

        await this.getDocumentUploadsByUserId();
        this.$toast.info("Charter PDF saved to documents.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      } catch (error) {
        console.error("Error saving charter PDF:", error);
        const serverError = error?.response?.data?.error || error?.message;
        this.$toast.error(
          serverError
            ? `Failed to save charter PDF: ${serverError}`
            : "Failed to save charter PDF.",
          {
            title: "Error",
            solid: true,
          },
        );
      }
    },
    changeSignature(signatureName, id) {
      id !== undefined
        ? (this.charterSignature[signatureName] = true)
        : (this.coachSignedPerformanceReportSignature[signatureName] = true);
    },
    saveSignature(signatureName) {
      if (!this.$refs[signatureName]) {
        console.error(`Signature ref "${signatureName}" not found`);
        return;
      }

      const jpeg = this.$refs[signatureName].save("image/jpeg");

      this.saveSignatureCall(jpeg, signatureName);
    },
    clearSignature(signatureName) {
      if (!this.$refs[signatureName]) {
        console.error(`Signature ref "${signatureName}" not found`);
        return;
      }

      this.$refs[signatureName].clear();
    },
    openAllPlayerSelfAssessmentModal() {
      this.getAllPlayerAssesments();
      this.showPlayerAssesmentModalView = true;
    },
    openAllTrainingReportsModal(type) {
      if (type === "allTrainingReportsModal") {
        this.showAllTrainingReportsModal = true;
      } else {
        this.showModal(type);
      }
    },
    getPlayerPhysicalPerformanceData() {
      return this.allPlayerPhysicalPerformanceData.reduce((a, b) => {
        return new Date(a.date) > new Date(b.date) ? a : b;
      });
    },
    getSelectedPerformanceReportTargets(reportId) {
      if (this.playerPerformanceReviewTargetsData.length === 0) {
        return this.playerPerformanceReviewTargetsData;
      }

      return this.playerPerformanceReviewTargetsData.filter(
        (element) => element.performance_report_id == reportId,
      );
    },
    getPlayersCurrentPerformanceTargetsForCategory(categoryName) {
      if (this.playerPerformanceReviewTargetsData.length === 0) {
        return this.playerPerformanceReviewTargetsData;
      }

      const currentReport =
        this.allplayerPerformanceReportData[
          this.allplayerPerformanceReportData.length - 1
        ];

      return this.playerPerformanceReviewTargetsData.filter(
        (element) =>
          element.performance_report_id == currentReport.id &&
          element.category === categoryName,
      );
    },
    getPlayersCurrentPerformanceTargets() {
      if (this.playerPerformanceReviewTargetsData.length === 0) {
        return this.playerPerformanceReviewTargetsData;
      }

      const currentReport =
        this.allplayerPerformanceReportData[
          this.allplayerPerformanceReportData.length - 1
        ];
      return this.playerPerformanceReviewTargetsData.filter(
        (element) => element.performance_report_id == currentReport.id,
      );
    },
    setPlayerPerformanceReviewData(reviewId) {
      return this.allplayerPerformanceReportData.filter(
        (review) => review.id == reviewId,
      );
    },
    openPlayerPerformanceReview(reviewId) {
      const review = this.setPlayerPerformanceReviewData(reviewId);
      this.playerPerformanceReportData = review[0];
      this.playerPerformanceReportData.attitude = Number(
        this.playerPerformanceReportData.attitude,
      );
      this.playerPerformanceReportData.leadership = Number(
        this.playerPerformanceReportData.leadership,
      );
      this.playerPerformanceReportData.mentality = Number(
        this.playerPerformanceReportData.mentality,
      );
      this.playerPerformanceReportData.physique = Number(
        this.playerPerformanceReportData.physique,
      );
      this.playerPerformanceReportData.professionalism = Number(
        this.playerPerformanceReportData.professionalism,
      );
      this.playerPerformanceReportData.skill = Number(
        this.playerPerformanceReportData.skill,
      );

      this.showModal("playerPerformanceReportVewDetailsModal");
    },
    formatDateForHuman(date) {
      return date !== undefined && moment(date).isValid()
        ? moment(date).format("MMMM Do YYYY")
        : "";
    },
    checkSignedDate(date) {
      return date === null || date === undefined || date === "" ? false : true;
    },
    converBoolean(boolean) {
      return boolean === "0" ? "No" : "Yes";
    },
    getImgUrl(pic) {
      return pic !== undefined && pic !== "" ? `/images/${pic}` : "";
    },
    resetAllPlayerData() {
      this.resetGamePerformanceData();
      this.resetcoachGamePerformanceData();
      this.resetplayerTrainingData();
      this.resetPlayersMoodData();
      this.showLastSeasonView = false;
    },
    resetPlayersMoodData() {
      this.playerMoodData = {};
      this.wellnessQuestions = {
        sleep: 0,
        stress: 0,
        happyness: 0,
        fatigue: 0,
        muscleSoreness: 0,
      };
    },
    resetplayerTrainingData() {
      this.trainingPerformanceData = {};
      this.newTrainingPerformanceData = {};
    },
    resetcoachGamePerformanceData() {
      this.coachGamePerformanceData = [];
      this.coachGamePerformanceReportData = {};
    },
    resetGamePerformanceData() {
      this.gamePerformanceData = {
        gameId: null,
        postion_played: [],
        goals: 0,
        assists: 0,
        clean_sheet: null,
        player_self_rating: null,
        yellowCardTotal: 0,
        redCardTotal: 0,
        timeOnPitch: null,
        gamesPlayed: null,
        gameName: null,
      };
    },
    download_csv(data, sensor) {
      if (!data || data.length === 0) {
        console.warn("No data to download");
        return;
      }

      this.$nextTick(() => {
        const doc = window.document || document;
        if (
          typeof doc === "undefined" ||
          typeof doc.createElement !== "function"
        ) {
          console.warn("Document createElement not available in this context");
          return;
        }

        let csvHeader = Object.keys(data[0]).join(",") + "\n"; // header row
        let csvBody = data
          .map((row) => Object.values(row).join(","))
          .join("\n");

        const hiddenElement = doc.createElement("a");
        hiddenElement.href =
          "data:text/csv;charset=utf-8," + encodeURI(csvHeader + csvBody);
        hiddenElement.target = "_blank";
        hiddenElement.download = sensor + ".csv";
        hiddenElement.click();
      });
    },
    resetPlayerCoachSignedData() {
      this.playerCoachSignedPerformanceReportData = {
        created_date: null,
        user_id: "",
        coach_id: null,
        technical_player_comments: "",
        technical_coach_comments: "",
        tactical_player_comments: "",
        tactical_coach_comments: "",
        physical_player_comments: "",
        physical_coach_comments: "",
        physcological_player_comments: "",
        physcological_coach_comments: "",
        player_comments: "",
        coach_comments: "",
        player_signature_id: null,
        parent_signature_id: null,
        coach_signature_id: null,
        published: 0,
        status: "Draft",
      };
    },
    async getPlayerCoachSignedPerformanceSignatures(id) {
      const userData = {
        id: id,
        action: "getPlayerCoachSignedPerformanceSignatures",
      };
      const responce = await Documents.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        if (responce.data.length > 0) {
          responce.data.find((signature) => {
            if (signature.type === "coachSignature") {
              this.coachSignedPerformanceReportSignature.coach_signature_change = false;
              this.playerCoachSignedPerformanceReportData.coach_signature_id =
                signature.id;
              this.playerCoachSignedPerformanceReportData.coachSignature =
                signature.signature_url;
            }
          });

          responce.data.find((signature) => {
            if (signature.type === "playerReportSignature") {
              this.coachSignedPerformanceReportSignature.player_signature_change = false;
              this.playerCoachSignedPerformanceReportData.player_signature_id =
                signature.id;
              this.playerCoachSignedPerformanceReportData.playerReportSignature =
                signature.signature_url;
            }
          });

          responce.data.find((signature) => {
            if (signature.type === "parentReportSignature") {
              this.coachSignedPerformanceReportSignature.parent_signature_change = false;
              this.playerCoachSignedPerformanceReportData.parent_signature_id =
                signature.id;
              this.playerCoachSignedPerformanceReportData.parentReportSignature =
                signature.signature_url;
            }
          });
        }
      }
    },
    openPlayerCoachSignedPerformanceModal(modelId, type, id = null) {
      this.playerCoachsignedReportReady = false;
      this.resetPlayerCoachSignedData();
      this.playerSignedPerformanceReportSelected = type;
      if (id) {
        this.playerCoachSignedPerformanceReportData =
          this.allPlayerCoachSignedPerformanceReportData.find(
            (review) => review.id === id,
          );

        const fetchReportData = async () => {
          try {
            await Promise.all([
              this.getPlayerCoachSignedPerformanceSignatures(id),
              this.getPlayerCoachSignedPerformanceReport(),
            ]);
            this.playerCoachsignedReportReady = true;
            this.showModal(modelId);
          } catch (error) {
            console.error("Failed to load report data:", error);
            this.$toast.error("Unable to load report details");
          }
        };
        fetchReportData();
      } else {
        if (type === "Coach") {
          this.playerCoachSignedPerformanceReportData.coach_id =
            this.userData.id;
          this.playerCoachSignedPerformanceReportData.userImage =
            this.userData.userImage;

          this.playerCoachSignedPerformanceReportData.name = this.userData.name;
        }

        this.playerCoachSignedPerformanceReportData.created_date =
          moment().format("YYYY-MM-DD");
        this.playerCoachsignedReportReady = true;
        this.showModal(modelId);
      }
    },
    openPlayerPerformanceModal(modelId) {
      this.playerPerformanceReportData = {};
      this.playerPerformanceReportData.review_date =
        moment().format("YYYY-MM-DD");
      this.showModal(modelId);
    },
    checkUserPosition() {
      return Object.keys(this.selectedUserData).length === 0
        ? this.userData.position
        : this.selectedUserData.position;
    },
    checkDateTimeFromNow(date) {
      if (!date) {
        return "";
      }
      const otherDate = new Date(date);
      // Guard against unparseable dates so this never throws "Invalid time
      // value".
      if (isNaN(otherDate.getTime())) {
        return "";
      }
      const now = new Date();
      const diffTime = Math.abs(
        new Date(now.setHours(0, 0, 0, 0)) -
          new Date(otherDate.setHours(0, 0, 0, 0)),
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays > 7 ? "red-warning" : "";
    },
    openTrainingPlanPage() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      this.$router.push({
        name: "trainingPlans",
        params: { trainingPlanUserId: this.selectedUserValue },
      });

      /* if (userType === "User") {
        this.$store.dispatch(POPULATE_SELECTED_USER_DATA, userId);
        this.$router.push({
          name: "trainingPlans",
          params: { trainingPlanUserId: 0 }
        });
      } else {
        this.$router.push({
          name: "trainingPlans",
          params: { trainingPlanUserId: userId }
        });
      } */
    },
    performanceTargetsHistoryModal() {
      this.showModal("performanceTargetsHistoryModal");
    },
    getPlayerById(id) {
      return this.allUserDataBeforFilterApplied.find(
        (player) => Number(player.id) === Number(id),
      );
    },
    async selectedUseChanged(player, type) {
      if (type !== undefined) {
        this.selectedUserValue = player;
        player = this.getPlayerById(player);
      }

      if (this.userHasMoreThanOneAccount !== null) {
        this.poupulateUserData(player);
        this.userData = { ...player };
        //const userData = player;
        this.selectedUserData = { ...player };
      }

      // This must complete first as it sets season dates that other calls depend on
      await this.getTeamsDataById(player.teamId);

      player.selectedUser === undefined
        ? (this.selectedUserValue = player.id)
        : (this.selectedUserValue = player.selectedUser);

      // Keep the "Select player" dropdown on the player actually shown (it was
      // only updated when the change came from the dropdown itself).
      this.selectedUserId = this.selectedUserValue;
      this.selectedUserDataForHeader = { ...player };

      this.under16 = this.showIfUnderU16(player.age_group);
      this.over14 = this.showIfOverU11(player.age_group);

      if (!this.checkSignedDate(this.selectedUserDataForHeader.joined_date)) {
        this.showModal("missingDataModal");
      }

      try {
        // For admin/coach users, getAllGamesEventsForPlayer must complete first
        // because loadPlayersProfilePerformanceData depends on this.allGameData
        if (
          this.userData.userType === "Admin" ||
          this.userData.userType === "Coach"
        ) {
          await this.getAllGamesEventsForPlayer(player);
        }

        // The IDP tab loads its data on tab-change only, so switching player
        // while sitting on that tab left the previous player's plan on screen —
        // a coach who opened one player's IDP then clicked through the squad
        // saw that same IDP against every team-mate. Clear it here, and reload
        // it when the tab is the one currently open.
        this.resetIDPDataForPlayerSwitch();

        // Now run the remaining promises in parallel
        const promises = [
          this.loadPlayersProfilePerformanceData(),
          this.getPlayerUserDataId(this.selectedUserValue),
          this.getPlayerPerformanceReviews(),
          this.getGameTargets(),
          this.getPlayerCoachSignedPerformanceReport(),
        ];

        if (this.selectedTab === "learning-development-plan-tab") {
          promises.push(
            this.getallQuatersPlayerIDPscores(),
            this.getIDPGoals(),
          );
        }

        await Promise.all(promises);
      } catch (error) {
        console.error("Error in selectedUseChanged:", error);
      }
    },
    async getTeamsDataById(teamId) {
      const userData = {
        id: teamId,
        action: "getTeamDataById",
      };

      if (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      ) {
        userData.clubId = this.userData.clubId;
      }
      const responce = await Teams.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data !== null) {
        // Don't clobber a past-season override (set by the global season selector).
        if (!localStorage.getItem("selectedSeasonYear")) {
          localStorage.setItem(
            "currentPlayingseasonStartDate",
            responce.data.season_start_date,
          );
          localStorage.setItem(
            "currentPlayingseasonEndDate",
            responce.data.season_end_date,
          );
        }
        ((this.season_start_date = responce.data.season_start_date),
          (this.season_end_date = responce.data.season_end_date));
        return true;
      }
    },
    async loadPlayerPhysicalPerformanceData() {
      const userData = {
        player_id: this.selectedUserValue,
        action: "loadPlayerPhysicalPerformanceDataById",
      };
      const responce = await PlayerPhysicalPerformance.find(userData).catch(
        (error) => {
          console.log(error);
        },
      );

      console.log(responce.data, "player physical data");

      if (responce.data.length > 0) {
        this.allPlayerPhysicalPerformanceData = responce.data;
        this.playerPhysicalPerformanceData =
          this.getPlayerPhysicalPerformanceData();
        this.checkIfNewValueisBetterOrWorse();
        this.populatePhysicalPerformanceLineChartData();
      }
    },
    async loadPlayersProfilePerformanceData() {
      this.loadingStuff = true;
      this.resetAllPlayerData();

      try {
        // Base data requests that can run in parallel
        const basePromises = [
          this.getAllGamesAttendedById(),
          this.getThisSeasonsgamePerformanceReportsForUser(),
          this.getAllTraningAttendedById(),
          this.getThisSeasonsTraningPerformanceReportsForUser(),
          this.getAllgoalsScoredByPlayerId(),
          this.getAllgoalAssistsByPlayerId(),
          this.getAllPlayerCardsForSeason(), // Cards from coach reports (team_game_results)
          this.getAllPlayerGameTimeForSeason(), // Game time from coach match reports
          this.getCoachesGamePerformanceReport(),
          this.getThisSeasionsCoachesGamePerformanceReports(),
          this.getAllHomeworkForPlayer(),
        ];
        // GPS/physical stats are Pro-tier only - skip the requests entirely
        if (this.hasFeature("gpsReports")) {
          basePromises.push(
            this.loadPlayerMinsPerformanceData(),
            this.loadPlayerPhysicalPerformanceData(),
            this.getPlayerMinsPerformanceDataForLastGameSessionPlayMaker(),
            this.getPlayerMinsPerformanceDataForLastTrainingSessionPlayMaker(),
            this.getPlayerMinsPerformanceDataForLastGameSession(),
            this.getPlayerMinsPerformanceDataForLastTrainingSession(),
          );
        }
        // Execute all promises in parallel
        await Promise.all([...basePromises]);
      } catch (error) {
        console.error("Error loading player profile performance data:", error);
      } finally {
        this.loadingStuff = false;
      }
    },
    prePopulatePlayerPerformanceValues() {
      this.playerPerformanceReportData.userImage =
        this.selectedUserData.userImage;
      this.playerPerformanceReportData.name = this.selectedUserData.name;
      this.playerPerformanceReportData.userImage =
        this.selectedUserData.userImage;
      this.playerPerformanceReportData.phone = this.selectedUserData.phone;
      this.playerPerformanceReportData.email = this.selectedUserData.email;
      this.playerPerformanceReportData.clubId = this.selectedUserData.clubId;
      this.playerPerformanceReportData.teamId = this.selectedUserData.teamId;
      this.playerPerformanceReportData.userId = this.selectedUserData.id;
      this.playerPerformanceReportData.dob = this.selectedUserData.dob;
      this.playerPerformanceReportData.position =
        this.selectedUserData.position;
      this.playerPerformanceReportData.preferred_foot =
        this.selectedUserData.preferred_foot;
      this.playerPerformanceReportData.coachId = this.userData.id;
    },
    async savePlayerPerformanceReview() {
      this.prePopulatePlayerPerformanceValues();
      const userData = {
        ...this.playerPerformanceReportData,
        performanceTargets: this.playerPerformanceTargets,
        action: "addPerformanceReview",
      };
      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "New performance review added.") {
        this.getPlayerPerformanceReviews();
        this.hideModal("playerPerformanceReportModal");
        this.$toast.info("Performance review added", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    checkIntTargetValue(value) {
      if (value !== undefined && value != 0) {
        return 1;
      } else {
        return 0;
      }
    },
    makeTheNewPerformanceReportTargetObject() {
      this.selectedPerformanceTarget.complete = this.checkIntTargetValue(
        this.selectedPerformanceTarget.complete,
      );
      let performanceId = null;
      let idpId = null;

      if (this.selectedPerformanceTarget.typeOfTarget === "game target") {
        idpId = this.playerIDPdata.id || null;
      } else {
        performanceId =
          this.selectedPerformanceTarget.performance_report_id || null;
      }

      return {
        player_id: this.selectedUserValue,
        performance_report_id: performanceId,
        idp_id: idpId,
        target: this.selectedPerformanceTarget.target,
        complete: this.selectedPerformanceTarget.complete,
        category: this.selectedPerformanceTarget.category,
        created_date: moment().format("YYYY-MM-DD"),
        possession: this.selectedPerformanceTarget.possession,
        action: "addNewPerformanceReportTarget",
      };
    },
    async addNewPerformanceReportTarget() {
      const userData = this.makeTheNewPerformanceReportTargetObject();

      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Performance report target added") {
        this.getPerformanceReviewTargets();
        this.getGameTargets();
        this.hideModal("newPerformanceTargetsModal");
        this.$toast.info("Performance report target added", {
          title: "added",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });

        this.sendFBNotificationMessage(
          "Coach added a performance report target",
          "You have a new performance report target to review.",
          [],
          this.selectedUserValue,
        );
      }
    },
    async deletePlayerCoachAssessment(id) {
      const userData = {
        id: id,
        action: "deletePlayerCoachAssessment",
      };

      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Player coach assessment deleted") {
        this.getPlayerCoachSignedPerformanceReport();
        this.$toast.info("Performance review deleted", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async deletePerformanceReview(id) {
      const userData = {
        id: id,
        action: "deletePerformanceReview",
      };

      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Performance review deleted") {
        this.getPerformanceReviewTargets();
        this.getPlayerPerformanceReviews();
        this.$toast.info("Performance review deleted", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async deletePerformanceReportTarget() {
      const userData = {
        id: this.selectedPerformanceTarget.id,
        action: "deletePerformanceReportTarget",
      };

      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Performance report target deleted") {
        this.getPerformanceReviewTargets();
        this.getGameTargets();
        this.hideModal("performanceTargetsModal");
        this.$toast.info("Performance report target deleted", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }
    },
    async updatePerformanceReportTarget() {
      const userData = {
        ...this.selectedPerformanceTarget,
        action: "updatePerformanceReportTarget",
      };
      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Performance report target updated") {
        this.getPerformanceReviewTargets();
        this.getGameTargets();
        this.hideModal("performanceTargetsModal");
        this.$toast.info("Performance report target updated", {
          title: "Updated",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
        this.sendFBNotificationMessage(
          "Coach updated a performance report target",
          "You have a performance report target to review.",
          [],
          this.selectedUserValue,
        );
      }
    },
    async getGameTargets() {
      const userData = {
        userId: this.selectedUserValue,
        action: "getGameTargets",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      this.playerGameTargetsData = responce.data;
      this.selectQuaterDataForGameTargets();
    },
    async getPerformanceReviewTargets() {
      const userData = {
        userId: this.selectedUserValue,
        action: "getPerformanceReviewTargets",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      this.playerPerformanceReviewTargetsData = responce.data;
    },
    async getAllgoalsScoredByPlayerId() {
      const data = {
        action: "getAllgoalsScoredByPlayerId",
        userId: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.data) {
        this.gamePerformanceData.goals = responce.data;
      }
    },
    async getAllgoalAssistsByPlayerId() {
      const data = {
        action: "getAllgoalAssistsByPlayerId",
        userId: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.data) {
        this.gamePerformanceData.assists = responce.data;
      }
    },
    async getAllPlayerCardsForSeason() {
      const data = {
        action: "getAllPlayerCardsForSeason",
        userId: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const response = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.data) {
        this.gamePerformanceData.yellowCardTotal =
          response.data.yellow_cards || 0;
        this.gamePerformanceData.redCardTotal = response.data.red_cards || 0;
      }
    },
    async getAllPlayerGameTimeForSeason() {
      const data = {
        action: "getAllPlayerGameTimeForSeason",
        userId: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const response = await Games.find(data).catch((error) => {
        console.log(error);
      });

      if (response && response.data) {
        this.gamePerformanceData.timeOnPitch = parseInt(response.data) || 0;
      }
    },
    async getPlayerPerformanceReviews() {
      if (!this.hasFeature("performanceReviews")) return;
      const userData = {
        userId: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
        action: "getPerformanceReviews",
      };
      const responce = await PerformanceReview.find(userData).catch((error) => {
        console.log(error);
      });

      this.allplayerPerformanceReportData = responce.data;
      this.getPerformanceReviewTargets();
    },
    async getThisSeasionsCoachesGamePerformanceReports() {
      const userData = {
        user_id: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
        action: "getThisSeasionsCoachesGamePerformanceReports",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data !== null) {
        this.filterOutAllGamesWithACoachPerformanceReport(responce.data);
      }
    },
    async getCoachesGamePerformanceReport() {
      const userData = {
        user_id: this.selectedUserValue,
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
        action: "getLastestCoachGamePerformanceReportsForUser",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (
        responce.data !== null &&
        responce.data !== false &&
        responce.data.length > 0
      ) {
        this.coachGamePerformanceData = responce.data;
        console.log(
          this.coachGamePerformanceData,
          "coach game performance data",
        );
        this.getCoachById(this.coachGamePerformanceData[0].coachId);
      }
    },
    async saveTraningPerformanceReport() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      this.loadingStuff = true;
      const userData = {
        ...this.newTrainingPerformanceData,
        user_id: this.selectedUserValue,
        created_date: moment().format("YYYY-MM-DD"),
        action: "saveUserTraningPerformanceReport",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Traning Performance Report added") {
        this.getAllTraningAttendedById();
        this.getThisSeasonsTraningPerformanceReportsForUser();
        this.hideModal("trainingPerformanceModal");
        this.loadingStuff = false;
        this.$toast.info("Traning Performance Report added", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
        this.sendFBNotificationMessage(
          `${this.userData.name} added a Traning performance report`,
          `You have a new raning performance report to review from ${this.userData.name} - ${this.userData.age_group}`,
          [],
          this.userData.coach_id,
        );
      }

      if (responce.data === "Training Performance Report already exists") {
        this.hideModal("trainingPerformanceModal");
        this.loadingStuff = false;
        this.$toast.info("Training Performance Report already exists", {
          title: "Error",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "warning",
        });
      }
    },
    async createMatchReport() {
      try {
        // Validate required data
        const gameId =
          this.coachGamePerformanceReportData.gameId ||
          this.newGamePerformanceData.gameId;
        if (!gameId) {
          throw new Error("Game ID is required");
        }

        if (!this.selectedUserData.id) {
          throw new Error("Player ID is required");
        }

        const responce = await Games.find({
          action: "saveMatchReport",
          gameId: gameId,
          player_id: this.selectedUserData.id,
          age_group: this.selectedUserData.age_group
            ? this.selectedUserData.age_group
            : null,
          coachId: this.userData.id,
          positions_played: this.selectedUserData.position
            ? this.selectedUserData.position
            : null,
          performance_rating:
            this.coachGamePerformanceReportData.performance_rating ||
            "Not rated",
          game_comments:
            this.coachGamePerformanceReportData.game_comments || "",
          game_improvements:
            this.coachGamePerformanceReportData.game_improvements || "",
          players_name: this.selectedUserData.name
            ? this.selectedUserData.name
            : null,
          session_mins: this.coachGamePerformanceReportData.session_mins || 0,
          trialistId: this.selectedUserData.trialistId
            ? this.selectedUserData.trialistId
            : null,
          assists: this.coachGamePerformanceReportData.assists || 0,
          goals: this.coachGamePerformanceReportData.goals || 0,
        });

        // Validate response
        if (!responce || responce.status !== 200) {
          throw new Error("Failed to create match report - invalid response");
        }

        // Check for successful creation
        if (
          responce.data &&
          (responce.data === "Match Report added" ||
            responce.data.includes("added"))
        ) {
          // Refresh data and update UI
          await this.getAllMatchReportsForUser();
          this.hideModal("matchReportModal");

          // Show success message
          this.$toast.success("Match Report created successfully", {
            title: "Success",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "success",
          });
        } else {
          throw new Error(
            responce.data ||
              "Unknown error occurred while creating match report",
          );
        }
      } catch (error) {
        console.error("Error creating match report:", error);

        // Show user-friendly error message
        this.$toast.error(error.message || "Failed to create match report", {
          title: "Error",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "danger",
        });
      }
    },
    async getAllMatchReportsForUser() {
      console.log(this.selectedUserData.id);
      try {
        const response = await Games.find({
          action: "getAllMatchReportsForUser",
          player_id: this.selectedUserData.id,
        });

        if (response && response.status === 200) {
          this.matchReports = response.data;
        } else {
          throw new Error("Failed to fetch match reports");
        }
      } catch (error) {
        console.error("Error fetching match reports:", error);
      }
    },
    async updateMatchReport(existingReport) {
      try {
        // Validate required data
        if (!existingReport || !existingReport.id) {
          throw new Error("Invalid existing report data");
        }

        const gameId =
          this.coachGamePerformanceReportData.gameId ||
          this.newGamePerformanceData.gameId;
        if (!gameId) {
          throw new Error("Game ID is required");
        }

        const responce = await Games.find({
          action: "updateMatchReport",
          id: existingReport.id,
          gameId: gameId,
          player_id: this.selectedUserData.id,
          age_group: this.selectedUserData.age_group
            ? this.selectedUserData.age_group
            : null,
          coachId: this.userData.id,
          positions_played: this.selectedUserData.position
            ? this.selectedUserData.position
            : null,
          performance_rating:
            this.coachGamePerformanceReportData.performance_rating ||
            existingReport.performance_rating ||
            "Not rated",
          game_comments:
            this.coachGamePerformanceReportData.game_comments ||
            existingReport.game_comments,
          game_improvements:
            this.coachGamePerformanceReportData.game_improvements ||
            existingReport.game_improvements,
          players_name: this.selectedUserData.name
            ? this.selectedUserData.name
            : null,
          session_mins:
            this.coachGamePerformanceReportData.session_mins ||
            existingReport.session_mins ||
            0,
          trialistId: this.selectedUserData.trialistId
            ? this.selectedUserData.trialistId
            : null,
          assists:
            this.coachGamePerformanceReportData.assists ||
            existingReport.assists ||
            0,
          goals:
            this.coachGamePerformanceReportData.goals ||
            existingReport.goals ||
            0,
        });

        // Validate response
        if (!responce || responce.status !== 200) {
          throw new Error("Failed to update match report - invalid response");
        }

        // Check for successful update
        if (
          responce.data &&
          (responce.data === "Match Report updated" ||
            responce.data.includes("updated"))
        ) {
          // Refresh data and update UI
          await this.getAllMatchReportsForUser();
          this.hideModal("matchReportModal");

          // Show success message
          this.$toast.success("Match Report updated successfully", {
            title: "Success",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "success",
          });
        } else {
          throw new Error(
            responce.data ||
              "Unknown error occurred while updating match report",
          );
        }
      } catch (error) {
        console.error("Error updating match report:", error);

        // Show user-friendly error message
        this.$toast.error(error.message || "Failed to update match report", {
          title: "Error",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "danger",
        });
      }
    },
    async saveTheMatchReport() {
      try {
        // Validate required data
        const gameId =
          this.coachGamePerformanceReportData.gameId ||
          this.newGamePerformanceData.gameId;

        if (!gameId) {
          throw new Error("Game ID is required");
        }

        if (!this.selectedUserData.id) {
          throw new Error("Player ID is required");
        }

        // Check match report existence
        const existingReport = await Games.find({
          action: "checkMatchReport",
          gameId: gameId,
          player_id: this.selectedUserData.id,
        });

        // Validate response structure
        if (!existingReport || existingReport.status !== 200) {
          throw new Error("Failed to check existing match report");
        }

        // Update or create based on existence
        if (existingReport.data && existingReport.data.id) {
          // Update the existing match report
          await this.updateMatchReport(existingReport.data);
        } else {
          // Create a new match report
          await this.createMatchReport();
        }
      } catch (error) {
        console.error("Error saving match report:", error);

        // Show user-friendly error message
        this.$toast.error(error.message || "Failed to save match report", {
          title: "Error",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "danger",
        });
      }
    },
    async coachesGamePerformanceReport() {
      // Validation checks
      const validationErrors = [];

      // Check if game is selected
      if (!this.coachGamePerformanceReportData.gameId) {
        validationErrors.push("Please select a game");
      }

      // Check if player rating is selected
      if (!this.coachGamePerformanceReportData.player_rating) {
        validationErrors.push("Please select a player rating");
      }

      // Check if positive comments are provided
      if (
        !this.coachGamePerformanceReportData.game_comments ||
        this.coachGamePerformanceReportData.game_comments.trim() === ""
      ) {
        validationErrors.push("Please add positive comments");
      }

      // Check if improvement comments are provided
      if (
        !this.coachGamePerformanceReportData.game_improvements ||
        this.coachGamePerformanceReportData.game_improvements.trim() === ""
      ) {
        validationErrors.push("Please add improvement comments");
      }

      // If there are validation errors, show them and return
      if (validationErrors.length > 0) {
        this.$toast.error(validationErrors.join("\n"), {
          title: "Validation Error",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "danger",
        });
        return;
      }

      // If validation passes, proceed with saving
      const userData = {
        ...this.coachGamePerformanceReportData,
        player_id: this.selectedUserValue,
        created_date: moment().format("YYYY-MM-DD"),
        action: "saveCoachesGamePerformanceReport",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        this.showCoachGamePerformanceModal = false;

        this.getCoachesGamePerformanceReport();
        this.getThisSeasionsCoachesGamePerformanceReports();

        if (this.$refs.gamesListComponent) {
          this.$refs.gamesListComponent.getAllGamesEventsForPlayer();
        }

        this.showGamePerformanceToast(
          responce.data,
          "coachGamePerformanceModal",
        );
        this.sendFBNotificationMessage(
          "Coach added a game performance report",
          "You have a new game performance report to review.",
          [],
          this.selectedUserValue,
        );
      }

      this.newGamePerformanceData.gameId =
        this.coachGamePerformanceReportData.gameId;
      this.newGamePerformanceData.player_self_rating =
        this.coachGamePerformanceReportData.player_rating;
      this.newGamePerformanceData.postion_played = this.selectedUserData
        .position
        ? this.selectedUserData.position
        : null;
      this.newGamePerformanceData.postion_played_two = null;
      this.newGamePerformanceData.goals = 0;
      this.newGamePerformanceData.assists = 0;
      this.newGamePerformanceData.clean_sheet = 0;
      this.newGamePerformanceData.card = "No";
      this.newGamePerformanceData.session_mins = 0;
      this.newGamePerformanceData.technically_improvements = null;
      this.newGamePerformanceData.technically_positives = null;
      this.newGamePerformanceData.tactility_improvements = null;
      this.newGamePerformanceData.tactility_positives = null;
      this.newGamePerformanceData.physicality_improvements = null;
      this.newGamePerformanceData.physicality_positives = null;
      this.newGamePerformanceData.mentally_improvements = null;
      this.newGamePerformanceData.mentally_positives = null;
      this.newGamePerformanceData.pdps_improvements = null;
      this.newGamePerformanceData.pdps_positives = null;
      this.newGamePerformanceData.overall_comments = null;
      this.newGamePerformanceData.matchDate = this.getMatchDateFromGameId(
        this.coachGamePerformanceReportData.gameId,
      );
      this.saveUserGamePerformanceReport(true);
    },
    getMatchDateFromGameId(gameId) {
      const game = this.allGameData.find((g) => g.id === Number(gameId));
      console.log("Game ID:", gameId, "Match Date:", game);
      return game ? game.date : null;
    },
    populatePlayerSelfRating() {
      let result = this.seasonsgamePerformanceReportsForUser.reduce((a, b) =>
        a.date > b.date ? a : b,
      );
      this.gamePerformanceData.gameId = result.gameId;
      this.gamePerformanceData.player_self_rating = result.player_self_rating;
      this.gamePerformanceData.created_date = result.created_date;
    },
    populateGameStatsForThisSeason(typeOfData) {
      this.gamePerformanceData[typeOfData] =
        this.seasonsgamePerformanceReportsForUser.reduce(function (
          accumulator,
          player,
        ) {
          return accumulator + Number(player[typeOfData]);
        }, 0);
    },
    populateTraningStatsForThisSeason(typeOfData) {
      this.trainingPerformanceData[typeOfData] =
        this.seasonsTraningPerformanceReportsForUser.reduce(function (
          accumulator,
          player,
        ) {
          return accumulator + Number(player[typeOfData]);
        }, 0);
    },
    populatePostionsPlayed() {
      if (this.seasonsgamePerformanceReportsForUser.length > 0) {
        this.gamePerformanceData.postion_played = [];
        let array = [];
        this.seasonsgamePerformanceReportsForUser.filter(function (postion) {
          array.push(postion.postion_played);
        });
        Object.keys(this.selectedUserData).length === 0
          ? this.gamePerformanceData.postion_played.push(this.userData.position)
          : this.gamePerformanceData.postion_played.push(
              this.selectedUserData.position,
            );
        this.gamePerformanceData.postion_played = array;
      } else {
        Object.keys(this.selectedUserData).length === 0
          ? this.gamePerformanceData.postion_played.push(this.userData.position)
          : this.gamePerformanceData.postion_played.push(
              this.selectedUserData.position,
            );
      }
    },
    populatePlayerCards() {
      this.seasonsgamePerformanceReportsForUser.forEach((player) => {
        if (player.card === "Yellow") {
          this.gamePerformanceData.yellowCardTotal =
            this.gamePerformanceData.yellowCardTotal + 1;
        }
        if (player.card === "Red" || player.card === "two Yellows (red)") {
          this.gamePerformanceData.redCardTotal =
            this.gamePerformanceData.redCardTotal + 1;
        }
      });
    },
    setCurrentTraningSessionRating() {
      return this.seasonsTraningPerformanceReportsForUser.reduce((a, b) =>
        a.created_date > b.created_date ? a : b,
      );
    },
    async getThisSeasonsTraningPerformanceReportsForUser() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      if (localStorage.getItem("currentPlayingSeason") !== null) {
        this.currentPlayingSeason = localStorage.getItem(
          "currentPlayingSeason",
        );
      }

      const userData = {
        user_id: this.selectedUserValue,
        action: "getThisSeasonsTraningPerformanceReportsForUser",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.seasonsTraningPerformanceReportsForUser = responce.data;
        this.trainingPerformanceData = {
          ...this.setCurrentTraningSessionRating(),
          ...this.trainingPerformanceData,
        };
        let effortData = this.populateTrainingPerformanceDataBarChart(
          "seasonsTraningPerformanceReportsForUser",
          "effort",
        );
        this.barChartDataSet(effortData, [
          "Amazing",
          "Good",
          "Ok",
          "Did not enjoy it",
        ]);
      }
    },
    barChartDataSet(effortData, labelsData) {
      this.trainingPerformanceBarChartDataSet = {
        labels: labelsData,
        datasets: [
          {
            label: "Effort",
            borderColor: "rgba(50, 115, 220, 0.5)",
            backgroundColor: "rgba(50, 115, 220, 0.1)",
            data: effortData,
          },
        ],
      };
    },
    populateBarChartWithData(arrayName, value) {
      let test = [];
      arrayName.filter((i) => {
        test.push(i[value]);
      });

      return test;
    },
    populateTrainingPerformanceDataBarChart(arrayName, value) {
      let test = [];
      this[arrayName].filter((i) => {
        test.push(i[value]);
      });

      return test;
    },
    barChartDataForPlayerMood() {
      this.playerMoodBarChartDataSet = {
        labels: this.populateTrainingPerformanceDataBarChart(
          "thisSeasionsPlayerMoodData",
          "date",
        ),
        datasets: [
          {
            label: "fatigue",
            borderColor: "rgba(50, 115, 220, 0.5)",
            backgroundColor: "rgba(50, 115, 220, 0.1)",
            data: this.populateTrainingPerformanceDataBarChart(
              "thisSeasionsPlayerMoodData",
              "fatigue",
            ),
          },
          {
            label: "Happiness",
            borderColor: "#4caf50",
            backgroundColor: "#4caf50",
            data: this.populateTrainingPerformanceDataBarChart(
              "thisSeasionsPlayerMoodData",
              "happyness",
            ),
          },
          {
            label: "muscle soreness",
            borderColor: "#ff9f00",
            backgroundColor: "#ff9f00",
            data: this.populateTrainingPerformanceDataBarChart(
              "thisSeasionsPlayerMoodData",
              "muscle_soreness",
            ),
          },
          {
            label: "sleep",
            borderColor: "#b605ff",
            backgroundColor: "#b605ff",
            data: this.populateTrainingPerformanceDataBarChart(
              "thisSeasionsPlayerMoodData",
              "sleep",
            ),
          },
          {
            label: "stress",
            borderColor: "#e53c3c",
            backgroundColor: "#e53c3c",
            data: this.populateTrainingPerformanceDataBarChart(
              "thisSeasionsPlayerMoodData",
              "stress",
            ),
          },
        ],
      };
    },
    populateFullSeasonStrainingAndGamesstatsChartDataSetsData(
      dataName,
      playerId,
      date,
      labelName,
    ) {
      const data = this.playerDailyMins.find((data) => {
        if (
          data.player_id === playerId &&
          data.session_date === date &&
          data.session_type === "Session"
        ) {
          if (data[dataName] !== undefined) {
            return data[dataName];
          }
        }
      });

      if (data !== undefined) {
        return [
          {
            label: labelName,
            backgroundColor: "#ffde00",
            data: [data[dataName]],
          },
        ];
      } else {
        return {};
      }
    },
    populateFullSeasonStrainingAndGamesstatsPlaymakerChartDataSetsData(
      dataName,
      playerId,
      date,
      labelName,
    ) {
      const data = this.playerPlayMakerGpsData.find((data) => {
        if (data.player_id === playerId && data.session_date === date) {
          if (data[dataName] !== undefined) {
            return data[dataName];
          }
        }
      });

      if (data[dataName] !== 0) {
        return [
          {
            label: labelName,
            backgroundColor: "#ffde00",
            data: [data[dataName]],
          },
        ];
      } else {
        return {};
      }
    },
    populateFullSeasonStrainingAndGamesstatsAllPlaymakerChartDataSetsData(
      dataName,
      playerId,
      date,
    ) {
      let datasetsData = [];
      const colours = [
        "#41B883",
        "#E46651",
        "#00D8FF",
        "#f7615d",
        "#41b883",
        "#16dddb",
        "#dd8b16",
        "#cddd16",
      ];

      this.playerPlayMakerGpsData.filter((data, index) => {
        if (data.player_id === playerId && data.session_date === date) {
          if (data[dataName] !== undefined) {
            datasetsData.push({
              label: data.session_type,
              backgroundColor: colours[index],
              data: [data[dataName]],
            });
          }
        }
      });

      return datasetsData;
    },
    populateSeasonStrainingAndGamesPlaymakerstatsChartDataSetsData(
      dataName,
      playerId,
      date,
    ) {
      return this.playerPlayMakerGpsData.map((data) => {
        if (data.player_id === playerId && data.session_date === date) {
          return data[dataName];
        }
      });
    },
    populateSeasonStrainingAndGamesstatsChartDataSetsData(
      dataName,
      playerId,
      date,
    ) {
      return this.playerDailyMins.map((data) => {
        if (data.player_id === playerId && data.session_date === date) {
          return data[dataName];
        }
      });
    },
    populateSeasonStrainingAndGamesstatsChartDataLabels(
      dataLable,
      playerId,
      date,
    ) {
      return this.playerDailyMins.map((data) => {
        if (data.player_id === playerId && data.session_date === date) {
          return data[dataLable];
        }
      });
    },

    populateSeasonStrainingAndGamesstatsChartPieDataPlayMakerSetsData(
      playerId,
      date,
      dataSetName,
    ) {
      let labelsData = [];
      let datasetsData = [];

      this.playerPlayMakerGpsData.map((data) => {
        if (data["player_id"] === playerId && data["session_date"] === date) {
          labelsData.push(data["session_type"]);
          if (data[dataSetName] !== 0) {
            datasetsData.push(data[dataSetName]);
          }
        }
      });

      if (datasetsData.length > 0) {
        return {
          labels: labelsData,
          datasets: [
            {
              backgroundColor: [
                "#41B883",
                "#E46651",
                "#00D8FF",
                "#DD1B16",
                "#41b883",
                "#16dddb",
                "#dd8b16",
                "#cddd16",
              ],
              data: datasetsData,
            },
          ],
        };
      } else {
        return {};
      }
    },

    populateSeasonStrainingAndGamesstatsChartPieDataSetsData(
      playerId,
      date,
      dataSetName,
    ) {
      let labelsData = [];
      let datasetsData = [];

      this.playerDailyMins.map((data) => {
        if (data["player_id"] === playerId && data["session_date"] === date) {
          labelsData.push(data["session_type"]);
          if (data[dataSetName] !== 0) {
            datasetsData.push(data[dataSetName]);
          }
        }
      });

      if (datasetsData.length > 0) {
        return {
          labels: labelsData,
          datasets: [
            {
              backgroundColor: [
                "#41B883",
                "#E46651",
                "#00D8FF",
                "#DD1B16",
                "#41b883",
                "#16dddb",
                "#dd8b16",
                "#cddd16",
              ],
              data: datasetsData,
            },
          ],
        };
      } else {
        return {};
      }
    },
    populatePysicalPerformanceLineChartDataSetsData(dataName) {
      return this.allPlayerPhysicalPerformanceData.map(
        (data) => data[dataName],
      );
    },

    populatePysicalPerformanceLineChartLabels() {
      return this.allPlayerPhysicalPerformanceData.map((data) => data.date);
    },
    populatePysicalPerformanceLineChartDataSets() {
      return [
        {
          label: "10m SPRINT",
          backgroundColor: "#91afea",
          data: this.populatePysicalPerformanceLineChartDataSetsData(
            "tenM_sprint_time",
          ),
        },
        {
          label: "30m SPRINT",
          backgroundColor: "#c791ea",
          data: this.populatePysicalPerformanceLineChartDataSetsData(
            "fortyM_sprint_time",
          ),
        },
      ];
    },
    populatePysicalPerformanceSingleDataPointChartSets(
      lableName,
      colour,
      typeOfData,
    ) {
      return [
        {
          label: lableName,
          backgroundColor: colour,
          data: this.populatePysicalPerformanceLineChartDataSetsData(
            typeOfData,
          ),
        },
      ];
    },
    populateSeasonStrainingAndGamesstatsChartDataPointChartSets(
      lableName,
      colour,
      typeOfData,
    ) {
      return [
        {
          label: lableName,
          backgroundColor: colour,
          data: this.populateSeasonStrainingAndGamesstatsChartDataSetsData(
            typeOfData,
          ),
        },
      ];
    },
    populateSeasonTrainingAndGamesstatsAccelerationsAndDecelerationsChart(
      playerid,
      date,
    ) {
      return [
        {
          label: "Accelerations",
          backgroundColor: "#00ff2a",
          data: this.populateSeasonStrainingAndGamesstatsChartDataSetsData(
            "accelerations_total_efforts",
            playerid,
            date,
          ),
        },
        {
          label: "Decelerations",
          backgroundColor: "#ff4e00",
          data: this.populateSeasonStrainingAndGamesstatsChartDataSetsData(
            "decelerations_total_efforts",
            playerid,
            date,
          ),
        },
      ];
    },
    populateFullSessionTrainingAndGamesstatsBarChart(
      label,
      typeOfData,
      date,
      playerid,
    ) {
      return [
        {
          label: label,
          backgroundColor: "#00ff2a",
          data: this.populateSeasonStrainingAndGamesstatsChartDataSetsData(
            typeOfData,
            playerid,
            date,
          ),
        },
      ];
    },
    populatePhysicalPerformanceLineChartData() {
      this.physicalPerformanceLineChartData = {
        labels: this.populatePysicalPerformanceLineChartLabels(),
        datasets: this.populatePysicalPerformanceLineChartDataSets(),
      };

      this.physicalPerformanceLineCountermovementJumpChartData = {
        labels: this.populatePysicalPerformanceLineChartLabels(),
        datasets: this.populatePysicalPerformanceSingleDataPointChartSets(
          "Countermovement jump",
          "#91afea",
          "cuntermovement_jump",
        ),
      };

      this.physicalPerformanceLineReactiveStrengthIndexChartData = {
        labels: this.populatePysicalPerformanceLineChartLabels(),
        datasets: this.populatePysicalPerformanceSingleDataPointChartSets(
          "Reactive strength index",
          "#91afea",
          "reactive_strength_index",
        ),
      };

      this.physicalPerformanceLineThirtyFithteenIntermittentFitnessTestChartData =
        {
          labels: this.populatePysicalPerformanceLineChartLabels(),
          datasets: this.populatePysicalPerformanceSingleDataPointChartSets(
            "Intermittent Fitness Test",
            "#91afea",
            "thirty_15_intermittent_fitness_test",
          ),
        };

      this.physicalPerformanceLineHeightChartData = {
        labels: this.populatePysicalPerformanceLineChartLabels(),
        datasets: this.populatePysicalPerformanceSingleDataPointChartSets(
          "Height",
          "#91afea",
          "height",
        ),
      };

      this.physicalPerformanceLineWeightChartData = {
        labels: this.populatePysicalPerformanceLineChartLabels(),
        datasets: this.populatePysicalPerformanceSingleDataPointChartSets(
          "Weight",
          "#91afea",
          "weight",
        ),
      };
    },
    async getThisSeasonsgamePerformanceReportsForUser() {
      try {
        // Initialize data
        this.seasonsgamePerformanceReportsForUser = [];

        // Set default user if not selected
        if (!this.selectedUserValue) {
          this.selectedUserValue = this.userData.id;
        }

        // Update current playing season from localStorage
        const currentSeason = localStorage.getItem("currentPlayingSeason");
        if (currentSeason) {
          this.currentPlayingSeason = currentSeason;
        }

        // Prepare request data
        const userData = {
          user_id: this.selectedUserValue,
          action: "getThisSeasonsgamePerformanceReportsForUser",
          season_start_date: localStorage.getItem(
            "currentPlayingseasonStartDate",
          ),
          season_end_date: this.extendSeasonEndDateToFullYear(),
        };

        // Make API call with better error handling
        const response = await Games.find(userData);

        if (!response || !response.data) {
          console.warn(
            "No response data received for game performance reports",
          );
          this.populatePostionsPlayed(); // Still populate positions even if no data
          return;
        }

        // Process response data
        if (Array.isArray(response.data) && response.data.length > 0) {
          this.seasonsgamePerformanceReportsForUser = response.data;

          // Populate derived statistics
          this.populatePlayerSelfRating();

          // Only populate non-stat data from player reports
          // Goals, assists, and cards now come from coach reports (team_game_results)
          const statsToPopulate = ["clean_sheet", "timeOnPitch"];
          statsToPopulate.forEach((stat) => {
            this.populateGameStatsForThisSeason(stat);
          });

          // Cards are now fetched from team_game_results via getAllPlayerCardsForSeason()
          // populatePlayerCards() is deprecated - cards come from coach reports only
        } else {
          console.info("No game performance reports found for this season");
        }

        // Always populate positions (uses fallback logic)
        this.populatePostionsPlayed();
      } catch (error) {
        console.error("Error fetching season game performance reports:", error);

        // Show user-friendly error message
        this.$toast.error("Failed to load game performance reports", {
          title: "Error",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "danger",
        });

        // Ensure positions are still populated on error
        this.populatePostionsPlayed();
      }
    },
    showGamePerformanceToast(responce, modelId) {
      if (responce === "Game Performance Report added") {
        this.hideModal(modelId);
        this.$toast.info("Game Performance Report added", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }

      if (responce === "Game Performance Report already exists") {
        this.hideModal(modelId);
        this.$toast.info("Game Performance Report already exists", {
          title: "Error",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "warning",
        });
      }
    },
    async saveUserGamePerformanceReport(skipValidation) {
      this.saveTheMatchReport();

      if (skipValidation !== true) {
        // Validation checks
        const validationErrors = [];

        // Check if game is selected
        if (!this.newGamePerformanceData.gameId) {
          validationErrors.push("Please select a game");
        }

        // Check if position is selected
        if (!this.newGamePerformanceData.postion_played) {
          validationErrors.push("Please select a position");
        }

        // Check if time on pitch is provided
        if (
          !this.newGamePerformanceData.timeOnPitch ||
          this.newGamePerformanceData.timeOnPitch < 0
        ) {
          validationErrors.push("Please enter how long you played for (mins)");
        }

        // Check if all improvement fields are filled
        const improvementFields = [
          "technically_improvements",
          "tactility_improvements",
          "physicality_improvements",
          "mentally_improvements",
        ];

        const positiveFields = [
          "technically_positives",
          "tactility_positives",
          "physicality_positives",
          "mentally_positives",
        ];

        improvementFields.forEach((field) => {
          if (
            !this.newGamePerformanceData[field] ||
            this.newGamePerformanceData[field].trim() === ""
          ) {
            const fieldName = field
              .replace("_improvements", "")
              .replace("_", " ");
            validationErrors.push(`Please add ${fieldName} improvements`);
          }
        });

        positiveFields.forEach((field) => {
          if (
            !this.newGamePerformanceData[field] ||
            this.newGamePerformanceData[field].trim() === ""
          ) {
            const fieldName = field.replace("_positives", "").replace("_", " ");
            validationErrors.push(`Please add ${fieldName} positives`);
          }
        });

        // If there are validation errors, show them and return
        if (validationErrors.length > 0) {
          this.$toast.error(validationErrors.join("\n"), {
            title: "Validation Error",
            toaster: "b-toaster-bottom-right",
            solid: true,
            appendToast: true,
            variant: "danger",
          });
          return;
        }
      }

      // If validation passes, proceed with saving
      if (this.newGamePerformanceData.player_self_rating === null) {
        this.newGamePerformanceData.player_self_rating = "Not Rated";
      }
      this.loadingStuff = true;
      const userData = {
        ...this.newGamePerformanceData,
        user_id: this.selectedUserData.id,
        created_date: moment().format("YYYY-MM-DD"),
        action: "saveUserGamePerformanceReport",
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });
      this.loadPlayersProfilePerformanceData();

      // Only call editDayMinsOnlyData if we have the required data
      try {
        if (
          this.newGamePerformanceData.gameId &&
          this.newGamePerformanceData.timeOnPitch
        ) {
          await this.editDayMinsOnlyData();
        }
      } catch (error) {
        console.error("Error updating mins data:", error);
        // Don't let this error stop the form submission
      }

      this.loadingStuff = false;
      this.showGamePerformanceToast(responce.data, "performanceModal");

      // Refresh the GamesList component
      if (this.$refs.gamesListComponent) {
        this.$refs.gamesListComponent.getAllGamesEventsForPlayer();
      }

      if (skipValidation !== true) {
        this.sendFBNotificationMessage(
          `${this.userData.name} added a game performance report`,
          `You have a new game performance report to review from ${this.userData.name} - ${this.userData.age_group}`,
          [],
          this.userData.coach_id,
        );
      }

      this.resetNewGamePerformanceData();
    },
    resetNewGamePerformanceData() {
      this.newGamePerformanceData = {
        gameId: null,
        postion_played: null,
        postion_played_two: null,
        goals: 0,
        assists: 0,
        clean_sheet: null,
        player_self_rating: null,
        card: "No",
        timeOnPitch: null,
        gamesPlayed: null,
        technically_improvements: null,
        technically_positives: null,
        tactility_improvements: null,
        tactility_positives: null,
        physicality_improvements: null,
        physicality_positives: null,
        mentally_improvements: null,
        mentally_positives: null,
        pdps_improvements: null,
        pdps_positives: null,
        overall_comments: null,
        session_mins: null,
      };
    },
    refreshGamesList() {
      // Refresh the GamesList component when coach saves a game performance report
      if (this.$refs.gamesListComponent) {
        this.$refs.gamesListComponent.getAllGamesEventsForPlayer();
      }
    },
    SetTrainingHoursThisSeason() {
      return this.trainingPerformanceData.traningAttended !== 0
        ? (this.trainingPerformanceData.time =
            this.trainingPerformanceData.traningAttended * 60)
        : (this.trainingPerformanceData.time = 0);
    },
    async getAllTraningAttendedById() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      const userData = {
        user_id: this.selectedUserValue,
        action: "getAllTraningAttendedById",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      this.trainingPerformanceData.traningAttended = responce.data;
      this.SetTrainingHoursThisSeason();
    },
    async getAllGamesAttendedById() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      if (localStorage.getItem("currentPlayingSeason") !== null) {
        this.currentPlayingSeason = localStorage.getItem(
          "currentPlayingSeason",
        );
      }
      const userData = {
        user_id: this.selectedUserValue,
        action: "getAllGamesAttendedById",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),

        year: this.currentPlayingSeason,
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      this.gamePerformanceData.gamesPlayed = responce.data;
    },
    editPlayerProfileInSettings() {
      this.$router.push("/settings").catch(() => {});
    },
    hideCoachPerformanceModel() {
      // Reset loading states
      this.loadingCoachPerformanceData = false;

      // Only refresh data if we have valid context
      if (this.selectedGame && this.selectedGame.id) {
        this.getCoachesGamePerformanceReport();
      }
    },
    openTrainingPerformanceModal() {
      this.getPastTrainingSessionsInfo();
      this.showModal("trainingPerformanceModal");
    },
    openGamePerformanceModal(modelId) {
      if (modelId === "coachGamePerformanceModal") {
        this.coachGamePerformanceReportData = {
          gameId: this.pastGameDataFilteredCoach[0].id,
        };
        this.eyeballPrefillApplied = false;
        // Try to pre-fill from Eyeball for the initially-selected game
        this.prefillFromEyeballForGame(this.pastGameDataFilteredCoach[0]);
      }
      this.getPastGamesInfo();
      this.showModal(modelId);
    },
    onCoachReportGameChange(event) {
      const selectedId = event.target.value;
      this.coachGamePerformanceReportData.gameId = selectedId;
      this.eyeballPrefillApplied = false;
      const game = this.pastGameDataFilteredCoach.find(
        (g) => g.id === selectedId,
      );
      if (game) this.prefillFromEyeballForGame(game);
    },
    async prefillFromEyeballForGame(game) {
      if (
        !game ||
        !game.matchDate ||
        !this.userData?.clubId ||
        !this.selectedUserData?.id
      )
        return;
      try {
        const response = await EyeBall.find({
          action: "getEyeballDataForMatchReport",
          matchDate: game.matchDate,
          clubId: this.userData.clubId,
        });
        if (!response?.data?.success) return;
        const allEyeballData = response.data.playerData || {};
        const eyeballForPlayer =
          allEyeballData[String(this.selectedUserData.id)];
        if (!eyeballForPlayer) return;

        const hasValue = (val) =>
          val !== null &&
          val !== undefined &&
          val !== "" &&
          val !== 0 &&
          val !== "0";
        const d = this.coachGamePerformanceReportData;

        if (!hasValue(d.session_mins) && hasValue(eyeballForPlayer.minutes)) {
          d.session_mins = eyeballForPlayer.minutes;
        }
        if (!hasValue(d.goals) && hasValue(eyeballForPlayer.goals)) {
          d.goals = eyeballForPlayer.goals;
        }
        if (!hasValue(d.postion_played) && eyeballForPlayer.position) {
          d.postion_played = eyeballForPlayer.position;
        }
        this.eyeballPrefillApplied = true;
      } catch (err) {
        console.error("Eyeball prefill (profile) failed:", err);
      }
    },
    getPlayerImage() {
      if (
        this.userData.userType === "Admin" ||
        this.userData.userType === "Coach"
      ) {
        return this.selectedUserDataForHeader.userImage !== "" &&
          this.selectedUserDataForHeader.userImage !== null
          ? this.getImgUrl(this.selectedUserDataForHeader.userImage)
          : AVATAR_PLACEHOLDER;
      }

      if (this.userData.userType === "User") {
        return this.userData.userImage !== "" &&
          this.userData.userImage !== null
          ? this.getImgUrl(this.userData.userImage)
          : AVATAR_PLACEHOLDER;
      }
    },
    filterOutAllTrainingSessionsWithAPerformanceReport() {
      let trainingSessions = [...this.pastTrainingSessionsData];

      this.pastTrainingSessionsDataFiltered = trainingSessions.map(
        (trainingSession) => {
          let hasPerformanceReport =
            this.seasonsTraningPerformanceReportsForUser.some(
              (report) => report.traningId === trainingSession.id,
            );

          return {
            ...trainingSession,
            disabled: hasPerformanceReport,
          };
        },
      );
    },
    filterOutAllGamesWithACoachPerformanceReport(coachReports) {
      const coachReportGameIds = coachReports.map((report) => report.gameId);
      this.pastGameDataFilteredCoach = this.allGameData.map((gameData) => {
        return {
          ...gameData,
          disabled: coachReportGameIds.includes(gameData.id),
        };
      });
    },
    filterOutAllGamesWithAPerformanceReport(data) {
      const reportsIds = this.seasonsgamePerformanceReportsForUser.map(
        (performanceReport) => performanceReport.gameId,
      );
      this.pastGameDataDataFiltered = data.map((gameData) => {
        return {
          ...gameData,
          disabled: reportsIds.includes(gameData.id),
        };
      });
    },
    async getPastTrainingSessionsInfo() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      if (localStorage.getItem("currentPlayingSeason") !== null) {
        this.currentPlayingSeason = localStorage.getItem(
          "currentPlayingSeason",
        );
      }

      const userData = {
        user_id: this.selectedUserValue,
        action: "getPastTrainingSessionsInfo",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.pastTrainingSessionsData = this.filterOutGames(responce.data);
        this.filterOutAllTrainingSessionsWithAPerformanceReport();
      }
    },
    filterOutGames(data) {
      return data.filter(function (item) {
        return item.gameType === "Training";
      });
    },
    async getAllGamesEventsForPlayer(player) {
      const userData = {
        teamId: player.teamId,
        action: "getAllGamesEventsForPlayer",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.allGameData = responce.data;
      }
    },
    async getPastGamesInfo() {
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      if (localStorage.getItem("currentPlayingSeason") !== null) {
        this.currentPlayingSeason = localStorage.getItem(
          "currentPlayingSeason",
        );
      }

      const userData = {
        user_id: this.selectedUserValue,
        action: "getPastGamesEvents",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Games.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        const cleanedData = await this.removeOtherteamsGames(responce.data);

        this.filterOutAllGamesWithAPerformanceReport(cleanedData);
        this.pastGameData = cleanedData;
        //this.pastGameDataDataFiltered = responce.data;
      }
    },
    getGamesWithTeamDetails(teams, gameData) {
      const teamIds = teams.map((team) => team.id.toString());

      return gameData
        .filter((game) => teamIds.includes(game.teamId))
        .map((game) => {
          const matchingTeam = teams.find(
            (team) => team.id.toString() === game.teamId,
          );
          return {
            ...game,
            teamDetails: matchingTeam,
          };
        });
    },
    async removeOtherteamsGames(gamesData) {
      //let updatedTeamsData = [];
      const userData = {
        userId: this.selectedUserValue,
        action: "getTeamsDataById",
      };

      const responce = await Teams.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.status === 200) {
        const gamesWithTeamDetails = this.getGamesWithTeamDetails(
          responce.data,
          gamesData,
        );
        return gamesWithTeamDetails;

        /*updatedTeamsData = responce.data.map(team => 
          gamesData.filter(game => game.teamId === team.id.toString())
        );
   
        console.log(updatedTeamsData);*/
      }
    },
    async getLatestPlayerMoodData() {
      if (!this.hasFeature("wellnessMonitoring")) return;
      if (this.selectedUserValue === "") {
        this.selectedUserValue = this.userData.id;
      }
      const userData = {
        player_id: this.selectedUserValue,
        action: "getLatestPlayerMoodData",
      };
      const responce = await Wellness.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data !== undefined) {
        this.playerMoodData = responce.data;
        this.getThisSeasionsPlayerMoodData();
      }
    },
    async getThisSeasionsPlayerMoodData() {
      const userData = {
        player_id: this.selectedUserValue,
        action: "getThisSeasionsPlayerMoodData",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await Wellness.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.thisSeasionsPlayerMoodData = responce.data;
        this.barChartDataForPlayerMood();
      }
    },
    showModal(modelId) {
      // Map old modal IDs to new v-model properties
      const modalMap = {
        newplayerIDPModal: () => (this.showNewplayerIDPModal = true),
        playerIDPModal: () => (this.showPlayerIDPModal = true),
        viewHomeworkModal: () => (this.showViewHomeworkModal = true),
        addHomeworkModal: () => (this.showAddHomeworkModal = true),
        addHeight: () => (this.showAddHeight = true),
        addWeight: () => (this.showAddWeight = true),
        viewDailyWellnessReport: () =>
          (this.showViewDailyWellnessReport = true),
        performanceModal: () => (this.showPerformanceModal = true),
        trainingPerformanceModal: () =>
          (this.showTrainingPerformanceModal = true),
        coachGamePerformanceModal: () => {
          console.log("hellloooo");
          this.populateCoachesData();
          this.showCoachGamePerformanceModal = true;
        },
        missingDataModal: () => (this.showMissingDataModal = true),
        playerPerformanceReportModal: () =>
          (this.showPlayerPerformanceReportModal = true),
        playerCoachPerformanceAssessmentModal: () =>
          (this.showPlayerCoachPerformanceAssessmentModal = true),
        playerPerformanceReportVewDetailsModal: () =>
          (this.showPlayerPerformanceReportVewDetailsModal = true),
        allTrainingReportsModal: () =>
          (this.showAllTrainingReportsModal = true),
        performanceTargetsHistoryModal: () =>
          (this.showPerformanceTargetsHistoryModal = true),
        newPerformanceTargetsModal: () =>
          (this.showNewPerformanceTargetsModal = true),
        performanceTargetsModal: () =>
          (this.showPerformanceTargetsModal = true),
        playerCVpersonalProfileModal: () =>
          (this.showPlayerCVpersonalProfileModal = true),
        openPlayerInterestsHobbiesModal: () =>
          (this.showOpenPlayerInterestsHobbiesModal = true),
        openPlayerEducationModal: () =>
          (this.showOpenPlayerEducationModal = true),
        playerVideosModal: () => (this.showPlayerVideosModal = true),
        playerCVPlayingExperenceModal: () =>
          (this.showPlayerCVPlayingExperenceModal = true),
        viewDayStatsBreakDown: () => (this.showViewDayStatsBreakDown = true),
        uploadPlayerMinsCSV: () => (this.showUploadPlayerMinsCSV = true),
        viewDownloadPDF: () => (this.showViewDownloadPDF = true),
        viewPlayersCV: () => (this.showViewPlayersCV = true),
        viewPlayerCoachReviewPDF: () =>
          (this.showViewPlayerCoachReviewPDF = true),
        upLoadModal: () => (this.showUpLoadModal = true),
        charterModal: () => (this.showCharterModal = true),
        iDPGoalsModal: () => (this.showIDPGoalsModal = true),
        playerAssesmentModalView: () =>
          (this.showPlayerAssesmentModalView = true),
        playerAssesmentModal: () => (this.showPlayerAssesmentModal = true),
      };

      if (modalMap[modelId]) {
        modalMap[modelId]();
      } else {
        console.warn(`Modal ID '${modelId}' not found in profile modal map`);
      }
    },
    hideModal(modelId) {
      // Map old modal IDs to new v-model properties for hiding
      const modalMap = {
        newplayerIDPModal: () => (this.showNewplayerIDPModal = false),
        playerIDPModal: () => (this.showPlayerIDPModal = false),
        viewHomeworkModal: () => (this.showViewHomeworkModal = false),
        addHomeworkModal: () => (this.showAddHomeworkModal = false),
        addHeight: () => (this.showAddHeight = false),
        addWeight: () => (this.showAddWeight = false),
        viewDailyWellnessReport: () =>
          (this.showViewDailyWellnessReport = false),
        performanceModal: () => (this.showPerformanceModal = false),
        trainingPerformanceModal: () =>
          (this.showTrainingPerformanceModal = false),
        coachGamePerformanceModal: () =>
          (this.showCoachGamePerformanceModal = false),
        missingDataModal: () => (this.showMissingDataModal = false),
        playerPerformanceReportModal: () =>
          (this.showPlayerPerformanceReportModal = false),
        playerCoachPerformanceAssessmentModal: () =>
          (this.showPlayerCoachPerformanceAssessmentModal = false),
        playerPerformanceReportVewDetailsModal: () =>
          (this.showPlayerPerformanceReportVewDetailsModal = false),
        allTrainingReportsModal: () =>
          (this.showAllTrainingReportsModal = false),
        performanceTargetsHistoryModal: () =>
          (this.showPerformanceTargetsHistoryModal = false),
        newPerformanceTargetsModal: () =>
          (this.showNewPerformanceTargetsModal = false),
        performanceTargetsModal: () =>
          (this.showPerformanceTargetsModal = false),
        playerCVpersonalProfileModal: () =>
          (this.showPlayerCVpersonalProfileModal = false),
        openPlayerInterestsHobbiesModal: () =>
          (this.showOpenPlayerInterestsHobbiesModal = false),
        openPlayerEducationModal: () =>
          (this.showOpenPlayerEducationModal = false),
        playerVideosModal: () => (this.showPlayerVideosModal = false),
        playerCVPlayingExperenceModal: () =>
          (this.showPlayerCVPlayingExperenceModal = false),
        viewDayStatsBreakDown: () => (this.showViewDayStatsBreakDown = false),
        uploadPlayerMinsCSV: () => (this.showUploadPlayerMinsCSV = false),
        viewDownloadPDF: () => (this.showViewDownloadPDF = false),
        viewPlayersCV: () => (this.showViewPlayersCV = false),
        viewPlayerCoachReviewPDF: () =>
          (this.showViewPlayerCoachReviewPDF = false),
        upLoadModal: () => (this.showUpLoadModal = false),
        charterModal: () => (this.showCharterModal = false),
        iDPGoalsModal: () => (this.showIDPGoalsModal = false),
        playerAssesmentModalView: () =>
          (this.showPlayerAssesmentModalView = false),
        playerAssesmentModal: () => (this.showPlayerAssesmentModal = false),
      };

      if (modalMap[modelId]) {
        modalMap[modelId]();
      } else {
        console.warn(`Modal ID '${modelId}' not found in profile modal map`);
      }
    },
    setMonToSundayWeekDates() {
      const year = JSON.stringify(moment().year());
      const monday = moment()
        .year(year)
        .isoWeek(this.weekSelectedNumber)
        .day("monday")
        .startOf("day");
      this.selectedWeekMonSunday =
        monday.format("MMM D - ") + monday.add(6, "days").format("D YYYY");
      // this.depatchMonToSundayWeekDatesInLocalStorage();
    },
    mondaySunDatesChanged(data) {
      this.selectedWeekMonSunday = data.monToFri;
    },
    calendarDateChanged(date) {
      this.weeklyDate = date;
    },
    weekSelectedChanged(number) {
      this.weekSelectedNumber = number.weekSelectedNumber;
    },
    tabChange(tabValue, selectedTabValue) {
      this[tabValue] = selectedTabValue;
      if (selectedTabValue === "wellness-tab") {
        this.getLatestPlayerMoodData();
      }

      if (selectedTabValue === "learning-development-plan-tab") {
        this.getallQuatersPlayerIDPscores();
        this.getGameTargets();
        this.getIDPGoals();
      }

      if (selectedTabValue === "player-documents-tab") {
        this.getDocumentUploadsByUserId();
        this.getCharterData();
        this.getSignatures();
      }

      if (selectedTabValue === "home-work-tab") {
        this.getAllHomeworkForTeam();
      }

      if (selectedTabValue === "review-tab") {
        this.loadPlayerPhysicalPerformanceData();
        // Bio-Banding calculator is now a separate modal component
      }
    },
    async getUserByIdReturnData(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        return responce.data[0];
      }
    },
    async getPlayerUserDataId(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.selectedUserData = { ...responce.data[0] };
        this.selectedTeamId = this.selectedUserData.teamId;
        this.populatePlayerCV(this.selectedUserData);
        this.getPlayerCoachSignedPerformanceReport();
      }
    },
    async getUserById(clientId) {
      const userData = {
        clientId: clientId,
        action: "getUserByID",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.userData = { ...responce.data[0] };
        const userData = responce.data[0];
        this.selectedUserData = { ...responce.data[0] };
        this.$store.dispatch(USER_POPULATE, { userData });
        this.populatePlayerCV(this.selectedUserData);
        this.getPlayerCoachSignedPerformanceReport();
        if (
          this.userData.userType === "User" &&
          !this.checkSignedDate(this.userData.joined_date)
        ) {
          this.showModal("missingDataModal");
        }
        return true;
      }
    },
    setUser() {
      if (this.getProfile !== null) {
        this.userData = { ...this.getProfile };
      }
    },
    async saveHowYouFeel() {
      const today = moment();
      let todayFormatted = moment(today).format("YYYY-MM-DD");
      if (this.wellnessDaySelected !== null) {
        todayFormatted = moment(this.wellnessDaySelected.date).format(
          "YYYY-MM-DD",
        );
      }
      const userData = {
        player_id: this.userData.id,
        ...this.wellnessQuestions,
        date: todayFormatted,
        // Ratings are 1–5 on every client. The backend normalises to 0–10
        // for the "struggling" alert, so it must know the scale.
        scale_max: 5,
        action: "savePlayerMood",
      };

      const responce = await Wellness.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data === "Your mood has been saved.") {
        this.getLatestPlayerMoodData();
        this.showViewDailyWellnessReport = false;
        this.$toast.info("Your mood has been saved.", {
          title: "Saved",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "success",
        });
      }

      if (
        responce.data === "You have already submitted your daily mood today."
      ) {
        this.showViewDailyWellnessReport = false;
        this.$toast.info("You have already submitted your daily mood today.", {
          title: "Info",
          toaster: "b-toaster-bottom-right",
          solid: true,
          appendToast: true,
          variant: "warning",
        });
      }
    },
    async getCoachById(id) {
      const userData = {
        id: id,
        action: "getCoachById",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.selectedCoachImageURL =
          responce.data[0].userImage !== "" &&
          responce.data[0].userImage !== null
            ? this.getImgUrl(responce.data[0].userImage)
            : AVATAR_PLACEHOLDER;
      }
    },
    addInjuredPlayerInfo(data) {
      this.coachesUsersData = this.coachesUsersData.map((player) => {
        const hasInjury = data.some(
          (injury) =>
            player.id == injury.player_id &&
            injury.injury_status !== "Fully recoverd",
        );
        return { ...player, injury: hasInjury };
      });
    },
    async highlightInjuredPlayers() {
      const userData = {
        clubId: this.userData.clubId,
        action: "getInjuryedPlayersByClubId",
        season_start_date: localStorage.getItem(
          "currentPlayingseasonStartDate",
        ),
        season_end_date: this.extendSeasonEndDateToFullYear(),
      };
      const responce = await PlayerInjury.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.addInjuredPlayerInfo(responce.data);
      }
    },
    async getAllGoalKeepersForCoach() {
      const userData = {
        clubId: this.userData.clubId,
        action: "getAllGoalKeepersForCoach",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.populatePlayerDataFromAllUsersCall(responce.data);
      }
    },
    async getAllUsersForCoach() {
      const userData = {
        clubId: this.userData.clubId,
        coach_id: this.userData.id,
        action: "getAllUsersForCoach",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.populatePlayerDataFromAllUsersCall(responce.data);
      }
    },
    async getTeamsByCoachid() {
      const data = {
        action: "getTeamsByCoachid",
        coach_id: this.userData.id,
      };

      const responce = await Teams.find(data).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.clubTeams = this.removeDuplicates(responce.data, "id");
      }
    },
    async getTeamsByUserId() {
      if (this.userData.userType === "Coach") {
        this.getTeamsByCoachid();
      } else {
        const clientId = JSON.parse(
          localStorage.getItem("the_w_selectedClientId"),
        );
        const data = {
          action: "getTeamsDataById",
          userId: clientId,
        };

        if (this.userData.userType === "Admin") {
          data.clubId = this.userData.clubId;
        }
        const response = await Teams.find(data).catch((error) => {
          console.log(error);
        });
        if (Array.isArray(response.data)) {
          this.clubTeams = this.removeDuplicates(response.data, "id");
        }
      }
    },
    async populatePlayerDataFromAllUsersCall(data) {
      try {
        this.coachesUsersData = data;

        // Wait for injury data to be highlighted
        await this.highlightInjuredPlayers();

        // Dispatch to store (this is synchronous in Vuex)
        this.$store.dispatch(POPULATE_COACHES_USER_DATA, this.coachesUsersData);

        // Save to localStorage
        localStorage.setItem(
          "coachesUsersData",
          JSON.stringify(this.coachesUsersData),
        );

        this.allUserDataBeforFilterApplied = this.coachesUsersData;

        // Fetch teams data asynchronously
        await this.getTeamsByUserId();

        // Handle route params if player data exists

        if (this.$route.query.playerData !== undefined) {
          const playerData = this.allUserDataBeforFilterApplied.find(
            (player) =>
              player.id === JSON.parse(this.$route.query.playerData).id,
          );

          if (playerData) {
            this.selectedUseChanged(JSON.parse(JSON.stringify(playerData)));
          }
        }
      } catch (error) {
        console.error("Error populating player data:", error);
        this.$toast.error("Failed to load player data");
      }
    },
    async getAllUsersForClubId() {
      const userData = {
        clubId: this.userData.clubId,
        action: "getUserByClubId",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });

      if (responce.data.length > 0) {
        this.populatePlayerDataFromAllUsersCall(responce.data);
      }
    },
    async getAllUsersForThisAdmin() {
      const userData = {
        coachId: this.userData.id,
        action: "getUserByCoachId",
      };
      const responce = await Users.find(userData).catch((error) => {
        console.log(error);
      });
      if (responce.data.length > 0) {
        this.populatePlayerDataFromAllUsersCall(responce.data);
      }
    },
    checkForCoachesUsersData() {
      if (this.getCoachesUsersData.length > 0) {
        this.coachesUsersData = [...this.getCoachesUsersData];
      } else {
        if (
          this.userData.userType === "Admin" ||
          this.userData.userType === "Coach"
        ) {
          this.getAllUsersForThisAdmin();
        }
      }
    },
    pounds(amount) {
      const numberWithRemovedZeros = amount / 100;
      if (amount !== undefined) {
        return Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
        }).format(numberWithRemovedZeros);
      }
    },
    formatDate(date) {
      if (date === null) {
        return "No Date";
      }
      return moment(date).format("MMMM Do YYYY");
    },
    formatDates(date) {
      return moment(date).format("DD MMM YYYY");
    },
    formatISOStringDateAndTime(timeDateString) {
      return moment(timeDateString).utc().format("MMMM Do YYYY h:mm a");
    },
    formatDateForDB(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
<style scoped lang="scss">
/* ============================================================
   Charter view & sign modal
   ============================================================ */
.charter-modal {
  max-width: 900px;
  margin: 0 auto;

  &__bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
  &__hint {
    margin: 0;
    font-size: 0.9rem;
    color: #6c757d;
    flex: 1 1 260px;
  }
}
.charter-pdf-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--brand-color, #0d6efd);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.9rem;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    filter: brightness(0.94);
  }
}

.charter-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  overflow: hidden;

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 18px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    h3 {
      margin: 0;
      font-size: 1.05rem;
      color: #212529;
    }
  }

  &__text {
    padding: 18px;
    max-height: 320px;
    overflow-y: auto;
    font-size: 0.92rem;
    line-height: 1.55;
    color: #343a40;
  }

  &__empty {
    padding: 28px 18px;
    text-align: center;
    color: #adb5bd;
    img {
      width: 90px;
      opacity: 0.7;
      margin-bottom: 8px;
    }
    p {
      margin: 0;
    }
  }

  &__sign {
    padding: 18px;
    border-top: 1px solid #f1f3f5;
    background: #fbfcfd;
  }
}

.sign-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 999px;
  white-space: nowrap;
  &.is-signed {
    background: #d1e7dd;
    color: #0f5132;
  }
  &.is-pending {
    background: #fff3cd;
    color: #664d03;
  }
}

.sign-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.sign-pad {
  display: inline-block;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  background: #fff;
  max-width: 100%;
  overflow-x: auto;
  :deep(canvas) {
    display: block;
    border-radius: 6px;
  }
}

.charter-consent {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.85rem;
  color: #495057;
  margin: 14px 0;
  cursor: pointer;
  input {
    width: auto;
    margin: 2px 0 0;
    flex-shrink: 0;
  }
}

.sign-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.btn-sign {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #198754;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 0.9rem;
  cursor: pointer;
  &:hover:not(:disabled) {
    background: #157347;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
.btn-clear {
  background: #fff;
  color: #495057;
  border: 1px solid #ced4da;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 0.9rem;
  cursor: pointer;
  &:hover {
    background: #f8f9fa;
  }
}
.btn-resign {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  background: #fff;
  color: var(--brand-color, #0d6efd);
  border: 1px solid currentColor;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 0.85rem;
  cursor: pointer;
  &:hover {
    background: #f8f9fa;
  }
}

.signed-view {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .signed-img {
    max-width: 260px;
    max-height: 120px;
    border-bottom: 1px solid #ced4da;
  }
}
.signed-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  color: #198754;
  margin: 8px 0 0;
}
.sign-prompt {
  display: flex;
  align-items: center;
  gap: 14px;
  p {
    margin: 0;
    color: #6c757d;
    font-size: 0.9rem;
  }
}

/* Typed (non-drawn) signatures render as text, not a broken image. */
.typed-signature {
  font-family: "Segoe Script", "Brush Script MT", cursive;
  font-size: 1.6rem;
  color: #212529;
  padding: 8px 4px;
  border-bottom: 1px solid #ced4da;
  min-width: 220px;
  display: inline-block;
}

/* ============================================================
   Section side-drawer layout — TEST on Profile (player view).
   The drawer (<SectionNav>) is a fixed full-height left rail; the whole
   page content is padded left to clear it so ALL content (header, stats,
   tabs) sits to the right of the rail — like a native app shell.
   ============================================================ */
.profile-page.with-drawer {
  --section-nav-w: 260px;
  padding-left: calc(var(--section-nav-w) + 28px);
  transition: padding-left 0.2s ease;
}

.profile-page.with-drawer.nav-collapsed {
  --section-nav-w: 72px;
}

.section-layout {
  display: block;
}

@media (max-width: 768px) {
  .profile-page.with-drawer,
  .profile-page.with-drawer.nav-collapsed {
    padding-left: 0;
  }
}

.main-button-bottom {
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.season-view-controls {
  width: 100%;
}

section.gps-stats-full-width {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  border-top: 1px dashed #c3cdd5;
  padding-top: 2rem;
  border-bottom: 1px dashed #c3cdd5;
  margin-bottom: 2rem;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#fafafa),
    to(#ffffff)
  );
  background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
}

// The performance tab's content column is pinned to 48% by a global
// `.two-col-flex > div:first-of-type` rule at >=1800px, which left half the page
// empty. Here it's a single full-width content column, so reclaim the width.
.two-col-flex > .games-stats {
  width: 100%;
  margin-right: 0;
}

// Lay the game-stats / playing-positions / recent-activity columns out side by
// side and let them grow to fill the full width (no wasted whitespace). The
// pitch and recent-activity grow most; the game-stats list stays compact.
.training-snapshot-section {
  width: 100%;
  margin-top: 0.5rem;
}

.gps-benchmark-section {
  width: 100%;
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid #f1f3f5;
}

.stats-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1.5rem 2.5rem;
  width: 100%;

  > .game-stats {
    flex: 1 1 260px;
    min-width: 240px;
    margin-bottom: 0;
  }

  > .playing-positions {
    flex: 2 1 340px;
    min-width: 300px;
    width: auto; // override the global width: 36%
  }
}

// On large screens the playing-positions column is wide, so cap the pitch so it
// doesn't blow up.
@media screen and (min-width: 1800px) {
  .pitch-wrapper {
    max-width: 70%;
  }
}

// Positions played, ranked by frequency (under the pitch).
.positions-frequency-wrap {
  margin-top: 1.25rem;

  h4 {
    margin: 0 0 0.5rem;
    font-size: 0.9rem;
  }
}

.positions-frequency {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 9px 0;
    border-bottom: 1px solid #f1f3f5;

    &:last-child {
      border-bottom: none;
    }
  }

  .pos-rank {
    flex: 0 0 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #eef1f4;
    color: #6b7280;
    font-size: 0.78rem;
    font-weight: 700;
  }

  .pos-body {
    flex: 1;
    min-width: 0;
  }

  .pos-line {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
  }

  .pos-name {
    font-size: 0.88rem;
    font-weight: 600;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .pos-count {
    flex: 0 0 auto;
    color: #6b7280;
    font-size: 0.78rem;
    white-space: nowrap;
  }

  .pos-bar {
    height: 7px;
    border-radius: 4px;
    background: #eef1f4;
    overflow: hidden;
  }

  .pos-bar-fill {
    height: 100%;
    border-radius: 4px;
    background: #cdd9e5;
    transition: width 0.4s ease;
  }

  // Most-played position: filled accent rank badge + stronger bar.
  li.is-top {
    .pos-rank {
      background: #2f6fb3;
      color: #fff;
    }

    .pos-name {
      color: #1f2937;
    }

    .pos-bar-fill {
      background: linear-gradient(90deg, #2f6fb3, #4a90d9);
    }
  }
}

// Full-width report modals (Training Week, Minutes & Stats).
.report-modal-dialog.modal-dialog {
  max-width: 95vw;
  width: 95vw;
  margin: 1rem auto;
}

.report-modal-content {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.report-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #eee;

  h3 {
    margin: 0;
  }
}

.report-modal-close {
  background: none;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;
  color: #6b7280;
}

.report-modal-body {
  overflow-y: auto;
}

.growth-tracking-section {
  margin: 2rem 0;
  padding: 0;
}

#bioband-widget {
  margin: 0;
  padding: 0 !important;
  border-top: none;

  div#imperial-row,
  div#metric-row {
    background: #f8fafb;
  }

  #show-results-imperial {
    width: 100%;

    button {
      width: 100%;
    }
  }

  .form-control::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    opacity: 1;
    /* Firefox */
  }

  .form-control:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #6c757d;
  }

  .form-control::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #6c757d;
  }

  .invalid-feedback {
    color: lightpink;
  }

  .valid-feedback {
    color: white;
  }

  .form-control.is-invalid,
  .was-validated .form-control:invalid {
    border-color: lightpink;
  }

  .form-check-input.is-invalid ~ .form-check-label,
  .was-validated .form-check-input:invalid ~ .form-check-label {
    color: lightpink;
  }

  .form-check-input.is-valid ~ .form-check-label,
  .was-validated .form-check-input:valid ~ .form-check-label {
    color: white;
  }

  a:link {
    color: transparent;
    background-color: transparent;
    text-decoration: none !important;
    border: none !important;
  }

  a:visited {
    color: transparent;
    background-color: transparent;
    text-decoration: none !important;
    border: none !important;
  }

  a:hover {
    color: transparent;
    background-color: transparent;
    text-decoration: none !important;
    border: none !important;
  }

  a:active {
    color: transparent;
    background-color: transparent;
    text-decoration: none !important;
    border: none !important;
  }
}

.success-box {
  border: 1px solid #86b534;
  padding: 2rem;
  border-radius: 4px;
}

.warning-box {
  border: 1px solid #ffc106;
  padding: 2rem;
  border-radius: 4px;
}

.game-stats {
  margin-bottom: 1rem;
}

.metrics-wrapper {
  padding: 2rem 0;
  width: 100%;

  h4 {
    text-transform: uppercase;
    width: 100%;
  }

  .metrics-item {
    border-bottom: 1px dashed #a9b3bc;
    margin-bottom: 1rem;

    .session-date {
      font-size: 0.8rem;
      margin: 0;
    }

    .title {
      font-size: 0.8rem;
      text-transform: uppercase;
      margin: 0;
    }

    .value {
      font-size: 2.5rem;
      font-weight: bold;
      margin: 0;

      span {
        font-size: 0.8rem;
        font-weight: normal;
        margin: 0;
      }
    }
  }
}

.split-module {
  border-top: 1px dashed #a9b3bc;
  border-bottom: 1px dashed #a9b3bc;
  margin-bottom: 2rem;
  padding-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  min-height: 19rem;
}

.visual-split-fade {
  background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
  padding: 1rem;
}

.doc-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;

  svg {
    border: 1px solid #c3cdd5;
    padding: 0.3rem;
    font-size: 1.7rem;

    &:hover,
    &:focus {
      cursor: pointer;
      background: #eaeff3;
    }
  }
}

.uploaded-documents-wrapper {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
  margin-top: 1rem;
}

.document-upload-physio-report {
  border: 1px solid #dee2e6;
  padding: 1rem;
  margin-bottom: 1rem;
  background: #f2f5f7;
}

.attached-reports-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 2rem;
  margin-top: 2rem;
  border-top: 1px dashed #dee2e6;
  padding-top: 2rem;
}

.player-coach-signed-reviews {
  margin-bottom: 2rem;
}

.buttons-wrapper {
  margin: 1rem 0;
  display: flex;
  gap: 0.5rem;
}

.block-item {
  display: block !important;
}

.select-user {
  margin-bottom: 2rem;

  &__scope {
    margin-left: 1rem;
    font-size: 0.85rem;
    white-space: nowrap;
  }

  .form__label {
    margin-right: 1rem;
  }
}

.home-work-tab.tab-content {
  overflow: scroll;
}

/* Homework Section Styles */
.homework-container {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.homework-section-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8ecef;
  overflow: hidden;
}

.homework-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #e8f4fd 0%, #d4e8f7 100%);
  border-bottom: 1px solid #c5ddf0;

  &.team {
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
    border-bottom: 1px solid #a5d6a7;
  }

  .section-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    i {
      font-size: 1.25rem;
      color: #1976d2;
    }

    h3 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #1565c0;
    }

    .badge-count {
      background: #1976d2;
      color: white;
      padding: 0.2rem 0.6rem;
      border-radius: 12px;
      font-size: 0.75rem;
      font-weight: 600;

      &.team {
        background: #388e3c;
      }
    }
  }

  &.team .section-title {
    i {
      color: #388e3c;
    }

    h3 {
      color: #2e7d32;
    }
  }
}

.add-homework-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #1565c0;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
  }
}

.homework-section-content {
  padding: 0;
}

.homework-table-wrapper {
  overflow-x: auto;

  .desktop-only {
    display: table;
  }

  .mobile-only {
    display: none;
  }
}

.homework-table-modern {
  width: 100%;
  border-collapse: collapse;

  thead {
    th {
      background: #f8fafb;
      padding: 0.875rem 1rem;
      font-size: 0.8rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #6c757d;
      letter-spacing: 0.5px;
      border-bottom: 2px solid #e8ecef;
      text-align: left;
      white-space: nowrap;
    }
  }

  tbody {
    tr {
      transition: background 0.2s ease;

      &:hover {
        background: #f8fafb;
      }

      &:not(:last-child) td {
        border-bottom: 1px solid #f0f3f5;
      }
    }

    td {
      padding: 0.875rem 1rem;
      vertical-align: middle;
    }
  }

  .date-cell {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #495057;
    font-size: 0.9rem;

    i {
      color: #6c757d;
    }
  }

  .game-cell {
    color: #495057;
    font-size: 0.9rem;
  }

  .title-cell {
    font-weight: 500;
    color: #212529;
  }

  .action-buttons {
    display: flex;
    gap: 0.5rem;

    .action-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;

      &.view {
        background: #e3f2fd;
        color: #1976d2;

        &:hover {
          background: #1976d2;
          color: white;
        }
      }

      &.edit {
        background: #fff3e0;
        color: #f57c00;

        &:hover {
          background: #f57c00;
          color: white;
        }
      }

      &.delete {
        background: #ffebee;
        color: #d32f2f;

        &:hover {
          background: #d32f2f;
          color: white;
        }
      }
    }
  }
}

/* Mobile Card View for Homework */
.homework-cards {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
}

.homework-card {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e8ecef;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.homework-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f8fafb;
  border-bottom: 1px solid #e8ecef;
}

.homework-date {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: #495057;

  i {
    color: #6c757d;
  }
}

.homework-card-body {
  padding: 0.875rem 1rem;
}

.homework-title {
  font-weight: 600;
  color: #212529;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.homework-game {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  color: #6c757d;

  i {
    color: #ffc107;
  }
}

.homework-card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-top: 1px solid #f0f3f5;
  background: #fafbfc;

  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;

    &.view {
      background: #e3f2fd;
      color: #1976d2;

      &:hover {
        background: #1976d2;
        color: white;
      }
    }

    &.edit {
      background: #fff3e0;
      color: #f57c00;

      &:hover {
        background: #f57c00;
        color: white;
      }
    }

    &.delete {
      background: #ffebee;
      color: #d32f2f;

      &:hover {
        background: #d32f2f;
        color: white;
      }
    }
  }

  .action-btns-right {
    display: flex;
    gap: 0.5rem;
  }
}

.empty-state-modern {
  text-align: center;
  padding: 3rem 2rem;

  .empty-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 1rem;
    background: #e3f2fd;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 1.75rem;
      color: #1976d2;
    }

    &.team {
      background: #e8f5e9;

      i {
        color: #388e3c;
      }
    }
  }

  h4 {
    margin: 0 0 0.5rem;
    font-size: 1.1rem;
    font-weight: 600;
    color: #212529;
  }

  p {
    margin: 0;
    color: #6c757d;
    font-size: 0.9rem;
  }
}

/* Responsive Styles for Homework */
@media (max-width: 768px) {
  .homework-container {
    padding: 0.75rem;
    gap: 1rem;
  }

  .homework-section-header {
    flex-direction: column;
    gap: 0.75rem;
    text-align: center;
    padding: 1rem;

    .section-title {
      justify-content: center;
    }

    .section-actions {
      width: 100%;

      .add-homework-btn {
        width: 100%;
        justify-content: center;
      }
    }
  }

  .homework-table-wrapper {
    .desktop-only {
      display: none !important;
    }

    .mobile-only {
      display: flex !important;
    }
  }
}

@media (max-width: 480px) {
  .homework-container {
    padding: 0.5rem;
  }

  .homework-section-header {
    padding: 0.75rem;

    .section-title {
      h3 {
        font-size: 1rem;
      }

      i {
        font-size: 1.1rem;
      }
    }
  }

  .add-homework-btn {
    font-size: 0.85rem;
    padding: 0.5rem 0.75rem;
  }

  .homework-cards {
    padding: 0.75rem;
    gap: 0.6rem;
  }

  .homework-card-header,
  .homework-card-body,
  .homework-card-actions {
    padding: 0.6rem 0.75rem;
  }

  .homework-title {
    font-size: 0.9rem;
  }

  .homework-game {
    font-size: 0.8rem;
  }

  .homework-card-actions {
    flex-direction: column;
    gap: 0.5rem;

    .action-btn.view {
      width: 100%;
      justify-content: center;
    }

    .action-btns-right {
      width: 100%;
      justify-content: flex-end;
    }
  }

  .empty-state-modern {
    padding: 2rem 1rem;

    .empty-icon {
      width: 52px;
      height: 52px;

      i {
        font-size: 1.5rem;
      }
    }

    h4 {
      font-size: 1rem;
    }

    p {
      font-size: 0.85rem;
    }
  }
}

/* Legacy styles - kept for backwards compatibility */
.player-homework,
.team-homework {
  width: 100%;
  overflow: scroll;

  .homework-table {
    width: 95rem;
  }
}

.physical-performance-table {
  width: 100%;
  max-height: 59rem;
  overflow-y: scroll;

  .physicalPerformanceTable {
    width: 144rem;
  }
}

.col-wrapper-charts {
  width: 100%;
  height: 100%;

  .cols {
    padding: 2rem;
  }
}

section.player-self-assessment-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  h3 {
    width: 100%;
  }
}

.physical-performance-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  width: 100%;
}

/* ===== Performance Review Tab Styling ===== */
.review-tab-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 0;
}

.review-section-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8ecef;
  overflow: hidden;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #f8fafb 0%, #f1f4f6 100%);
  border-bottom: 1px solid #e8ecef;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  i {
    font-size: 1.25rem;
    color: #28a745;
  }

  h3 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #2c3e50;
  }
}

.section-actions {
  display: flex;
  gap: 0.5rem;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 500;

  &.primary {
    padding: 0.5rem 1rem;
  }
}

.section-content {
  padding: 1.25rem 1.5rem;
}

/* Reviews Table Styling */
.reviews-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  thead {
    th {
      background: #f8fafb;
      padding: 0.75rem 1rem;
      font-size: 0.8rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #6c757d;
      letter-spacing: 0.5px;
      border-bottom: 2px solid #e8ecef;
    }
  }

  tbody {
    tr {
      transition: background 0.2s ease;

      &:hover {
        background: #f8fafb;
      }
    }

    td {
      padding: 0.875rem 1rem;
      border-bottom: 1px solid #f0f3f5;
      vertical-align: middle;
    }
  }
}

.report-link {
  color: #28a745;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;

  &:hover {
    color: #1e7e34;
    text-decoration: underline;
  }

  i {
    font-size: 1rem;
  }
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;

  &.published {
    background: #d4edda;
    color: #155724;
  }

  &.draft {
    background: #fff3cd;
    color: #856404;
  }
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
}

.empty-state-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
  color: #6c757d;

  i {
    font-size: 3rem;
    margin-bottom: 1rem;
    opacity: 0.5;
  }

  p {
    margin: 0;
    font-size: 1rem;
    font-weight: 500;
  }

  .empty-hint {
    margin-top: 0.5rem;
    font-size: 0.85rem;
    opacity: 0.7;
  }
}

/* Bio-Band Section Styling */
.bioband-section {
  .section-header {
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  }
}

.measurement-toggle {
  display: flex;
  background: #ffffff;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.toggle-option {
  padding: 0.4rem 1rem;
  cursor: pointer;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #6c757d;
  transition: all 0.2s ease;
  margin: 0;

  input {
    display: none;
  }

  &.active,
  &:has(input:checked) {
    background: #28a745;
    color: white;
  }

  &:hover:not(.active):not(:has(input:checked)) {
    background: #f0f0f0;
  }
}

.bioband-calculator-container {
  max-width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  border-top: none !important;
}

.bioband-form {
  background: #f8fafb;
  border-radius: 8px;
  margin-top: 0;

  .form-label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.4rem;
    display: block;
    text-align: left;
  }

  .optional-label {
    font-weight: 400;
    color: #adb5bd;
    font-size: 0.75rem;
  }

  .form-hint {
    display: block;
    font-size: 0.7rem;
    color: #6c757d;
    margin-top: 0.25rem;
    text-align: left;
  }

  .form-control {
    border-radius: 6px;
    border: 1px solid #ced4da;

    &:focus {
      border-color: #28a745;
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.15);
    }
  }
}

.gender-toggle {
  display: flex;
  gap: 0.5rem;
}

.gender-option {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  background: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0;

  input {
    display: none;
  }

  span {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.85rem;
    color: #495057;
  }

  &:has(input:checked) {
    background: #28a745;
    border-color: #28a745;

    span {
      color: white;
    }
  }

  &:hover:not(:has(input:checked)) {
    border-color: #28a745;
    background: #f8fff9;
  }
}

.calculate-btn {
  width: 100%;
  padding: 0.6rem 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 6px;
}

.spinner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
}

.error-pane {
  margin-top: 1rem;

  .alert {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    border-radius: 8px;

    i {
      font-size: 1.25rem;
    }
  }
}

/* Growth Section Styling */
.growth-section {
  .section-header {
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  }

  .section-title i {
    color: #1976d2;
  }
}

/* Performance Targets Styling */
.targets-section {
  .section-header {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  }

  .section-title i {
    color: #f57c00;
  }
}

.performance-targets-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}

.target-categories {
  background: #f8fafb;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #e8ecef;

  h4 {
    font-size: 0.9rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.75rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #28a745;
  }
}

.target-info {
  background: white;
  border-radius: 6px;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border: 1px solid #e8ecef;

  h4 {
    font-size: 0.8rem;
    color: #28a745;
    margin: 0 0 0.25rem 0;
    padding: 0;
    border: none;
    display: flex;
    align-items: center;
    gap: 0.4rem;

    img {
      width: 16px;
      height: 16px;
    }
  }

  .small-date-player-coach {
    font-size: 0.75rem;
    padding: 0.15rem 0.5rem;
    background: #fff3cd;
    border-radius: 4px;
    display: inline-block;
    margin-bottom: 0.5rem;

    &.completed {
      background: #d4edda;
      color: #155724;
    }
  }
}

/* Season Toggle Styling */
.season-view-controls {
  .btn-group .btn {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
    border-radius: 0.375rem !important;
  }

  .btn-group .btn:first-child {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .btn-group .btn:last-child {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}

.key-value-list li span.time-value {
  color: #6c757d;
  font-weight: 600;
}

.small-date-player-coach {
  color: #6c757d;
  font-style: italic;
}

.charter {
  border: 1px solid #d6dadd;
  padding: 2rem;
  margin-bottom: 1rem;

  .signatureWrapper {
    div.player-game-responce {
      border: none;
    }
  }
}

button.mins-button {
  width: 100%;
}

.goal-item {
  padding: 1rem 0;
}

.player-game-targets {
  border-top: 1px solid #a9b3bc;
  padding: 2rem 0;
  margin-top: 1rem;

  .game-target {
    border: 1px solid #efefef;
    padding: 1rem;
    border-radius: 4px;
    min-width: 18rem;
  }

  .in-possession,
  .out-of-possession {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;

    .targets {
      min-width: 16rem;

      &:first-child {
        min-width: 16rem;

        h4 {
          font-size: 1rem;
          text-align: center;
        }

        svg {
          margin: 0 auto;
          margin: 1rem auto;
          display: block;
        }
      }

      border: 1px solid #efefef;
      padding: 1rem;
      border-radius: 4px;

      h4 {
        font-size: 1rem;
      }

      .target-outline {
        img {
          width: 2rem;
        }

        button {
          margin-top: 1rem;
          display: block;
        }
      }
    }
  }
}

.idp-game-targets {
  border-top: 1px dashed #dee2e6;
  margin-top: 2rem;
  padding-top: 2rem;

  .label {
    .value {
      width: 10rem;
      display: inline-block;
      font-weight: normal;
      font-size: 1.2rem;
    }
  }
}

.target-outline {
  margin-bottom: 0.5rem;
  border-bottom: 1px dashed #c0c4c8;
  padding-bottom: 1rem;
  margin-bottom: 1rem;

  .target-wrapper {
  }

  span:first-of-type {
    display: inline-block;
    margin-bottom: 1rem;
    margin-right: 1rem;
  }

  span.complete {
    border: 1px solid #08a10f;
    padding: 0.3rem;
    border-radius: 4px;
    color: #08a10f;
  }

  span.not-complete {
    border: 1px solid #d40035;
    padding: 0.3rem;
    border-radius: 4px;
    color: #d40035;
  }

  img {
    width: 2rem;
  }
}

.player-coach-scores-idp {
  .scores-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    .score-item {
      min-width: 17rem;
      padding: 1rem;
      border: 1px solid #efefef;
      border-radius: 4px;

      .green,
      .yellow,
      .red {
        h4 {
          padding: 1rem;
        }
      }

      .green {
        h4 {
          background: #57b88b;
          color: white;
        }

        p {
          color: #198754;
        }
      }

      .yellow {
        h4 {
          background: #fbd055;
          color: white;
        }

        p {
          color: #c89a15;
        }
      }

      .red {
        h4 {
          color: white;
          background: #e06670;
        }

        p {
          color: #b91c29;
        }
      }

      p {
        color: auto;
      }
    }
  }

  .idp-comments {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-bottom: 1rem;

    .comments-item {
      margin-top: 1rem;
      border: 1px solid #efefef;
      padding: 1rem;
      border-radius: 4px;
    }
  }
}

.development-plan-info {
  padding: 2rem;
  width: 100%;
}

.homework-links {
  margin-bottom: 1rem;
}

.areas-wrapper {
  border: 1px solid #dee2e6;
  padding: 1rem;
  margin-bottom: 1rem;
}

section.games-and-training-lists {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 99%;
  gap: 3.5rem;
  margin-bottom: 2rem;

  .games-section {
    flex: 1;
  }
}

.document {
  max-width: 14rem;
  text-align: center;
  padding: 1rem;
  margin: 1rem;
  border-radius: 4px;
  box-shadow: 0 4px 16px rgba(138, 138, 138, 0.3);
  border: 1px solid transparent;

  &:hover,
  &:focus {
    border: 1px solid $secondary-color;
  }

  h3 {
    margin-top: 1rem;
    font-size: 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-transform: inherit;
  }

  img {
    width: 40%;
  }
}

.player-weight-height-stats {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  h3 {
    width: 100%;
  }
}

.game-assesment-reports-table {
  max-height: 10rem;
  overflow-x: scroll;
}

.full-player-report {
  .label {
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  .value {
    display: block;
    font-weight: normal;
  }

  .player-assesment-report,
  .coach-assesment-report {
    border-top: 1px dashed #dee2e6;
    margin-top: 2rem;
    padding-top: 2rem;
  }
}

.gps-data-for-same-date {
  border-top: 1px dashed #dee2e6;
  margin-top: 2rem;
  padding-top: 2rem;
}

.player-game-report {
  border: 1px solid #dee2e6;
  padding: 2rem;
  width: 100%;

  h3 {
    margin-bottom: 2rem;
  }
}

.performance-targets {
  width: 100%;

  .target-categories-wrapper {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    justify-content: space-between;

    .target-categories {
      min-width: 14.8rem;
      border-right: 1px solid #a9b3bc;
      border-left: 1px solid #a9b3bc;
      padding: 1rem;
    }
  }
}

.show-imported-CSV-data {
  margin-top: 1rem;
  padding: 1rem;
  background: #e6e8e9;
  height: 20rem;
  overflow-x: scroll;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}

.player-stats-gps-wrapper {
  .player-session-details {
    .player-name {
      font-size: 2rem;
      font-weight: bold;
      margin: 0;
    }

    .session-name {
      p {
        margin: 0;

        span {
          width: 8rem;
          display: inline-block;
        }
      }
    }

    .main-session .wrapper-mins-stuff {
      background: #f2f5f7;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      padding: 1rem;

      .mins-from-session {
        padding: 1rem;
        border: 1px solid #c7ccd0;
        min-width: 12rem;

        span {
        }

        p {
          font-size: 3rem;
          font-weight: bold;
          line-height: 2.7rem;
          margin: 0;

          span {
            font-size: 1rem;
          }
        }
      }
    }
  }
}

#personal_profile_text_box {
  margin-bottom: 1rem;
}

.cv-section {
  border: 1px solid #e2e7e4;
  border-radius: 6px;
  background: #fbfcfb;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;

  .cv-section__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.75rem;

    h3 {
      margin: 0;
      font-size: 1.05rem;
      text-transform: none;
    }
  }

  .cv-empty {
    color: #6b7a85;
    font-style: italic;
  }

  .education ul {
    list-style: none;
    margin: 0 0 0.5rem;
    padding: 0;

    li {
      display: flex;
      align-items: baseline;
      flex-wrap: wrap;
      gap: 0.35rem 1rem;
      padding: 0.5rem 0;
      border-bottom: 1px solid #eef1f3;

      &:last-child {
        border-bottom: none;
      }

      .title {
        font-weight: 700;
      }

      .info {
        color: #5b6770;
        font-size: 0.9rem;
      }

      .buttons-row {
        margin-left: auto;
      }
    }
  }
}

.cv-preview-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5rem;
}

.each-target.playing-experence-item {
  border-bottom: 1px dashed #dddddd;
  padding-bottom: 1rem;
  margin-bottom: 2rem;
}

.playing-experence-wrapper {
  padding-top: 1rem;

  .playing-experiance-add-button {
    margin-right: 1rem;
  }

  label {
    margin-right: 1rem;
  }
}

.player-cv-content {
  margin-top: 1rem;
  width: 100%;
  height: 50rem;

  iframe {
    width: 100%;
    height: 100%;
  }

  .form__item {
    display: grid;
  }
}

.performance-targets-display {
  display: block !important;

  .performance-target-item {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;

    .target-wrapper {
      display: flex;

      img {
        width: 1rem;
        margin-right: 0.5rem;
      }
    }
  }
}

.performance-target-modal-content {
  .custom-checkbox {
    border: 1px solid #dee2e6;
    padding: 1rem;
    margin: 1rem 0;

    label.custom-control-label {
      margin-left: 0.5rem;
    }
  }
}

.target-info {
  border-bottom: 1px dotted #a9b3bc;
  margin-bottom: 1rem;
  margin-top: 1rem;

  h4 {
    img {
      width: 1rem;
    }
  }

  .target-content {
    display: flex;
    justify-content: space-between;

    p {
      max-width: 20rem;
    }
  }
}

.perfomance-targets {
  border-top: 1px solid #e4e4e4;
  padding: 1rem 0;

  label {
    button {
      margin-right: 0.5rem;
    }
  }

  .each-target {
    border-top: 1px dashed #e4e4e4;
    padding: 1rem 0;
    margin-top: 1rem;
  }
}

.player-profile-details.injury {
  .user-photo-info {
    border: 1px solid red !important;
    background: #ffeeeb;
  }
}

.headding-space {
  border-top: none;
  padding-top: 0px !important;
}

.tabs {
  .tab-item {
    min-width: auto;
  }
}

.user-info {
  p {
    img {
      width: 1.5rem;
    }
  }
}

.two-col-pop {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #dee2e6;
}

span.vue-star-rating-rating-text {
  font-size: 2rem;
  padding: 0.5rem 1rem 0 1rem;
}

.user-details-pop p span {
  font-weight: bold;
  display: inline-block;
  min-width: 8rem;
}

.td-no-padding {
  padding: 0;
}

.comments-box {
  border: 1px solid #dee2e6;
  margin-top: 1rem;
  padding: 0.5rem;
}

.table-scroll {
  width: 100%;
  overflow: scroll;

  .w-a-style {
    width: 84rem;
  }
}

.table-scroll.performance-reviews-data {
  width: 100%;
  overflow: scroll;

  .w-a-style {
    width: 61rem;
  }
}

.review-average-score {
  min-width: 20rem;
}

.small-image-name-wrapper {
  margin-bottom: 1rem;
}

.small-image {
  border: 1px solid #a9b3bc;
  width: 4rem;
  border-radius: 100px;
  margin-right: 1rem;
}

.session-enjoyment-wrapper {
  ul {
    li {
      margin-bottom: 1rem;
    }
  }
}

.all-training-reports {
  a {
    border: 1px solid #c3cdd5;
    padding: 1rem;
    display: flex;
    margin-bottom: 1rem;
    border-radius: 4px;
    font-weight: bold;
    text-decoration: none;
    min-width: 18rem;

    &:hover,
    &:focus {
      background: #47a9f9;
      color: white;
    }
  }
}

.signatureWrapper {
  margin-bottom: 2rem;

  div {
    border: 1px solid #d6dadd;
    margin-bottom: 1rem;
  }
}

.players-code {
  margin-bottom: 2rem;
}

.completed {
  color: #08a10f;
}

.injury-table {
  tbody {
    tr.full-recoverd {
      border-left: 2px solid #08a10f;

      .injury-status {
        color: #08a10f;
      }
    }

    tr {
      border-left: 2px solid #d85c64;
    }
  }
}

button.btn.btn-outline-warning,
button.btn.btn-outline-danger {
  background: white;

  &:hover,
  &:focus {
    background: #ffc10c;
    color: white !important;
  }
}

table {
  tr {
    td {
      button.btn.btn-outline-warning,
      button.btn.btn-outline-danger {
        background: white;
      }

      button.btn.btn-outline-warning {
        &:hover,
        &:focus {
          color: #ffc109;
        }
      }

      button.btn.btn-outline-danger {
        &:hover,
        &:focus {
          color: #d85c64;
        }
      }
    }
  }
}

.players-without-subscriptions {
  margin: 1rem;
}

span.unpaid {
  background: #d85c64;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
  display: block;
  color: white;
  padding: 0.1rem 1rem;
  font-weight: bold;
}

ul.injury-list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  span {
    font-weight: bold;
    float: right;
    margin-left: 1rem;
  }
}

.modal-container {
  margin-top: 1rem;
  width: 100%;
  height: 50rem;

  iframe {
    border: 0;
    width: 100%;
    height: 50rem;
  }
}

.visually-hidden {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.mood-chart {
  margin-top: 2rem;
  flex-grow: 1;
  min-height: 0;

  > div {
    position: relative;
    height: 100%;
  }
}

.player-cv {
  max-width: 1000px;

  .sessions-info {
    display: flex;
    flex-wrap: wrap;

    .video-wrapper {
      margin-bottom: 1rem;
    }

    .session-card {
      padding: 1rem;
      margin-bottom: 1rem;
      display: block;
    }
  }
}

.modal-container.performance-report {
  img {
    width: 100%;
  }
}

.player-cv-content {
  .cv-header {
    display: flex;
    margin-bottom: 2rem;

    .user-photo-info {
      display: flex;

      h1 {
        margin-left: 1rem;
      }

      img {
        border-radius: 100px;
        border: 1px solid #c3cdd5;
        width: 150px;
        height: 150px;
      }
    }

    .cv-address {
      ul {
        list-style: none;

        li {
          padding: 0.2rem 0;
        }
      }
    }
  }

  .cv-body {
    .Personal-profile {
      margin: 3rem 0;
    }

    .players-videos {
      .sessions-info {
        .session-card {
          width: 47%;
        }
      }
    }
  }
}

.education {
  margin: 2rem 0;

  ul {
    li {
      margin-bottom: 1rem;

      .title {
        font-weight: bold;
        display: block;
        margin-bottom: 0.5rem;
      }
    }
  }
}

.create-academy-report-button {
  margin-top: 2rem;
  margin-bottom: 0;
}

.filters {
  width: 100%;
  transition: all 0.4s ease-in-out;

  select {
    width: auto;
  }

  label {
    display: inline-block;
  }

  input#fullPitch,
  input#injuredPlayers,
  input#trialistPlayers {
    width: 17px;
  }
}

.filters-sort {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
}

.search-small {
  max-width: 20rem;
}

.filter-small {
  height: 2.5rem;
  border: transparent;
  color: #9ea7b0;

  &:hover,
  &:focus {
    background: transparent;
    color: #7c838a;
    border: transparent;
    outline: transparent;
    box-shadow: 0 0 0 0rem;
  }
}

span.paid {
  background: #00cf63;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
  display: block;
  color: white;
  padding: 0.1rem;
  font-weight: bold;
}

.select-wrapper {
  display: flex;
  gap: 1rem;
}

.remove-icon-button {
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
  font-size: 1.5rem;
}

.green-totals {
  color: #05a110;
}

.amber-totals {
  color: #ffc107;
}

.red-totals {
  color: #ff2407;
}

@media screen and (min-width: 480px) {
}

@media screen and (min-width: 720px) {
}

@media screen and (min-width: 960px) {
}

@media screen and (min-width: 1024px) {
  .metrics-wrapper {
    padding: 2rem 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;

    .metrics-item {
      border: 1px dashed #a9b3bc;
      margin-bottom: 1rem;
      padding: 1rem;
      border-radius: 4px;
    }
  }

  .signed-report {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;

    .two-col-pop {
      min-height: 13rem;
    }

    .player-signed-report,
    .coach-signed-report {
      width: 48%;
      border: 1px solid #dee2e6;
      padding: 2rem;
      background: #f9f9f9;

      .editr--content {
        background: white;
      }
    }
  }

  .col-wrapper-charts {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%;
    height: 100%;

    .cols {
      width: 49%;
      padding: 2rem;
    }
  }

  .full-player-report {
    .value {
      display: inline-block;
      width: 10rem;
    }
  }

  .target-outline {
    span:first-of-type {
      display: inline-block;
      min-width: 22rem;
    }
  }

  .player-stats-gps-wrapper {
    .player-session-details {
      .main-session .wrapper-mins-stuff {
        .mins-from-session {
          min-width: 20rem;
        }
      }
    }
  }

  .table-scroll.performance-reviews-data {
    width: auto;
  }

  .physical-performance-stats {
    flex: 1;
  }

  .player-cv {
    .sessions-info {
      .video-wrapper {
        width: 48%;
      }
    }
  }

  .all-game-reports {
    display: flex;
    gap: 1rem;

    .game-assesment-reports-table {
      min-width: 29rem;
    }
  }

  .development-plan-wrapper {
    .development-plan-main-links {
      .development-plan-item {
        max-width: 20rem;
      }
    }
  }

  .player-coach-scores-idp {
    .scores-wrapper {
      .score-item {
        min-width: 31rem;
      }
    }
  }

  .player-game-targets {
    .in-possession,
    .out-of-possession {
      min-width: 36%;

      .targets {
        min-width: 35%;
      }
    }
  }

  .player-coach-scores-idp {
    .idp-comments {
      .comments-item {
        width: 44%;
      }
    }
  }

  form.form.performance-form h3 {
    border-bottom: 2px solid #e4e2e2;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
  }

  .head-style {
    border-top: 2px solid #e4e2e2;
    padding-top: 2rem;
  }
}

@media (min-width: 1400px) {
  .col-xxl-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 49.333333%;
  }
}

@media (min-width: 1720px) {
  .col-xxl-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 49.333333%;
  }
}

@media (min-width: 1730px) {
  .col-xxl-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 49.333333%;
  }
}

/* Required field styling */
.required-field {
  position: relative;
}

.required-field::after {
  content: " *";
  color: #dc3545;
  font-weight: bold;
}

.form__item select:invalid,
.form__item input:invalid,
.form__item textarea:invalid {
  border-color: #dc3545;
}

.form__item select:invalid:focus,
.form__item input:invalid:focus,
.form__item textarea:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

/* ============================================
   BIOBAND CALCULATOR RESPONSIVE STYLES
   ============================================ */

/* Results pane responsive layout */
#results-pane {
  .row {
    margin: 0;
  }

  /* Make summary and bio age sections stack on mobile */
  .col-6.col-md-6 {
    @media (max-width: 767px) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}

/* Heights grid responsive */
#results-pane .gallery {
  overflow-x: auto;
  min-height: 280px;

  @media (max-width: 576px) {
    grid-template-columns: repeat(21, 4.76%) !important;
    grid-template-rows: repeat(17, 14px) !important;
    min-height: 240px;
  }
}

/* SVG figures responsive sizing */
.father-height-human,
.mother-height-human,
.child-height-human,
.estimated-height-human,
.decimal-age-human,
.bio-age-human {
  max-width: 100%;
  height: auto !important;

  @media (max-width: 767px) {
    max-height: 150px !important;
  }

  @media (max-width: 576px) {
    max-height: 120px !important;
  }
}

/* Bio Age grid responsive */
#results-pane .text-black.col-6 .gallery {
  @media (max-width: 576px) {
    grid-template-rows: repeat(13, 18px) !important;
  }
}

/* Summary cards responsive */
#results-pane .alert {
  @media (max-width: 576px) {
    padding: 0.5rem !important;
    margin-bottom: 0.5rem;

    .py-2 {
      padding-top: 0.25rem !important;
      padding-bottom: 0.25rem !important;
    }
  }
}

/* Progress bar in summary */
#results-pane .progress {
  @media (max-width: 576px) {
    height: 24px !important;
  }
}

/* Bioband form responsive enhancements */
.bioband-form {
  @media (max-width: 576px) {
    padding: 0.75rem !important;

    .col-12 {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    .form-label {
      font-size: 0.8rem;
    }

    .form-control {
      font-size: 0.85rem;
      padding: 0.4rem 0.6rem;
    }

    .input-group-sm > .form-control {
      padding: 0.35rem 0.5rem;
    }
  }
}

/* Gender toggle responsive */
.gender-toggle {
  @media (max-width: 576px) {
    flex-direction: row;
    gap: 0.35rem;

    .gender-option {
      padding: 0.4rem 0.5rem;

      span {
        font-size: 0.75rem;
        gap: 0.2rem;
      }
    }
  }
}

/* Calculate button responsive */
.calculate-btn {
  @media (max-width: 576px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;

    i {
      font-size: 0.9rem;
    }
  }
}

/* Height text labels in results */
#father-height-text,
#mother-height-text,
#child-height-text,
#estimated-height-text,
#decimal-age-text,
#bio-age-text {
  @media (max-width: 576px) {
    font-size: 9px !important;
  }
}

/* Grid axis labels */
#results-pane .gallery > div > div[style*="font-size: small"] {
  @media (max-width: 576px) {
    font-size: 10px !important;
  }
}

/* Person labels (Father, Mother, etc.) */
#results-pane
  .gallery
  div[style*="grid-row-start: 16"]
  div[style*="font-size: small"] {
  @media (max-width: 576px) {
    font-size: 10px !important;
  }
}

/* Section titles in results */
#results-pane .row.align-items-center.justify-content-center {
  @media (max-width: 576px) {
    font-size: 0.85rem;
    padding-top: 0.5rem !important;
  }
}

/* Summary section adjustments */
#results-pane .d-flex.flex-column.align-items-center {
  @media (max-width: 576px) {
    padding-top: 1rem !important;
    gap: 0.5rem;
  }
}

/* Bio Age Difference box */
#bio-age-diff {
  @media (max-width: 576px) {
    font-size: 11px !important;
  }
}

/* Percent obtained text */
#percent-obtained {
  @media (max-width: 576px) {
    font-size: 11px !important;
  }
}

/* Tablet-specific adjustments */
@media (min-width: 577px) and (max-width: 991px) {
  #results-pane .gallery {
    grid-template-rows: repeat(17, 15px) !important;
    min-height: 260px;
  }

  .father-height-human,
  .mother-height-human,
  .child-height-human,
  .estimated-height-human {
    max-height: 170px !important;
  }

  .decimal-age-human,
  .bio-age-human {
    max-height: 160px !important;
  }
}

/* Ensure bioband section doesn't overflow */
.bioband-section {
  .section-content {
    overflow-x: hidden;
  }

  .physical-performance-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* Input row scrollable on very small screens */
#imperial-row,
#metric-row {
  @media (max-width: 400px) {
    padding: 0.5rem !important;
  }
}

/* Error pane responsive */
.error-pane {
  @media (max-width: 576px) {
    .alert {
      flex-direction: column;
      text-align: center;
      gap: 0.5rem;

      i {
        font-size: 1.5rem;
      }

      span {
        font-size: 0.85rem;
      }
    }
  }
}

/* ============================================
   BIOBAND RESULTS SECTION - ENHANCED RESPONSIVE
   ============================================ */

.bioband-results {
  padding: 0.5rem;

  @media (max-width: 576px) {
    padding: 0.25rem;
  }
}

/* Heights Gallery - Main visualization */
.heights-gallery {
  padding: 0.5rem;

  @media (max-width: 576px) {
    grid-template-columns: repeat(21, 4.76%) !important;
    grid-template-rows: repeat(17, 12px) !important;
    padding: 0.25rem;
    min-height: 200px;
  }

  @media (min-width: 577px) and (max-width: 767px) {
    grid-template-rows: repeat(17, 14px) !important;
    min-height: 240px;
  }
}

/* Bio Age Gallery */
.bioage-gallery {
  padding: 0.5rem;

  @media (max-width: 576px) {
    grid-template-columns: repeat(21, 4.76%) !important;
    grid-template-rows: repeat(13, 16px) !important;
    padding: 0.25rem;
    min-height: 210px;
  }

  @media (min-width: 577px) and (max-width: 767px) {
    grid-template-rows: repeat(13, 18px) !important;
    min-height: 240px;
  }
}

/* Section titles */
.bioband-section-title {
  font-size: 0.95rem;
  font-weight: 600;

  @media (max-width: 576px) {
    font-size: 0.8rem;
    padding: 0.5rem 0 !important;
  }
}

/* Summary card styling */
.bioband-summary-card {
  @media (max-width: 576px) {
    padding: 1rem 0.5rem !important;
    order: 2;
    /* Show after bio age grid on mobile */
  }

  .d-flex.flex-column {
    @media (max-width: 576px) {
      padding-top: 0.5rem !important;
    }
  }

  .alert {
    @media (max-width: 576px) {
      min-width: 100%;
      margin-bottom: 0.75rem;
    }
  }
}

/* Bio age grid styling */
.bioband-bioage-grid {
  @media (max-width: 576px) {
    padding: 0.5rem !important;
    order: 1;
    /* Show first on mobile */
  }
}

/* Heights grid styling */
.bioband-heights-grid {
  @media (max-width: 576px) {
    padding: 0.5rem !important;
    margin-bottom: 0.5rem;
  }
}

/* Make row flex on mobile for reordering */
.bioband-results > .col > .row {
  @media (max-width: 575px) {
    display: flex;
    flex-wrap: wrap;
  }
}

/* Coach Performance Reviews - Responsive Styles */
.performance-reviews-data {
  .desktop-only {
    display: table;
  }

  .mobile-only {
    display: none;
  }
}

/* Mobile Card View for Reviews */
.reviews-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.review-card {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e8ecef;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.review-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #f8fafb 0%, #f1f4f6 100%);
  border-bottom: 1px solid #e8ecef;
}

.review-date {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #495057;

  i {
    color: #6c757d;
  }
}

.review-card-body {
  padding: 0.75rem 1rem;
}

.review-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .info-label {
    font-size: 0.85rem;
    color: #6c757d;
  }

  .info-value {
    font-weight: 500;
    color: #212529;
  }
}

.review-card-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border-top: 1px solid #f0f3f5;
  background: #fafbfc;

  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    border: none;

    &.view {
      background: #e8f4fd;
      color: #0d6efd;

      &:hover {
        background: #0d6efd;
        color: white;
      }
    }

    &.print {
      background: #d4edda;
      color: #28a745;

      &:hover {
        background: #28a745;
        color: white;
      }
    }

    &.delete {
      background: #f8d7da;
      color: #dc3545;

      &:hover {
        background: #dc3545;
        color: white;
      }
    }
  }

  .action-btns-right {
    display: flex;
    gap: 0.5rem;
  }
}

/* Responsive visibility for reviews */
@media (max-width: 768px) {
  .performance-reviews-data {
    overflow: visible;

    .desktop-only {
      display: none !important;
    }

    .mobile-only {
      display: flex !important;
    }
  }

  .review-section-card {
    .section-header {
      flex-direction: column;
      gap: 0.75rem;
      text-align: center;
      padding: 1rem;

      .section-title {
        justify-content: center;
      }

      .section-actions {
        width: 100%;

        .action-btn {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .reviews-cards {
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .review-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.6rem 0.75rem;
  }

  .review-card-body {
    padding: 0.6rem 0.75rem;
  }

  .review-card-actions {
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.6rem 0.75rem;

    .action-btn.view {
      width: 100%;
      justify-content: center;
    }

    .action-btns-right {
      width: 100%;
      justify-content: flex-end;
    }
  }

  .review-date {
    font-size: 0.85rem;
  }

  .review-info-row {
    font-size: 0.85rem;
  }
}
</style>
